module.exports = {
  "en-GB": {
    "ActivityFeed": {
      "empty_files": "No files.",
      "empty_items": "No items.",
      "empty_notes": "No private notes.",
      "empty_updates": "No updates.",
      "empty_viewings": "No viewings.",
      "filters": {
        "Call": "Calls",
        "DealNote": "Updates",
        "Email": "Emails",
        "File": "Emails",
        "Note": "Updates",
        "Proposal": "Proposals",
        "Viewing": "Viewings",
        "all": "All",
        "call": "Calls",
        "deal_note": "Updates",
        "email": "Emails",
        "file": "Files",
        "label": "Show",
        "note": "Updates",
        "proposal": "Proposals",
        "update": "Updates",
        "viewing": "Viewings"
      },
      "header": {
        "Call": "Call",
        "DealNote": "Update",
        "Email": "Email",
        "Note": "Update",
        "Proposal": "Proposal",
        "Viewing": "Viewing",
        "call": "Call",
        "deal_note": "Update",
        "email": "Email",
        "file": "File",
        "label": "Post",
        "note": "Update",
        "proposal": "Proposal",
        "update": "Update",
        "viewing": "Viewing"
      }
    },
    "AddActions": {
      "addDeal": ""
    },
    "Asset": {
      "deals": {
        "empty": "No enquiries",
        "fetching": "Fetching..",
        "hide": "Hide enquiries",
        "show": "View %{smart_count} enquiry |||| View %{smart_count} enquiries"
      },
      "noAvailableSpaces": "No available spaces",
      "spaces": {
        "empty": "No available spaces",
        "fetching": "Fetching..",
        "hide": "Hide spaces",
        "show": "View %{smart_count} space |||| View %{smart_count} spaces"
      },
      "spacesFetching": "Fetching..",
      "spacesHide": "Hide spaces",
      "spacesView": "View %{smart_count} space |||| View %{smart_count} spaces"
    },
    "AssetActions": {
      "askQuestion": "Ask question",
      "copied": "URL copied!",
      "copy": "Copy flyer URL",
      "download": "Download flyer",
      "open": "Open flyer",
      "requestFlyer": "Request flyer",
      "sendSMS": "Send SMS",
      "subscribed": "Subscribed to weekly digest",
      "unsubscribed": "Unsubscribed to weekly digest"
    },
    "AssetAvailability": {
      "availableSpace": "Available space",
      "spaces": "spaces"
    },
    "AssetCharges": {
      "allIn": "Service charges and taxes included",
      "rate": "est. Tax rate",
      "sell": "Selling price",
      "service": "est. Service charges"
    },
    "AssetCreateModal": {
      "autoGenerateFlyer": "Automatically generate a Flyer for this asset",
      "description": "Fill in basic information on new asset here. You can fill in more details later. ",
      "title": "Add asset"
    },
    "AssetDeals": {
      "actions": {
        "dropped": "Dropped out",
        "edit": "Edit",
        "exclude": "Exclude from report",
        "include": "Include in report",
        "not_dropped": "Not dropped out",
        "not_viewed": "Mark as not viewed",
        "viewed": "Mark as viewed"
      },
      "groups": {
        "active": "Active",
        "dead": "Dead deals",
        "prospects": "Prospects"
      },
      "nonProspectCommentMissing": "Comments / next steps are required for export"
    },
    "AssetFilter": {
      "budget": "Budget",
      "region": "Region",
      "status": "Status",
      "type": "Type"
    },
    "AssetHeader": {
      "deals": "Enquiry Pipeline",
      "export": {
        "btn": "Export",
        "disabled": "Export not possible. Missing input on: comments / next steps",
        "notification": {
          "message": "You will receive an email shortly",
          "title": "Your letting report is being exported"
        }
      },
      "tabs": {
        "access": "Access",
        "announcements": "Announcements",
        "assetDeals": "Letting Report",
        "contacts": "Contacts",
        "files": "Photos & Files",
        "floorplan": "Floorplans",
        "infosheet": "Proforma",
        "settings": "Settings",
        "spaces": "Spaces"
      }
    },
    "AssetIncentives": {
      "active": "Active",
      "emptyMessage": {
        "active": "Drag and drop your <strong>active</strong> incentives here",
        "inactive": "Drag and drop your <strong>inactive</strong> incentives here"
      },
      "inactive": "Inactive",
      "info": "Need a new incentive template? You can create more incentive templates in your <a href=\"/settings/templates/incentives\">global settings</a>."
    },
    "AssetInfoModal": {
      "btn": "Ask a question",
      "header": "Question about %{asset}",
      "questionPlaceholder": "Ask your question..",
      "topic": "Related to",
      "topics": {
        "another": "Other",
        "commissions": "Fee and commissions",
        "service": "Service charges",
        "viewing": "Viewing enquiry"
      }
    },
    "AssetInformation": {
      "incentives": "Incentives",
      "title": "Fee and commissions",
      "tos": "Terms of service"
    },
    "AssetLeadAddress": {
      "title": "Address Details"
    },
    "AssetLeadContacts": {
      "title": "Contacts"
    },
    "AssetLeadCreateForm": {
      "address": "Street and number",
      "assetLead": "Acquisition"
    },
    "AssetLeadDetails": {
      "description": "Additional information",
      "title": "Acquisition Details"
    },
    "AssetLeadHeader": {
      "collaborators": {
        "title": "Collaborators"
      },
      "days_active_from_now": "Active for %{days}",
      "pointPerson": {
        "dropdownHeader": "Select Point Person",
        "title": "Point Person"
      },
      "reopen": "Re-open this lead?",
      "status": {
        "days_active_from_now": "Active for %{days} ",
        "number_of_days_active": "Active for %{days} days",
        "title": "Status"
      },
      "title": "Acquisition Lead"
    },
    "AssetLeadModal": {
      "title": "Create acquisition lead"
    },
    "AssetLeadStatusMessage": {
      "disregarded": "disregarded",
      "executed": "executed",
      "message": "The acquisition lead has been <strong>%{status}</strong> by %{actor} on %{date}",
      "message_no_actor": "The acquisition lead has been <strong>%{status}</strong> on %{date}"
    },
    "AssetLeadsList": {
      "emptyStage": "No acquisition found in the current stage"
    },
    "AssetNavigator": {
      "disclaimer": "The listing and any and all information contained in the said document is strictly confidential and you are not authorised to disclose, use, disseminate or transmit,nor shall you permit to procure the disclosure, use, dissemination or transmittal (other than your disclosure to prospective tenants for our benefit), by whatever means to any party, the listing and any or all information contained therein, in whole or in part, except with the prior consent in writing to us.",
      "filter": "Filter",
      "loading": "Loading...",
      "noAssets": "Your search query did not return any result.",
      "searchPlaceholder": "Search.."
    },
    "AssetNavigatorHeader": {
      "collapse": "Collapse all",
      "display": "Display",
      "expand": "Expand all",
      "placeholder": "Search.."
    },
    "AssetOnMarket": {
      "onMarket": "on-market"
    },
    "AssetSettings": {
      "access": "Access",
      "actions": {
        "menuTitle": "Actions",
        "portfolio": {
          "dropdownTitle": "Move to",
          "information": "When you move this asset to another portfolio, <strong>all enquiries</strong> with an association to that asset in the current portfolio will be moved to the new portfolio too.",
          "menuTitle": "Change portfolio",
          "title": "Change portfolio"
        }
      },
      "assetUsers": {
        "cancel_invite": "Cancel invitation",
        "invitationPending": "Invitation pending",
        "inviteBtn": "Invite",
        "menuTitle": "Collaborators\n",
        "none": {
          "fully_let": "Your asset is <strong>fully let</strong>. <a href=\"/assets/%{id}/settings/access/status\">Change its status</a> to invite collaborators.",
          "invite": "You have <strong>no collaborators</strong> yet. ",
          "private": "Your asset is <strong>private</strong>. <a href=\"/assets/%{id}/settings/access/status\">Change its status</a> to invite collaborators.",
          "public": "You have <strong>no collaborators</strong> yet. ",
          "sold": "Your asset is <strong>sold</strong>. <a href=\"/assets/%{id}/settings/access/status\">Change its status</a> to invite collaborators."
        },
        "resend_invite": "Resend invitation",
        "revoke": "Revoke access",
        "revoke_company": "Revoke access team"
      },
      "costs": {
        "allIn": "Service charges and taxes included",
        "menuTitle": "General",
        "rentPrice": "Rent price",
        "sellPrice": "Sale price",
        "sellingTitle": "Sale price",
        "serviceTitle": "Service charges",
        "taxTitle": "Tax rate"
      },
      "fees": "Fees",
      "financial": "Financial",
      "flyerSettings": {
        "autogenerateFlyer": "Auto-generate flyer for this asset",
        "description": "Enabling <strong>auto-generate</strong> for flyers will create a flyer and keep it up-to-date. This means whenever you add or update a space, picture, floor plan, ... we will automatically generate a new flyer for you.",
        "title": "Flyer Settings"
      },
      "general": "General",
      "incentives": "Incentives",
      "options": {
        "delete": {
          "confirm": "Are you sure you want to remove this asset? This is irreversible!",
          "information": "If you wish to provide your agents more information on why the asset was deleted, you can add <a href=%{link}>an announcement</a> or select a reason below.",
          "menuTitle": "Delete asset",
          "reason": "Reason for deleting",
          "title": "Delete asset from portfolio",
          "warning": "Removing this asset will remove all its data and is <strong>irreversible</strong>. <br/> After deleting, your team members and agents will be notified in next weeks digest. Afterwards, they will no longer have access and the asset will be <strong>permanently</strong> removed."
        },
        "menuTitle": "Options"
      },
      "status": {
        "description": "Updating the status of the asset will impact the way it is marketed on Rialto:",
        "descriptionFullyLet": "When set <strong>fully let</strong>, your asset can only be accessed by you and your team",
        "descriptionInvite": "When marketed as <strong>invite-only</strong>, you decide which collaborators to invite",
        "descriptionPrivate": "When set <strong>private</strong>, your asset can only be accessed by you and your team",
        "descriptionPublic": "When marketed as <strong>free-fight</strong>, it can be accessed by all agents that were granted access to this portfolio.",
        "dropdownTitle": "Status",
        "menuTitle": "Status",
        "public_to_invite": "Are you sure you wish to change the status to Invite-only? All collaborators will be removed access.",
        "public_to_private": "Are you sure you wish to change the status to private? All previously invited collaborators will have their access revoked.",
        "title": "Update Status"
      },
      "tos": "Terms of service",
      "tosExtraInfo": "Select the terms of service below to inform your collaborators about terms and conditions applying to this asset.",
      "tosInfo": "Need a new terms of service template? You can create more terms of service templates in your <a href=\"/settings/templates/tos\">global settings</a>."
    },
    "AssetShareStatus": {
      "Tooltips": {
        "body_fully_let": "This asset is fully let",
        "body_invite": "List of collaborators this asset is shared with.",
        "body_private": "This asset is private to you and your team.",
        "body_public": "This asset is publicly shared with all agents that were granted access to this portfolio.",
        "footer_invite": {
          "one": "and %{count} more",
          "other": "and %{count} more"
        },
        "header_invite": "Shared with"
      }
    },
    "AssetSort": {
      "name": "Name",
      "on_market": "Available space",
      "order_by": "Order by",
      "updated_at": "Last update"
    },
    "AssetStatistics": {
      "available": "Available now",
      "deals": "Enquiries",
      "onMarket": "On-market",
      "total": "Total",
      "viewings": "Viewings"
    },
    "AssetTermsOfService": {
      "info": "Need a new incentive template? You can create more incentive templates in your <a href=\"/settings/incentives\">global settings</a>."
    },
    "Backbutton": {
      "back": "Back"
    },
    "BrokerInviteForm": {
      "broker": "Collaborator",
      "invite": "Invite",
      "inviting": "Inviting..",
      "portfolioAssets": "Portfolio & assets"
    },
    "BrokerInviteModal": {
      "description": "If you invite a collaborator, you will grant the company of the collaborator access to the leasing availabilities of the assets you select, including marketing material and documents. You don't share any of the enquiries created by you or by a collaborator with this company. The collaborator will be subscribed in real-time to any asset updates, and can share enquiries with you.",
      "title": "Invite Collaborator"
    },
    "Calendar": {
      "call": "Call",
      "day": "Day",
      "download": "Subscribe",
      "due_proposal": "Proposal due date",
      "lease_expiration": "Lease expiry",
      "lease_start": "Lease commencement",
      "month": "Month",
      "space_available": "Space available",
      "today": "Today",
      "viewing": "Viewing",
      "week": "Week"
    },
    "Channels": {
      "category": "Category",
      "company": "Company",
      "confirm": {
        "delete": "Are you sure you want to delete?"
      },
      "name": "First and last name",
      "phone": "Phone",
      "title": "Originators"
    },
    "Commissions": {
      "durationLabel": "Contract Duration",
      "feeLabel": "Commission",
      "header": "Commissions",
      "info": "The commission percentage is related to the contract duration, <strong>they are linked as following</strong>:",
      "year": "yr"
    },
    "CompanyBlock": {
      "newPortfolio": "New portfolio",
      "visitCompanyPage": "Company Profile"
    },
    "CompanyPage": {
      "Contact": {
        "email": "Email us",
        "phone": "Call us"
      },
      "Login": {
        "footer": "Don't have one?",
        "header": "Have a Rialto account?",
        "login": "Login to Rialto",
        "requestAccess": "Request access"
      },
      "NotFound": {
        "message": "We could not find a matching company for this url",
        "title": "This page is not available"
      },
      "contacts": "Contacts",
      "features": "Features",
      "incentives": "Incentives",
      "introduce": "Introduce client",
      "portfolios": "Portfolios",
      "tos": "Terms of service"
    },
    "CompanyTooltip": {
      "inCountry": "in %{value}",
      "numberOfAssets": "%{smart_count} asset |||| %{smart_count} assets",
      "viewCompanyProfile": "View company profile"
    },
    "Dashboard": {
      "empty": "There is no dashboard for this portfolio"
    },
    "DateTime": {
      "add_date": "Please choose a date",
      "add_time": "Add time?",
      "select_date": "Select date",
      "set": "Set",
      "submit": "Set",
      "time": "Time",
      "title": "Select date"
    },
    "DealActions": {
      "delete": {
        "confirm": "Are you sure you want to permanently delete this enquiry? Comments on this deal will also be removed.",
        "tooltip": "Delete"
      },
      "duplicate": {
        "tooltip": "Duplicate"
      },
      "merge": {
        "tooltip": "Merge"
      }
    },
    "DealCancel": {
      "cancelDate": "Date of termination",
      "confirm": "Confirm",
      "confirming": "Confirming...",
      "feedback": "Feedback",
      "feedbackInfo": "Your feedback will be displayed to anyone with access to this enquiry.",
      "feedbackPlaceholder": "Enter your feedback here",
      "moveDate": "Move date",
      "reason": "Reason",
      "title": "Cancel lease"
    },
    "DealCard": {
      "nbAssets": "%{smart_count} assets"
    },
    "DealColumns": {
      "title": "Customize columns"
    },
    "DealDetail": {
      "confirmDelete": "Are you sure you want to permanently delete this enquiry? Comments on this deal will also be removed."
    },
    "DealDetails": {
      "budget": {
        "separator": "to",
        "title": "Budget"
      },
      "description": "Additional information",
      "location": {
        "title": "Location"
      },
      "spaces": {
        "archive": "Archive",
        "car_parking": "Outdoor Parking",
        "category": "Category",
        "covered_car_parking": "Covered Car Parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Land",
        "leisure": "Leisure",
        "logistical": "Logistical",
        "meeting": "Meeting / Conference",
        "new": "New",
        "office": "Office",
        "other_cat": "Other",
        "outdoor_area": "Outdoor area",
        "residential": "Residential",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Warehouse",
        "title": "Spaces"
      },
      "start_date": {
        "title": "Start date"
      },
      "term": {
        "months": "month(s)",
        "title": "Max term",
        "years": "year(s)"
      },
      "title": "Enquiry Details",
      "type": "Key Drivers",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "desks"
      }
    },
    "DealFilter": {
      "advanced": "Advanced filters",
      "asset": "Asset",
      "selectedAsset": "%{nb} selected"
    },
    "DealForm": {
      "assets": {
        "info": "For each asset you select, a separate enquiry will be created. Mind the privacy settings on the bottom left before adding.",
        "title": "Asset |||| Assets"
      },
      "channel": {
        "expand": "Add <strong>originator</strong> details",
        "title": "Originator"
      },
      "description": {
        "disclose": "<strong>Add additional information</strong>",
        "placeholder": "Enter comment here",
        "title": "Additional information"
      },
      "details": {
        "title": "Enquiry"
      },
      "enquiry": {
        "title": ""
      },
      "placeholders": {
        "asset": "Associate asset(s) (optional)",
        "assets": "Associate asset (optional)"
      },
      "portfolio": {
        "title": "Portfolio"
      },
      "save": "Add enquiry",
      "saving": "Adding enquiry..",
      "stage": "Stage",
      "tenant": {
        "title": "Tenant",
        "undisclose": "<strong>Do not</strong> disclose the tenant details"
      }
    },
    "DealMerge": {
      "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui sint asperiores maiores eaque voluptatum mollitia eum architecto, neque possimus hic corporis aliquid aut est tempore voluptates iste harum enim iusto rerum blanditiis magni aliquam. Vero maxime qui quis explicabo eum excepturi asperiores rerum eos veritatis, reprehenderit voluptatem possimus aliquam incidunt!",
      "source": "Merge",
      "target": "Into",
      "title": "Merge Enquiry"
    },
    "DealModal": {
      "header": "Add new enquiry"
    },
    "Deals": {
      "portfolio_subscribed": "Subscribed to weekly digest",
      "portfolio_unsubscribed": "Unsubscribed to weekly digest"
    },
    "DealsFilter": {
      "asset": "Asset",
      "channel": "Originator",
      "searchPlaceholder": "Search..",
      "stage": "Stage"
    },
    "DealsTable": {
      "empty": "No enquiries found",
      "empty_stage": "No enquiries found in the current stage",
      "export": {
        "btnLabel": "Export",
        "csv": "A CSV version of the interest schedule that allows for editing.",
        "pdf": "A PDF version of the interest schedule with all activity per asset.",
        "title": "Interest Schedule"
      },
      "loading": "Loading..."
    },
    "Dialog": {
      "confirm": "Confirm",
      "title": "Are you sure?"
    },
    "DisregardModal": {
      "disregard": "Disregard",
      "disregarding": "Disregarding..",
      "feedbackInfo": "Your feedback will be displayed to anyone with access to this enquiry.",
      "feedbackPlaceholder": "Enter your feedback here",
      "header": "Disregard this Enquiry",
      "outcome": "Outcome",
      "reason": "Reason"
    },
    "DropdownUserItem": {
      "me": "me"
    },
    "DropdownUserSelect": {
      "pointPerson": "Point person"
    },
    "Dropzone": {
      "notSupported": "The file type you uploaded is not supported",
      "placeholder": "Click or drag here to upload file",
      "placeholderPicture": "Click or drag here to upload an image"
    },
    "EnquiryDetails": {
      "budget": {
        "title": ""
      },
      "title": ""
    },
    "EnquiryHeader": {
      "DealStages": {
        "hide": "Hide",
        "modal": {
          "body": "Here you can edit what assets are in the running for %{stage}. When editing, the asset will be disregarded for this deal.",
          "title": "Edit Assets in %{stage}"
        },
        "show": "View %{smart_count} more"
      },
      "assignAsset": "Associate asset",
      "assignFeePotential": "Add opportunity value",
      "collaborators": {
        "title": "Collaborators"
      },
      "confirm": {
        "assetRemove": "This enquiry may have one or more spaces from %{asset} associated. This association will be removed when deleting the asset. Are you sure you want to proceed?",
        "assetUpdate": "This enquiry may have one or more spaces from %{asset} associated. This association will be removed when updating the asset. Are you sure you want to proceed?",
        "cancel": "Are you sure you want cancel? All changes will be lost",
        "feePotentialRemove": "Are you sure you wish to remove the value for this enquiry?"
      },
      "duplicate": "Duplicate for renewal",
      "feePotential": "Opportunity value",
      "modal": {
        "header": "Custom share settings",
        "info": "Any partner added here will be able to see and update this enquiry. We don’t notify them when you choose to no longer share the enquiry with them.",
        "save": "Save changes",
        "search_collaborators": "Search collaborators",
        "title": "Collaborators with access to the enquiry"
      },
      "point_person": {
        "dropdown_header": "Select Point Person",
        "title": "Point Person"
      },
      "renew": "Duplicate for renewal",
      "reopen": "Re-open this enquiry?",
      "status": {
        "days_active_from_now": "Active for %{days} ",
        "number_of_days_active": "Active for %{days} days",
        "title": "Status"
      },
      "subscribed": "Subscribed",
      "title": "Enquiry",
      "unsubscribed": "Unsubscribed"
    },
    "EnquiryModal": {
      "addEnquiry": "Add enquiry",
      "addingEnquiry": "Adding enquiry..",
      "assets": {
        "title_pl": "Assets",
        "title_sg": "Asset"
      },
      "channel": {
        "category": "Type",
        "company": "Company",
        "email": "Email",
        "name": "Name",
        "title": "Originator"
      },
      "collapse_channel_details": "Collapse <strong>originator</strong> details",
      "collapse_comment_details": "<strong>Collapse notes</strong> to post upon creation",
      "collapse_tenant_details": "<strong>Collapse tenant</strong> and/or originator details",
      "comment": {
        "placeholder": "Enter comment here",
        "title": "Add Update"
      },
      "confirm": {
        "cancel": "Are you sure you want cancel? All changes will be lost."
      },
      "enquiry": {
        "name": "Name",
        "title": "Enquiry"
      },
      "expand_channel_details": "Add <strong>originator</strong> details",
      "expand_comment_details": "<strong>Add note</strong> to post upon creation",
      "expand_tenant_details": "<strong>Add tenant</strong> and/or originator details",
      "header": "Add new enquiry",
      "headerRenewal": "Duplicate for renewal",
      "industry": {
        "art_culture": "Art & culture",
        "automobile": "Automotive",
        "aviation": "Aviation & Travel",
        "banks": "Banks",
        "basic_resources": "Basic Resources",
        "chemicals": "Chemicals",
        "construction": "Construction & Materials",
        "consumer_electronics": "Consumer Electronics",
        "education": "Education",
        "education_art": "Education & Art",
        "entertainment_gaming": "Entertainment & gaming",
        "financial_services": "Financial",
        "food": "FMCG - Food & Drink",
        "healthcare": "Pharmaceutical & health care",
        "household_goods": "Personal & Household Goods",
        "industrial_goods": "Industrial Goods & Services",
        "insurance": "Insurance",
        "legal": "Legal",
        "luxury": "Fashion, décor & luxury",
        "media": "Media",
        "oil_gas": "Oil & Gas",
        "other_cat": "Other",
        "professional_services": "Professional services",
        "public": "Public Sector",
        "real_estate": "Real Estate",
        "retail": "Retail",
        "sports_leisure": "Sports & Leisure",
        "technology": "Technology",
        "telecommunications": "Telecommunications",
        "title": "Industry",
        "travel": "Travel & Leisure",
        "utilities": "Utilities",
        "wellbeing": "Wellbeing"
      },
      "info": "For each asset you select, a separate enquiry will be created. Mind the privacy settings on the bottom left before adding.",
      "portfolio": {
        "title": "Portfolio"
      },
      "size": {
        "separator": "to",
        "title": "Size"
      },
      "start_date": {
        "title": "Start date"
      },
      "tenant": {
        "company": "Company",
        "email": "Email address",
        "industry": "Industry",
        "name": "First and last name",
        "title": "Tenant"
      },
      "tenantRepresentative": {
        "company": "Company",
        "email": "Email address",
        "name": "First and last name",
        "title": "Tenant Representative"
      },
      "undiscloseTenantBroker": "<strong>Do not</strong> disclose the tenant details",
      "undiscloseTenantOwner": "Tenant details <strong>not disclosed</strong>",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "units"
      }
    },
    "EnquiryStatusMessage": {
      "advisedBy": "Advised by",
      "commencement": "<strong>Commencement</strong> on",
      "disregarded": "disregarded",
      "executed": "executed",
      "expiring": "<strong>Expiring</strong> on",
      "leaseBreak": "<strong>First break</strong> on",
      "message": "The enquiry has been <strong>%{status}</strong> by %{actor}",
      "message_no_actor": "The enquiry has been <strong>%{status}</strong>",
      "renewal": "Duplicate for renewal",
      "renewalPeriod": "<strong>Renewal</strong> each",
      "reopen": "Re-open this enquiry?",
      "size": {
        "of": "of"
      },
      "yearlyRent": {
        "for": "for",
        "message": "Total yearly rent is"
      }
    },
    "ErrorBoundary": {
      "back": "Go back",
      "message": "Our team has been notified and will implement a fix as soon as possible. <br />\nWe will get back to you when the issue got resolved.",
      "title": "Oops, something went wrong.."
    },
    "ExecuteModal": {
      "channels": "Eligible for success fee",
      "execute": "Execute",
      "executing": "Executing..",
      "header": "Execute this enquiry",
      "info": "The details of the executed lease will be available in the executed enquiries section and will remain available to you and optionally your invited brokers on this enquiry.",
      "involvedSpaces": "Spaces leased",
      "leasingAgent": "Leasing agent",
      "offered": "sent",
      "reasonForMoving": "Reason",
      "received": "received",
      "tenant": "Tenant name"
    },
    "ExportActions": {
      "assetLeads": {
        "title": "Acquisition",
        "xls": "A XLS export."
      },
      "assets": {
        "csv": "A CSV export after filter.",
        "pdf": "A PDF export, after filter.",
        "title": "Assets and Spaces",
        "xls": "A XLS export after filter."
      },
      "btnLabel": "Export",
      "deals": {
        "csv": "A CSV version of the interest schedule that allows for editing.",
        "pdf": "A PDF version of the interest schedule with all activity per asset.",
        "title": "Interest Schedule",
        "xls": "A XLS version of the interest schedule that allows for editing."
      },
      "portfolioAssets": {
        "pdf": "A PDF with all assets in this portfolio (after filter).",
        "title": "Portfolio",
        "xls": "A XLS version of this portfolio (after filter)."
      }
    },
    "FileManager": {
      "empty": "You have not uploaded any pictures or files yet.",
      "files": "Documents",
      "filesSelected": "%{value} files selected",
      "header": "Use as flyer header",
      "pictures": "Pictures",
      "private": "Do not show on flyer",
      "searchPlaceholder": "(name, kind, tag, ..)",
      "thumbnail": "Use as asset thumbnail",
      "uploaded": "Added"
    },
    "Floorplans": {
      "actions": "Space actions",
      "addSpace": "Associate space",
      "availability": "Availability",
      "clearLines": "Clear lines",
      "clickToLink": "Click to link space",
      "createFloorplan": "Create new floorplan",
      "deleteConfirm": "Are you sure you want to delete this floorplan?",
      "deleteFloorplan": "Delete floorplan",
      "duplicate": "Duplicate",
      "editSpace": "Edit space ",
      "file": "File",
      "floor": "Floor",
      "floorPlaceholder": "Floor name",
      "floorSelector": "Floor selector",
      "information": "<h3>Zoom the floorplan</h3>\n<p>Hold CTRL or CMD and scroll to zoom the image of the floorplan</p>\n\n<h3>Move the floorplan</h3>\n<p>Hold CTRL or CMD, click and move the mouse to move the image of the floorplan</p>\n\n<h3>Draw on the floorplan</h3>\n<p>Click on the image of the floorplan to draw a line. Once you finish drawing, you can link the drawn space with a space on the asset</p>\n\n<h3>Link a space on the asset</h3>\n<p>Click on a drawn space to link it with a space on the asset</p>\n\n<h3>Move a drawn space on the floorplan</h3>\n<p>Click on a drawn space and move the mouse to move the drawn space</p>\n\n<h3>Duplicate a drawn space</h3>\n<p>Click on a drawn space, then on the edit icon and finally on the duplicate button to create an identical copy of the selected drawn space</p>",
      "informationTitle": "Info about floorplans",
      "leaseHolder": "Leaseholder",
      "none": "No floorplans available",
      "pricing": "Pricing",
      "scroll": "Hold %{key} to zoom and pan the image.",
      "size": "Size",
      "startDragging": "Start dragging",
      "status": "Status",
      "stopDragging": "Stop dragging",
      "uploadFloorplan": "Upload floorplan"
    },
    "Flyer": {
      "NotFound": {
        "message": "We are sorry, but this flyer is no longer available. <br>\nYou can visit the <a href=\"https://www.rial.to/app\">Rialto platform</a>, or <a href=\"mailto:dgtqwgb3@incoming.intercom-mail.com\">contact us</a>.",
        "title": "Flyer is no longer available"
      },
      "ServiceRate": {
        "allIn": "Service charges and taxes included",
        "rate": "est. tax rate",
        "service": "est. service charges"
      },
      "contact": "Contact us",
      "facilities": {
        "categories": {
          "fire_safety": "Fire safety",
          "general": "General",
          "other_cat": "Other",
          "security": "Security"
        },
        "title": "Facilities"
      },
      "location": "Location",
      "marketing": "Marketing Package"
    },
    "FlyerContactModal": {
      "info": "Your question will be sent to the contact person of this asset",
      "question": "Enter your question here",
      "successBody": "The contact person will reply asap",
      "successTitle": "Message delivered",
      "title": "Ask a question"
    },
    "ForgotPasswordModal": {
      "header": "Forgot password",
      "info": "Fill in your email address that you are using on rial.to and check your email inbox for further instructions on resetting your password."
    },
    "FormButton": {
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "save": "Save changes"
    },
    "GmailAuth": {
      "body": "Quickly identify leads from your email inbox on Rialto and directly convert them to an enquiry. Rialto will recognise LeadDADI and this way help you seamlessly track broker introductions. Click the button below to connect.",
      "title": "Connect your email account to Rialto"
    },
    "Inbox": {
      "convertDeal": "Convert to enquiry",
      "fetching": "Fetching mails..",
      "noSelection": "No email selected"
    },
    "Incentive": {
      "fee": "<strong>%{fee}</strong> commission will be granted",
      "minSize": "at a minimum of",
      "months": "months",
      "sprinter": "At closing maximum <strong>%{duration} month(s)</strong> after <strong> %{stage}</strong>.",
      "termAfter": "after %{date}",
      "termBefore": "before %{date}"
    },
    "IncentiveCard": {
      "commissionFixed": "%{value} %{currency} when %{type} a tenant.",
      "commissionPercentage": "%{value} when %{type} a tenant.",
      "commissionPeriod": "%{value} %{period} when %{type} a tenant.",
      "conditionsSize": "Contract size > %{value} %{unit}",
      "conditionsTerm": "Contract length > %{value} %{period}",
      "payoutLinked": "Recurring payment in sync with rent payments for max. %{value} %{period} rent",
      "payoutRecurring": "Recurring payment every %{recurrenceValue} %{recurrencePeriod} for max. %{value} %{period} rent",
      "payoutUpfront": "Upfront payment over %{value} %{period} rent",
      "type": {
        "expansion": "expanding",
        "new": "signing",
        "reduction": "reducing",
        "renegotiation": "renegotiating",
        "renewal": "renewing"
      }
    },
    "IncentiveForm": {
      "addIncentive": "Add incentive",
      "autoAssign": "Show on company page and auto-assign to public assets",
      "conditionTypes": {
        "conditions": "Conditions",
        "endDate": "End date",
        "minSize": "Mininum size",
        "term": "Term"
      },
      "deleteAutoassignConfirm": "Are you sure you want to delete this incentive? This incentive was auto-assigned to the company page and assets with public status. After deleting the incentive, it will no longer be shown.",
      "deleteConfirm": "Are you sure you want to delete this incentive?",
      "deleteSuccess": "Incentive deleted successfully!",
      "description": "Description",
      "editIncentive": "Edit incentive",
      "feeTypes": {
        "fees": "Fee",
        "fixedFee": "Fixed",
        "monthsFee": "Months",
        "percentageFee": "Percentage"
      },
      "payout": "Payout",
      "payoutLinked": "In sync with rent payments",
      "payoutTypes": {
        "payoutPeriod": "Upfront",
        "payoutRecurrence": "Recurring"
      },
      "rentPeriod": "Rent Period",
      "title": "Title",
      "type": "Type"
    },
    "IntegrationStatus": {
      "officernd": "OfficeR&D",
      "syncedAt": "Last synced with <strong>%{integration}</strong> at <strong>%{date}</strong>",
      "syncedFrom": "Synced with <strong>%{integration}</strong>"
    },
    "Intro": {
      "addButton": "<h3>Add enquiry, asset or collaborator </h3>\nYou can add a new enquiry, asset or collaborator by clicking here.",
      "addButtonBroker": "<h3>Add enquiry or draft contract</h3>\nYou can add a new enquiry or proposal here.",
      "assetActions": "<h3>Asset actions</h3>\nWith these actions you can email (un)subscribe to an asset and view the flyer when present.",
      "assetExport": "<h3>Export</h3>\nClick here to export the filtered list of assets and spaces in the current portfolio as CSV or PDF.",
      "assetFilter": "<h3>Asset filter</h3>\nHere you can search the current portfolio for spaces and assets that meet your criteria.",
      "assetInfo": "<h3>Asset info</h3>\nBy hovering and / or clicking these icons, you can get more information about sharing settings, commissions as well as service charges and taxes of the asset.",
      "assetList": "<h3>Assets</h3>\nHere you can see an overview of all assets in this portfolio.",
      "associateAsset": "<h3>Associate asset</h3>\nAfter associating an asset to this enquiry, you will find this enquiry by filtering on the navigator. Also, you'll be able to associate spaces to this enquiry and/or make proposals for spaces on this asset.",
      "channelDetails": "<h3>Associate originator</h3>\nSpecify more information about the origin of this enquiry.",
      "dealDetail": "<h3>Enquiry detail</h3>\nOpen an enquiry in the list to find more details, share an update, add tenant details, etc.",
      "dealDetails": "<h3>Specify requirements</h3>\nDefine detailed requirements the tenant has.",
      "dealExport": "<h3>Export</h3>\nClick here to export your enquiries in the current portfolio as CSV or PDF.",
      "dealToggleView": "<h3>Toggle view</h3>\nClick here to toggle between a table view or a drag-and-drop column view or select custom table columns. ",
      "deals": "<h3>Deals</h3>Browse here to access the enquiries on this portfolio.",
      "dealsList": "<h3>Enquiries</h3>\nHere you can see an overview of all your active enquiries in this portfolio. In the filter bar you can switch between different statuses.",
      "done": "Done",
      "expandAsset": "<h3>View spaces</h3>\nClick here to see the list of spaces for this asset.",
      "intercom": "<h3>Help</h3>\nYou have reached the end of the tour. If you have questions at any point whilst using our platform, do not hesitate to ask us a question by clicking this button. We will get back to you as soon as possible.",
      "next": "Got it",
      "previous": "Previous",
      "settings": "<h3>Settings</h3>\nHere you can find all of your settings (language preferences, notification settings, team management etc.), as well as an easy logout.",
      "skip": "Skip",
      "subscribeAsset": "<h3>Subscribe to asset</h3>\nClick here to subscribe to asset and get weekly updates in your mailbox.",
      "switchPortfolio": "<h3>Switch portfolios</h3>\nHere you can switch between all portfolios available to you as well as search all portfolios in one view.",
      "tenantDetails": "<h3> Specify tenant details </h3>\nSave key company details of the tenant.",
      "welcome": "<h3>Welcome to Rialto!</h3>\nThis tour will guide you through the main features of our platform. This will take max. three minutes of your time and gives you a quick head-start.\nYou can skip tour at any point by clicking the 'skip' button."
    },
    "LinkedinOauthCallback": {
      "errorBody": "Sign in with email and password instead",
      "errorTitle": "LinkedIn user unknown"
    },
    "LoginForm": {
      "emailPlaceholder": "Enter email",
      "forgotPassword": "Forgot?",
      "linkedin_signin": "Sign in with LinkedIn",
      "loggingIn": "Signing in..",
      "login": "Sign in",
      "passwordPlaceholder": "Enter password",
      "register": "Don't have an account? "
    },
    "Modal": {
      "comment": {
        "collapse": "<strong>Collapse comment</strong> to post upon creation",
        "expand": "<strong>Add comment</strong> to post upon creation",
        "placeholder": "Enter comment here",
        "title": "Comment"
      }
    },
    "Navbar": {
      "back": "Back",
      "dashboard": {
        "deal": "Deal dashboard",
        "marketing": "Marketing dashboard"
      },
      "help": "Ask for help",
      "settings": "Settings",
      "sign_out": "Sign out"
    },
    "Ner": {
      "area": "Area and capacity",
      "costs": "Sum of costs",
      "free_rent_period": "Free rent period (in months)",
      "header": "Net Effective Rent",
      "price": "Prices (per month)",
      "term": "Term or renewal term (in months)",
      "title": "The <strong>Net Effective Rent</strong> gets calculated as follows:"
    },
    "Notes": {
      "alert": {
        "no_content": "Please add %{contentType} before saving!"
      },
      "call": {
        "alert_empty": "No empty calls",
        "btnLabel": "Select date",
        "placeholder": "Enter your call notes here",
        "title": "Choose date of call"
      },
      "confirm": {
        "cancel": "Are you sure you want to cancel? All your changes will be lost.",
        "delete": "Are you sure you want to delete?"
      },
      "email": {
        "alert_empty": "No empty emails",
        "btnLabel": "Select date",
        "code": "Post an email by FWD or BCC it to",
        "codeMobile": "FWD or BCC to",
        "copied": "URL copied!",
        "copy": "\nCopy to clipboard\n",
        "created_by": "Created by",
        "date_received": "Date received",
        "date_sent": "Date sent",
        "from": "from",
        "paste": "Copy/paste email content here",
        "placeholder": "Enter your call notes here",
        "received": "Received",
        "received_from": "Received from",
        "sent": "Sent",
        "sent_to": "Sent to",
        "title": "Choose date of email",
        "to": "to"
      },
      "file": {
        "comment": "Comment",
        "comment_placeholder": "Enter comment here (optional)",
        "download": "Download",
        "title": "Title",
        "title_placeholder": "Enter title here"
      },
      "no_contacts": "No contacts",
      "note": {
        "indicator": "Private"
      },
      "placeholder": "Enter your notes here",
      "private": "Only me",
      "proposal": {
        "dueDate": "Due date",
        "offered_by": "Offered by",
        "offering": "Offering",
        "received_by": "Received by",
        "receiving": "Receiving"
      },
      "public": "Public",
      "unknownUser": "Unknown",
      "update": {
        "placeholder": "Enter your update here"
      },
      "upload": "Upload file",
      "viewing": {
        "add": "Add to calendar",
        "btnLabel": "Select date",
        "placeholder": "Enter your viewing notes here",
        "scheduled_for": "Viewing scheduled for",
        "title": "Choose viewing date"
      }
    },
    "Notification": {
      "deal": {
        "create": {
          "body": "%{values}",
          "title": {
            "one": "New enquiry added!",
            "other": "New enquiries added!"
          }
        },
        "invite": {
          "body": "They now have access to enquiry %{values}.",
          "title": {
            "one": "Collaborators have been invited!",
            "other": ""
          }
        }
      },
      "flyer": {
        "create": {
          "body": "Flyer for %{values} updated!",
          "title": {
            "one": "Flyer updated!",
            "other": ""
          }
        },
        "error": {
          "body": "Please try again or contact support@rial.to",
          "title": {
            "one": "Flyer could not be generated!",
            "other": ""
          }
        }
      },
      "user": {
        "invitation_accepted": {
          "body": "%{values} has accepted your invite and is now on Rialto!",
          "title": {
            "one": "Invitation accepted!",
            "other": ""
          }
        }
      }
    },
    "Pagination": {
      "next": "next",
      "previous": "previous"
    },
    "PortfolioActions": {
      "addAsset": "Asset",
      "addAssetLead": "Acquisition",
      "addBroker": "Collaborator",
      "addDeal": "Enquiry",
      "addProposal": "Proposal",
      "addSpace": "Space",
      "btnLabel": "Add"
    },
    "PortfolioBlock": {
      "edit": "Edit portfolio",
      "requestAccess": "Request access",
      "requestPending": "Request pending.."
    },
    "PortfolioDeleteModal": {
      "confirmDelete": "Are you sure you want to remove %{portfolio}? All associated assets and enquiries will be deleted.",
      "confirmTransfer": "Are you sure you want to remove %{portfolio}? All associated assets and enquiries will be transferred to %{transferPortfolio}.",
      "header": "Delete Portfolio",
      "noPortfolios": "No portfolios to transfer to",
      "transfer": "Transfer to",
      "warning": "When deleting a portfolio, you can choose to transfer your assets, enquires and subscription preferences to another portfolio. </br> </br> If you choose not to, <strong>all data</strong> that is associated with this portfolio will be <strong>permanently</strong> deleted.</br>"
    },
    "PortfolioFilter": {
      "portfolios": "Portfolios",
      "selected": "selected"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "",
        "deal": ""
      },
      "export": {
        "assets": {
          "csv": "A CSV version of this portfolio.",
          "pdf": "A PDF with all assets in this portfolio.",
          "title": "Portfolio"
        },
        "btnLabel": "Export",
        "deals": {
          "csv": "A CSV version of the interest schedule that allows for editing.",
          "pdf": "A PDF version of the interest schedule with all activity per asset.",
          "title": "Interest Schedule"
        }
      },
      "tabs": {
        "asset_leads": "Acquisition",
        "assets": "Assets",
        "dashboard": "Dashboard",
        "deals": "Enquiries"
      }
    },
    "PortfolioInfo": {
      "companiesSelected": "%{value} companies selected",
      "portfoliosSelected": "%{value} portfolios selected"
    },
    "PortfolioModal": {
      "delete": "Delete portfolio",
      "nameLabel": "Name",
      "statsUnitLabel": "Stats unit",
      "titleAdd": "Add new Portfolio",
      "titleEdit": "Edit Portfolio",
      "typeLabel": "Type"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "assets": "assets",
      "available": "available",
      "availableSpace": "Available Now",
      "deals": "Enquiries",
      "onMarket": "on-market",
      "rentableArea": "Total"
    },
    "Proposal": {
      "accepted": "Proposal",
      "addPrice": "add price",
      "addSpace": "+ add another space",
      "asset": "Asset",
      "billingPeriod": "Billing period",
      "breakDates": "Lease break term",
      "breakTerm": "First break after",
      "channelFee": "Broker ",
      "commencementDate": "LCD",
      "contractLength": "Contract Length Details",
      "costs": "Costs",
      "deposit": "Rent guarantee",
      "dueDate": "Valid until",
      "expirationDate": "LXD",
      "firstRefusalRight": "Apply right of first refusal",
      "legalFee": "Legal fees",
      "movingAllowance": "Moving allowance",
      "negativeDiscount": "(%{percentage}% above list price)",
      "ner": "NER",
      "offeredBy": "Offered by",
      "offering": "Offering",
      "otherCosts": "Other cost",
      "placeholder": "Enter your notes here",
      "positiveDiscount": "(%{percentage}% discount)",
      "receivedBy": "Received by",
      "receiving": "Receiving",
      "renewalPeriod": "Renewal period",
      "rentFreePeriod": "Rent free period",
      "term": "Term",
      "terms": "Financial Terms",
      "tiAllowance": "TI allowance",
      "token": "Copy the URL below to share the proposal with your client"
    },
    "ProposalAcceptModal": {
      "accept": "Request",
      "accepting": "Requesting..",
      "commentPlaceholder": "Enter any comments here",
      "header": "Request draft contract"
    },
    "ProposalForm": {
      "deal": "Enquiry",
      "dealLabel": "Search for existing or create a new one by name"
    },
    "ProposalModal": {
      "title": "Add proposal"
    },
    "ProposalPage": {
      "accept": "Draft contract",
      "accepted": {
        "message": "Thanks for your request! %{name} got notified and will get in touch as soon as possible.",
        "title": "Contract draft requested!"
      },
      "proposalFor": "Proposal for",
      "proposalOn": "Proposal on %{date}"
    },
    "RegionFilter": {
      "apply": "Apply",
      "region": "Region",
      "tabs": {
        "region": "By Region"
      }
    },
    "ResetPassword": {
      "confirm_label": "Password confirmation",
      "confirm_placeholder": "Enter password confirmation",
      "current_label": "Current password",
      "current_placeholder": "Enter current password",
      "description": "Fill in all fields below to change your password.",
      "new_label": "New password",
      "new_placeholder": "Enter new password",
      "title": "Reset password"
    },
    "SearchBlock": {
      "landlordsTitle": "All portfolios",
      "searchPortfolios": "Search portfolios",
      "selectAll": "Select all",
      "title": "Search all assets",
      "unselectAll": "Unselect all"
    },
    "SeeMore": {
      "seeMore": "Show more"
    },
    "SelectAll": {
      "clear": "Clear",
      "selectAll": "Select all"
    },
    "Settings": {
      "Subscriptions": {
        "assetDigest": {
          "description": "Select which assets should be included in the email digest. Unselect all to unsubscribe completely.",
          "title": "Email on changed availabilities"
        },
        "dealDigest": {
          "description": "Select which portfolios should be included in the enquiry activity digest. Unselect all to unsubscribe completely.",
          "title": "Enquiry activity email digest"
        },
        "portfolio_deal": {
          "description": "You can select your preference for default subscription on NEW enquiries. Select the portfolios on which you want automatic enquiry subscriptions:",
          "title": "New enquiries"
        },
        "unsubscribeDeals": {
          "body": "Unsubscribe from real-time enquiry updates?",
          "unsubscribe": "Remove all existing enquiry subscriptions for portfolios to be unsubscribed"
        }
      },
      "company": {
        "billing": {
          "billingInfo": "We have not found any billing information linked to your account. It could be that either you are currently not on a paid plan, or we have made a mistake.",
          "contact": "Contact us to get set up",
          "manage": "Change settings",
          "subscriptions": "You are currently subscribed to:",
          "title": "Billing information and settings",
          "total": "Next billing amount will be %{total} (incl. VAT in case applicable), and will be billed %{date}",
          "trial": "Your account is currently in the trial period (<strong>%{value} days left</strong>).",
          "vatExclusive": "%{value}, VAT exclusive"
        },
        "branding": {
          "HeaderImageInfo": {
            "body": "The image you upload here will be shown in your company's <strong>weekly asset digest</strong> and the <strong>profile page</strong> of your company. For best results, we recommend uploading a high-resolution file. ",
            "header": "Header Image"
          },
          "accentColor": "Accent color",
          "comapnyPageBlocks": {
            "contacts": "Show contacts",
            "dealForm": "Introduce client",
            "incentives": "Show auto-assigned incentives",
            "portfolios": "Show portfolios"
          },
          "companyPage": "Company Profile",
          "general": "General",
          "headerImage": "Header image",
          "headerImageOverlay": "Add an image overlay",
          "primaryColor": "Primary color",
          "slug": "Company Page Identifier"
        },
        "details": {
          "address": "Address",
          "city": "City",
          "country": "Country",
          "description": "Description",
          "email": "Email",
          "industry": "Industry",
          "mobile": "Mobile",
          "name": "Name",
          "phone": "Phone",
          "tagline": "Tagline",
          "website": "Website",
          "zip": "Zip"
        },
        "integrations": {
          "search": "Search integrations..."
        },
        "settings": {
          "CompanyPageInfo": {
            "header": "Company Page",
            "infoBody": "A public profile for your company that can be used as a <strong>landing page</strong> between yourself and your partners. By default, your contact information and an overview of the portfolios are shown, after which the partner can also log in via the page or request access to the protected part of Rialto. You can also add your incentives and possibly an FAQ section.",
            "infoTitle": "What is the company page?",
            "linkBody": "You can always link from your own website to your company page on our platform. You can find the page at <strong>URL below</strong>.\n<br /> <br />\nIf you want, you can also use your own domain to display the company page. This can be done by setting a <strong>CNAME</strong> to your domain name provider with the URL below.",
            "linkTitle": "Custom Domain",
            "linkToken": "Click here to copy your custom company page url to clipboard"
          },
          "accent": "Accent color",
          "branding": "Branding",
          "currency": "Currency",
          "interface": "Interface",
          "language": "Language",
          "primary": "Primary color",
          "regional": "Regional",
          "sizeUnit": "Area unit",
          "slug": "Company Page Identifier",
          "statsUnit": "Statistics unit",
          "type": "Type"
        }
      },
      "delete": "Delete",
      "deleting": "Deleting..",
      "incentives": {
        "add": "Add incentive",
        "new": "Add new",
        "none": "You don't have any <b>incentive templates</b> yet.",
        "search": "Search incentives"
      },
      "menu": {
        "billing": "Billing",
        "branding": "Branding\n",
        "company": "Company",
        "details": "Company details",
        "incentives": "Incentives",
        "integrations": "Integrations",
        "notifications": "Notifications",
        "personal_details": "Personal details",
        "profile": "My profile",
        "requests": "Requests",
        "settings": "Settings",
        "team": "Team",
        "templates": "Templates",
        "tos": "Terms of service",
        "users": "Members"
      },
      "profile": {
        "email_label": "Email",
        "fname_label": "First name",
        "license_label": "RICS membership number",
        "lname_label": "Last name",
        "mobile_label": "Mobile number",
        "phone_label": "Phone",
        "title_label": "Title"
      },
      "save": "Save",
      "saving": "Saving..",
      "settings": {
        "change_password": "Change password",
        "confirm_label": "Confirm new password",
        "current_label": "Current password",
        "delete": {
          "confirmDelete": "Are you sure you want to remove your account? This move is PERMANENTLY and cannot be reverted. You will lose access to Rialto.",
          "title": "Delete account",
          "warning": "Removing your account will <strong>permanently</strong> remove all your data and is irreversible. You are responsible for transferring enquiries and assets where you are point person. <br/> After deleting your account, you will no longer have access to Rialto and will no longer receive update emails from the platform.",
          "warning_account_holder": "You are an <strong>account holder</strong> for your current company. Before deleting your account, transfer your role in team settings first."
        },
        "language_label": "Language",
        "locale": "Language settings",
        "new_label": "New password",
        "password_empty_hint": "Leave the password fields empty if you do not wish to change your password.",
        "timezone_label": "Timezone"
      },
      "team": {
        "add": "Add user",
        "confirm": {
          "removeUser": "Are you sure you want to remove this user? If this user was point person on assets or enquiries, either manually assign someone else in your team or get in touch with Rialto to update the records."
        },
        "edit": "Edit user",
        "remove": "Remove user",
        "requests": {
          "accept": "Accept",
          "active": "Pending",
          "empty": "No access requests to date",
          "reject": "Reject",
          "rejected": "Rejected"
        },
        "resend": "Resend invitation",
        "roles": {
          "account_holder": "Has full marketing, sales and administrative rights",
          "administrator": "Has full marketing and sales rights ",
          "internal_user": "Has full sales rights"
        },
        "search": "Search users..."
      },
      "tos": {
        "add": "Add terms and conditions",
        "edit": "Edit",
        "new": "Add new",
        "none": "You don't have any <b>terms of service</b> yet.",
        "remove": "Remove",
        "search": "Search terms and conditions"
      }
    },
    "ShareStatusSelector": {
      "header": "Who should get access?",
      "status": {
        "all": "All collaborators",
        "broker_owner_team": "Me & my client",
        "broker_team_owner_team": "My team & my client",
        "custom": "Custom",
        "owner_team": "My team"
      }
    },
    "SignUp": {
      "brokerCompany": "Broker Company",
      "cancel": {
        "error": {
          "body": "You already activated your account",
          "title": "We could not confirm your email!"
        },
        "success": {
          "body": "You will no longer receive reminder emails from us",
          "title": "Sign up cancelled! "
        }
      },
      "cancelBtn": "Cancel",
      "company": {
        "createNew": "Couldn't find your team? Just create your own, it's easy. <a href=\"%{link}\">Click here</a> to create an account for your team.",
        "details": "Fill in the details below to register your team on Rialto:",
        "name": "Company name",
        "requestAccess": "Request access",
        "requestPending": "Request pending",
        "role": "My business is best described as follows:",
        "roles": {
          "broker": "I'm a real estate agent / online broker",
          "ownerFlex": "I'm a flex workspace / coworking operator",
          "ownerLeasing": "I'm a landlord and / or run my own leasing team"
        },
        "welcome": "Welcome to Rialto, %{name}!\n<br />\n<br />\nThe following teams match your email domain. Get access to yours."
      },
      "existingAccount": "Already have an account?",
      "getStarted": "Get started",
      "linkedin_signup": "Signup with LinkedIn",
      "submitted": "Welcome %{fname}!\n<br />\n<br />\nWe'll reach out shortly to confirm your email address. After clicking the link in the email, you can choose to either <strong>join an existing team</strong> or <strong>create a new team</strong>.\n<br />\n<br />\n👉🏻 Did not receive an email? Please make sure to check your <strong>spam folder</strong>.\n<br />",
      "submittedCampaign": "Welcome %{fname}!\n<br />\n<br />\nWe'll reach out shortly to confirm your email address. After clicking the link in the email, you can <strong>start using Rialto</strong>.",
      "tagline": "There's a smarter way to drive workspace occupancy. <br />\nYou thought about it. We built it for you.",
      "title": "Get started for free"
    },
    "Size": {
      "amount": "unit",
      "amounts": "units",
      "m2": "sqm",
      "square_foot": "sqft"
    },
    "SpaceCategory": {
      "residential": ""
    },
    "SpaceModal": {
      "title": "Add new space"
    },
    "SpaceStatusDialog": {
      "body": "Are you sure you want to set this space off-market? Agents will no longer see this space. It will no longer appear on the asset navigator or the flyers.",
      "confirm": "Put off-market",
      "notify": "Notify brokers that the space is no longer available"
    },
    "SpacesTable": {
      "actions": {
        "delete": "Delete",
        "duplicate": "Duplicate",
        "edit": "Edit",
        "setNotUnderOffer": "No longer Under Offer",
        "setPrivate": "Put off-market",
        "setPublic": "Put on-market",
        "setUnderOffer": "Set Under Offer"
      },
      "addPrice": "add price",
      "assetDetailNoSpaces": "No spaces for this product yet, click <strong>Add</strong> on the right.",
      "availability": {
        "mobile": {
          "now": "Available",
          "tbd": "TDB"
        },
        "now": "Vacant",
        "tbd": "TBD"
      },
      "deals_associated": "%{smart_count} deal is referring to this space. |||| %{smart_count} deals are referring to this space.",
      "firstRefusalRight": "Right of first refusal",
      "form": {
        "titleAdd": "Add space",
        "titleEdit": "Edit space"
      },
      "headers": {
        "availableFrom": "Availability",
        "category": "Type",
        "description": "Description",
        "edit": " ",
        "floor": "Floor",
        "image": "",
        "inventory": "Number in Inventory",
        "leaseholder": "Leaseholder",
        "leaseholders": "Leaseholder",
        "minContractLength": "Contract Length",
        "name": "Unit",
        "period": "Period",
        "price": "Price",
        "size": "Size",
        "sizeUnit": "Unit",
        "status": "Status",
        "syncInfo": "",
        "unit": "Unit Name"
      },
      "inventory": "Inventory",
      "lxd": "LXD",
      "noSpaces": "No available spaces for this asset.",
      "periods": {
        "daily": {
          "one": "day",
          "other": "days"
        },
        "hourly": {
          "one": "hour",
          "other": "hours"
        },
        "monthly": {
          "one": "month",
          "other": "months"
        },
        "weekly": {
          "one": "week",
          "other": "weeks"
        },
        "yearly": {
          "one": "year",
          "other": "years"
        }
      },
      "price": {
        "all_in": "Service charges and taxes included",
        "rate": "Tax:",
        "rent": "Rent:",
        "service": "Charges:",
        "undisclosed": "Upon request"
      },
      "pricing": "Pricing",
      "private": "<strong>off</strong>&nbsp;market",
      "public": "<strong>on</strong> market",
      "removeSpace": "Do you want to permanently remove this space? Space will be disassociated from enquiries and proposals. Agents won't be notified.",
      "renewalPeriod": "Renewal each",
      "undefined": "Undefined",
      "under_offer": "Under Offer"
    },
    "StageProgress": {
      "selectStage": "Select stage"
    },
    "Statistics": {
      "assetLeads": "Acquisition |||| Acquisitions",
      "totalSize": "total demand"
    },
    "StatusButton": {
      "disregard": "Disregard",
      "execute": "Executed"
    },
    "SubmitButton": {
      "submit": "Post",
      "submitted": "Submitted!",
      "submitting": "Posting.."
    },
    "SubscribeButton": {
      "subscribe": "Subscribe",
      "subscribed": "Subscribed"
    },
    "TabbedFilter": {
      "apply": "Apply",
      "channel": "Originator",
      "region": "Region",
      "regionCategories": {
        "regions": "By Region"
      },
      "selected": "%{nb} selected"
    },
    "Table": {
      "headers": {
        "activity": "Activity",
        "asset": "Asset",
        "assetSpaces": "Asset",
        "asset_spaces": "Asset",
        "assets": "Assets",
        "budget": "Budget",
        "category": "Type",
        "channel": "Originator",
        "closeDate": "Close Date",
        "comment": "Comment",
        "contact": "Contact",
        "currentSituation": "Current situation",
        "date": "Date",
        "description": "Additional information",
        "disregardComment": "Reason of cancellation",
        "endDate": "End Date",
        "features": "Requirements",
        "feePotential": "Opp. value",
        "fee_potential": "Opp. value",
        "followUpDate": "Follow-up",
        "includeInReport": "In report",
        "location": "Location",
        "name": "Name",
        "nonProspectComment": "Comments / Follow up",
        "pointPerson": "Point Person",
        "point_person": "Point Person",
        "portfolio": "Portfolio",
        "potential": "Potential",
        "probability": "Probability",
        "prospectComment": "Comments",
        "shareStatus": "",
        "share_status": "",
        "size": "Size",
        "spaceCategories": "Category",
        "space_categories": "Category",
        "stage": "Phase",
        "startDate": "Start Date",
        "start_date": "Start Date",
        "tenant": "Tenant",
        "term": "Term",
        "type": "Key Drivers",
        "viewed": "Viewed",
        "warning": " "
      },
      "noAsssetLeads": "No results",
      "noDeals": "No enquiries found"
    },
    "TenantProfile": {
      "address": {
        "title": "Current address"
      },
      "company": {
        "title": "Company"
      },
      "confirm": {
        "cancel": "Are you sure you want to cancel? All your changes will be lost.",
        "delete": "Are you sure you want to delete?"
      },
      "contacts": {
        "title": "Contacts"
      },
      "email": {
        "title": "Email"
      },
      "head_count": {
        "title": "Head Count"
      },
      "industry": {
        "title": "Industry"
      },
      "leaseExpiration": {
        "title": "Lease expiration date"
      },
      "locale": "Language",
      "mobile": {
        "title": "Mobile phone"
      },
      "name": {
        "title": "First and last name"
      },
      "phone": {
        "title": "Office phone"
      },
      "position": {
        "title": "Position"
      },
      "rentable_area": {
        "title": "Rentable Area"
      },
      "title": "Tenant Profile"
    },
    "TenantRepresentative": {
      "actions": {
        "edit": "Edit",
        "unlink": "Unlink"
      },
      "company": {
        "title": "Company"
      },
      "email": {
        "title": "Email"
      },
      "job_title": {
        "title": "Title"
      },
      "name": {
        "title": "First and last name"
      },
      "phone": {
        "title": "Phone"
      },
      "title": "Tenant Representative"
    },
    "TermsOfServiceForm": {
      "addTos": "Add Terms of Service",
      "body": "Content",
      "default": "Set as default: show on company profile and auto-assign to new assets created",
      "defaultTosWarning": "You can only have one default terms of service. If you continue, any existing default terms of service will be replaced. Are you sure?",
      "file": "File",
      "title": "Title"
    },
    "Timestamp": {
      "original": "Original timestamp"
    },
    "TitledDate": {
      "title": "Choose %{title}"
    },
    "TourButton": {
      "book": "Book a tour"
    },
    "UserConfirmModal": {
      "agreement": {
        "agree": "OK - I understand",
        "description": "Hi %{user}, you will get access to Rialto after you confirmed your account details.",
        "terms_description": "By completing this confirmation form, you confirm that you have read and accepted our <a href=\"http://www.getrialto.com/terms\" target=\"_blank\">Terms of Service</a> and <a href=\"https://www.getrialto.com/privacy\" target=\"_blank\">Privacy Policy</a>",
        "title": "Confirmation needed"
      },
      "confirm": "Confirm",
      "confirming": "Confirming..",
      "details": {
        "description": "Please verify your details and confirm your account.",
        "title": "Profile details"
      }
    },
    "UserDetails": {
      "inactive": "inactive"
    },
    "UserEdit": {
      "first_name": "First name"
    },
    "ViewToggle": {
      "display": "Display"
    },
    "deal": {
      "space_categories": "Category"
    },
    "forms": {
      "picturePlaceholder": "Upload a picture"
    },
    "notifications": {
      "asset": {
        "delete": {
          "success": {
            "title": "Asset deleted!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "You will receive an email shortly",
            "title": "Your portfolio is being exported"
          }
        },
        "requestFlyer": {
          "success": {
            "message": "You can expect feedback from the asset manager over email.",
            "title": "Request for more information sent succesfully!"
          }
        }
      },
      "deal": {
        "delete": {
          "error": {
            "message": "Please try again later",
            "title": "Enquiry could not be destroyed!"
          },
          "success": {
            "title": "Enquiry deleted successfully!"
          }
        },
        "duplicate": {
          "success": {
            "title": "Enquiry duplicated successfully!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "You will receive an email shortly",
            "title": "Interest schedule is being exported"
          }
        },
        "renew": {
          "success": {
            "title": "Enquiry duplicated successfully!"
          }
        }
      },
      "defaultErrorTitle": "An error occured!",
      "defaultInfoTitle": "Info",
      "notAuthenticated": {
        "message": "Please re-login",
        "title": "You are not authenticated"
      },
      "portfolio": {
        "delete": {
          "success": {
            "bodyDelete": "All associated assets and enquiries are removed.",
            "bodyTransfer": "All associated assets and enquiries are transferred.",
            "title": "Portfolio deleted!"
          }
        }
      },
      "subscriptions": {
        "update": {
          "success": {
            "body": "Your changes are effective immediately",
            "title": "Notification settings saved!"
          }
        }
      },
      "user": {
        "brokerInvite": {
          "success": {
            "messageActive": "%{user} now has access to the selected assets.",
            "messageNew": "%{user} will have access to the assets after accepting the invitation.",
            "title": "%{user} invited successfully!"
          }
        },
        "requestPasswordReset": {
          "success": {
            "message": "You will receive an email shortly with further instructions.",
            "title": "New password requested!"
          }
        },
        "resetPassword": {
          "success": {
            "message": "You should now use this password the next time you sign in.",
            "title": "Password changed successfully."
          }
        }
      }
    },
    "shared": {
      "add": "Add",
      "adding": "Adding..",
      "address": "%{address} %{city}, %{zip}",
      "amount": "Amount",
      "and": "and",
      "askInfo": "Request flyer",
      "asset": {
        "address": "Address",
        "asset": "Asset",
        "city": "City",
        "name": "Name",
        "region": "Region",
        "state": "State",
        "statuses": {
          "fully_let": "Fully let",
          "invite": "Invite-only",
          "other": "Other",
          "private": "Private",
          "public": "Free-fight",
          "sold": "Sold"
        },
        "zip": "Zip"
      },
      "assetCategories": {
        "hotel": "Hotel",
        "industrial": "Industrial",
        "land": "Land",
        "multi_family": "Multi-family",
        "office": "Office",
        "other_cat": "Other",
        "residential": "Residential",
        "retail": "Retail",
        "warehouse": "Warehouse"
      },
      "assetLeadStages": {
        "closing": "Closing",
        "negotiating": "Negotiating",
        "pitch": "Pitch",
        "prospect": "Prospect"
      },
      "assetLeads": "Acquisition",
      "billingMethods": {
        "post": "post-payment",
        "pre": "pre-payment"
      },
      "budget": "Budget",
      "cancel": "Cancel",
      "category": "Type",
      "channelCategories": {
        "email": "Email",
        "employee_referral": "Employee referral",
        "leasing_agent": "Leasing agent",
        "listing_site": "Classifieds",
        "online_broker": "Online broker",
        "other_cat": "Other",
        "phone": "Over phone",
        "referral": "Referral",
        "social_media": "Social Media",
        "tenant_rep": "Tenant Rep",
        "unknown": "Unknown",
        "walk_in": "Walk-in",
        "website": "Website"
      },
      "closeDate": "Close Date",
      "company": "Company",
      "companyTypes": {
        "acquisition": "Acquisition",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "confirm": {
        "cancel": "Are you sure you want cancel? All changes will be lost",
        "delete": "Are you sure you want to delete?"
      },
      "contactCategories": {
        "agent": "Agent",
        "asset_manager": "Asset Manager",
        "key_holder": "Key Holder",
        "landlord": "Landlord",
        "other_cat": "Other",
        "property_manager": "Property Manager",
        "tenant": "Tenant"
      },
      "copied": "Copied!",
      "copy": "Copy",
      "copy_of": "Copy of",
      "country": "Country",
      "deal": {
        "activity": "Activity",
        "asset": "Asset",
        "assets": "Assets",
        "budget": "Budget",
        "channel": "Originator",
        "deal": "Enquiry",
        "fee_potential": "Opportunity value",
        "leaseBreakDates": "Lease break dates",
        "leaseCommencementDate": "Lease commencement date",
        "leaseExpirationDate": "Lease expiration date",
        "location": "Location",
        "point_person": "Point Person",
        "portfolio": "Portfolio",
        "probability": "Probability",
        "share_status": "Share status",
        "size": "Size",
        "space_categories": "Category",
        "start_date": "Start Date",
        "tenant": "Tenant",
        "term": "Term",
        "type": "Reason for moving"
      },
      "dealStages": {
        "delivery": "Completion",
        "execution": "Exchange",
        "finder": "Monitoring",
        "inquiry": "Inquiry",
        "new": "New",
        "prospects": "Prospect",
        "signed_loi": "Agreement",
        "touring": "Viewing",
        "trading_proposal": "RFP/Proposal"
      },
      "dealStatuses": {
        "active": "Active",
        "all": "All",
        "dead": "Disregarded",
        "executed": "Executed"
      },
      "dealTypes": {
        "expansion": "Expansion",
        "new": "New",
        "reduction": "Reduction",
        "renegotiation": "Renegotiation",
        "renewal": "Renewal"
      },
      "deals": "Enquiries",
      "default": "Default",
      "delete": "Delete",
      "deletedUser": "Deleted User",
      "deleting": "Deleting..",
      "disregard_outcomes": {
        "move": "Signed with competing asset",
        "other_outcome": "Other",
        "stay": "Renewed current lease",
        "unknown": "Unknown"
      },
      "disregard_reasons": {
        "broker": "Broker information request",
        "duplicate_entry": "Duplicate entry",
        "location": "Location",
        "other_reason": "Other",
        "price": "Price",
        "quality": "Quality",
        "size": "Offered unit(s) don't match needs",
        "tenant_unqualified": "Tenant not qualified",
        "timed_out": "Requirement timed out",
        "unknown": "Unknown"
      },
      "download": "Download",
      "download_ics": "Add to diary",
      "edited": "Edited",
      "email": "Email",
      "emptyText": {
        "assetDeal": "First associate asset to this opportunity",
        "channels": "First add originator(s) on the enquiry page",
        "proposals": "First add proposal(s) on the enquiry page",
        "spaces": "First add space(s) to the asset of this enquiry",
        "spacesDeal": "First add an asset to this enquiry and/or space(s) to its asset"
      },
      "endDate": "End date",
      "errorTitle": "An error occured!",
      "every": "Every",
      "filter": "Filter",
      "flyer": "Flyer",
      "flyerContact": "Flyer Contact",
      "footer": {
        "about": "About Rialto",
        "blog": "Blog",
        "careers": "Careers",
        "status": "Status",
        "terms": "Terms of use"
      },
      "formChangesPrompt": "You have some unsaved data. Are you sure you want to navigate to another page?",
      "free": "free",
      "from": "from",
      "fullName": "First and last name",
      "in": "in",
      "industries": {
        "automobile": "Automotive",
        "aviation": "Aviation & Travel",
        "banks": "Banks",
        "basic_resources": "Basic Resources",
        "chemicals": "Chemicals",
        "construction": "Construction & Materials",
        "consumer_electronics": "Consumer Electronics",
        "culture": "Culture",
        "cw": {
          "automotive": "Automotive",
          "business_space": "Overige bedrijfsruimte",
          "cleanroom": "Cleanroom/Laboratorium",
          "datacenter": "Datacenter",
          "dc": "DC",
          "food": "Food",
          "high_tech": "High Tech/3D",
          "self_storage": "Self Storage",
          "sustainable_energy": "Sustainable/(Nieuwe) energie",
          "urban_logistics": "Urban Logistics/Cross Docks"
        },
        "education": "Education",
        "education_art": "Education & Art",
        "entertainment": "Entertainment",
        "financial_services": "Financial",
        "food": "FMCG - Food & Drink",
        "healthcare": "Pharmaceutical & health care",
        "household_goods": "Personal & Household Goods",
        "industrial_goods": "Industrial Goods & Services",
        "insurance": "Insurance",
        "legal": "Legal",
        "luxury": "Fashion, décor & luxury",
        "media": "Media",
        "oil_gas": "Oil & Gas",
        "other_cat": "Other",
        "professional_services": "Professional services",
        "public": "Public Sector",
        "real_estate": "Real Estate",
        "retail": "Retail",
        "sports_leisure": "Sports & Leisure",
        "technology": "Technology",
        "telecommunications": "Telecommunications",
        "travel": "Travel & Leisure",
        "utilities": "Utilities",
        "wellbeing": "Wellbeing"
      },
      "industry": "Industry",
      "integrationCategories": {
        "listing_site": "Listing site",
        "mail": "Email",
        "online_broker": "Online broker",
        "other_cat": "Other",
        "property_management": "Property management"
      },
      "language": "Language",
      "languages": {
        "en": "English",
        "en-GB": "British English",
        "en-GB-acquisition": "British English",
        "en-GB-flex": "British English",
        "en-acquisition": "English",
        "en-flex": "English",
        "fr-FR": "Français",
        "fr-FR-acquisition": "Français",
        "fr-FR-flex": "Français",
        "nl-BE": "Nederlands (BE)",
        "nl-BE-acquisition": "Nederlands (BE)",
        "nl-BE-flex": "Nederlands (BE)",
        "nl-NL": "Nederlands (NL)",
        "nl-NL-acquisition": "Nederlands (NL)",
        "nl-NL-flex": "Nederlands (NL)"
      },
      "loading": "Loading..",
      "more": "more",
      "name": "Name",
      "ner": "NER",
      "on": "on",
      "password": "Password",
      "per": "per",
      "phone": "Phone number",
      "placeholder": "Enter text here",
      "placeholders": {
        "assets": "Select one or more assets",
        "portfolios": "Select a portfolio"
      },
      "pointPerson": "Point Person",
      "portfolio": "Portfolio",
      "portfolioTypes": {
        "acquisition": "Acquisition",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "potentials": {
        "above_average": "Above average",
        "average": "Average",
        "high": "High potential",
        "low": "Low",
        "moderate": "Moderate"
      },
      "private": "Private",
      "probability": "Probability",
      "proposal": "Proposal",
      "rofr": "ROFR",
      "rofr_full": "Right of first refusal",
      "roles": {
        "account_holder": "Account holder |||| Account holders",
        "administrator": "Administrator |||| Administrators",
        "internal_user": "Internal user |||| Internal users"
      },
      "save": "Save",
      "saved": "Saved!",
      "saving": "Saving..",
      "search": "Search",
      "search_placeholder": "Search...",
      "send": "Send",
      "sending": "Sending..",
      "shareStatuses": {
        "all": "All collaborators",
        "broker_owner_team": "Me & my client",
        "broker_team_owner_team": "My team & my client",
        "custom": "Custom",
        "owner_team": "My team"
      },
      "size": {
        "separator": "to",
        "title": "Size"
      },
      "space": "Space",
      "spaceCategories": {
        "archive": "Archive",
        "carParking": "Outdoor parking",
        "car_parking": "Outdoor parking",
        "coveredCarParking": "Covered car parking",
        "covered_car_parking": "Covered car parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Land",
        "leisure": "Leisure",
        "logistical": "Logistical",
        "meeting": "Meeting/Conference",
        "office": "Office",
        "other": "Other",
        "other_cat": "Other",
        "outdoor_area": "Outdoor area",
        "residential": "Residential",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Warehouse"
      },
      "spaceStatuses": {
        "all": "All",
        "private": "Off market",
        "public": "On-market"
      },
      "spaces": "Spaces",
      "startDate": "Start date",
      "status": "Status",
      "systemEvents": {
        "asset_lead_add_contact": "Originator <i>%{contact}</i> added by <i>%{actor}</i>",
        "asset_lead_create": "<i>%{creator}</i> created acquisition",
        "asset_lead_stage_update": "<i>%{actor}</i> changed stage from <i>%{before}</i> to <i>%{after}</i>",
        "asset_lead_status_update": "<i>%{actor}</i> changed status from <i>%{before}</i> to <i>%{after}</i>",
        "deal_accept_proposal": "Draft contract requested by <i>%{name}</i>",
        "deal_add_asset": "<i>%{actor}</i> added this opportunity to <i>%{asset}</i>",
        "deal_channel_add": "Originator <i>%{channel}</i> added by <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> created enquiry for <i>%{asset}</i>",
        "deal_create_no_asset": "<i>%{creator}</i> created enquiry",
        "deal_lease_cancel": "<i>%{actor}</i> has terminated the lease",
        "deal_merge": "",
        "deal_point_person_change": "<i>%{creator}</i> changed point person from <i>%{before}</i> to <i>%{after}</i>",
        "deal_remove_asset": "Enquiry disassociated from <i>%{asset}</i> by <i>%{actor}</i>",
        "deal_renewal": "<i>%{creator}</i> duplicated enquiry <i>%{ancestor}</i> for renewal.",
        "deal_share_status_update": "Enquiry sharing settings updated to <i>%{after}</i> by <i>%{actor}</i>",
        "deal_stage_update": "<i>%{actor}</i> changed stage from <i>%{before}</i> to <i>%{after}</i>",
        "deal_status_update": "<i>%{actor}</i> changed status from <i>%{before}</i> to <i>%{after}</i>",
        "deal_tenant_add": "<i>%{actor}</i> added <i>%{tenant}</i> as tenant",
        "deal_tenant_broker_add": "<i>%{actor}</i> added <i>%{tenant_rep}</i> as tenant rep"
      },
      "to": "to",
      "totalSize": "total size",
      "undisclosed": "Undisclosed",
      "units": {
        "CAD": "CAD",
        "CHF": "CHF",
        "DKK": "DKK",
        "EUR": "EUR",
        "GBP": "GBP",
        "NOK": "NOK",
        "SGD": "SGD",
        "USD": "USD",
        "amount": "unit |||| units",
        "amount_desk": "desk |||| desks",
        "amount_person": "person |||| people",
        "amount_room": "room |||| rooms",
        "daily": "day |||| days",
        "desk": "desk |||| desks",
        "floor": "floor |||| floors",
        "ft²": "ft²",
        "hourly": "hour |||| hours",
        "m2": "sqm",
        "monthly": "month |||| months",
        "monthly_short": "mo",
        "m²": "m²",
        "parking": "parking |||| parkings",
        "person": "person |||| people",
        "room": "room |||| rooms",
        "space": "unit |||| units",
        "sqft": "sqft",
        "square_foot": "sqft",
        "units": "units",
        "weekly": "week |||| weeks",
        "yearly": "year |||| years",
        "yearly_short": "yr"
      },
      "upload": "Upload file",
      "user": {
        "email": "Email",
        "fname": "First name",
        "licenseNumber": "RICS membership number",
        "lname": "Last name",
        "locale": "Language",
        "mobile": "Mobile number",
        "name": "First and last name",
        "password": "Password",
        "passwordConfirmation": "Password confirmation",
        "phone": "Phone number",
        "role": "Role",
        "timezone": "Timezone",
        "title": "Title"
      },
      "with": "with"
    },
    "spaces": {
      "category": "Category"
    }
  },
  "en": {
    "ActivityFeed": {
      "empty_files": "No files.",
      "empty_items": "No items.",
      "empty_notes": "No private notes.",
      "empty_updates": "No updates.",
      "empty_viewings": "No tours.",
      "filters": {
        "Call": "Calls",
        "DealNote": "Updates",
        "Email": "Emails",
        "File": "Emails",
        "Note": "Updates",
        "Proposal": "Proposals",
        "Viewing": "Viewings",
        "all": "All",
        "call": "Calls",
        "deal_note": "Updates",
        "email": "Emails",
        "file": "Files",
        "label": "Show",
        "note": "Updates",
        "proposal": "Proposals",
        "update": "Updates",
        "viewing": "Tours"
      },
      "header": {
        "Call": "Call",
        "DealNote": "Update",
        "Email": "Email",
        "Note": "Update",
        "Proposal": "Proposal",
        "Viewing": "Touring",
        "call": "Call",
        "deal_note": "Update",
        "email": "Email",
        "file": "File",
        "label": "Post",
        "note": "Update",
        "proposal": "Proposal",
        "update": "Update",
        "viewing": "Touring"
      }
    },
    "AddActions": {
      "addDeal": ""
    },
    "Asset": {
      "deals": {
        "empty": "No opportunities",
        "fetching": "Fetching..",
        "hide": "Hide opportunities",
        "show": "View %{smart_count} opportunity |||| View %{smart_count} opportunities"
      },
      "noAvailableSpaces": "No available spaces",
      "spaces": {
        "empty": "No available spaces",
        "fetching": "Fetching..",
        "hide": "Hide spaces",
        "show": "View %{smart_count} space |||| View %{smart_count} spaces"
      },
      "spacesFetching": "Fetching..",
      "spacesHide": "Hide spaces",
      "spacesView": "View %{smart_count} space |||| View %{smart_count} spaces"
    },
    "AssetActions": {
      "askQuestion": "Ask question",
      "copied": "URL copied!",
      "copy": "Copy flyer URL",
      "download": "Download flyer",
      "open": "Open flyer",
      "requestFlyer": "Request flyer",
      "sendSMS": "Send SMS",
      "subscribed": "Subscribed to weekly digest",
      "unsubscribed": "Unsubscribed to weekly digest"
    },
    "AssetAvailability": {
      "availableSpace": "Available space",
      "spaces": "spaces"
    },
    "AssetCharges": {
      "allIn": "Service charges and taxes included",
      "rate": "est. Tax rate",
      "sell": "Selling price",
      "service": "est. Service charges"
    },
    "AssetCreateModal": {
      "autoGenerateFlyer": "Automatically generate a Flyer for this asset",
      "description": "Fill in basic information on new asset here. You can fill in more details later. ",
      "title": "Add asset"
    },
    "AssetDeals": {
      "actions": {
        "dropped": "Dropped out",
        "edit": "Edit",
        "exclude": "Exclude from report",
        "include": "Include in report",
        "not_dropped": "Not dropped out",
        "not_viewed": "Mark as not viewed",
        "viewed": "Mark as viewed"
      },
      "groups": {
        "active": "Active",
        "dead": "Dead deals",
        "prospects": "Prospects"
      },
      "nonProspectCommentMissing": "Comments / next steps are required for export"
    },
    "AssetFilter": {
      "budget": "Budget",
      "region": "Region",
      "status": "Status",
      "type": "Type"
    },
    "AssetHeader": {
      "deals": "Opportunity Pipeline",
      "export": {
        "btn": "Export",
        "disabled": "Export not possible. Missing input on: comments / next steps",
        "notification": {
          "message": "You will receive an email shortly",
          "title": "Your letting report being exported"
        }
      },
      "tabs": {
        "access": "Access",
        "announcements": "Announcements",
        "assetDeals": "Letting Report",
        "contacts": "Contacts",
        "files": "Photos & Files",
        "floorplan": "Floorplans",
        "infosheet": "Form",
        "settings": "Settings",
        "spaces": "Spaces"
      }
    },
    "AssetIncentives": {
      "active": "Active",
      "emptyMessage": {
        "active": "Drag and drop your <strong>active</strong> incentives here",
        "inactive": "Drag and drop your <strong>inactive</strong> incentives here"
      },
      "inactive": "Inactive",
      "info": "Need a new incentive template? You can create more incentive templates in your <a href=\"/settings/templates/incentives\">global settings</a>."
    },
    "AssetInfoModal": {
      "btn": "Ask a question",
      "header": "Question about %{asset}",
      "questionPlaceholder": "Ask your question..",
      "topic": "Related to",
      "topics": {
        "another": "Other",
        "commissions": "Fee and commissions",
        "service": "Service charges",
        "viewing": "Request tour"
      }
    },
    "AssetInformation": {
      "incentives": "Incentives",
      "title": "Fee and commissions",
      "tos": "Terms of service"
    },
    "AssetLeadAddress": {
      "title": "Address Details"
    },
    "AssetLeadContacts": {
      "title": "Contacts"
    },
    "AssetLeadCreateForm": {
      "address": "Street and number",
      "assetLead": "Acquisition"
    },
    "AssetLeadDetails": {
      "description": "Additional information",
      "title": "Acquisition Details"
    },
    "AssetLeadHeader": {
      "collaborators": {
        "title": "Collaborators"
      },
      "days_active_from_now": "Active for %{days}",
      "pointPerson": {
        "dropdownHeader": "Select Point Person",
        "title": "Point Person"
      },
      "reopen": "Re-open this lead?",
      "status": {
        "days_active_from_now": "Active for %{days}",
        "number_of_days_active": "Active for %{days} days",
        "title": "Status"
      },
      "title": "Acquisition Lead"
    },
    "AssetLeadModal": {
      "title": "Create acquisition lead"
    },
    "AssetLeadStatusMessage": {
      "disregarded": "disregarded",
      "executed": "executed",
      "message": "The acquisition lead has been <strong>%{status}</strong> by %{actor} on %{date}",
      "message_no_actor": "The acquisition lead has been <strong>%{status}</strong> on %{date}"
    },
    "AssetLeadsList": {
      "emptyStage": "No acquisition found in the current stage"
    },
    "AssetNavigator": {
      "disclaimer": "The listing and any and all information contained in the said document is strictly confidential and you are not authorised to disclose, use, disseminate or transmit,nor shall you permit to procure the disclosure, use, dissemination or transmittal (other than your disclosure to prospective tenants for our benefit), by whatever means to any party, the listing and any or all information contained therein, in whole or in part, except with the prior consent in writing to us.",
      "filter": "Filter",
      "loading": "Loading...",
      "noAssets": "Your search query did not return any result.",
      "searchPlaceholder": "Search.."
    },
    "AssetNavigatorHeader": {
      "collapse": "Collapse all",
      "display": "Display",
      "expand": "Expand all",
      "placeholder": "Search.."
    },
    "AssetOnMarket": {
      "onMarket": "on-market"
    },
    "AssetSettings": {
      "access": "Access",
      "actions": {
        "menuTitle": "Actions",
        "portfolio": {
          "dropdownTitle": "Move to",
          "information": "When you move this asset to another portfolio, <strong>all opportunities</strong> with an association to that asset in the current portfolio will be moved to the new portfolio too.",
          "menuTitle": "Change portfolio",
          "title": "Change portfolio"
        }
      },
      "assetUsers": {
        "cancel_invite": "Cancel invitation",
        "invitationPending": "Invitation pending",
        "inviteBtn": "Invite",
        "menuTitle": "Collaborators",
        "none": {
          "fully_let": "Your asset is <strong>fully let</strong>. <a href=\"/assets/%{id}/settings/access/status\">Change its status</a> to invite collaborators.",
          "invite": "You have <strong>no collaborators</strong> yet. ",
          "private": "Your asset is <strong>private</strong>. <a href=\"/assets/%{id}/settings/access/status\">Change its status</a> to invite collaborators.",
          "public": "You have <strong>no collaborators</strong> yet. ",
          "sold": "Your asset is <strong>sold</strong>. <a href=\"/assets/%{id}/settings/access/status\">Change its status</a> to invite collaborators."
        },
        "resend_invite": "Resend invitation",
        "revoke": "Revoke access",
        "revoke_company": "Revoke access team"
      },
      "costs": {
        "allIn": "Service charges and taxes included",
        "menuTitle": "General",
        "rentPrice": "Rent price",
        "sellPrice": "Sale price",
        "sellingTitle": "Sale price",
        "serviceTitle": "Service charges",
        "taxTitle": "Tax rate"
      },
      "fees": "Fees",
      "financial": "Financial",
      "flyerSettings": {
        "autogenerateFlyer": "Auto-generate flyer for this asset",
        "description": "Enabling <strong>auto-generate</strong> for flyers will create a flyer and keep it up-to-date. This means whenever you add or update a space, picture, floor plan, ... we will automatically generate a new flyer for you.",
        "title": "Flyer Settings"
      },
      "general": "General",
      "incentives": "Incentives",
      "options": {
        "delete": {
          "confirm": "Are you sure you want to remove this asset? This is irreversible!",
          "information": "If you wish to provide your brokers more information on why the asset was deleted, you can add <a href=%{link}>an announcement</a> or select a reason below.",
          "menuTitle": "Delete asset",
          "reason": "Reason for deleting",
          "title": "Delete asset from portfolio",
          "warning": "Removing this asset will remove all its data and is <strong>irreversible</strong>. <br/> After deleting, your team members and brokers will be notified in next weeks digest. Afterwards, they will no longer have access and the asset will be <strong>permanently</strong> removed."
        },
        "menuTitle": "Options"
      },
      "status": {
        "description": "Updating the status of the asset will impact the way it is marketed on Rialto:",
        "descriptionFullyLet": "When set <strong>fully let</strong>, your asset can only be accessed by you and your team",
        "descriptionInvite": "When marketed as <strong>invite-only</strong>, you decide which collaborators to invite",
        "descriptionPrivate": "When set <strong>private</strong>, your asset can only be accessed by you and your team",
        "descriptionPublic": "When marketed as <strong>free-fight</strong>, it can be accessed by all brokers that were granted access to this portfolio.",
        "dropdownTitle": "Status",
        "menuTitle": "Status",
        "public_to_invite": "Are you sure you wish to change the status to Invite-only? All collaborators will be removed access.",
        "public_to_private": "Are you sure you wish to change the status to private? All previously invited collaborators will have their access revoked.",
        "title": "Update Status"
      },
      "tos": "Terms of service",
      "tosExtraInfo": "Select the terms of service below to inform your collaborators about terms and conditions applying to this asset.",
      "tosInfo": "Need a new terms of service template? You can create more terms of service templates in your <a href=\"/settings/templates/tos\">global settings</a>."
    },
    "AssetShareStatus": {
      "Tooltips": {
        "body_fully_let": "This asset is fully let",
        "body_invite": "List of collaborators this asset is shared with.",
        "body_private": "This asset is private to you and your team.",
        "body_public": "This asset is publicly shared with all brokers that were granted access to this portfolio.",
        "footer_invite": {
          "one": "and %{count} more",
          "other": "and %{count} more"
        },
        "header_invite": "Shared with"
      }
    },
    "AssetSort": {
      "name": "Name",
      "on_market": "Available space",
      "order_by": "Order by",
      "updated_at": "Last update"
    },
    "AssetStatistics": {
      "available": "Available now",
      "deals": "Opportunities",
      "onMarket": "On-market",
      "total": "Total",
      "viewings": "Tours"
    },
    "AssetTermsOfService": {
      "info": "Need a new incentive template? You can create more incentive templates in your <a href=\"/settings/incentives\">global settings</a>."
    },
    "Backbutton": {
      "back": "Back"
    },
    "BrokerInviteForm": {
      "broker": "Collaborator",
      "invite": "Invite",
      "inviting": "Inviting..",
      "portfolioAssets": "Portfolio & assets"
    },
    "BrokerInviteModal": {
      "description": "If you invite a collaborator, you will grant the company of the collaborator access to the leasing availabilities of the assets you select, including marketing material and documents. You don't share any of the opportunities created by you or by a collaborator with this collaborator. The collaborator will be subscribed in real-time to any asset updates, and can share opportunities with you.",
      "title": "Invite Collaborator"
    },
    "Calendar": {
      "call": "Call",
      "day": "Day",
      "download": "Subscribe",
      "due_proposal": "Proposal due date",
      "lease_expiration": "Lease expiry",
      "lease_start": "Lease commencement",
      "month": "Month",
      "space_available": "Space available",
      "today": "Today",
      "viewing": "Tours",
      "week": "Week"
    },
    "Channels": {
      "category": "Category",
      "company": "Company",
      "confirm": {
        "delete": "Are you sure you want to delete?"
      },
      "name": "First and last name",
      "phone": "Phone",
      "title": "Originators"
    },
    "Commissions": {
      "durationLabel": "Contract Duration",
      "feeLabel": "Commission",
      "header": "Commissions",
      "info": "The commission percentage is related to the contract duration, <strong>they are linked as following</strong>:",
      "year": "yr"
    },
    "CompanyBlock": {
      "newPortfolio": "New portfolio",
      "visitCompanyPage": "Company Profile"
    },
    "CompanyPage": {
      "Contact": {
        "email": "Email us",
        "phone": "Call us"
      },
      "Login": {
        "footer": "Don't have one?",
        "header": "Have a Rialto account?",
        "login": "Login to Rialto",
        "requestAccess": "Request access"
      },
      "NotFound": {
        "message": "We could not find a matching company for this url",
        "title": "This page is not available"
      },
      "contacts": "Contacts",
      "features": "Features",
      "incentives": "Incentives",
      "introduce": "Introduce client",
      "portfolios": "Portfolios",
      "tos": "Terms of service"
    },
    "CompanyTooltip": {
      "inCountry": "in %{value}",
      "numberOfAssets": "%{smart_count} asset |||| %{smart_count} assets",
      "viewCompanyProfile": "View company profile"
    },
    "Dashboard": {
      "empty": "There is no dashboard for this portfolio"
    },
    "DateTime": {
      "add_date": "Please choose a date",
      "add_time": "Add time?",
      "select_date": "Select date",
      "set": "Set",
      "submit": "Set",
      "time": "Time",
      "title": "Select date"
    },
    "DealActions": {
      "delete": {
        "confirm": "Are you sure you want to permanently delete this opportunity? Comments on this deal will also be removed.",
        "tooltip": "Delete"
      },
      "duplicate": {
        "tooltip": "Duplicate"
      },
      "merge": {
        "tooltip": "Merge"
      }
    },
    "DealCancel": {
      "cancelDate": "Date of termination",
      "confirm": "Confirm",
      "confirming": "Confirming...",
      "feedback": "Feedback",
      "feedbackInfo": "Your feedback will be displayed to anyone with access to this opportunity.",
      "feedbackPlaceholder": "Enter your feedback here",
      "moveDate": "Move date",
      "reason": "Reason",
      "title": "Cancel lease"
    },
    "DealCard": {
      "nbAssets": "%{smart_count} assets"
    },
    "DealColumns": {
      "title": "Customize columns"
    },
    "DealDetail": {
      "confirmDelete": "Are you sure you want to permanently delete this opportunity? Comments on this deal will also be removed."
    },
    "DealDetails": {
      "budget": {
        "separator": "to",
        "title": "Budget"
      },
      "description": "Additional information",
      "location": {
        "title": "Location"
      },
      "spaces": {
        "archive": "Archive",
        "car_parking": "Outdoor Parking",
        "category": "Category",
        "covered_car_parking": "Covered Car Parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Land",
        "leisure": "Leisure",
        "logistical": "Logistical",
        "meeting": "Meeting / Conference",
        "new": "New",
        "office": "Office",
        "other_cat": "Other",
        "outdoor_area": "Outdoor area",
        "residential": "Residential",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Warehouse",
        "title": "Spaces"
      },
      "start_date": {
        "title": "Start date"
      },
      "term": {
        "months": "month(s)",
        "title": "Max term",
        "years": "year(s)"
      },
      "title": "Opportunity Details",
      "type": "Key Drivers",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "desks"
      }
    },
    "DealFilter": {
      "advanced": "Advanced filters",
      "asset": "Asset",
      "selectedAsset": "%{nb} selected"
    },
    "DealForm": {
      "assets": {
        "info": "For each asset you select, a separate opportunity will be created. Mind the privacy settings on the bottom left before adding.",
        "title": "Asset |||| Assets"
      },
      "channel": {
        "expand": "Add <strong>originator</strong> details",
        "title": "Originator"
      },
      "description": {
        "disclose": "<strong>Add additional information</strong>",
        "placeholder": "Enter comment here",
        "title": "Additional information"
      },
      "details": {
        "title": "Opportunity"
      },
      "enquiry": {
        "title": ""
      },
      "placeholders": {
        "asset": "Associate asset(s) (optional)",
        "assets": "Associate asset (optional)"
      },
      "portfolio": {
        "title": "Portfolio"
      },
      "save": "Add opportunity",
      "saving": "Adding opportunity..",
      "stage": "Stage",
      "tenant": {
        "title": "Tenant",
        "undisclose": "<strong>Do not</strong> disclose the tenant details"
      }
    },
    "DealMerge": {
      "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui sint asperiores maiores eaque voluptatum mollitia eum architecto, neque possimus hic corporis aliquid aut est tempore voluptates iste harum enim iusto rerum blanditiis magni aliquam. Vero maxime qui quis explicabo eum excepturi asperiores rerum eos veritatis, reprehenderit voluptatem possimus aliquam incidunt!",
      "source": "Merge",
      "target": "Into",
      "title": "Merge Opportunity"
    },
    "DealModal": {
      "header": "Add new opportunity"
    },
    "Deals": {
      "portfolio_subscribed": "Subscribed to weekly digest",
      "portfolio_unsubscribed": "Unsubscribed to weekly digest"
    },
    "DealsFilter": {
      "asset": "Asset",
      "channel": "Originator",
      "searchPlaceholder": "Search..",
      "stage": "Stage"
    },
    "DealsTable": {
      "empty": "No opportunities found",
      "empty_stage": "No opportunities found in the current stage",
      "export": {
        "btnLabel": "Export",
        "csv": "A CSV version of the interest schedule that allows for editing.",
        "pdf": "A PDF version of the opportunities schedule with all activity per asset.",
        "title": "Opportunities"
      },
      "loading": "Loading..."
    },
    "Dialog": {
      "confirm": "Confirm",
      "title": "Are you sure?"
    },
    "DisregardModal": {
      "disregard": "Disregard",
      "disregarding": "Disregarding..",
      "feedbackInfo": "Your feedback will be displayed to anyone with access to this opportunity.",
      "feedbackPlaceholder": "Enter your feedback here",
      "header": "Disregard this Opportunity",
      "outcome": "Outcome",
      "reason": "Reason"
    },
    "DropdownUserItem": {
      "me": "me"
    },
    "DropdownUserSelect": {
      "pointPerson": "Point person"
    },
    "Dropzone": {
      "notSupported": "The file type you uploaded is not supported",
      "placeholder": "Click or drag here to upload file",
      "placeholderPicture": "Click or drag here to upload an image"
    },
    "EnquiryDetails": {
      "budget": {
        "title": ""
      },
      "title": ""
    },
    "EnquiryHeader": {
      "DealStages": {
        "hide": "Hide",
        "modal": {
          "body": "Here you can edit what assets are in the running for %{stage}. When editing, the asset will be disregarded for this deal.",
          "title": "Edit Assets in %{stage}"
        },
        "show": "View %{smart_count} more"
      },
      "assignAsset": "Associate asset",
      "assignFeePotential": "Add enquiry value",
      "collaborators": {
        "title": "Collaborators"
      },
      "confirm": {
        "assetRemove": "This opportunity may have one or more spaces from %{asset} associated. This association will be removed when deleting the asset. Are you sure you want to proceed?",
        "assetUpdate": "This opportunity may have one or more spaces from %{asset} associated. This association will be removed when updating the asset. Are you sure you want to proceed?",
        "cancel": "Are you sure you want cancel? All changes will be lost.",
        "feePotentialRemove": "Are you sure you wish to remove the value for this opportunity?"
      },
      "duplicate": "Duplicate for renewal",
      "feePotential": "Enquiry value",
      "modal": {
        "header": "Custom share settings",
        "info": "Any partner added here will be able to see and update this opportunity. We don’t notify them when you choose to no longer share the opportunity with them.",
        "save": "Save changes",
        "search_collaborators": "Search collaborators",
        "title": "Collaborators with access to the opportunity"
      },
      "point_person": {
        "dropdown_header": "Select Point Person",
        "title": "Point Person"
      },
      "renew": "Duplicate for renewal",
      "reopen": "Re-open this opportunity?",
      "status": {
        "days_active_from_now": "Active for %{days}",
        "number_of_days_active": "Active for %{days} days",
        "title": "Status"
      },
      "subscribed": "Subscribed",
      "title": "Opportunity",
      "unsubscribed": "Unsubscribed"
    },
    "EnquiryModal": {
      "addEnquiry": "Add opportunity",
      "addingEnquiry": "Adding opportunity..",
      "assets": {
        "title_pl": "Assets",
        "title_sg": "Asset"
      },
      "channel": {
        "category": "Type",
        "company": "Company",
        "email": "Email",
        "name": "Name",
        "title": "Originator"
      },
      "collapse_channel_details": "Collapse <strong>originator</strong> details",
      "collapse_comment_details": "<strong>Collapse notes</strong> to post upon creation",
      "collapse_tenant_details": "<strong>Collapse tenant</strong> and/or originator details",
      "comment": {
        "placeholder": "Enter comment here",
        "title": "Add Update"
      },
      "confirm": {
        "cancel": "Are you sure you want cancel? All changes will be lost."
      },
      "enquiry": {
        "name": "Name",
        "title": "Opportunity"
      },
      "expand_channel_details": "Add <strong>originator</strong> details",
      "expand_comment_details": "<strong>Add note</strong> to post upon creation",
      "expand_tenant_details": "<strong>Add tenant</strong> and/or originator details",
      "header": "Add new opportunity",
      "headerRenewal": "Duplicate for renewal",
      "industry": {
        "art_culture": "Art & culture",
        "automobile": "Automotive",
        "aviation": "Aviation & Travel",
        "banks": "Banks",
        "basic_resources": "Basic Resources",
        "chemicals": "Chemicals",
        "construction": "Construction & Materials",
        "consumer_electronics": "Consumer Electronics",
        "education": "Education",
        "education_art": "Education & Art",
        "entertainment_gaming": "Entertainment & gaming",
        "financial_services": "Financial Services",
        "food": "FMCG - Food & Beverage",
        "healthcare": "Pharmaceutical & health care",
        "household_goods": "Personal & Household Goods",
        "industrial_goods": "Industrial Goods & Services",
        "insurance": "Insurance",
        "legal": "Legal",
        "luxury": "Fashion, décor & luxury",
        "media": "Media",
        "oil_gas": "Oil & Gas",
        "other_cat": "Other",
        "professional_services": "Professional services",
        "public": "Public Sector",
        "real_estate": "Real Estate",
        "retail": "Retail",
        "sports_leisure": "Sports & Leisure",
        "technology": "Technology",
        "telecommunications": "Telecommunications",
        "title": "Industry",
        "travel": "Travel & Leisure",
        "utilities": "Utilities",
        "wellbeing": "Wellbeing"
      },
      "info": "For each asset you select, a separate opportunity will be created. Mind the privacy settings on the bottom left before adding.",
      "portfolio": {
        "title": "Portfolio"
      },
      "size": {
        "separator": "to",
        "title": "Size"
      },
      "start_date": {
        "title": "Start date"
      },
      "tenant": {
        "company": "Company",
        "email": "Email address",
        "industry": "Industry",
        "name": "First and last name",
        "title": "Tenant"
      },
      "tenantRepresentative": {
        "company": "Company",
        "email": "Email address",
        "name": "First and last name",
        "title": "Tenant Rep."
      },
      "undiscloseTenantBroker": "<strong>Do not</strong> disclose the tenant details",
      "undiscloseTenantOwner": "Tenant details <strong>not disclosed</strong>",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "units"
      }
    },
    "EnquiryStatusMessage": {
      "advisedBy": "Advised by",
      "commencement": "<strong>Commencement</strong> on",
      "disregarded": "disregarded",
      "executed": "executed",
      "expiring": "<strong>Expiring</strong> on",
      "leaseBreak": "<strong>First break</strong> on",
      "message": "The opportunity has been <strong>%{status}</strong> by %{actor}",
      "message_no_actor": "The opportunity has been <strong>%{status}</strong>",
      "renewal": "Duplicate for renewal",
      "renewalPeriod": "<strong>Renewal</strong> each",
      "reopen": "Re-open this opportunity?",
      "size": {
        "of": "of"
      },
      "yearlyRent": {
        "for": "for",
        "message": "Total yearly rent is"
      }
    },
    "ErrorBoundary": {
      "back": "Go back",
      "message": "Our team has been notified and will implement a fix as soon as possible. <br />\nWe will get back to you when the issue got resolved.",
      "title": "Oops, something went wrong.."
    },
    "ExecuteModal": {
      "channels": "Eligible for success fee",
      "execute": "Execute",
      "executing": "Execute..",
      "header": "Execute this opportunity",
      "info": "The details of the executed lease will be available in the executed opportunities section and will remain available to you and optionally your invited brokers on this opportunity.",
      "involvedSpaces": "Spaces leased",
      "leasingAgent": "Leasing agent",
      "offered": "sent",
      "reasonForMoving": "Reason",
      "received": "received",
      "tenant": "Tenant name"
    },
    "ExportActions": {
      "assetLeads": {
        "title": "Acquisition",
        "xls": "A XLS export."
      },
      "assets": {
        "csv": "A CSV export after filter.",
        "pdf": "A PDF export, after filter.",
        "title": "Assets and Spaces",
        "xls": "A XLS export after filter."
      },
      "btnLabel": "Export",
      "deals": {
        "csv": "A CSV version of the interest schedule that allows for editing.",
        "pdf": "A PDF version of the opportunities schedule with all activity per asset.",
        "title": "Opportunities",
        "xls": "A XLS version of the interest schedule that allows for editing."
      },
      "portfolioAssets": {
        "pdf": "A PDF with all assets in this portfolio (after filter).",
        "title": "Portfolio",
        "xls": "A XLS version of this portfolio (after filter)."
      }
    },
    "FileManager": {
      "empty": "You have not uploaded any pictures or files yet.",
      "files": "Documents",
      "filesSelected": "%{value} files selected",
      "header": "Use as flyer header",
      "pictures": "Pictures",
      "private": "Do not show on flyer",
      "searchPlaceholder": "(name, kind, tag, ..)",
      "thumbnail": "Use as asset thumbnail",
      "uploaded": "Added"
    },
    "Floorplans": {
      "actions": "Space actions",
      "addSpace": "Associate space",
      "availability": "Availability",
      "clearLines": "Clear lines",
      "clickToLink": "Click to link space",
      "createFloorplan": "Create new floorplan",
      "deleteConfirm": "Are you sure you want to delete this floorplan?",
      "deleteFloorplan": "Delete floorplan",
      "duplicate": "Duplicate",
      "editSpace": "Edit space",
      "file": "File",
      "floor": "Floor",
      "floorPlaceholder": "Floor name",
      "floorSelector": "Floor selector",
      "information": "<h3>Zoom the floorplan</h3>\n<p>Hold CTRL or CMD and scroll to zoom the image of the floorplan</p>\n\n<h3>Move the floorplan</h3>\n<p>Hold CTRL or CMD, click and move the mouse to move the image of the floorplan</p>\n\n<h3>Draw on the floorplan</h3>\n<p>Click on the image of the floorplan to draw a line. Once you finish drawing, you can link the drawn space with a space on the asset</p>\n\n<h3>Link a space on the asset</h3>\n<p>Click on a drawn space to link it with a space on the asset</p>\n\n<h3>Move a drawn space on the floorplan</h3>\n<p>Click on a drawn space and move the mouse to move the drawn space</p>\n\n<h3>Duplicate a drawn space</h3>\n<p>Click on a drawn space, then on the edit icon and finally on the duplicate button to create an identical copy of the selected drawn space</p>",
      "informationTitle": "Info about floorplans",
      "leaseHolder": "Leaseholder",
      "none": "No floorplans available",
      "pricing": "Pricing",
      "scroll": "Hold %{key} to zoom and pan the image.",
      "size": "Size",
      "startDragging": "Start dragging",
      "status": "Status",
      "stopDragging": "Stop dragging",
      "uploadFloorplan": "Upload floorplan"
    },
    "Flyer": {
      "NotFound": {
        "message": "We are sorry, but this flyer is no longer available. <br>\nYou can visit the <a href=\"https://www.rial.to/app\">Rialto platform</a>, or <a href=\"mailto:dgtqwgb3@incoming.intercom-mail.com\">contact us</a>.",
        "title": "Flyer is no longer available"
      },
      "ServiceRate": {
        "allIn": "Service charges and taxes included",
        "rate": "est. tax rate",
        "service": "est. service charges"
      },
      "contact": "Contact us",
      "facilities": {
        "categories": {
          "fire_safety": "Fire safety",
          "general": "General",
          "other_cat": "Other",
          "security": "Security"
        },
        "title": "Facilities"
      },
      "location": "Location",
      "marketing": "Broker Package"
    },
    "FlyerContactModal": {
      "info": "Your question will be sent to the contact person of this asset",
      "question": "Enter your question here",
      "successBody": "The contact person will reply asap",
      "successTitle": "Message delivered",
      "title": "Ask a question"
    },
    "ForgotPasswordModal": {
      "header": "Forgot password",
      "info": "Fill in your email address that you are using on rial.to and check your email inbox for further instructions on resetting your password."
    },
    "FormButton": {
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "save": "Save changes"
    },
    "GmailAuth": {
      "body": "Quickly identify leads from your email inbox on Rialto and directly convert them to an opportunity. No more hassle switching between apps. Click the button below to connect.",
      "title": "Connect your email account to Rialto"
    },
    "Inbox": {
      "convertDeal": "Convert to opportunity",
      "fetching": "Fetching mails..",
      "noSelection": "No email selected"
    },
    "Incentive": {
      "fee": "<strong>%{fee}</strong> commission will be granted",
      "minSize": "at a minimum of",
      "months": "months",
      "sprinter": "At closing maximum <strong>%{duration} month(s)</strong> after <strong> %{stage}</strong>.",
      "termAfter": "after %{date}",
      "termBefore": "before %{date}"
    },
    "IncentiveCard": {
      "commissionFixed": "%{value} %{currency} when %{type} a tenant.",
      "commissionPercentage": "%{value} when %{type} a tenant.",
      "commissionPeriod": "%{value} %{period} when %{type} a tenant.",
      "conditionsSize": "Contract size > %{value} %{unit}",
      "conditionsTerm": "Contract length > %{value} %{period}",
      "payoutLinked": "Recurring payment in sync with rent payments for max. %{value} %{period} rent",
      "payoutRecurring": "Recurring payment every %{recurrenceValue} %{recurrencePeriod} for max. %{value} %{period} rent",
      "payoutUpfront": "Upfront payment over %{value} %{period} rent",
      "type": {
        "expansion": "expanding",
        "new": "signing",
        "reduction": "reducing",
        "renegotiation": "renegotiating",
        "renewal": "renewing"
      }
    },
    "IncentiveForm": {
      "addIncentive": "Add incentive",
      "autoAssign": "Show on company page and auto-assign to public assets",
      "conditionTypes": {
        "conditions": "Conditions",
        "endDate": "End date",
        "minSize": "Minimum size",
        "term": "Term"
      },
      "deleteAutoassignConfirm": "Are you sure you want to delete this incentive? This incentive was auto-assigned to the company page and assets with public status. After deleting the incentive, it will no longer be shown.",
      "deleteConfirm": "Are you sure you want to delete this incentive?",
      "deleteSuccess": "Incentive deleted successfully!",
      "description": "Description",
      "editIncentive": "Edit incentive",
      "feeTypes": {
        "fees": "Fee",
        "fixedFee": "Fixed",
        "monthsFee": "Months",
        "percentageFee": "Percentage"
      },
      "payout": "Payout",
      "payoutLinked": "In sync with rent payments",
      "payoutTypes": {
        "payoutPeriod": "Upfront",
        "payoutRecurrence": "Recurring"
      },
      "rentPeriod": "Rent Period",
      "title": "Title",
      "type": "Type"
    },
    "IntegrationStatus": {
      "officernd": "OfficeR&D",
      "syncedAt": "Last synced with <strong>%{integration}</strong> at <strong>%{date}</strong>",
      "syncedFrom": "Synced with <strong>%{integration}</strong>"
    },
    "Intro": {
      "addButton": "<h3>Add opportunity, asset or collaborator</h3>\nYou can add a new opportunity, asset or collaborator by clicking here.",
      "addButtonBroker": "<h3>Add opportunity or draft contract</h3>\nYou can add a new opportunity or proposal here.",
      "assetActions": "<h3>Asset actions</h3>\nWith these actions you can email (un)subscribe to an asset and view the flyer when present.",
      "assetExport": "<h3>Export</h3>\nClick here to export the filtered list of assets and spaces in the current portfolio as CSV or PDF.",
      "assetFilter": "<h3>Asset filter</h3>\nHere you can search the current portfolio for spaces and assets that meet your criteria.",
      "assetInfo": "<h3>Asset info</h3>\nBy hovering and / or clicking these icons, you can get more information about sharing settings, commissions as well as service charges and taxes of the asset.",
      "assetList": "<h3>Assets</h3>\nHere you can see an overview of all assets in this portfolio.",
      "associateAsset": "<h3>Associate asset</h3>\nAfter associating an asset to this opportunity, you will find this opportunity by filtering on the navigator. Also, you'll be able to associate spaces to this opportunity and/or make proposals for spaces on this asset.",
      "channelDetails": "<h3>Associate originator</h3>\nSpecify more information about the origin of this opportunity.",
      "dealDetail": "<h3>Opportunity detail</h3>\nOpen an opportunity in the list to find more details, share an update, add tenant details, etc.",
      "dealDetails": "<h3>Specify requirements</h3>\nDefine detailed requirements the tenant has.",
      "dealExport": "<h3>Export</h3>\nClick here to export your opportunities in the current portfolio as CSV or PDF.",
      "dealToggleView": "<h3>Toggle view</h3>\nClick here to toggle between a table view or a drag-and-drop column view or select custom table columns. ",
      "deals": "<h3>Deals</h3>Browse here to access the opportunities on this portfolio.",
      "dealsList": "<h3>Opportunities</h3>\nHere you can see an overview of all your active opportunities in this portfolio. In the filter bar you can switch between different statuses.",
      "done": "Done",
      "expandAsset": "<h3>View spaces</h3>\nClick here to see the list of spaces for this asset.",
      "intercom": "<h3>Help</h3>\nYou have reached the end of the tour. If you have questions at any point whilst using our platform, do not hesitate to ask us a question by clicking this button. We will get back to you as soon as possible.",
      "next": "Got it",
      "previous": "Previous",
      "settings": "<h3>Settings</h3>\nHere you can find all of your settings (language preferences, notification settings, team management etc.), as well as an easy logout.",
      "skip": "Skip",
      "subscribeAsset": "<h3>Subscribe to asset</h3>\nClick here to subscribe to asset and get weekly updates in your mailbox.",
      "switchPortfolio": "<h3>Switch portfolios</h3>\nHere you can switch between all portfolios available to you as well as search all portfolios in one view.",
      "tenantDetails": "<h3> Specify tenant details </h3>\nSave key company details of the tenant.",
      "welcome": "<h3>Welcome to Rialto!</h3>\nThis tour will guide you through the main features of our platform. This will take max. three minutes of your time and gives you a quick head-start.\nYou can skip tour at any point by clicking the 'skip' button."
    },
    "LinkedinOauthCallback": {
      "errorBody": "Sign in with email and password instead",
      "errorTitle": "LinkedIn user unknown"
    },
    "LoginForm": {
      "emailPlaceholder": "Enter email",
      "forgotPassword": "Forgot?",
      "linkedin_signin": "Sign in with LinkedIn",
      "loggingIn": "Signing in..",
      "login": "Sign in",
      "passwordPlaceholder": "Enter password",
      "register": "Don't have an account?"
    },
    "Modal": {
      "comment": {
        "collapse": "<strong>Collapse comment</strong> to post upon creation",
        "expand": "<strong>Add comment</strong> to post upon creation",
        "placeholder": "Enter comment here",
        "title": "Note"
      }
    },
    "Navbar": {
      "back": "Back",
      "dashboard": {
        "deal": "Deal dashboard",
        "marketing": "Marketing dashboard"
      },
      "help": "Ask for help",
      "settings": "Settings",
      "sign_out": "Sign out"
    },
    "Ner": {
      "area": "Area and capacity",
      "costs": "Sum of costs",
      "free_rent_period": "Free rent period (in months)",
      "header": "Net Effective Rent",
      "price": "Prices (per month)",
      "term": "Term or renewal term (in months)",
      "title": "The <strong>Net Effective Rent</strong> gets calculated as follows:"
    },
    "Notes": {
      "alert": {
        "no_content": "Please add %{contentType} before saving!"
      },
      "call": {
        "alert_empty": "No empty calls",
        "btnLabel": "Select date",
        "placeholder": "Enter your call notes here",
        "title": "Choose date of call"
      },
      "confirm": {
        "cancel": "Are you sure you want to cancel? All your changes will be lost.",
        "delete": "Are you sure you want to delete?"
      },
      "email": {
        "alert_empty": "No empty calls",
        "btnLabel": "Select date",
        "code": "Post an email by FWD or BCC it to",
        "codeMobile": "FWD or BCC to",
        "copied": "URL copied!",
        "copy": "Copy to clipboard",
        "created_by": "Created by",
        "date_received": "Date received",
        "date_sent": "Date sent",
        "from": "from",
        "paste": "Copy/paste email content here",
        "placeholder": "Enter your email notes here",
        "received": "Received",
        "received_from": "Received from",
        "sent": "Sent",
        "sent_to": "Sent to",
        "title": "Choose date of email",
        "to": "to"
      },
      "file": {
        "comment": "Comment",
        "comment_placeholder": "Enter comment here (optional)",
        "download": "Download",
        "title": "Title",
        "title_placeholder": "Enter title here"
      },
      "no_contacts": "No contacts",
      "note": {
        "indicator": "Private"
      },
      "placeholder": "Enter your notes here",
      "private": "Only me",
      "proposal": {
        "dueDate": "Due date",
        "offered_by": "Offered by",
        "offering": "Offering",
        "received_by": "Received by",
        "receiving": "Receiving"
      },
      "public": "Public",
      "unknownUser": "Unknown",
      "update": {
        "placeholder": "Enter your update here"
      },
      "upload": "Upload file",
      "viewing": {
        "add": "Add to calendar",
        "btnLabel": "Select date",
        "placeholder": "Enter your tour notes here",
        "scheduled_for": "Tour scheduled for",
        "title": "Choose tour date"
      }
    },
    "Notification": {
      "deal": {
        "create": {
          "body": "%{values}",
          "title": {
            "one": "New opportunity added!",
            "other": "New opportunities added!"
          }
        },
        "invite": {
          "body": "They now have access to opportunity: %{values}.",
          "title": {
            "one": "Collaborators have been invited!",
            "other": ""
          }
        }
      },
      "flyer": {
        "create": {
          "body": "Flyer for %{values} updated!",
          "title": {
            "one": "Flyer updated!",
            "other": ""
          }
        },
        "error": {
          "body": "Please try again or contact support@rial.to",
          "title": {
            "one": "Flyer could not be generated!",
            "other": ""
          }
        }
      },
      "user": {
        "invitation_accepted": {
          "body": "%{values} has accepted your invite and is now on Rialto!",
          "title": {
            "one": "Invitation accepted!",
            "other": ""
          }
        }
      }
    },
    "Pagination": {
      "next": "next",
      "previous": "previous"
    },
    "PortfolioActions": {
      "addAsset": "Asset",
      "addAssetLead": "Acquisition",
      "addBroker": "Collaborator",
      "addDeal": "Opportunity",
      "addProposal": "Proposal",
      "addSpace": "Space",
      "btnLabel": "Add"
    },
    "PortfolioBlock": {
      "edit": "Edit portfolio",
      "requestAccess": "Request access",
      "requestPending": "Request pending.."
    },
    "PortfolioDeleteModal": {
      "confirmDelete": "Are you sure you want to remove %{portfolio}? All associated assets and opportunities will be deleted.",
      "confirmTransfer": "Are you sure you want to remove %{portfolio}? All associated assets and opportunities will be transferred to %{transferPortfolio}.",
      "header": "Delete Portfolio",
      "noPortfolios": "No portfolios to transfer to",
      "transfer": "Transfer to",
      "warning": "When deleting a portfolio, you can choose to transfer your assets, opportunities and subscription preferences to another portfolio. </br> </br> If you choose not to, <strong>all data</strong> that is associated with this portfolio will be <strong>permanently</strong> deleted."
    },
    "PortfolioFilter": {
      "portfolios": "Portfolios",
      "selected": "selected"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "",
        "deal": ""
      },
      "export": {
        "assets": {
          "csv": "A CSV version of this portfolio.",
          "pdf": "A PDF with all assets in this portfolio.",
          "title": "Portfolio"
        },
        "btnLabel": "Export",
        "deals": {
          "csv": "A CSV version of the interest schedule that allows for editing.",
          "pdf": "A PDF version of the opportunities schedule with all activity per asset.",
          "title": "Opportunities"
        }
      },
      "tabs": {
        "asset_leads": "Acquisition",
        "assets": "Assets",
        "dashboard": "Dashboard",
        "deals": "Opportunities"
      }
    },
    "PortfolioInfo": {
      "companiesSelected": "%{value} companies selected",
      "portfoliosSelected": "%{value} portfolios selected"
    },
    "PortfolioModal": {
      "delete": "Delete portfolio",
      "nameLabel": "Name",
      "statsUnitLabel": "Stats unit",
      "titleAdd": "Add new Portfolio",
      "titleEdit": "Edit Portfolio",
      "typeLabel": "Type"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "assets": "assets",
      "available": "available",
      "availableSpace": "Available Now",
      "deals": "Opportunities",
      "onMarket": "on-market",
      "rentableArea": "Total"
    },
    "Proposal": {
      "accepted": "Proposal",
      "addPrice": "Add price",
      "addSpace": "+ add another space",
      "asset": "Asset",
      "billingPeriod": "Billing period",
      "breakDates": "Lease break term",
      "breakTerm": "First break after",
      "channelFee": "Broker",
      "commencementDate": "LCD",
      "contractLength": "Contract Length Details",
      "costs": "Costs",
      "deposit": "Rent guarantee",
      "dueDate": "Valid until",
      "expirationDate": "LXD",
      "firstRefusalRight": "Apply right of first refusal",
      "legalFee": "Legal fees",
      "movingAllowance": "Moving allowance",
      "negativeDiscount": "(%{percentage}% above list price)",
      "ner": "NER",
      "offeredBy": "Offered by",
      "offering": "Offering",
      "otherCosts": "Other cost",
      "placeholder": "Enter your notes here",
      "positiveDiscount": "(%{percentage}% discount)",
      "receivedBy": "Received by",
      "receiving": "Receiving",
      "renewalPeriod": "Renewal period",
      "rentFreePeriod": "Rent free period",
      "term": "Term",
      "terms": "Financial Terms",
      "tiAllowance": "TI allowance",
      "token": "Copy the URL below to share the proposal with your client"
    },
    "ProposalAcceptModal": {
      "accept": "Request",
      "accepting": "Requesting..",
      "commentPlaceholder": "Enter any comments here",
      "header": "Request draft contract"
    },
    "ProposalForm": {
      "deal": "Opportunity",
      "dealLabel": "Search for existing or create a new one by name"
    },
    "ProposalModal": {
      "title": "Add proposal"
    },
    "ProposalPage": {
      "accept": "Draft contract",
      "accepted": {
        "message": "Thanks for your request! %{name} got notified and will get in touch as soon as possible.",
        "title": "Contract draft requested!"
      },
      "proposalFor": "Proposal for",
      "proposalOn": "Proposal on %{date}"
    },
    "RegionFilter": {
      "apply": "Apply",
      "region": "Region",
      "tabs": {
        "region": "By Region"
      }
    },
    "ResetPassword": {
      "confirm_label": "Password confirmation",
      "confirm_placeholder": "Enter password confirmation",
      "current_label": "Current password",
      "current_placeholder": "Enter current password",
      "description": "Fill in all fields below to change your password.",
      "new_label": "New password",
      "new_placeholder": "Enter new password",
      "title": "Reset password"
    },
    "SearchBlock": {
      "landlordsTitle": "All portfolios",
      "searchPortfolios": "Search portfolios",
      "selectAll": "Select all",
      "title": "Search all assets",
      "unselectAll": "Unselect all"
    },
    "SeeMore": {
      "seeMore": "Show more"
    },
    "SelectAll": {
      "clear": "Clear",
      "selectAll": "Select all"
    },
    "Settings": {
      "Subscriptions": {
        "assetDigest": {
          "description": "Select which assets should be included in the email digest. Unselect all to unsubscribe completely.",
          "title": "Email on changed availabilities"
        },
        "dealDigest": {
          "description": "Select which portfolios should be included in the opportunity activity digest. Unselect all to unsubscribe completely.",
          "title": "Opportunity activity email digest"
        },
        "portfolio_deal": {
          "description": "You can select your preference for default subscription on NEW opportunities. Select the portfolios on which you want automatic opportunity subscriptions:",
          "title": "New opportunities"
        },
        "unsubscribeDeals": {
          "body": "Unsubscribe from real-time opportunity updates?",
          "unsubscribe": "Remove all existing opportunity subscriptions for portfolios to be unsubscribed"
        }
      },
      "company": {
        "billing": {
          "billingInfo": "We have not found any billing information linked to your account. It could be that either you are currently not on a paid plan, or we have made a mistake.",
          "contact": "Contact us to get set up",
          "manage": "Change settings",
          "subscriptions": "You are currently subscribed to:",
          "title": "Billing information and settings",
          "total": "Next billing amount will be %{total} (incl. VAT in case applicable), and will be billed %{date}",
          "trial": "Your account is currently in the trial period (<strong>%{value} days left</strong>).",
          "vatExclusive": "%{value}, VAT exclusive"
        },
        "branding": {
          "HeaderImageInfo": {
            "body": "The image you upload here will be shown in your company's <strong>weekly asset digest</strong> and the <strong>profile page</strong> of your company. For best results, we recommend uploading a high-resolution file. ",
            "header": "Header Image"
          },
          "accentColor": "Accent color",
          "comapnyPageBlocks": {
            "contacts": "Show contacts",
            "dealForm": "Introduce client",
            "incentives": "Show auto-assigned incentives",
            "portfolios": "Show portfolios"
          },
          "companyPage": "Company Profile",
          "general": "General",
          "headerImage": "Header image",
          "headerImageOverlay": "Add an image overlay",
          "primaryColor": "Primary color",
          "slug": "Company Page Identifier"
        },
        "details": {
          "address": "Address",
          "city": "City",
          "country": "Country",
          "description": "Description",
          "email": "Email",
          "industry": "Industry",
          "mobile": "Mobile",
          "name": "Name",
          "phone": "Phone",
          "tagline": "Tagline",
          "website": "Website",
          "zip": "Zip"
        },
        "integrations": {
          "search": "Search integrations..."
        },
        "settings": {
          "CompanyPageInfo": {
            "header": "Company Page ",
            "infoBody": "A public profile for your company that can be used as a <strong>landing page</strong> between yourself and your partners. By default, your contact information and an overview of the portfolios are shown, after which the partner can also log in via the page or request access to the protected part of Rialto. You can also add your incentives and possibly an FAQ section.",
            "infoTitle": "What is the company page?",
            "linkBody": "You can always link from your own website to your company page on our platform. You can find the page at <strong>URL below</strong>.\n<br /> <br />\nIf you want, you can also use your own domain to display the company page. This can be done by setting a <strong>CNAME</strong> to your domain name provider with the URL below.",
            "linkTitle": "Custom Domain",
            "linkToken": "Click here to copy your custom company page url to clipboard"
          },
          "accent": "Accent color",
          "branding": "Branding",
          "currency": "Currency",
          "interface": "Interface",
          "language": "Language",
          "primary": "Primary color",
          "regional": "Regional",
          "sizeUnit": "Area unit",
          "slug": "Company Page Identifier",
          "statsUnit": "Statistics unit",
          "type": "Type"
        }
      },
      "delete": "Delete",
      "deleting": "Deleting..",
      "incentives": {
        "add": "Add incentive",
        "new": "Add new",
        "none": "You don't have any <b>incentive templates</b> yet.",
        "search": "Search incentives"
      },
      "menu": {
        "billing": "Billing",
        "branding": "Branding",
        "company": "Company",
        "details": "Company details",
        "incentives": "Incentives",
        "integrations": "Integrations",
        "notifications": "Notifications",
        "personal_details": "Personal details",
        "profile": "My profile",
        "requests": "Requests",
        "settings": "Settings",
        "team": "Team",
        "templates": "Templates",
        "tos": "Terms of service",
        "users": "Members"
      },
      "profile": {
        "email_label": "Email",
        "fname_label": "First name",
        "license_label": "RICS membership number",
        "lname_label": "Last name",
        "mobile_label": "Mobile number",
        "phone_label": "Phone",
        "title_label": "Title"
      },
      "save": "Save",
      "saving": "Saving..",
      "settings": {
        "change_password": "Change password",
        "confirm_label": "Confirm new password",
        "current_label": "Current password",
        "delete": {
          "confirmDelete": "Are you sure you want to remove your account? This move is PERMANENTLY and cannot be reverted. You will lose access to Rialto.",
          "title": "Delete account",
          "warning": "Removing your account will <strong>permanently</strong> remove all your data and is irreversible. You are responsible for transferring opportunities and assets where you are point person. <br/> After deleting your account, you will no longer have access to Rialto and will no longer receive update emails from the platform.",
          "warning_account_holder": "You are an <strong>account holder</strong> for your current company. Before deleting your account, transfer your role in team settings first."
        },
        "language_label": "Language",
        "locale": "Language settings",
        "new_label": "New password",
        "password_empty_hint": "Leave the password fields empty if you do not wish to change your password.",
        "timezone_label": "Timezone"
      },
      "team": {
        "add": "Add user",
        "confirm": {
          "removeUser": "Are you sure you want to remove this user? If this user was point person on assets or opportunities, either manually assign someone else in your team or get in touch with Rialto to update the records."
        },
        "edit": "Edit user",
        "remove": "Remove user",
        "requests": {
          "accept": "Accept",
          "active": "Pending",
          "empty": "No access requests to date",
          "reject": "Reject",
          "rejected": "Rejected"
        },
        "resend": "Resend invitation",
        "roles": {
          "account_holder": "Has full marketing, sales and administrative rights",
          "administrator": "Has full marketing and sales rights",
          "internal_user": "Has full sales rights"
        },
        "search": "Search users..."
      },
      "tos": {
        "add": "Add terms and conditions",
        "edit": "Edit",
        "new": "Add new",
        "none": "You don't have any <b>terms of service</b> yet.",
        "remove": "Remove",
        "search": "Search terms and conditions"
      }
    },
    "ShareStatusSelector": {
      "header": "Who should get access?",
      "status": {
        "all": "All collaborators",
        "broker_owner_team": "Me & my client",
        "broker_team_owner_team": "My team & my client",
        "custom": "Custom",
        "owner_team": "My team"
      }
    },
    "SignUp": {
      "brokerCompany": "Broker Company",
      "cancel": {
        "error": {
          "body": "You already activated your account",
          "title": "We could not confirm your email!"
        },
        "success": {
          "body": "You will no longer receive reminder emails from us",
          "title": "Sign up canceled! "
        }
      },
      "cancelBtn": "Cancel",
      "company": {
        "createNew": "Couldn't find your team? Just create your own, it's easy. <a href=\"%{link}\">Click here</a> to create an account for your team.",
        "details": "Fill in the details below to register your team on Rialto:",
        "name": "Company name",
        "requestAccess": "Request access",
        "requestPending": "Request pending",
        "role": "My business is best described as follows:",
        "roles": {
          "broker": "I'm a real estate agent / online broker",
          "ownerFlex": "I'm a flex workspace / coworking operator",
          "ownerLeasing": "I'm a landlord and / or run my own leasing team"
        },
        "welcome": "Welcome to Rialto, %{name}!\n<br />\n<br />\nThe following teams match your email domain. Get access to yours."
      },
      "existingAccount": "Already have an account?",
      "getStarted": "Get started",
      "linkedin_signup": "Signup with LinkedIn",
      "submitted": "Welcome %{fname}!\n<br />\n<br />\nWe'll reach out shortly to confirm your email address. After clicking the link in the email, you can choose to either <strong>join an existing team</strong> or <strong>create a new team</strong>.\n<br />\n<br />\n👉🏻 Did not receive an email? Please make sure to check your <strong>spam folder</strong>.",
      "submittedCampaign": "Welcome %{fname}!\n<br />\n<br />\nWe'll reach out shortly to confirm your email address. After clicking the link in the email, you can <strong>start using Rialto</strong>.",
      "tagline": "There's a smarter way to drive workspace occupancy. <br />\nYou thought about it. We built it for you.",
      "title": "Get started for free"
    },
    "Size": {
      "amount": "unit",
      "amounts": "units",
      "m2": "sqm",
      "square_foot": "sqft"
    },
    "SpaceCategory": {
      "residential": ""
    },
    "SpaceModal": {
      "title": "Add new space"
    },
    "SpaceStatusDialog": {
      "body": "Are you sure you want to set this space off-market? Brokers will no longer see this space. It will no longer appear on the asset navigator or the flyers.",
      "confirm": "Set off-market",
      "notify": "Notify brokers that the space is no longer available"
    },
    "SpacesTable": {
      "actions": {
        "delete": "Delete",
        "duplicate": "Duplicate",
        "edit": "Edit",
        "setNotUnderOffer": "No longer Under Offer",
        "setPrivate": "Put off-market",
        "setPublic": "Put on-market",
        "setUnderOffer": "Put Under Offer"
      },
      "addPrice": "Add price",
      "assetDetailNoSpaces": "No spaces for this product yet, click <strong>Add</strong> on  the right.",
      "availability": {
        "mobile": {
          "now": "Available",
          "tbd": "TBD"
        },
        "now": "Vacant",
        "tbd": "TBD"
      },
      "deals_associated": "%{smart_count} deal is referring to this space. |||| %{smart_count} deals are referring to this space.",
      "firstRefusalRight": "Right of first refusal",
      "form": {
        "titleAdd": "Add space",
        "titleEdit": "Add space"
      },
      "headers": {
        "availableFrom": "Availability",
        "category": "Type",
        "description": "Description",
        "edit": " ",
        "floor": "Floor",
        "image": "",
        "inventory": "Number in Inventory",
        "leaseholder": "Leaseholder",
        "leaseholders": "Leaseholder",
        "minContractLength": "Contract Length",
        "name": "Unit",
        "period": "Period",
        "price": "Price",
        "size": "Size",
        "sizeUnit": "Unit",
        "status": "Status",
        "syncInfo": "",
        "unit": "Unit Name"
      },
      "inventory": "Inventory",
      "lxd": "LXD",
      "noSpaces": "No available spaces for this asset.",
      "periods": {
        "daily": {
          "one": "day",
          "other": "days"
        },
        "hourly": {
          "one": "hour",
          "other": "hours"
        },
        "monthly": {
          "one": "month",
          "other": "months"
        },
        "weekly": {
          "one": "week",
          "other": "weeks"
        },
        "yearly": {
          "one": "year",
          "other": "years"
        }
      },
      "price": {
        "all_in": "Service charges and taxes included",
        "rate": "Tax:",
        "rent": "Rent:",
        "service": "Charges:",
        "undisclosed": "Upon request"
      },
      "pricing": "Pricing",
      "private": "<strong>off</strong> market",
      "public": "<strong>on</strong> market",
      "removeSpace": "Do you want to permanently remove this space? Space will be disassociated from opportunities and proposals. Brokers won't be notified.",
      "renewalPeriod": "Renewal each",
      "undefined": "Undefined",
      "under_offer": "Under Offer"
    },
    "StageProgress": {
      "selectStage": "Select stage"
    },
    "Statistics": {
      "assetLeads": "Acquisition |||| Acquisitions",
      "totalSize": "total demand"
    },
    "StatusButton": {
      "disregard": "Disregard",
      "execute": "Executed"
    },
    "SubmitButton": {
      "submit": "Post",
      "submitted": "Submitted!",
      "submitting": "Posting.."
    },
    "SubscribeButton": {
      "subscribe": "Subscribe",
      "subscribed": "Subscribed"
    },
    "TabbedFilter": {
      "apply": "Apply",
      "channel": "Originator",
      "region": "Region",
      "regionCategories": {
        "regions": "By Region"
      },
      "selected": "%{nb} selected"
    },
    "Table": {
      "headers": {
        "activity": "Activity",
        "asset": "Asset",
        "assetSpaces": "Asset",
        "asset_spaces": "Asset",
        "assets": "Assets",
        "budget": "Budget",
        "category": "Type",
        "channel": "Originator",
        "closeDate": "Close Date",
        "comment": "Comment",
        "contact": "Contact",
        "currentSituation": "Current situation",
        "date": "Date",
        "description": "Additional information",
        "disregardComment": "Reason of cancellation",
        "endDate": "End Date",
        "features": "Requirements",
        "feePotential": "Enquiry value",
        "fee_potential": "Enquiry value",
        "followUpDate": "Follow-up",
        "includeInReport": "In report",
        "location": "Location",
        "name": "Name",
        "nonProspectComment": "Comments / Follow up",
        "pointPerson": "Point Person",
        "point_person": "Point Person",
        "portfolio": "Portfolio",
        "potential": "Potential",
        "probability": "Probability",
        "prospectComment": "Comments",
        "shareStatus": "",
        "share_status": "",
        "size": "Size",
        "spaceCategories": "Category",
        "space_categories": "Category",
        "stage": "Phase",
        "startDate": "Start Date",
        "start_date": "Start Date",
        "tenant": "Tenant",
        "term": "Term",
        "type": "Key Drivers",
        "viewed": "Viewed",
        "warning": " "
      },
      "noAsssetLeads": "No results",
      "noDeals": "No opportunities found"
    },
    "TenantProfile": {
      "address": {
        "title": "Current address"
      },
      "company": {
        "title": "Company"
      },
      "confirm": {
        "cancel": "Are you sure you want to cancel? All your changes will be lost.",
        "delete": "Are you sure you want to delete?"
      },
      "contacts": {
        "title": "Contacts"
      },
      "email": {
        "title": "Email"
      },
      "head_count": {
        "title": "Head Count"
      },
      "industry": {
        "title": "Industry"
      },
      "leaseExpiration": {
        "title": "Lease expiration date"
      },
      "locale": "Language",
      "mobile": {
        "title": "Mobile phone"
      },
      "name": {
        "title": "First and last name"
      },
      "phone": {
        "title": "Office phone"
      },
      "position": {
        "title": "Position"
      },
      "rentable_area": {
        "title": "Rentable Area"
      },
      "title": "Tenant Profile"
    },
    "TenantRepresentative": {
      "actions": {
        "edit": "Edit",
        "unlink": "Unlink"
      },
      "company": {
        "title": "Company"
      },
      "email": {
        "title": "Email"
      },
      "job_title": {
        "title": "Title"
      },
      "name": {
        "title": "First and last name"
      },
      "phone": {
        "title": "Phone"
      },
      "title": "Tenant Rep."
    },
    "TermsOfServiceForm": {
      "addTos": "Add Terms of Service",
      "body": "Content",
      "default": "Set as default: show on company profile and auto-assign to new assets created",
      "defaultTosWarning": "You can only have one default terms of service. If you continue, any existing default terms of service will be replaced. Are you sure?",
      "file": "File",
      "title": "Title"
    },
    "Timestamp": {
      "original": "Original timestamp"
    },
    "TitledDate": {
      "title": "Choose %{title}"
    },
    "TourButton": {
      "book": "Book a tour"
    },
    "UserConfirmModal": {
      "agreement": {
        "agree": "OK - I understand",
        "description": "Hi %{user}, you will get access to Rialto after you confirmed your account details.",
        "terms_description": "By completing this confirmation form, you confirm that you have read and accepted our <a href=\"http://www.getrialto.com/terms\" target=\"_blank\">Terms of Service</a> and <a href=\"https://www.getrialto.com/privacy\" target=\"_blank\">Privacy Policy</a>",
        "title": "Confirmation needed"
      },
      "confirm": "Confirm",
      "confirming": "Confirming..",
      "details": {
        "description": "Please verify your details and confirm your account.",
        "title": "Profile details"
      }
    },
    "UserDetails": {
      "inactive": "inactive"
    },
    "UserEdit": {
      "first_name": "First name"
    },
    "ViewToggle": {
      "display": "Display"
    },
    "deal": {
      "space_categories": "Category"
    },
    "forms": {
      "picturePlaceholder": "Upload a picture"
    },
    "notifications": {
      "asset": {
        "delete": {
          "success": {
            "title": "Asset deleted!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "You will receive an email shortly",
            "title": "Your portfolio is being exported"
          }
        },
        "requestFlyer": {
          "success": {
            "message": "You can expect feedback from the asset manager over email.",
            "title": "Request for more information sent succesfully!"
          }
        }
      },
      "deal": {
        "delete": {
          "error": {
            "message": "Please try again later",
            "title": "Opportunity could not be destroyed!"
          },
          "success": {
            "title": "Opportunity deleted successfully!"
          }
        },
        "duplicate": {
          "success": {
            "title": "Opportunity duplicated successfully!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "You will receive an email shortly",
            "title": "Opportunities schedule is being exported"
          }
        },
        "renew": {
          "success": {
            "title": "Opportunity duplicated successfully!"
          }
        }
      },
      "defaultErrorTitle": "An error occured!",
      "defaultInfoTitle": "Info",
      "notAuthenticated": {
        "message": "Please re-login",
        "title": "You are not authenticated"
      },
      "portfolio": {
        "delete": {
          "success": {
            "bodyDelete": "All associated assets and opportunities are removed.",
            "bodyTransfer": "All associated assets and opportunities are transferred.",
            "title": "Portfolio deleted!"
          }
        }
      },
      "subscriptions": {
        "update": {
          "success": {
            "body": "Your changes are effective immediately",
            "title": "Notification settings saved!"
          }
        }
      },
      "user": {
        "brokerInvite": {
          "success": {
            "messageActive": "%{user} now has access to the selected assets.",
            "messageNew": "%{user} will have access to the assets after accepting the invitation.",
            "title": "%{user} invited successfully!"
          }
        },
        "requestPasswordReset": {
          "success": {
            "message": "You will receive an email shortly with further instructions.",
            "title": "New password requested!"
          }
        },
        "resetPassword": {
          "success": {
            "message": "You should now use this password the next time you sign in.",
            "title": "Password changed successfully."
          }
        }
      }
    },
    "shared": {
      "add": "Add",
      "adding": "Adding..",
      "address": "%{address} %{city}, %{zip}",
      "amount": "Amount",
      "and": "and",
      "askInfo": "Request flyer",
      "asset": {
        "address": "Address",
        "asset": "Asset",
        "city": "City",
        "name": "Name",
        "region": "Region",
        "state": "State",
        "statuses": {
          "fully_let": "Fully let",
          "invite": "Invite-only",
          "other": "Other",
          "private": "Private",
          "public": "Free-fight",
          "sold": "Sold"
        },
        "zip": "Zip"
      },
      "assetCategories": {
        "hotel": "Hotel",
        "industrial": "Industrial",
        "land": "Land",
        "multi_family": "Multi-family",
        "office": "Office",
        "other_cat": "Other",
        "residential": "Residential",
        "retail": "Retail",
        "warehouse": "Warehouse"
      },
      "assetLeadStages": {
        "closing": "Closing",
        "negotiating": "Negotiating",
        "pitch": "Pitch",
        "prospect": "Prospect"
      },
      "assetLeads": "Acquisition",
      "billingMethods": {
        "post": "post-payment",
        "pre": "pre-payment"
      },
      "budget": "Budget",
      "cancel": "Cancel",
      "category": "Type",
      "channelCategories": {
        "email": "Email",
        "employee_referral": "Employee referral",
        "leasing_agent": "Leasing agent",
        "listing_site": "Listing site",
        "online_broker": "Online broker",
        "other_cat": "Other",
        "phone": "Over phone",
        "referral": "Referral",
        "social_media": "Social Media",
        "tenant_rep": "Tenant Rep",
        "unknown": "Unknown",
        "walk_in": "Walk-in",
        "website": "Website"
      },
      "closeDate": "Close Date",
      "company": "Company",
      "companyTypes": {
        "acquisition": "Acquisition",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "confirm": {
        "cancel": "Are you sure you want cancel? All changes will be lost.",
        "delete": "Are you sure you want to delete?"
      },
      "contactCategories": {
        "agent": "Agent",
        "asset_manager": "Asset Manager",
        "key_holder": "Key Holder",
        "landlord": "Landlord",
        "other_cat": "Other",
        "property_manager": "Property Manager",
        "tenant": "Tenant"
      },
      "copied": "Copied!",
      "copy": "Copy",
      "copy_of": "Copy of",
      "country": "Country",
      "deal": {
        "activity": "Activity",
        "asset": "Asset",
        "assets": "Assets",
        "budget": "Budget",
        "channel": "Originator",
        "deal": "Opportunity",
        "fee_potential": "Enquiry value",
        "leaseBreakDates": "Lease break dates",
        "leaseCommencementDate": "Lease commencement date",
        "leaseExpirationDate": "Lease expiration date",
        "location": "Location",
        "point_person": "Point Person",
        "portfolio": "Portfolio",
        "probability": "Probability",
        "share_status": "Share status",
        "size": "Size",
        "space_categories": "Category",
        "start_date": "Start Date",
        "tenant": "Tenant",
        "term": "Term",
        "type": "Reason for moving"
      },
      "dealStages": {
        "delivery": "Completion",
        "execution": "Exchange",
        "finder": "Monitoring",
        "inquiry": "Inquiry",
        "new": "New",
        "prospects": "Prospect",
        "signed_loi": "Agreement",
        "touring": "Viewing",
        "trading_proposal": "RFP/Proposal"
      },
      "dealStatuses": {
        "active": "Active",
        "all": "All",
        "dead": "Dead",
        "executed": "Executed"
      },
      "dealTypes": {
        "expansion": "Expansion",
        "new": "New",
        "reduction": "Reduction",
        "renegotiation": "Renegotation",
        "renewal": "Renewal"
      },
      "deals": "Opportunities",
      "default": "Default",
      "delete": "Delete",
      "deletedUser": "Deleted User",
      "deleting": "Deleting..",
      "disregard_outcomes": {
        "move": "Signed with competing asset",
        "other_outcome": "Other",
        "stay": "Renewed current lease",
        "unknown": "Unknown"
      },
      "disregard_reasons": {
        "broker": "Broker information request",
        "duplicate_entry": "Duplicate entry",
        "location": "Location",
        "other_reason": "Other",
        "price": "Price",
        "quality": "Quality",
        "size": "Offered unit(s) don't match needs",
        "tenant_unqualified": "Tenant not qualifed",
        "timed_out": "Requirement timed out",
        "unknown": "Unknown"
      },
      "download": "Download",
      "download_ics": "Add to calendar",
      "edited": "Edited",
      "email": "Email",
      "emptyText": {
        "assetDeal": "First associate asset to this opportunity",
        "channels": "First add originator(s) on the opportunity page",
        "proposals": "First add proposal(s) on the opportunity page",
        "spaces": "First add space(s) to the asset of this opportunity",
        "spacesDeal": "First add an asset to this opportunity and/or space(s) to its asset"
      },
      "endDate": "End date",
      "errorTitle": "An error occured!",
      "every": "Every",
      "filter": "Filter",
      "flyer": "Flyer",
      "flyerContact": "Flyer Contact",
      "footer": {
        "about": "About Rialto",
        "blog": "Blog",
        "careers": "Careers",
        "status": "Status",
        "terms": "Terms of use"
      },
      "formChangesPrompt": "You have some unsaved data. Are you sure you want to navigate to another page?",
      "free": "free",
      "from": "from",
      "fullName": "First and last name",
      "in": "in",
      "industries": {
        "automobile": "Automotive",
        "aviation": "Aviation & Travel",
        "banks": "Banks",
        "basic_resources": "Basic Resources",
        "chemicals": "Chemicals",
        "construction": "Construction & Materials",
        "consumer_electronics": "Consumer Electronics",
        "culture": "Culture",
        "cw": {
          "automotive": "Automotive",
          "business_space": "Overige bedrijfsruimte",
          "cleanroom": "Cleanroom/Laboratorium",
          "datacenter": "Datacenter",
          "dc": "DC",
          "food": "Food",
          "high_tech": "High Tech/3D",
          "self_storage": "Self Storage",
          "sustainable_energy": "Sustainable/(Nieuwe) energie",
          "urban_logistics": "Urban Logistics/Cross Docks"
        },
        "education": "Education",
        "education_art": "Education & Art",
        "entertainment": "Entertainment",
        "financial_services": "Financial Services",
        "food": "FMCG - Food & Beverage",
        "healthcare": "Pharmaceutical & health care",
        "household_goods": "Personal & Household Goods",
        "industrial_goods": "Industrial Goods & Services",
        "insurance": "Insurance",
        "legal": "Legal",
        "luxury": "Fashion, décor & luxury",
        "media": "Media",
        "oil_gas": "Oil & Gas",
        "other_cat": "Other",
        "professional_services": "Professional services",
        "public": "Public Sector",
        "real_estate": "Real Estate",
        "retail": "Retail",
        "sports_leisure": "Sports & Leisure",
        "technology": "Technology",
        "telecommunications": "Telecommunications",
        "travel": "Travel & Leisure",
        "utilities": "Utilities",
        "wellbeing": "Wellbeing"
      },
      "industry": "Industry",
      "integrationCategories": {
        "listing_site": "Listing site",
        "mail": "Email",
        "online_broker": "Online broker",
        "other_cat": "Other",
        "property_management": "Property management"
      },
      "language": "Language",
      "languages": {
        "en": "English",
        "en-GB": "British English",
        "en-GB-acquisition": "British English",
        "en-GB-flex": "British English",
        "en-acquisition": "English",
        "en-flex": "English",
        "fr-FR": "Français",
        "fr-FR-acquisition": "Français",
        "fr-FR-flex": "Français",
        "nl-BE": "Nederlands (BE)",
        "nl-BE-acquisition": "Nederlands (BE)",
        "nl-BE-flex": "Nederlands (BE)",
        "nl-NL": "Nederlands (NL)",
        "nl-NL-acquisition": "Nederlands (NL)",
        "nl-NL-flex": "Nederlands (NL)"
      },
      "loading": "Loading..",
      "more": "more",
      "name": "Name",
      "ner": "NER",
      "on": "on",
      "password": "Password",
      "per": "per",
      "phone": "Phone number",
      "placeholder": "Enter text here",
      "placeholders": {
        "assets": "Select one or more assets",
        "portfolios": "Select a portfolio"
      },
      "pointPerson": "Point Person",
      "portfolio": "Portfolio",
      "portfolioTypes": {
        "acquisition": "Acquisition",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "potentials": {
        "above_average": "Above average",
        "average": "Average",
        "high": "High potential",
        "low": "Low",
        "moderate": "Moderate"
      },
      "private": "Private",
      "probability": "Probability",
      "proposal": "Proposal",
      "rofr": "ROFR",
      "rofr_full": "Right of first refusal",
      "roles": {
        "account_holder": "Account holder |||| Account holders",
        "administrator": "Administrator |||| Administrators",
        "internal_user": "Internal user |||| Internal users"
      },
      "save": "Save",
      "saved": "Saved!",
      "saving": "Saving..",
      "search": "Search",
      "search_placeholder": "Search...",
      "send": "Send",
      "sending": "Sending..",
      "shareStatuses": {
        "all": "All collaborators",
        "broker_owner_team": "Me & my client",
        "broker_team_owner_team": "My team & my client",
        "custom": "Custom",
        "owner_team": "My team"
      },
      "size": {
        "separator": "to",
        "title": "Size"
      },
      "space": "Space",
      "spaceCategories": {
        "archive": "Archive",
        "carParking": "Outdoor parking",
        "car_parking": "Outdoor parking",
        "coveredCarParking": "Covered car parking",
        "covered_car_parking": "Covered car parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Land",
        "leisure": "Leisure",
        "logistical": "Logistical",
        "meeting": "Meeting/Conference",
        "office": "Office",
        "other": "Other",
        "other_cat": "Other",
        "outdoor_area": "Outdoor area",
        "residential": "Residential",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Warehouse"
      },
      "spaceStatuses": {
        "all": "All",
        "private": "Off market",
        "public": "On-market"
      },
      "spaces": "Spaces",
      "startDate": "Start date",
      "status": "Status",
      "systemEvents": {
        "asset_lead_add_contact": "Contact <i>%{contact}</i> added by <i>%{actor}</i>",
        "asset_lead_create": "<i>%{creator}</i> created acquisition",
        "asset_lead_stage_update": "<i>%{actor}</i> changed stage from <i>%{before}</i> to <i>%{after}</i>",
        "asset_lead_status_update": "<i>%{actor}</i> changed status from <i>%{before}</i> to <i>%{after}</i>",
        "deal_accept_proposal": "Draft contract requested by <i>%{name}</i>",
        "deal_add_asset": "<i>%{actor}</i> added opportunity to <i>%{asset}</i>",
        "deal_channel_add": "Originator <i>%{channel}</i> added by <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> created opportunity for <i>%{asset}</i>",
        "deal_create_no_asset": "<i>%{creator}</i> created opportunity",
        "deal_lease_cancel": "<i>%{actor}</i> has terminated the lease",
        "deal_merge": "Deal merged with <i>%{after}</i> by <i>%{actor}</i>",
        "deal_point_person_change": "<i>%{creator}</i> changed point person from <i>%{before}</i> to <i>%{after}</i>",
        "deal_remove_asset": "Opportunity disassociated from <i>%{asset}</i> by <i>%{actor}</i>",
        "deal_renewal": "<i>%{creator}</i> duplicated opportunity <i>%{ancestor}</i> for renewal.",
        "deal_share_status_update": "Opportunity sharing settings updated to <i>%{after}</i> by <i>%{actor}</i>",
        "deal_stage_update": "<i>%{actor}</i> changed stage from <i>%{before}</i> to <i>%{after}</i>",
        "deal_status_update": "<i>%{actor}</i> changed status from <i>%{before}</i> to <i>%{after}</i>",
        "deal_tenant_add": "<i>%{actor}</i> added <i>%{tenant}</i> as tenant",
        "deal_tenant_broker_add": "<i>%{actor}</i> added <i>%{tenant_rep}</i> as tenant rep"
      },
      "to": "to",
      "totalSize": "total size",
      "undisclosed": "Undisclosed",
      "units": {
        "CAD": "CAD",
        "CHF": "CHF",
        "DKK": "DKK",
        "EUR": "EUR",
        "GBP": "GBP",
        "NOK": "NOK",
        "SGD": "SGD",
        "USD": "USD",
        "amount": "unit |||| units",
        "amount_desk": "desk |||| desks",
        "amount_person": "person |||| people",
        "amount_room": "room |||| rooms",
        "daily": "day |||| days",
        "desk": "desk |||| desks",
        "floor": "floor |||| floors",
        "ft²": "ft²",
        "hourly": "hour |||| hours",
        "m2": "sqm",
        "monthly": "month |||| months",
        "monthly_short": "mo",
        "m²": "m²",
        "parking": "parking |||| parkings",
        "person": "person |||| people",
        "room": "room |||| rooms",
        "space": "unit |||| units",
        "sqft": "sqft",
        "square_foot": "sqft",
        "units": "units",
        "weekly": "week |||| weeks",
        "yearly": "year |||| years",
        "yearly_short": "yr"
      },
      "upload": "Upload file",
      "user": {
        "email": "Email",
        "fname": "First name",
        "licenseNumber": "RICS membership number",
        "lname": "Last name",
        "locale": "Language",
        "mobile": "Mobile number",
        "name": "First and last name",
        "password": "Password",
        "passwordConfirmation": "Password confirmation",
        "phone": "Phone number",
        "role": "Role",
        "timezone": "Timezone",
        "title": "Title"
      },
      "with": "with"
    },
    "spaces": {
      "category": "Category"
    }
  },
  "fr-FR": {
    "ActivityFeed": {
      "empty_files": "Aucun fichier.",
      "empty_items": "Aucun objet.",
      "empty_notes": "Aucune message privée.",
      "empty_updates": "There are no updates.",
      "empty_viewings": "Aucune visite.",
      "filters": {
        "Call": "Appels",
        "DealNote": "Messages",
        "Email": "Emails",
        "File": "Emails",
        "Note": "Messages",
        "Proposal": "Propositions",
        "Viewing": "Visites",
        "all": "Tous",
        "call": "Appels",
        "deal_note": "Messages",
        "email": "Emails",
        "file": "Fichiers",
        "label": "Afficher",
        "note": "Messages",
        "proposal": "Propositions",
        "update": "Messages",
        "viewing": "Visites"
      },
      "header": {
        "Call": "Appel",
        "DealNote": "Message",
        "Email": "Email",
        "Note": "Message",
        "Proposal": "Proposition",
        "Viewing": "Visite",
        "call": "Appel",
        "deal_note": "Message",
        "email": "Email",
        "file": "Fichier",
        "label": "Envoyer",
        "note": "Message",
        "proposal": "Proposition",
        "update": "Message",
        "viewing": "Visite"
      }
    },
    "AddActions": {
      "addDeal": ""
    },
    "Asset": {
      "deals": {
        "empty": "Aucune opportunité",
        "fetching": "En cours..",
        "hide": "Masquer opportunités",
        "show": "Afficher %{smart_count} opportunité |||| Afficher %{smart_count} opportunités"
      },
      "noAvailableSpaces": "Pas des espaces disponibles",
      "spaces": {
        "empty": "Pas des espaces disponibles",
        "fetching": "En cours..",
        "hide": "Masquer espaces",
        "show": "Afficher %{smart_count} espace |||| Afficher %{smart_count} espaces"
      },
      "spacesFetching": "En cours..",
      "spacesHide": "Masquer espaces",
      "spacesView": "Afficher %{smart_count} espace |||| Afficher %{smart_count} espaces"
    },
    "AssetActions": {
      "askQuestion": "Question",
      "copied": "l'URL du flyer copié !",
      "copy": "Copier l'URL de la brochure",
      "download": "Télécharger la brochure d'information",
      "open": "Afficher la brochure",
      "requestFlyer": "Brochure",
      "sendSMS": "Texto",
      "subscribed": "S’abonner à la newsletter hebdomadaire",
      "unsubscribed": "Se désabonner à la newsletter hebdomadaire"
    },
    "AssetAvailability": {
      "availableSpace": "Vacance",
      "spaces": "espaces"
    },
    "AssetCharges": {
      "allIn": "Frais de service et taxes (hors TVA) inclus",
      "rate": "Impôts fonciers (est.)",
      "sell": "Prix de vente",
      "service": "Frais de service (est.)"
    },
    "AssetCreateModal": {
      "autoGenerateFlyer": "Générer automatiquement une brochure pour cet actif",
      "description": "Entrez les informations de base du nouvel actif ici. Vous pouvez ajouter plus de détails plus tard.",
      "title": "Ajouter un actif"
    },
    "AssetDeals": {
      "actions": {
        "dropped": "Abandonné",
        "edit": "Éditer",
        "exclude": "Exclure du rapport",
        "include": "Inclure dans le rapport",
        "not_dropped": "Pas abandonné",
        "not_viewed": "Marquer comme pas visité",
        "viewed": "Marquer comme visité"
      },
      "groups": {
        "active": "Actif",
        "dead": "Négligé",
        "prospects": "Prospects"
      },
      "nonProspectCommentMissing": "Proch. étapes sont requis pour l'exportation"
    },
    "AssetFilter": {
      "budget": "Budget",
      "region": "région",
      "status": "Statut",
      "type": "Type"
    },
    "AssetHeader": {
      "deals": "Pipeline des demandes",
      "export": {
        "btn": "Exporter",
        "disabled": "Exportation impossible. Entrée manquante sur : Proch. étapes",
        "notification": {
          "message": "Vous recevrez un email bientôt",
          "title": "Votre rapport locatif sera exporté"
        }
      },
      "tabs": {
        "access": "Accès",
        "announcements": "Annonces",
        "assetDeals": "Rapport Locatif",
        "contacts": "Contacts",
        "files": "Photos et Fichiers",
        "floorplan": "Plans",
        "infosheet": "Formulaire",
        "settings": "Paramètres",
        "spaces": "Espaces"
      }
    },
    "AssetIncentives": {
      "active": "Actif",
      "emptyMessage": {
        "active": "Faites glisser vos modèles d'honoraires <strong>actifs</strong> ici",
        "inactive": "Faites glisser vos modèles d'honoraires <strong>inactifs</strong> ici"
      },
      "inactive": "Inactif",
      "info": "Besoin d'un nouveau modèle d'honoraire? Vous pouvez créer des nouveaux modèles d'honoraires dans vos <a href=\"/settings/templates/incentives\">paramètres généraux</a>."
    },
    "AssetInfoModal": {
      "btn": "Poser votre question",
      "header": "Question à propos de %{asset}",
      "questionPlaceholder": "Poser votre question..",
      "topic": "Objet à",
      "topics": {
        "another": "Autre",
        "commissions": "Commissions",
        "service": "Coûts communs",
        "viewing": "Demande visite"
      }
    },
    "AssetInformation": {
      "incentives": "Honoraires",
      "title": "Calcul de commissions",
      "tos": "Conditions de service"
    },
    "AssetLeadAddress": {
      "title": "Détails de l'adresse"
    },
    "AssetLeadContacts": {
      "title": "Contacts"
    },
    "AssetLeadCreateForm": {
      "address": "Rue et numéro",
      "assetLead": "Acquisition"
    },
    "AssetLeadDetails": {
      "description": "Information additionnelle",
      "title": "Détails d'acquisition"
    },
    "AssetLeadHeader": {
      "collaborators": {
        "title": "Collaborateurs"
      },
      "days_active_from_now": "En cours depuis %{days}",
      "pointPerson": {
        "dropdownHeader": "Selectionner",
        "title": "Référent"
      },
      "reopen": "Réouvrez?",
      "status": {
        "days_active_from_now": "En cours depuis %{days}",
        "number_of_days_active": "En cours depuis %{days} jours",
        "title": "Statut"
      },
      "title": "Opportunité d'acquisition"
    },
    "AssetLeadModal": {
      "title": "Créer opportunité acquisition"
    },
    "AssetLeadStatusMessage": {
      "disregarded": "négligé",
      "executed": "réalisée",
      "message": "L'opportunité d'acquisition a été <strong>%{status}</strong> par %{actor} le %{date}",
      "message_no_actor": "L'opportunité d'acquisition a été <strong>%{status}</strong> le %{date}"
    },
    "AssetLeadsList": {
      "emptyStage": "Aucune acquisition au stage présent"
    },
    "AssetNavigator": {
      "disclaimer": "Les informations contenues dans ce document sont strictement confidentielles. Vous n’êtes pas autorisé à les diffuser, sauf s’il s’agit de potentiels locataires avec qui vous êtes en contact. Pour tout autre cas, merci de bien vouloir tout d’abord nous contacter avant de transmettre ce document vers l’extérieur.",
      "filter": "Filtrer",
      "loading": "Chargement...",
      "noAssets": "Votre recherche n'a donné aucun résultat.",
      "searchPlaceholder": "Rechercher.."
    },
    "AssetNavigatorHeader": {
      "collapse": " Masquer les détails",
      "display": "Affichage",
      "expand": "Afficher tous",
      "placeholder": "Rechercher.."
    },
    "AssetOnMarket": {
      "onMarket": "sur le marché"
    },
    "AssetSettings": {
      "access": "Accès",
      "actions": {
        "menuTitle": "Actions",
        "portfolio": {
          "dropdownTitle": "Passer à",
          "information": "Lorsque vous transférez cet actif dans un autre portefeuille, toutes les <strong>demandes</strong> associées à cet actif du portefeuille actuel seront également transférées dans le nouveau portefeuille.",
          "menuTitle": "Changer de portefeuille",
          "title": "Changer de portefeuille"
        }
      },
      "assetUsers": {
        "cancel_invite": "Annuler l'invitation",
        "invitationPending": "Invitation en attente",
        "inviteBtn": "Inviter",
        "menuTitle": "Collaborateurs",
        "none": {
          "fully_let": "Votre actif est <strong>complètement loué</strong>. <a href=\"/assets/%{id}/settings/access/status\">Changez son statut </a> pour inviter des collaborateurs.",
          "invite": "Vous n'avez <strong>pas de collaborateurs</strong> pour le moment.",
          "private": "Votre actif est <strong>privé</strong>. <a href=\"/assets/%{id}/settings/access/status\">Changez son statut </a> pour inviter des collaborateurs.",
          "public": "Vous n'avez <strong>pas de collaborateurs</strong> pour le moment.",
          "sold": "Votre actif est <strong>complètement loué</strong>. <a href=\"/assets/%{id}/settings/access/status\">Changez son statut </a> pour inviter des collaborateurs."
        },
        "resend_invite": "Renvoyer l'invitation",
        "revoke": "Révoquer l'accès",
        "revoke_company": "Révoquer l'accès à l'équipe"
      },
      "costs": {
        "allIn": "Frais de service et taxes (hors TVA) inclus",
        "menuTitle": "Général",
        "rentPrice": "Prix de location",
        "sellPrice": "Prix de vente",
        "sellingTitle": "Prix de vente",
        "serviceTitle": "Frais de service",
        "taxTitle": "Impôts fonciers"
      },
      "fees": "Frais",
      "financial": "Financier",
      "flyerSettings": {
        "autogenerateFlyer": "Génération automatique du brochure",
        "description": "L'activation de <strong>génération automatique</strong> pour les brochures crée une brochure et la tient à jour. Cela signifie que chaque fois que vous ajoutez ou mettez à jour un espace, une image, un plan d'étage, ... nous allons générer automatiquement un nouvelle brochure pour vous.",
        "title": "Paramètres de la brochure"
      },
      "general": "Général",
      "incentives": "Honoraraires",
      "options": {
        "delete": {
          "confirm": "Êtes-vous sûr de vouloir supprimer cet actif? C'est irréversible!",
          "information": "Si vous souhaitez fournir à vos courtiers plus d'informations sur les raisons pour lesquelles l'actif a été supprimé, vous pouvez ajouter <a href=%{link}>une annonce</a> ou sélectionner une raison ci-dessous.",
          "menuTitle": "Supprimer l'actif",
          "reason": "Raison de la suppression",
          "title": "Supprimer l'actif du portefeuille",
          "warning": "La suppression de l'actif supprime toutes ses données et est <strong>irréversible</strong>. <br/> Après la suppression, les membres de votre équipe et les courtiers seront avertis dans le résumé de la semaine prochaine. Ensuite, ils n'auront plus accès et l'actif sera <strong>définitivement</strong> supprimé."
        },
        "menuTitle": "Options"
      },
      "status": {
        "description": "La mise à jour du statut de l'actif aura une incidence sur la manière dont il est commercialisé sur Rialto:",
        "descriptionFullyLet": "Quand <strong>complètement loué</strong>, l'actif ne peut être accessible qu'à vous et à votre équipe",
        "descriptionInvite": "Quand <strong>sur invitation uniquement</strong>, vous décidez quels collaborateurs à inviter",
        "descriptionPrivate": "Quand <strong>privé</strong>, l'actif ne peut être accessible qu'à vous et à votre équipe",
        "descriptionPublic": "Quand disponible sous <strong>mandat ouvert</strong>, tous les courtiers peuvent y accéder sur Rialto.",
        "dropdownTitle": "Statut",
        "menuTitle": "Statut",
        "public_to_invite": "",
        "public_to_private": "",
        "title": "Mettre à jour le statut"
      },
      "tos": "Conditions d'utilisation",
      "tosExtraInfo": "Sélectionnez les conditions d'utilisation ci-dessous pour informer vos collaborateurs des conditions applicables à cet actif.",
      "tosInfo": "Besoin d'un nouveau modèle de conditions d'utilisation? Vous pouvez créer des nouveaux modèles de conditions d'utilisation dans vos <a href=\"/settings/templates/tos\">paramètres généraux</a>."
    },
    "AssetShareStatus": {
      "Tooltips": {
        "body_fully_let": "Cet actif est complètement loué",
        "body_invite": "List of collaborateurs this asset is shared with.",
        "body_private": "Cet actif est privé pour vous et votre équipe.",
        "body_public": "Cet actif est partagé avec tous les courtiers qui ont eu accès à ce portefeuille.",
        "footer_invite": {
          "one": "et %{count} plus",
          "other": "et %{count} plus"
        },
        "header_invite": "Partagé avec"
      }
    },
    "AssetSort": {
      "name": "Nom",
      "on_market": "Espace disponible",
      "order_by": "Trier par",
      "updated_at": "Dernière mise à jour"
    },
    "AssetStatistics": {
      "available": "Disponible ajd",
      "deals": "Demandes",
      "onMarket": "Sur le marché",
      "total": "Surface totale",
      "viewings": "Visites"
    },
    "AssetTermsOfService": {
      "info": "Besoin d'un nouveau modèle d'honoraire? Vous pouvez créer des nouveaux modèles d'honoraires dans vos <a href=\"/settings/incentives\">paramètres généraux</a>."
    },
    "Backbutton": {
      "back": "Retour"
    },
    "BrokerInviteForm": {
      "broker": "Collaborateur",
      "invite": "Inviter",
      "inviting": "Inviter..",
      "portfolioAssets": "Portefeuille & actifs"
    },
    "BrokerInviteModal": {
      "description": "Si vous invitez un collaborateur, vous accordez à la société du collaborateur l'accès aux disponibilités de location des actifs que vous avez sélectionnés, y compris les documents et le matériel de marketing. Vous n'avez partagé aucune des demandes créées par vous ou par un collaborateur avec cette collaborateur. Le courtier sera abonné en temps réel à l'une des mises à jour des actifs, et peut partager les demandes avec vous.",
      "title": "Inviter Collaborateur"
    },
    "Calendar": {
      "call": "Appel",
      "day": "Jour",
      "download": "S'abonner",
      "due_proposal": "Échéance de proposition",
      "lease_expiration": "Échéance du bail",
      "lease_start": "Début du bail",
      "month": "Mois",
      "space_available": "Espace disponible",
      "today": "Aujourd'hui",
      "viewing": "Visite",
      "week": "Semaine"
    },
    "Channels": {
      "category": "Catégory",
      "company": "Société",
      "confirm": {
        "delete": "Etes-vous sûr que vous voulez supprimer ?"
      },
      "name": "Prénom et nom",
      "phone": "Numéro de téléphone",
      "title": "Initiateurs"
    },
    "Commissions": {
      "durationLabel": "Durée de contrat",
      "feeLabel": "Commission",
      "header": "Commissions",
      "info": " Le pourcentage de commission et la durée du contrat sont <strong>liés comme suit</strong> :",
      "year": "an(s)"
    },
    "CompanyBlock": {
      "newPortfolio": "Nouveau portefeuille",
      "visitCompanyPage": "Profil de la société"
    },
    "CompanyPage": {
      "Contact": {
        "email": "Écrivez-nous",
        "phone": "Appelez nous"
      },
      "Login": {
        "footer": "Besoin d'un compte?",
        "header": "Vous avez un compte Rialto?",
        "login": "Se connecter à Rialto",
        "requestAccess": "Demande d'accès"
      },
      "NotFound": {
        "message": "Nous n'avons pas trouvé de société correspondante pour cette url",
        "title": "Cette page n'est pas disponible"
      },
      "contacts": "Contacts",
      "features": "Fonctionnalités",
      "incentives": "Honoraires",
      "introduce": "Présenter un client",
      "portfolios": "Portefeuilles",
      "tos": "Conditions de service"
    },
    "CompanyTooltip": {
      "inCountry": "in %{value}",
      "numberOfAssets": "%{smart_count} actif |||| %{smart_count} actifs",
      "viewCompanyProfile": "Profil de la société"
    },
    "Dashboard": {
      "empty": "Il n'y a pas de tableau de bord pour ce portefeuille"
    },
    "DateTime": {
      "add_date": "S'il vous plaît choisir une date",
      "add_time": "Choisissez l'heure ?",
      "select_date": "Selectionner",
      "set": "Définir",
      "submit": "Sauvegarder",
      "time": "Heure",
      "title": "Selectionner la date"
    },
    "DealActions": {
      "delete": {
        "confirm": "Êtes-vous sûr de vouloir supprimer définitivement cette demande ? Les commentaires sur cette opération seront aussi supprimés.",
        "tooltip": "Supprimer"
      },
      "duplicate": {
        "tooltip": "Dupliquer"
      },
      "merge": {
        "tooltip": "Fusionner"
      }
    },
    "DealCancel": {
      "cancelDate": "Date d'annulation",
      "confirm": "Confirmer",
      "confirming": "Confirmant",
      "feedback": "Feedback",
      "feedbackInfo": "Vos commentaires seront affichés à toute personne ayant accès à cette demande.",
      "feedbackPlaceholder": "Entrez vos commentaires ici",
      "moveDate": "Date de déménagement",
      "reason": "Raison",
      "title": "Annuler le bail"
    },
    "DealCard": {
      "nbAssets": "%{smart_count} biens"
    },
    "DealColumns": {
      "title": "Personnaliser les colonnes"
    },
    "DealDetail": {
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer définitivement cette demande ? Les commentaires sur cette opération seront aussi supprimés."
    },
    "DealDetails": {
      "budget": {
        "separator": "à",
        "title": "Budget"
      },
      "description": "Information additionnelle",
      "location": {
        "title": "Localisation"
      },
      "spaces": {
        "archive": "Archives",
        "car_parking": "Parking extérieur",
        "category": "Catégorie",
        "covered_car_parking": "Parking pour voitures couvert",
        "coworking": "Co-working",
        "industrial": "Surface industrielle",
        "land": "Terrain",
        "leisure": "Loisirs",
        "logistical": "Logistique",
        "meeting": "Réunion / Conférence",
        "new": "Nouveau",
        "office": "Postes de travail",
        "other_cat": "Autres",
        "outdoor_area": "Cour extérieur",
        "residential": "Résidentiel",
        "retail": "Détail",
        "showroom": "Showroom",
        "storage": "Stockage",
        "title": "Espaces"
      },
      "start_date": {
        "title": "Date de début"
      },
      "term": {
        "months": "mois",
        "title": "Durée maximale",
        "years": "année(s)"
      },
      "title": "Détails de la demande",
      "type": "Type",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "espaces"
      }
    },
    "DealFilter": {
      "advanced": "",
      "asset": "Actif",
      "selectedAsset": "%{nb} sélectionnés"
    },
    "DealForm": {
      "assets": {
        "info": "Pour chaque actif sélectionné, une demande séparée sera créée. N'oubliez pas les paramètres de confidentialité en bas à gauche avant l'ajout.",
        "title": "Actif |||| Actifs"
      },
      "channel": {
        "expand": "Ajouter les détails du <strong>bailleur</strong>",
        "title": "Origine"
      },
      "description": {
        "disclose": "<strong>Ajouter plus d'informations</ strong>",
        "placeholder": "Entrez un commentaire",
        "title": "Information additionnelle"
      },
      "details": {
        "title": "Demande"
      },
      "enquiry": {
        "title": ""
      },
      "placeholders": {
        "asset": "Associer actif(s) (facultatif)",
        "assets": "Associer actif (facultatif)"
      },
      "portfolio": {
        "title": "Portefeuille"
      },
      "save": "Ajouter",
      "saving": "Ajouter..",
      "stage": "Stage",
      "tenant": {
        "title": "Locataire",
        "undisclose": "<strong>Ne partagez pas</strong> les détails du bailleur"
      }
    },
    "DealMerge": {
      "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui sint asperiores maiores eaque voluptatum mollitia eum architecto, neque possimus hic corporis aliquid aut est tempore voluptates iste harum enim iusto rerum blanditiis magni aliquam. Vero maxime qui quis explicabo eum excepturi asperiores rerum eos veritatis, reprehenderit voluptatem possimus aliquam incidunt!",
      "source": "Fusionner ",
      "target": "Avec",
      "title": "Fusionner la demande"
    },
    "DealModal": {
      "header": "Nouvelle demande"
    },
    "Deals": {
      "portfolio_subscribed": "S’abonner à la newsletter hebdomadaire",
      "portfolio_unsubscribed": "Se désabonner à la newsletter hebdomadaire"
    },
    "DealsFilter": {
      "asset": "Actif",
      "channel": "Origine",
      "searchPlaceholder": "Rechercher..",
      "stage": "Stage"
    },
    "DealsTable": {
      "empty": "Aucune demande",
      "empty_stage": "Aucune demande au stage présent",
      "export": {
        "btnLabel": "Exporter",
        "csv": "Une version CSV du calendrier des demandes qui permet la modification.",
        "pdf": "Une version PDF du calendrier des demandes contenant toutes les activités par actif.",
        "title": "Demandes"
      },
      "loading": "Chargement..."
    },
    "Dialog": {
      "confirm": "Validez",
      "title": "Êtes-vous sûr ?"
    },
    "DisregardModal": {
      "disregard": "Négliger",
      "disregarding": "Négliger..",
      "feedbackInfo": "Vos commentaires seront affichés à toute personne ayant accès à cette demande.",
      "feedbackPlaceholder": "Entrez vos commentaires ici",
      "header": "Négliger cette demande",
      "outcome": "Résultat",
      "reason": "Raison"
    },
    "DropdownUserItem": {
      "me": "moi"
    },
    "DropdownUserSelect": {
      "pointPerson": "Référent"
    },
    "Dropzone": {
      "notSupported": "Le type de fichier que vous avez téléchargé n'est pas pris en charge",
      "placeholder": "Cliquez ou faites glisser ici pour télécharger un fichier",
      "placeholderPicture": "Cliquez ou faites glisser ici pour télécharger une image"
    },
    "EnquiryDetails": {
      "budget": {
        "title": ""
      },
      "title": ""
    },
    "EnquiryHeader": {
      "DealStages": {
        "hide": "Masquer",
        "modal": {
          "body": "Ici, vous pouvez modifier les actifs en cours d'exécution pour %{stage}. Lors de la modification, l'actif sera négligé pour cette demande.",
          "title": "Modifier les actifs dans %{stage}"
        },
        "show": "Afficher %{smart_count} autres"
      },
      "assignAsset": "Associez un actif",
      "assignFeePotential": "",
      "collaborators": {
        "title": "Collaborateurs"
      },
      "confirm": {
        "assetRemove": "Cette demande peut avoir un ou plusieurs espaces associés de %{asset}. Cette association sera supprimée lors de la suppression de l'actif. Êtes-vous sur de vouloir continuer?",
        "assetUpdate": "Cette demande peut avoir un ou plusieurs espaces associés de %{asset}. Cette association sera supprimée lors de la mise à jour de l'actif. Êtes-vous sur de vouloir continuer?",
        "cancel": "Etes-vous sûre de vouloir annuler ? Toutes vos modifications seront perdues.",
        "feePotentialRemove": ""
      },
      "duplicate": "Dupliquer pour renouvellement",
      "feePotential": "",
      "modal": {
        "header": "Paramètres de partage personnalisés",
        "info": "Tout collaborateur marqué ici peut voir et mettre à jour cette demande. Nous ne les informerons pas si vous choisissez de ne plus partager.",
        "save": "Enregistrer",
        "search_collaborators": "Cherche collaborateurs",
        "title": "Collaborateurs ayant accès à la demande"
      },
      "point_person": {
        "dropdown_header": "Selectionner",
        "title": "Référent"
      },
      "renew": "Dupliquer pour renouvellement",
      "reopen": "Réouvrez cette demande ?",
      "status": {
        "days_active_from_now": "En cours depuis %{days}",
        "number_of_days_active": "En cours depuis %{days} jours",
        "title": "Statut"
      },
      "subscribed": "S’abonner",
      "title": "Demande",
      "unsubscribed": "Se désabonner"
    },
    "EnquiryModal": {
      "addEnquiry": "Ajouter",
      "addingEnquiry": "Ajouter..",
      "assets": {
        "title_pl": "Actifs",
        "title_sg": "Actif"
      },
      "channel": {
        "category": "Type",
        "company": "Société",
        "email": "Email",
        "name": "Nom",
        "title": "Origine"
      },
      "collapse_channel_details": "Masquer les détails du <strong>représentant</strong>",
      "collapse_comment_details": "<strong>Masquer le commentaire</strong> pour afficher lors de la création",
      "collapse_tenant_details": "<strong>Masquer les détails du bailleur</strong> et/ou les détails du représentant",
      "comment": {
        "placeholder": "Entrez un commentaire",
        "title": "Ajouter un message"
      },
      "confirm": {
        "cancel": "Etes-vous sûre de vouloir annuler ? Toutes vos modifications seront perdues."
      },
      "enquiry": {
        "name": "Nom",
        "title": "Demande"
      },
      "expand_channel_details": "Ajouter les détails du <strong>bailleur</strong>",
      "expand_comment_details": "<strong>Ajouter une note</ strong> pour afficher lors de la création",
      "expand_tenant_details": "<strong>Ajouter les détails du bailleur</strong> et/ou les détails du représentant",
      "header": "Nouvelle demande",
      "headerRenewal": "Dupliquer pour le renouvellement",
      "industry": {
        "art_culture": "Art et culture",
        "automobile": "Automobile",
        "aviation": "Aviation et voyage",
        "banks": "Banques",
        "basic_resources": "Resources de base",
        "chemicals": "Produits chimiques",
        "construction": "Construction et matériaux",
        "consumer_electronics": "Électronique grand public",
        "education": "Éducation",
        "education_art": "Éducation et Art",
        "entertainment_gaming": "Jeux et divertissement",
        "financial_services": "Services financiers",
        "food": "PDGC - Aliments et Boissons",
        "healthcare": "Produits pharmaceutiques et santé",
        "household_goods": "Biens personnels et domestiques",
        "industrial_goods": "Services et biens industriels",
        "insurance": "Assurance",
        "legal": "Juridique",
        "luxury": "Mode, décor et luxe",
        "media": "Média",
        "oil_gas": "Pétrole et Gaz",
        "other_cat": "Autres",
        "professional_services": "Services professionnels",
        "public": "Secteur public",
        "real_estate": "Immobilier",
        "retail": "Vente au détail",
        "sports_leisure": "Sports et Loisirs",
        "technology": "Technologie",
        "telecommunications": "Télécommunications",
        "title": "Secteur d'activité",
        "travel": "Voyage et Loisirs",
        "utilities": "Services",
        "wellbeing": "Bien-être"
      },
      "info": "Pour chaque actif sélectionné, une demande séparée sera créée. N'oubliez pas les paramètres de confidentialité en bas à gauche avant l'ajout.",
      "portfolio": {
        "title": "Portefeuille"
      },
      "size": {
        "separator": "à",
        "title": "Surface"
      },
      "start_date": {
        "title": "Date de début"
      },
      "tenant": {
        "company": "Société",
        "email": "Adresse email",
        "industry": "Secteur d'activité",
        "name": "Prénom et nom",
        "title": "Locataire"
      },
      "tenantRepresentative": {
        "company": "Société",
        "email": "Adresse email",
        "name": "Prénom et nom",
        "title": "Représentant du locataire"
      },
      "undiscloseTenantBroker": "<strong>Ne partagez pas</strong> les détails du bailleur",
      "undiscloseTenantOwner": "Les détails du bailleur ne sont <strong>pas partagés</strong>",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "espaces"
      }
    },
    "EnquiryStatusMessage": {
      "advisedBy": "Conseillé par",
      "commencement": "<strong>Commencement</strong> à",
      "disregarded": "négligé",
      "executed": "réalisée",
      "expiring": "<strong>Expirant</strong> le",
      "leaseBreak": "<strong>Première pause</strong> à",
      "message": "La demande est <strong>%{status}</strong> par %{actor}",
      "message_no_actor": "La demande est <strong>%{status}</strong>",
      "renewal": "Dupliquer pour renouvellement",
      "renewalPeriod": "<strong>Renouvellement</strong> chaque(s)",
      "reopen": "Réouvrez cette demande ?",
      "size": {
        "of": "de"
      },
      "yearlyRent": {
        "for": "pour",
        "message": "Le loyer annuel total est"
      }
    },
    "ErrorBoundary": {
      "back": "Retourner",
      "message": "Notre équipe a été informée et résoudra le problème dès que possible. <br />\nNous vous recontacterons après la résolution du problème.",
      "title": "Désolé, quelque chose s'est mal passé.."
    },
    "ExecuteModal": {
      "channels": "Admissible à des honoraires de succès",
      "execute": "Réaliser",
      "executing": "Réaliser..",
      "header": "Réaliser cette demande",
      "info": "Les détails de ce bail exécuté seront disponibles dans la section des demandes exécutées et resteront à votre propre disposition et éventuellement aussi à vos courtiers invités à cette demande.",
      "involvedSpaces": "Unités louées",
      "leasingAgent": "Agent de location",
      "offered": "envoyé",
      "reasonForMoving": "Motif",
      "received": "reçu",
      "tenant": "Nom locataire"
    },
    "ExportActions": {
      "assetLeads": {
        "title": "Acquisition",
        "xls": "Un export au format XLS."
      },
      "assets": {
        "csv": "Un export au format CSV après filtre.",
        "pdf": "Un export au format PDF, après filtre.",
        "title": "Actifs et Espaces",
        "xls": "Un export au format XLS après filtre."
      },
      "btnLabel": "Exporter",
      "deals": {
        "csv": "Une version CSV du calendrier des demandes qui permet la modification.",
        "pdf": "Une version PDF du calendrier des demandes contenant le suivi par actif.",
        "title": "Demandes",
        "xls": "Une version XLS du calendrier des demandes qui permet la modification."
      },
      "portfolioAssets": {
        "pdf": "Un export au format PDF de ce portefeuille (après filtre).",
        "title": "Portfolio",
        "xls": "Un export au format XLS de cette portefeuille (après filtre)."
      }
    },
    "FileManager": {
      "empty": "Vous n'avez pas encore téléchargé de photos ou de fichiers.",
      "files": "Documents",
      "filesSelected": "%{value} fichiers sélectionnés",
      "header": "Utiliser comme en-tête de flyer",
      "pictures": "Images",
      "private": "Pas afficher sur flyer",
      "searchPlaceholder": "(name, kind, tag, ..)",
      "thumbnail": "Utiliser comme vignette",
      "uploaded": "Ajouté"
    },
    "Floorplans": {
      "actions": "",
      "addSpace": "Associer espace",
      "availability": "Disponibilité",
      "clearLines": "Eliminer les lignes",
      "clickToLink": "Cliquez pour lier l'espace",
      "createFloorplan": "Créez un nouveau plan d'étage",
      "deleteConfirm": "Vous êtes sûr de vouloir effacer ce plan?",
      "deleteFloorplan": "Effacer plan",
      "duplicate": "Dupliquer",
      "editSpace": "Editer espace",
      "file": "Dossier",
      "floor": "Etage",
      "floorPlaceholder": "Nom de l'étage",
      "floorSelector": "Sélecteur d'étage",
      "information": "<h3>Agrandir le plan d'étage</h3>\n<p>Maintenez la touche CTRL ou CMD enfoncée et faites défiler pour agrandir l'image du plan d'étage.</p>\n\n<h3>Déplacer le plan d'étage</h3>\n<p>Maintenez CTRL ou CMD, cliquez et déplacez la souris pour déplacer l'image du plan d'étage.</p>\n\n<h3>Dessiner sur le plan d'étage</h3>\n<p>Cliquez sur l'image du plan pour tracer une ligne. Une fois le dessin est terminé, vous pouvez lier l'espace dessiné à un espace sur l'actif.</p>\n\n<h3>Lier un espace sur le bien</h3>\n<p>Cliquez sur un espace dessiné pour le lier à un espace sur l'actif.</p>\n\n<h3>Déplacer un espace dessiné sur le plan d'étage </h3>.\n<p>Cliquez sur un espace dessiné et déplacez la souris pour déplacer l'espace dessiné </p>\n\n<h3>Dupliquer un espace dessiné</h3>\n<p>Cliquez sur un espace dessiné, puis sur l'icône d'édition et enfin sur le bouton dupliquer pour créer une copie identique de l'espace dessiné sélectionné</p>",
      "informationTitle": "Information sur les plans d'étage",
      "leaseHolder": "Locataire",
      "none": "Pas de plans disponibles",
      "pricing": "Prix",
      "scroll": "Clique %{key} pour zoomer et panoramiser l'image.",
      "size": "Superficie",
      "startDragging": "Commencer de glisser",
      "status": "Status",
      "stopDragging": "Arrêter de glisser",
      "uploadFloorplan": "Télécharger le plan"
    },
    "Flyer": {
      "NotFound": {
        "message": "We are sorry, but this flyer is no longer available. <br>\nYou can visit the <a href=\"https://www.rial.to/app\">Rialto platform</a>, or <a href=\"mailto:dgtqwgb3@incoming.intercom-mail.com\">contact us</a>.",
        "title": "Flyer n'est plus disponible"
      },
      "ServiceRate": {
        "allIn": "Frais de service et taxes (hors TVA) inclus",
        "rate": "impôts fonciers (est.)",
        "service": "frais de service (est.)"
      },
      "contact": "Contactez nous",
      "facilities": {
        "categories": {
          "fire_safety": "Sécurité incendie",
          "general": "Général",
          "other_cat": "Autres",
          "security": "Sécurité"
        },
        "title": "Services"
      },
      "location": "Emplacement",
      "marketing": "Fichiers"
    },
    "FlyerContactModal": {
      "info": "Votre question sera envoyée à la personne de contact de cet actif",
      "question": "Entrez votre question ici",
      "successBody": "La personne de contact vous répondra dès que possible",
      "successTitle": "Message envoyé",
      "title": "Poser une question"
    },
    "ForgotPasswordModal": {
      "header": "Mot de passe perdu",
      "info": "Saisissez l’adresse email liée à votre compte Rialto. Un email vous sera envoyé afin de réinitialiser votre mot de passe."
    },
    "FormButton": {
      "cancel": "Annuler",
      "delete": "Effacer",
      "edit": "Editer",
      "save": "Enregistrer"
    },
    "GmailAuth": {
      "body": "Identifiez rapidement les prospects de votre compte email sur Rialto et convertissez-les directement en opportunité. Plus besoin de basculer entre les applications. Cliquez sur le bouton ci-dessous pour vous connecter.",
      "title": "Connectez votre compte email à Rialto"
    },
    "Inbox": {
      "convertDeal": "Convertir en opportunité",
      "fetching": "Chargement des mails..",
      "noSelection": "Aucun e-mail sélectionné"
    },
    "Incentive": {
      "fee": "<strong>%{fee}</strong> de commission sera accordée",
      "minSize": "pour un minimum de",
      "months": "mois",
      "sprinter": "Pour signature du bail maximale <strong>%{duration} mois </strong> après <strong>%{stage}</strong>.",
      "termAfter": "après %{date}",
      "termBefore": "avant %{date}"
    },
    "IncentiveCard": {
      "commissionFixed": "%{value} %{currency} après %{type} un locataire.",
      "commissionPercentage": "%{value} après %{type} un locataire.",
      "commissionPeriod": "%{value} %{period} après %{type} un locataire.",
      "conditionsSize": "Taille de contract  > %{value} %{unit}",
      "conditionsTerm": "Durée de contrat > %{value} %{period}",
      "payoutLinked": "Paiement récurrent synchronisé avec les paiements de loyer pour max. %{value} %{period} de loyer",
      "payoutRecurring": "Paiement récurrent tous les %{recurrenceValue} %{recurrencePeriod} pour max. %{value} %{period} de loyer",
      "payoutUpfront": "Prépaiement sur %{value} %{period} de loyer",
      "type": {
        "expansion": "croître",
        "new": "signer",
        "reduction": "réduire",
        "renegotiation": "renégocier",
        "renewal": "renouveller"
      }
    },
    "IncentiveForm": {
      "addIncentive": "Ajoutez honoraire",
      "autoAssign": "Afficher sur la page de la société et attribuer automatiquement aux objets publics",
      "conditionTypes": {
        "conditions": "Conditions",
        "endDate": "Date de fin",
        "minSize": "Taille minimale",
        "term": "Durée"
      },
      "deleteAutoassignConfirm": "Etes-vous sûr de vouloir supprimer cette honoraire? Cet honoraire a été affecté automatiquement à la page de la société et aux actifs au statut public. Une fois supprimée, il ne sera plus affichée.",
      "deleteConfirm": "Etes-vous sûr de vouloir supprimer cette honoraire?",
      "deleteSuccess": "Honoraire supprimé!",
      "description": "Description",
      "editIncentive": "Modifiez honoraire",
      "feeTypes": {
        "fees": "Compensation",
        "fixedFee": "Fixe",
        "monthsFee": "Mois",
        "percentageFee": "Pourcentage"
      },
      "payout": "Paiement",
      "payoutLinked": "Synchronisé avec les paiements de loyer",
      "payoutTypes": {
        "payoutPeriod": "Prépaiement",
        "payoutRecurrence": "Récurrent"
      },
      "rentPeriod": "Période de location",
      "title": "Titre",
      "type": "Type"
    },
    "IntegrationStatus": {
      "officernd": "OfficeR&D",
      "syncedAt": "Dernière synchronisation avec <strong>%{integration}</strong> à <strong>%{date}</strong>",
      "syncedFrom": ""
    },
    "Intro": {
      "addButton": "<h3>Ajouter une demande, un actif ou un collaborateur</h3>\nCliquez ici pour ajouter une demande, un actif ou un broker.",
      "addButtonBroker": "<h3>Ajouter une demande ou un project de contrat</h3>\nCliquez ici pour ajouter une demande ou un project de contrat.",
      "assetActions": "<h3>Actions</h3>\nVous pouvez vous abonner à un actif mais aussi afficher et/ou télécharger la brochure d’information correspondante",
      "assetExport": "<h3>Exporter</h3>\nCliquez ici pour exporter la liste des actifs et espaces du portefeuille sélectionné (au format CSV ou PDF)",
      "assetFilter": "<h3>Rechercher</h3>\nLancez une recherche personnalisée d’espaces et d’actifs parmi le portefeuille sélectionné.",
      "assetInfo": "<h3>Informations complémentaires</h3>\nFaites glisser la souris et/ou cliquez sur les différentes icônes pour obtenir plus d’informations sur l’actif : partage, frais et commissions",
      "assetList": "<h3>Biens</h3>\nIci vous pouvez voir un aperçu de tous les actifs dans ce portefeuille.",
      "associateAsset": "<h3>Connecter actif</h3>\nIci, vous pouvez connecter un actif et utilisez les informations d'espace.",
      "channelDetails": "<h3> Initiateurs associé </ h3>\nSauvegarder plus d'informations sur les initiateurs de cette opportunité.",
      "dealDetail": "<h3>Plus d’informations sur une demande</h3>\nCliquez sur l’une des demandes de la liste pour y ajouter un détail : mise à jours, information sur le locataire etc.",
      "dealDetails": "<h3> Spécifiez les conditions requises </ h3>\nSpécifiez les détails de votre opportunité.",
      "dealExport": "<h3>Exporter</h3>\nCliquez ici pour exporter la liste des demandes reçues pour le portefeuille sélectionné (au format CSV ou PDF)",
      "dealToggleView": "<h3>Affichage</h3>\nCliquez ici pour basculer de l’affichage liste à l’affiche en colonne ou sélectionnez des colonnes de table personnalisées.",
      "deals": "<h3>Deals</h3>Vous trouverez ici une liste des demandes reçues au sujet des actifs du portefeuille.",
      "dealsList": "<h3>Demandes</h3>\nIci vous pouvez voir un aperçu de toutes vos demandes actives dans ce portefeuille. Dans la barre de filtre, vous pouvez changer entre différents statuts.",
      "done": "Fini",
      "expandAsset": "<h3>Afficher tous les espaces</h3>\nCliquez ici pour accéder à la liste complète des différents espaces disponibles pour cet actif.",
      "intercom": "<h3>Aide</h3>\nL’introduction est maintenant terminée. N’hésitez pas à nous contacter pour toute question concernant l’utilisation de la plateforme . Nous reviendrons vers vous aussi rapidement que possible.",
      "next": "Compris",
      "previous": "Précédent",
      "settings": "<h3>Paramètres</h3>\nAccédez à vos paramètres (préférences linguistiques, notifications, gestion d’équipe etc.) ou déconnectez vous.",
      "skip": "Passer",
      "subscribeAsset": "<h3>Abonnez-vous au actif</h3>\nCliquez ici pour vous abonner au actif et obtenir des mises à jour hebdomadaires par courrier électronique.",
      "switchPortfolio": "<h3>Changer de portefeuille</h3>\nBasculez d’un portefeuille à l’autre ou affichez l’intégralité des informations contenues dans tous les portefeuilles.",
      "tenantDetails": "<h3> Spécifier les détails du locataire </ h3>\nSauvegarder les données du locataire.",
      "welcome": "<h3>Bienvenue chez Rialto !</h3>\nCette introduction vous présente les principales caractéristiques de notre plateforme. Cela ne prendra pas plus de trois minutes et vous permettra de bien comprendre le fonctionnement de Rialto.\nVous pouvez à tout moment interrompre cette introduction en cliquant sur le bouton « passer »"
    },
    "LinkedinOauthCallback": {
      "errorBody": "Connectez-vous avec l'email et le mot de passe à la place",
      "errorTitle": "Utilisateur LinkedIn inconnu"
    },
    "LoginForm": {
      "emailPlaceholder": "Saisir l'adresse email",
      "forgotPassword": "Oublié ?",
      "linkedin_signin": "Se connecter avec LinkedIn",
      "loggingIn": "Connexion..",
      "login": "Connexion",
      "passwordPlaceholder": "Saisir mot de passe",
      "register": "Besoin d'un compte?"
    },
    "Modal": {
      "comment": {
        "collapse": "<strong>Masquer le commentaire</strong> pour afficher lors de la création",
        "expand": "<strong> Ajouter le commentaire</ strong> pour afficher lors de la création",
        "placeholder": "Entrez le commentaire",
        "title": "Commentaire"
      }
    },
    "Navbar": {
      "back": "Retour",
      "dashboard": {
        "deal": "Deal dashboard",
        "marketing": "Marketing dashboard"
      },
      "help": "Demander de l'aide",
      "settings": "Paramètres",
      "sign_out": "Déconnexion"
    },
    "Ner": {
      "area": "Surface et capacité",
      "costs": "Somme des coûts",
      "free_rent_period": "Période de location gratuite (en mois)",
      "header": "Loyer effectif net",
      "price": "Prix (par mois)",
      "term": "Durée ou période de renouvellement (en mois)",
      "title": "Le <strong>loyer effectif net</strong> est calculé comme suit:"
    },
    "Notes": {
      "alert": {
        "no_content": "Veuillez ajouter %{contentType} avant d'enregistrer !"
      },
      "call": {
        "alert_empty": "No empty calls",
        "btnLabel": "Selectionner date",
        "placeholder": "Entrez vos notes d'appel ici",
        "title": "Choisissez la date d'appel"
      },
      "confirm": {
        "cancel": "Etes-vous sûre de vouloir annuler ? Toutes vos modifications seront perdues.",
        "delete": "Etes-vous sûre de vouloir supprimer ?"
      },
      "email": {
        "alert_empty": "No empty emails",
        "btnLabel": "Selectionner date",
        "code": "Partager un email en le transférant (TR) ou en le copiant (CCI) à",
        "codeMobile": "CCi ou transmettre à",
        "copied": "l'URL du flyer copié !",
        "copy": "Copier l'adresse email",
        "created_by": "Créé par",
        "date_received": "Date de réception",
        "date_sent": "Date d'envoi\n",
        "from": "de",
        "paste": "Copiez-collez ci-dessous le contenu d’un email",
        "placeholder": "Entrez vos notes d'email ici",
        "received": "Reçu",
        "received_from": "Reçu de",
        "sent": "Envoyé",
        "sent_to": "Envoyé à",
        "title": "Choisissez la date d'email",
        "to": "à"
      },
      "file": {
        "comment": "Commentaire",
        "comment_placeholder": "Entrez un commentaire (facultatif)",
        "download": "Télécharger",
        "title": "Titre",
        "title_placeholder": "Entrez le titre"
      },
      "no_contacts": "",
      "note": {
        "indicator": "Privé"
      },
      "placeholder": "Entrez vos notes ici",
      "private": "Seulement moi",
      "proposal": {
        "dueDate": "Date d'échéance",
        "offered_by": "Offert par",
        "offering": "Émise",
        "received_by": "Reçu par",
        "receiving": "Reçu"
      },
      "public": "Public",
      "unknownUser": "Inconnu",
      "update": {
        "placeholder": "Renseignez ici les informations liées à cette demande"
      },
      "upload": "Ajouter un fichier",
      "viewing": {
        "add": "Ajouter au calendrier",
        "btnLabel": "Selectionner date",
        "placeholder": "Entrez vos notes de visite ici",
        "scheduled_for": "Visite prévue pour",
        "title": "Choisissez la date de visite"
      }
    },
    "Notification": {
      "deal": {
        "create": {
          "body": "%{values}",
          "title": {
            "one": "Nouvelle demande ajoutée !",
            "other": "Nouvelles demandes ajoutées !"
          }
        },
        "invite": {
          "body": "Ils ont maintenant accès à la demande %{values}.",
          "title": {
            "one": "Les collaborateurs ont été invités !",
            "other": ""
          }
        }
      },
      "flyer": {
        "create": {
          "body": "La brochure pour %{values} à été mise à jour !",
          "title": {
            "one": "Brochure mise à jour !",
            "other": ""
          }
        },
        "error": {
          "body": "Veuillez réessayer ou contacter support@rial.to",
          "title": {
            "one": "Impossible de générer la brochure !",
            "other": ""
          }
        }
      },
      "user": {
        "invitation_accepted": {
          "body": "%{values} a accepté votre invitation et est maintenant sur Rialto !",
          "title": {
            "one": "Invitation acceptée !",
            "other": ""
          }
        }
      }
    },
    "Pagination": {
      "next": "suivant",
      "previous": "précédent"
    },
    "PortfolioActions": {
      "addAsset": "Actif",
      "addAssetLead": "Acquisition",
      "addBroker": "Collaborateur",
      "addDeal": "Demande",
      "addProposal": "Proposition",
      "addSpace": "Espace",
      "btnLabel": "Ajouter"
    },
    "PortfolioBlock": {
      "edit": "Modifier portefeuille",
      "requestAccess": "Demande d'accès",
      "requestPending": "Demande en attente.."
    },
    "PortfolioDeleteModal": {
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer %{portfolio}? Tous les actifs et opportunités associés seront supprimés.",
      "confirmTransfer": "Êtes-vous sûr de vouloir supprime %{portfolio}? Tous les actifs et opportunités associés seront seront transférés à %{transferPortfolio}. ",
      "header": "Supprimer le portefeuille",
      "noPortfolios": "Pas de portefeuilles à transférer à",
      "transfer": "Transférer à",
      "warning": "Lorsque vous supprimez un portefeuille, vous pouvez choisir de transférer vos actifs, opportunités et abonnements vers un autre portefeuille. </br> </br> Si vous choisissez de ne pas le faire, <strong>toutes les données</strong> associées à ce portefeuille seront <strong>définitivement</strong> supprimées."
    },
    "PortfolioFilter": {
      "portfolios": "Portefeuilles",
      "selected": "sélectionnés"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "",
        "deal": ""
      },
      "export": {
        "assets": {
          "csv": "Un export au format CSV de ce portefeuille.",
          "pdf": "Un export au format PDF de ce portefeuille.",
          "title": "Portfolio"
        },
        "btnLabel": "Exporter",
        "deals": {
          "csv": "Une version CSV du calendrier des demandes qui permet la modification.",
          "pdf": "Une version PDF du calendrier des demandes contenant toutes le suivi par actif.",
          "title": "Demandes"
        }
      },
      "tabs": {
        "asset_leads": "Acquisition",
        "assets": "Actifs",
        "dashboard": "Dashboard",
        "deals": "Demandes"
      }
    },
    "PortfolioInfo": {
      "companiesSelected": "%{value} entreprises sélectionnées",
      "portfoliosSelected": "%{value} portefeuilles sélectionnés"
    },
    "PortfolioModal": {
      "delete": "Supprimer portefeuille",
      "nameLabel": "Nom",
      "statsUnitLabel": "Unité de statistiques",
      "titleAdd": "Ajouter un Portfolio",
      "titleEdit": "Modifier le portfolio",
      "typeLabel": "Type"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "assets": "actifs",
      "available": "disponible",
      "availableSpace": "Disponible ajd",
      "deals": "Demandes",
      "onMarket": "sur le marché",
      "rentableArea": "Surface totale"
    },
    "Proposal": {
      "accepted": "Project de contrat",
      "addPrice": "Ajouter prix",
      "addSpace": "+ ajouter un autre espace",
      "asset": "",
      "billingPeriod": "Fréquence de facturation",
      "breakDates": "Résiliation possible à partir du",
      "breakTerm": "Résiliation possible à partir du",
      "channelFee": "Broker",
      "commencementDate": " Date de début",
      "contractLength": "Durée du bail",
      "costs": "Frais",
      "deposit": "Garantie",
      "dueDate": "Valable jusqu'au",
      "expirationDate": "Date d’expiration",
      "firstRefusalRight": "Appliquer le droit de premier refus",
      "legalFee": "Frais juridiques",
      "movingAllowance": "Indemnité de déménagement",
      "negativeDiscount": "(%{percentage}% au dessus du prix initial)",
      "ner": "Loyer net",
      "offeredBy": "Offert par",
      "offering": "Émise",
      "otherCosts": "Autre coût",
      "placeholder": "Entrez vos notes ici",
      "positiveDiscount": "(%{percentage}% réduction)",
      "receivedBy": "Reçu par",
      "receiving": "Reçu",
      "renewalPeriod": "Renouvellement",
      "rentFreePeriod": "Franchise de loyer",
      "term": "Terme",
      "terms": "Conditions financières",
      "tiAllowance": "Budget d'amélioration locative",
      "token": "Copiez l'URL ci-dessous pour partager la proposition avec votre client"
    },
    "ProposalAcceptModal": {
      "accept": "Demander",
      "accepting": "Demander..",
      "commentPlaceholder": "Entrez des commentaires ici",
      "header": "Demander project de contrat"
    },
    "ProposalForm": {
      "deal": "Demande",
      "dealLabel": "Rechercher un existant ou en créer un nouveau par nom"
    },
    "ProposalModal": {
      "title": "Ajouter propostion"
    },
    "ProposalPage": {
      "accept": "Project de contrat",
      "accepted": {
        "message": "Merci! %{name} serait notifié.",
        "title": "Project de contrat demandé!"
      },
      "proposalFor": "Proposition pour",
      "proposalOn": "Proposition du %{date}"
    },
    "RegionFilter": {
      "apply": "Appliquer",
      "region": "Région",
      "tabs": {
        "region": "Par Région"
      }
    },
    "ResetPassword": {
      "confirm_label": "Confirmation du mot de passe",
      "confirm_placeholder": "Saisir la confirmation du mot de passe",
      "current_label": "Mot de passe actuel",
      "current_placeholder": "Saisir mot de passe actuel",
      "description": "Remplissez tous les champs ci-dessous pour changer votre mot de passe.",
      "new_label": "Nouveau mot de passe",
      "new_placeholder": "Saisir le nouveau mot de passe",
      "title": "Réinitialiser mot de passe"
    },
    "SearchBlock": {
      "landlordsTitle": "Tous les portefeuilles",
      "searchPortfolios": "Chercher ",
      "selectAll": "Sélectionner tous",
      "title": "Rechercher tous les actifs",
      "unselectAll": "Désélectionner tous"
    },
    "SeeMore": {
      "seeMore": "Voir plus"
    },
    "SelectAll": {
      "clear": "Effacer",
      "selectAll": "Tout sélectionner"
    },
    "Settings": {
      "Subscriptions": {
        "assetDigest": {
          "description": "Sélectionnez les actifs à intégrer dans la newsletter [hebdomadaire]. Pour vous désabonner complètement, décochez tous les actifs.",
          "title": "Changement de disponibilité des actifs"
        },
        "dealDigest": {
          "description": " Sélectionnez les portefeuilles à intégrer dans la newsletter [hebdomadaire]. Pour vous désabonner complètement, décochez tous les portefeuilles.",
          "title": "Suivi du statut des demandes"
        },
        "portfolio_deal": {
          "description": " Sélectionnez les portefeuilles pour lesquels vous souhaitez être automatiquement informé en cas de nouvelle demande :",
          "title": "Nouvelles demandes"
        },
        "unsubscribeDeals": {
          "body": "",
          "unsubscribe": ""
        }
      },
      "company": {
        "billing": {
          "billingInfo": "Nous n'avons trouvé aucune information de facturation liée à votre compte. Il se peut que soit vous n’êtes actuellement pas rémunéré, soit nous nous sommes trompés.",
          "contact": "Contactez-nous pour vous installer",
          "manage": "Gérer les paramètres",
          "subscriptions": "Vous êtes actuellement abonné à:",
          "title": "Informations de facturation et paramètres",
          "total": "Le montant de la prochaine facture sera %{total} (TVA inclus) et sera facturé %{date}",
          "trial": "Votre compte est actuellement en phase d'essai (il reste <strong>%{value} jours</ strong>).",
          "vatExclusive": "%{value}, sans TVA"
        },
        "branding": {
          "HeaderImageInfo": {
            "body": "The image you upload here will be shown in your company's <strong>weekly asset digest</strong> and the <strong>profile page</strong> of your company. For best results, we recommend uploading a high-resolution file. ",
            "header": "Image d'en-tête"
          },
          "accentColor": "Couleur d'accent",
          "comapnyPageBlocks": {
            "contacts": "Show contacts",
            "dealForm": "Introduce client",
            "incentives": "Show auto-assigned incentives",
            "portfolios": "Show portfolios"
          },
          "companyPage": "Profil de la société",
          "general": "Général",
          "headerImage": "Image d'en-tête",
          "headerImageOverlay": "Ajouter une superposition d'image",
          "primaryColor": "Couleur primaire",
          "slug": "Identifiant de l'Entreprise"
        },
        "details": {
          "address": "Adresse",
          "city": "Ville",
          "country": "Pays",
          "description": "Description",
          "email": "Adresse email",
          "industry": "Secteur d'activité",
          "mobile": "Portable",
          "name": "Nom",
          "phone": "Téléphone",
          "tagline": "Slogan",
          "website": "Site Internet",
          "zip": "Code postal"
        },
        "integrations": {
          "search": "Rechercher intégrations..."
        },
        "settings": {
          "CompanyPageInfo": {
            "header": "Page Entreprise",
            "infoBody": "Un profil public pour votre entreprise pouvant être utilisé comme <strong>page de destination</strong> entre vous et vos partenaires. Par défaut, vos informations de contact et un aperçu des portefeuilles sont affichés, après quoi le partenaire peut également se connecter via la page ou demander l'accès à la partie protégée de Rialto. Vous pouvez également ajouter vos primes et éventuellement une section FAQ.",
            "infoTitle": "Quelle est la page de l'entreprise?",
            "linkBody": "Vous pouvez toujours créer un lien entre votre propre site web et la page de votre entreprise sur notre plateforme. Vous pouvez trouver la page sur <strong>URL ci-dessous</strong>.\n<br /> <br />\nSi vous le souhaitez, vous pouvez également utiliser votre propre domaine pour afficher la page de l'entreprise. Cela peut être fait en définissant un <strong>CNAME</strong> à votre fournisseur de nom de domaine avec l'URL ci-dessous.",
            "linkTitle": "Domaine personnalisé",
            "linkToken": "Cliquez ici pour copier l'URL de votre page d'entreprise personnalisée"
          },
          "accent": "Couleur d'accent",
          "branding": "Branding",
          "currency": "Monnaie",
          "interface": "Interface",
          "language": "Langue",
          "primary": "Couleur primaire",
          "regional": "Régio",
          "sizeUnit": "Unité de surface",
          "slug": "Identifiant de l'Entreprise",
          "statsUnit": "Unité de statistiques",
          "type": "Type"
        }
      },
      "delete": "Supprimer",
      "deleting": "Supprimer..",
      "incentives": {
        "add": "Ajouter honoraire",
        "new": "Ajoutez nouveau",
        "none": "Vous n'avez pas encore de <strong>modèle d'honoraire</strong>.",
        "search": "Chercher honoraire"
      },
      "menu": {
        "billing": "Facturation",
        "branding": "l'Image de marque",
        "company": "Entreprise",
        "details": "Détails de la société",
        "incentives": "Honoraraires",
        "integrations": "Intégrations",
        "notifications": "Notifications",
        "personal_details": "Détails personnels",
        "profile": "Mon profil",
        "requests": "Demandes d'accès",
        "settings": "Paramètres",
        "team": "Équipe",
        "templates": "Modèles",
        "tos": "Conditions d'utilisation",
        "users": "Membres"
      },
      "profile": {
        "email_label": "Adresse Email",
        "fname_label": "Prénom",
        "license_label": "Numéro IPI",
        "lname_label": "Nom",
        "mobile_label": "Téléphone portable",
        "phone_label": "Téléphone fixe",
        "title_label": "Poste"
      },
      "save": "Enregistrer",
      "saving": "Enregistrer..",
      "settings": {
        "change_password": "Changer mot de passe",
        "confirm_label": "Confirmation du nouveau mot de passe",
        "current_label": "Mot de passe actuel",
        "delete": {
          "confirmDelete": "Êtes-vous sûr de vouloir supprimer votre compte ? Ce mouvement est PERMANENT et ne peut pas être annulé. Vous allez perdre l'accès à Rialto.",
          "title": "Supprimer le compte",
          "warning": "La suppression de votre compte supprime <strong>définitivement</strong> toutes vos données et est irréversible. Vous êtes responsable du transfert des demandes et des actifs lorsque vous êtes point de contact. <br/> Après la suppression de votre compte, vous n'aurez plus accès à Rialto et ne recevrez plus d'emails de mise à jour depuis la plateforme.",
          "warning_account_holder": "Vous êtes <strong>détenteur de compte </strong> pour votre entreprise actuelle. Avant de supprimer votre compte, transférez d'abord votre rôle dans les paramètres de l'équipe."
        },
        "language_label": "Langue",
        "locale": "Paramètres de langue",
        "new_label": "Nouveau mot de passe",
        "password_empty_hint": "Laissez les champs de mot de passe vides si vous ne souhaitez pas changer votre mot de passe.",
        "timezone_label": "Fuseau horaire"
      },
      "team": {
        "add": "Ajouter utilisateur",
        "confirm": {
          "removeUser": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?"
        },
        "edit": "Modifier utilisateur",
        "remove": "Supprimer utilisateur",
        "requests": {
          "accept": "Accepter",
          "active": "En attendant",
          "empty": "Aucune demande d'accès à ce jour",
          "reject": "Rejeter",
          "rejected": "Rejetées"
        },
        "resend": "Renvoyer invitation",
        "roles": {
          "account_holder": "A tous les droits de marketing, de vente et d'administration",
          "administrator": "A tous les droits de marketing et de vente",
          "internal_user": "A tous les droits de vente"
        },
        "search": "Rechercher utilisateurs..."
      },
      "tos": {
        "add": "Ajouter conditions d'utilisation",
        "edit": "Modifier",
        "new": "Ajoutez nouveau",
        "none": "Vous n'avez pas encore de <strong>conditions d'utilisation</strong>.",
        "remove": "Supprimer",
        "search": "Chercher conditions d'utilisation"
      }
    },
    "ShareStatusSelector": {
      "header": "Qui devrait avoir accès ?",
      "status": {
        "all": "Tous les collaborateurs",
        "broker_owner_team": "Moi & mon client",
        "broker_team_owner_team": "Mon équipe a mon client",
        "custom": "Personnalisé",
        "owner_team": "Mon équipe"
      }
    },
    "SignUp": {
      "brokerCompany": "Société de courtage",
      "cancel": {
        "error": {
          "body": "Vous avez déjà activé votre compte",
          "title": "Votre email ne peut pas être confirmé!"
        },
        "success": {
          "body": "Vous ne recevrez plus d'e-mails de rappel",
          "title": "Inscription annulée!"
        }
      },
      "cancelBtn": "Annuler",
      "company": {
        "createNew": "Vous n'avez pas trouvé votre équipe? Créez simplement le vôtre, c'est facile. <a href=\"%{link}\">Cliquez ici</a> pour créer un compte pour votre équipe.",
        "details": "Complétez les informations ci-dessous pour enregistrer votre entreprise sur Rialto:",
        "name": "Nom de la société",
        "requestAccess": "Demander accès",
        "requestPending": "En attente",
        "role": "Mon entreprise est mieux décrite comme suit:",
        "roles": {
          "broker": "Je suis un agent immobilier / courtier en ligne",
          "ownerFlex": "Je suis un opérateur de travail / coworking flexible",
          "ownerLeasing": "Je suis un propriétaire et / ou dirige ma propre équipe de leasing"
        },
        "welcome": "Bienvenue sur Rialto, %{name}!\n<br />\n<br />\nLes équipes suivantes correspondent à votre domaine de messagerie. Accédez au vôtre."
      },
      "existingAccount": "Vous avez déjà un compte?",
      "getStarted": "Commencer",
      "linkedin_signup": "S'inscrire avec LinkedIn",
      "submitted": "Bienvenue %{fname}!\n<br />\n<br />\nVous recevrez un email pour confirmer votre adresse email. Après, vous pouvez choisir <strong>de rejoindre une équipe existante</strong> ou <strong>de créer une nouvelle équipe</strong>.\n<br />\n<br />\n👉🏻 Vous n'avez pas reçu d'email? Consultez votre <strong>dossier Spam</strong>.\n<br />",
      "submittedCampaign": "Bienvenue %{fname}!\n<br />\n<br />\nVous recevrez un email pour confirmer votre adresse email. Après, vous pouvez <strong>commencer à utiliser Rialto</strong>.",
      "tagline": "Quels processus soutiennent la croissance du taux d'occupation? <br/>\nVous y avez pensé. Nous l'avons construit pour vous.",
      "title": "Commencez gratuitement"
    },
    "Size": {
      "amount": "espace",
      "amounts": "espaces",
      "m2": "m²",
      "square_foot": "ft²"
    },
    "SpaceCategory": {
      "residential": ""
    },
    "SpaceModal": {
      "title": "Ajouter nouvelle espace"
    },
    "SpaceStatusDialog": {
      "body": "Êtes-vous sûr de changer de public vers private ? Les courtiers n'auront pus acces à cet espace.",
      "confirm": "Mettre private",
      "notify": "Informer courtiers que l'espace n'est plus disponible"
    },
    "SpacesTable": {
      "actions": {
        "delete": "Supprimer",
        "duplicate": "Dupliquer",
        "edit": "Modifier",
        "setNotUnderOffer": "Ne fait plus l’objet d’une proposition",
        "setPrivate": "Ne plus proposer sur le marché",
        "setPublic": "Définir en mode public",
        "setUnderOffer": "Proposition en cours"
      },
      "addPrice": "ajouter",
      "assetDetailNoSpaces": "Aucun espace pour ce produit, cliquez sur <strong>Ajouter</strong>.",
      "availability": {
        "mobile": {
          "now": "Disponible",
          "tbd": "À définir"
        },
        "now": "Disponible",
        "tbd": "À définir"
      },
      "deals_associated": "%{smart_count} demande fait référence vers cet espace. |||| %{smart_count} demandes font référence vers cet espace.",
      "firstRefusalRight": "Droit de premier refus",
      "form": {
        "titleAdd": "Ajouter espace",
        "titleEdit": "Modifier espace"
      },
      "headers": {
        "availableFrom": "Disponibilité",
        "category": "Type",
        "description": "Description",
        "edit": " ",
        "floor": "Niveau",
        "image": "",
        "inventory": "nombre dans l'Inventaire",
        "leaseholder": "Locataire",
        "leaseholders": "Locataire",
        "minContractLength": "Durée de contrat",
        "name": "Espace",
        "period": "Période",
        "price": "Loyer",
        "size": "Surface",
        "sizeUnit": "Unité",
        "status": "Statut",
        "syncInfo": "",
        "unit": "Nom de l'espace"
      },
      "inventory": "",
      "lxd": "LXD",
      "noSpaces": "Aucun espace disponible pour cet actif.",
      "periods": {
        "daily": {
          "one": "jour",
          "other": "jours"
        },
        "hourly": {
          "one": "heure",
          "other": "heures"
        },
        "monthly": {
          "one": "mois",
          "other": "mois"
        },
        "weekly": {
          "one": "semaine",
          "other": "semaines"
        },
        "yearly": {
          "one": "ans",
          "other": "ans"
        }
      },
      "price": {
        "all_in": "Frais de service et taxes (hors TVA) inclus",
        "rate": "Impôts:",
        "rent": "Location:",
        "service": "Frais:",
        "undisclosed": "Sur demande"
      },
      "pricing": "Prix",
      "private": "privé",
      "public": "sur le marché",
      "removeSpace": "Voulez-vous supprimer cet espace définitivement ? L'espace sera dissocié des demandes et des propositions. Les agents ne seront pas notifiés.",
      "renewalPeriod": "Renouvellement chaque(s)",
      "undefined": "Non défini",
      "under_offer": "Proposition en cours"
    },
    "StageProgress": {
      "selectStage": "Sélectionnez une étape"
    },
    "Statistics": {
      "assetLeads": "Acquisition |||| Acquisitions",
      "totalSize": "de demande total"
    },
    "StatusButton": {
      "disregard": "Négligé",
      "execute": "Réalisée"
    },
    "SubmitButton": {
      "submit": "Envoyer",
      "submitted": "Submitted!",
      "submitting": "Publication en cours.."
    },
    "SubscribeButton": {
      "subscribe": "Abonner",
      "subscribed": "Abonné"
    },
    "TabbedFilter": {
      "apply": "Appliquer",
      "channel": "Origine",
      "region": "Région",
      "regionCategories": {
        "regions": "Par Région"
      },
      "selected": "%{nb} sélectionnés"
    },
    "Table": {
      "headers": {
        "activity": "Suivi ",
        "asset": "Actif",
        "assetSpaces": "Actif",
        "asset_spaces": "Actif",
        "assets": "Actifs",
        "budget": "Budget",
        "category": "Type",
        "channel": "Origine",
        "closeDate": "Close Date",
        "comment": "Explication",
        "contact": "Contact",
        "currentSituation": "Situation actuelle",
        "date": "Date",
        "description": "Information additionnelle",
        "disregardComment": "Raison de l'abandon",
        "endDate": "Date de fin",
        "features": "Caractéristiques",
        "feePotential": "",
        "fee_potential": "",
        "followUpDate": "Date de suivi",
        "includeInReport": "Rapporter",
        "location": "Lieu",
        "name": "Nom",
        "nonProspectComment": "Proch. étapes",
        "pointPerson": "Référent",
        "point_person": "Référent",
        "portfolio": "Portfolio",
        "potential": "Potentiel",
        "probability": "Probabilité",
        "prospectComment": "Notes",
        "shareStatus": "",
        "share_status": "",
        "size": "Surface",
        "spaceCategories": "Catégorie",
        "space_categories": "Catégorie",
        "stage": "Stage",
        "startDate": "Date de début",
        "start_date": "Date de début",
        "tenant": "Locataire",
        "term": "",
        "type": "Type",
        "viewed": "Visité",
        "warning": " "
      },
      "noAsssetLeads": "Aucune résultat",
      "noDeals": "Aucune opportunité"
    },
    "TenantProfile": {
      "address": {
        "title": "Adresse actuelle"
      },
      "company": {
        "title": "Société"
      },
      "confirm": {
        "cancel": "Etes-vous sûre de vouloir annuler ? Toutes vos modifications seront perdues.",
        "delete": "Etes-vous sûre de vouloir supprimer ?"
      },
      "contacts": {
        "title": "Contacts"
      },
      "email": {
        "title": "Adresse email"
      },
      "head_count": {
        "title": "Effectif"
      },
      "industry": {
        "title": "Secteur d'activité"
      },
      "leaseExpiration": {
        "title": "Date d'expiration du bail"
      },
      "locale": "Langue",
      "mobile": {
        "title": "Portable"
      },
      "name": {
        "title": "Prénom et nom"
      },
      "phone": {
        "title": "Numéro de téléphone"
      },
      "position": {
        "title": "Position"
      },
      "rentable_area": {
        "title": "Surface"
      },
      "title": "Locataire"
    },
    "TenantRepresentative": {
      "actions": {
        "edit": "Modifier",
        "unlink": "Dissocier"
      },
      "company": {
        "title": "Société"
      },
      "email": {
        "title": "Adresse email"
      },
      "job_title": {
        "title": "Titre"
      },
      "name": {
        "title": "Prénom et nom"
      },
      "phone": {
        "title": "Numéro de téléphone"
      },
      "title": "Représentant du locataire"
    },
    "TermsOfServiceForm": {
      "addTos": "",
      "body": "Contenu",
      "default": "Défaut: afficher sur le profil de la société et attribuer automatiquement aux nouveaux objets crées",
      "defaultTosWarning": "Vous ne pouvez avoir qu'une seule condition de service par défaut. Si vous continuez, toutes les conditions de service par défaut existantes seront remplacées. Êtes-vous sûr?",
      "file": "Fichier",
      "title": "Titre"
    },
    "Timestamp": {
      "original": "Date réelle"
    },
    "TitledDate": {
      "title": "Sélectionner %{title}"
    },
    "TourButton": {
      "book": "Book a tour"
    },
    "UserConfirmModal": {
      "agreement": {
        "agree": "OK - J'ai compris",
        "description": "Bonjour %{user}, veuillez validez les informations de votre profil pour accéder à votre compte Rialto.",
        "terms_description": "En remplissant ce formulaire, vous certifiez avoir lu et accepté nos <a href=\"http://www.getrialto.com/terms\" target=\"_blank\">Conditions de Service</a> et notre <a href=\"https://www.getrialto.com/privacy\" target=\"_blank\">Politique de Confidentialité</a>",
        "title": "Confirmation requise"
      },
      "confirm": "Validez",
      "confirming": "Validez..",
      "details": {
        "description": "Veuillez vérifier vos coordonnées et confirmer votre compte",
        "title": "Profil"
      }
    },
    "UserDetails": {
      "inactive": "inactif"
    },
    "UserEdit": {
      "first_name": "Prénom"
    },
    "ViewToggle": {
      "display": "Affichage"
    },
    "deal": {
      "space_categories": "Catégorie"
    },
    "forms": {
      "picturePlaceholder": "Télécharger une photo"
    },
    "notifications": {
      "asset": {
        "delete": {
          "success": {
            "title": "Actif supprimé!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "Vous recevrez un email bientôt",
            "title": "Votre portefeuille sera exporté"
          }
        },
        "requestFlyer": {
          "success": {
            "message": "Vous pouvez vous attendre à recevoir un suivi par email.",
            "title": "Demande envoyée avec succès !"
          }
        }
      },
      "deal": {
        "delete": {
          "error": {
            "message": "Veuillez réessayer plus tard",
            "title": "Impossible de supprimer la demande !"
          },
          "success": {
            "title": "La demande a été supprimée avec succès !"
          }
        },
        "duplicate": {
          "success": {
            "title": "Demande dupliquée avec succès !"
          }
        },
        "exportPdf": {
          "success": {
            "message": "Vous recevrez un email bientôt",
            "title": "Calendrier des demandes sera exportées"
          }
        },
        "renew": {
          "success": {
            "title": "Demande dupliquée avec succès !"
          }
        }
      },
      "defaultErrorTitle": "Une erreur s'est produite !",
      "defaultInfoTitle": "Info",
      "notAuthenticated": {
        "message": "Veuillez vous reconnecter",
        "title": "Vous n'êtes pas authentifié"
      },
      "portfolio": {
        "delete": {
          "success": {
            "bodyDelete": "Tous les actifs et opportunités associés sont supprimés.",
            "bodyTransfer": "Tous les actifs et opportunités associés sont transférés.",
            "title": "Portefeuille supprimé!"
          }
        }
      },
      "subscriptions": {
        "update": {
          "success": {
            "body": "Vos modifications entrent en vigueur immédiatement",
            "title": "Paramètres de notification enregistrés !"
          }
        }
      },
      "user": {
        "brokerInvite": {
          "success": {
            "messageActive": "%{user} a désormais accès aux actifs sélectionnés.",
            "messageNew": "%{user} aura accès aux actifs après avoir accepté l'invitation.",
            "title": "%{user} invité avec succès !"
          }
        },
        "requestPasswordReset": {
          "success": {
            "message": "Vous recevrez sous peu un email contenant des instructions supplémentaires.",
            "title": "Nouveau mot de passe demandé !"
          }
        },
        "resetPassword": {
          "success": {
            "message": "Vous devez maintenant utiliser ce mot de passe lors de votre prochaine connexion.",
            "title": "Mot de passe modifié avec succès."
          }
        }
      }
    },
    "shared": {
      "add": "Ajouter",
      "adding": "Ajouter..",
      "address": "%{address} %{zip} %{city}",
      "amount": "Montant",
      "and": "et",
      "askInfo": "Demande brochure",
      "asset": {
        "address": "Adresse",
        "asset": "Actif",
        "city": "Ville",
        "name": "Nom",
        "region": "Région",
        "state": "État",
        "statuses": {
          "fully_let": "Laissé",
          "invite": "Sur invitation uniquement",
          "other": "Autre",
          "private": "Privé",
          "public": "Mandat Ouvert",
          "sold": "Vendu"
        },
        "zip": "Code postal"
      },
      "assetCategories": {
        "hotel": "Hôtel",
        "industrial": "Industriel",
        "land": "Terrain",
        "multi_family": "Residentiel - multi-family",
        "office": "Postes de travail",
        "other_cat": "Autres",
        "residential": "Résidentiel",
        "retail": "Au détail",
        "warehouse": "Entrepôt"
      },
      "assetLeadStages": {
        "closing": "Closing",
        "negotiating": "Negotiating",
        "pitch": "Pitch",
        "prospect": "Prospect"
      },
      "assetLeads": "Acquisition",
      "billingMethods": {
        "post": "paiement en fin de période",
        "pre": "paiement en début de période"
      },
      "budget": "Budget",
      "cancel": "Annuler",
      "category": "Type",
      "channelCategories": {
        "email": "Email",
        "employee_referral": "Référence d'employée",
        "leasing_agent": "Leasing agent",
        "listing_site": "Portal",
        "online_broker": "Online broker",
        "other_cat": "Autre",
        "phone": "Par téléphone",
        "referral": "Référence",
        "social_media": "Social Media",
        "tenant_rep": "Tenant Rep",
        "unknown": "Inconnue",
        "walk_in": "Visiteur",
        "website": "Website"
      },
      "closeDate": "Close Date",
      "company": "Société",
      "companyTypes": {
        "acquisition": "Acquisition",
        "flex": "Flex",
        "leasing": "Crédit-bail"
      },
      "confirm": {
        "cancel": "Etes-vous sûre de vouloir annuler ? Toutes vos modifications seront perdues.",
        "delete": "Etes-vous sûr que vous voulez supprimer ?"
      },
      "contactCategories": {
        "agent": "Agent",
        "asset_manager": "Asset Manager",
        "key_holder": "Porte-clés",
        "landlord": "Propriétaire",
        "other_cat": "Autre",
        "property_manager": "Property Manager",
        "tenant": "Bailleur"
      },
      "copied": "Copié!",
      "copy": "Copier",
      "copy_of": "Copie de",
      "country": "Pays",
      "deal": {
        "activity": "Suivi ",
        "asset": "Actif",
        "assets": "Actifs",
        "budget": "Budget",
        "channel": "Origine",
        "deal": "Demande",
        "fee_potential": "",
        "leaseBreakDates": "Dates de rupture du bail",
        "leaseCommencementDate": "Date de début du bail",
        "leaseExpirationDate": "Date d'expiration du bail",
        "location": "Lieu",
        "point_person": "Référent",
        "portfolio": "Portfolio",
        "probability": "Probabilité",
        "share_status": "Statut de partage",
        "size": "Surface",
        "space_categories": "Catégorie",
        "start_date": "Date de début",
        "tenant": "Locataire",
        "term": "Terme",
        "type": "Motif"
      },
      "dealStages": {
        "delivery": "Livraison",
        "execution": "Exécution",
        "finder": "Monitorer",
        "inquiry": "Enquête",
        "new": "Nouveau",
        "prospects": "Prospect",
        "signed_loi": "Négociation",
        "touring": "Visite",
        "trading_proposal": "Proposition en cours"
      },
      "dealStatuses": {
        "active": "En cours",
        "all": "Tous",
        "dead": "Non abouties",
        "executed": "Réalisé"
      },
      "dealTypes": {
        "expansion": "Expansion",
        "new": "Nouveau",
        "reduction": "Réduction",
        "renegotiation": "Renégociation",
        "renewal": "Renouvellement"
      },
      "deals": "Demandes",
      "default": "Défaut",
      "delete": "Supprimer",
      "deletedUser": "Utilisateur supprimé",
      "deleting": "Supprimer..",
      "disregard_outcomes": {
        "move": "Signé au actif concurrent",
        "other_outcome": "Autre",
        "stay": "Bail actuel renouvelé",
        "unknown": "Inconnue"
      },
      "disregard_reasons": {
        "broker": "Demande d'informations courtier",
        "duplicate_entry": "Double entrée",
        "location": "Localisation",
        "other_reason": "Autre",
        "price": "Prix",
        "quality": "Qualité",
        "size": "L'unité ne correspond pas aux besoins",
        "tenant_unqualified": "Locataire non qualifié",
        "timed_out": "Exigence expirée",
        "unknown": "Inconnu"
      },
      "download": "Télécharger",
      "download_ics": "Ajouter au calendrier",
      "edited": "Edité",
      "email": "Email",
      "emptyText": {
        "assetDeal": "Premièrement sélectionnez un actif pour cette demande",
        "channels": "Premièrement ajouter initiateur(s) sur la page précédente",
        "proposals": "Premièrement ajouter proposition(s) sur la page précédente",
        "spaces": "Premièrement ajouter espace(s) au cet actif",
        "spacesDeal": "Premièrement ajouter un actif à cette demande et/ou espace(s) à son actif"
      },
      "endDate": "Date de fin",
      "errorTitle": "Une erreur s'est produite !",
      "every": "Chaque",
      "filter": "Filtrer",
      "flyer": "Brochure",
      "flyerContact": "Contact de brochure",
      "footer": {
        "about": "À propos de Rialto",
        "blog": "Blog",
        "careers": "Recrutement",
        "status": "Statut des services",
        "terms": "Conditions d'utilisation"
      },
      "formChangesPrompt": "Vous avez des données non sauvegardées. Êtes-vous sûr de vouloir naviguer vers une autre page ?",
      "free": "gratuit",
      "from": "de",
      "fullName": "Prénom et nom",
      "in": "dans",
      "industries": {
        "automobile": "Automobile",
        "aviation": "Aviation et voyage",
        "banks": "Banques",
        "basic_resources": "Resources de base",
        "chemicals": "Produits chimiques",
        "construction": "Construction et matériaux",
        "consumer_electronics": "Électronique grand public",
        "culture": "Culture",
        "cw": {
          "automotive": "Automotive",
          "business_space": "Overige bedrijfsruimte",
          "cleanroom": "Cleanroom/Laboratorium",
          "datacenter": "Datacenter",
          "dc": "DC",
          "food": "Food",
          "high_tech": "High Tech/3D",
          "self_storage": "Self Storage",
          "sustainable_energy": "Sustainable/(Nieuwe) energie",
          "urban_logistics": "Urban Logistics/Cross Docks"
        },
        "education": "Éducation",
        "education_art": "Éducation et Art",
        "entertainment": "Divertissement",
        "financial_services": "Services financiers",
        "food": "PDGC - Aliments et Boissons",
        "healthcare": "Produits pharmaceutiques et santé",
        "household_goods": "Biens personnels et domestiques",
        "industrial_goods": "Services et biens industriels",
        "insurance": "Assurance",
        "legal": "Juridique",
        "luxury": "Mode, décor et luxe",
        "media": "Média",
        "oil_gas": "Pétrole et Gaz",
        "other_cat": "Autres",
        "professional_services": "Services professionnels",
        "public": "Secteur public",
        "real_estate": "Immobilier",
        "retail": "Vente au détail",
        "sports_leisure": "Sports et Loisirs",
        "technology": "Technologie",
        "telecommunications": "Télécommunications",
        "travel": "Voyage et Loisirs",
        "utilities": "Services",
        "wellbeing": "Bien-être"
      },
      "industry": "Secteur d'activité",
      "integrationCategories": {
        "listing_site": "",
        "mail": "Email",
        "online_broker": "",
        "other_cat": "Autre",
        "property_management": ""
      },
      "language": "Langue",
      "languages": {
        "en": "English",
        "en-GB": "British English",
        "en-GB-acquisition": "British English",
        "en-GB-flex": "British English",
        "en-acquisition": "English",
        "en-flex": "English",
        "fr-FR": "Français",
        "fr-FR-acquisition": "Français",
        "fr-FR-flex": "Français",
        "nl-BE": "Nederlands (BE)",
        "nl-BE-acquisition": "Nederlands (BE)",
        "nl-BE-flex": "Nederlands (BE)",
        "nl-NL": "Nederlands (NL)",
        "nl-NL-acquisition": "Nederlands (NL)",
        "nl-NL-flex": "Nederlands (NL)"
      },
      "loading": "Chargement..",
      "more": "de plus",
      "name": "Nom",
      "ner": "Loyer net",
      "on": "à",
      "password": "Mot de passe",
      "per": "par",
      "phone": "Numéro de téléphone",
      "placeholder": "Entrez le texte ici",
      "placeholders": {
        "assets": "Selectionner un ou plusieur actifs",
        "portfolios": "Selectionner un portefeuille"
      },
      "pointPerson": "Référent",
      "portfolio": "Portefeuille",
      "portfolioTypes": {
        "acquisition": "Acquisition",
        "flex": "Flex",
        "leasing": "Crédit-bail"
      },
      "potentials": {
        "above_average": "Supérieur à la moyenne",
        "average": "Moyenne",
        "high": "Potentiel élevé",
        "low": "Faible",
        "moderate": "Modéré"
      },
      "private": "Privé",
      "probability": "Probabilité",
      "proposal": "Project de contrat",
      "rofr": "Premier Refus",
      "rofr_full": "Droit de premier refus",
      "roles": {
        "account_holder": "Détenteur de compte |||| Détenteurs de compte",
        "administrator": "Administrateur |||| Administrateurs",
        "internal_user": "Utilisateur interne |||| Utilisateurs internes"
      },
      "save": "Sauvegarder",
      "saved": "Sauvegardé!",
      "saving": "Sauvegarder...",
      "search": "Chercher",
      "search_placeholder": "Chercher...",
      "send": "Envoyer",
      "sending": "Envoyer..",
      "shareStatuses": {
        "all": "Tous les collaborateurs",
        "broker_owner_team": "Moi & mon client",
        "broker_team_owner_team": "Mon équipe a mon client",
        "custom": "Personnalisé",
        "owner_team": "Mon équipe"
      },
      "size": {
        "separator": "à",
        "title": "Surface"
      },
      "space": "Espace",
      "spaceCategories": {
        "archive": "Archives",
        "carParking": "Parking extérieur",
        "car_parking": "Parking extérieur",
        "coveredCarParking": "Parking couvert",
        "covered_car_parking": "Parking couvert",
        "coworking": "Co-working",
        "industrial": "Surface industrielle",
        "land": "Terrain",
        "leisure": "Loisirs",
        "logistical": "Logistique",
        "meeting": "Réunion/Conférence",
        "office": "Postes de travail",
        "other": "Autres",
        "other_cat": "Autres",
        "outdoor_area": "Cour extérieur",
        "residential": "Résidentiel",
        "retail": "Détail",
        "showroom": "Showroom",
        "storage": "Stockage"
      },
      "spaceStatuses": {
        "all": "Tous",
        "private": "Privé",
        "public": "Public"
      },
      "spaces": "Espaces",
      "startDate": "Date de début",
      "status": "Statut",
      "systemEvents": {
        "asset_lead_add_contact": "Contact <i>%{contact}</i> ajouté par <i>%{actor}</i>",
        "asset_lead_create": "<i>%{creator}</i> a créée cette acquisition",
        "asset_lead_stage_update": "<i>%{actor}</i> a changé le statut de <i>%{before}</i> à <i>%{after}</i>",
        "asset_lead_status_update": "<i>%{actor}</i> a changé le statut de <i>%{before}</i> à <i>%{after}</i>",
        "deal_accept_proposal": "Project de contract demandé par <i>%{name}</i>",
        "deal_add_asset": "<i>%{actor}</i> a ajouté cette demande sur <i>%{asset}</i>",
        "deal_channel_add": "Initiateur <i>%{channel}</i> ajouté par <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> a créée cette demande sur <i>%{asset}</i>",
        "deal_create_no_asset": "<i>%{creator}</i> a créée cette demande",
        "deal_lease_cancel": "<i>%{actor}</i> a terminé le bail",
        "deal_merge": "La demande est fusionnée avec <i>%{after}</i> par <i>%{actor}</i>",
        "deal_point_person_change": "<i>%{creator}</i> a changé le référent de <i>%{before}</i> à <i>%{after}</i>",
        "deal_remove_asset": "Demande dissocié du <i>%{asset}</i> par <i>%{actor}</i>",
        "deal_renewal": "<i>%{creator}</i> a dupliqué la demande <i>%{ancestor}</i> pour le renouvellement",
        "deal_share_status_update": "La demande is partagée avec <i>%{after}</i> par <i>%{actor}</i>",
        "deal_stage_update": "<i>%{actor}</i> a changé le statut de <i>%{before}</i> à <i>%{after}</i>",
        "deal_status_update": "<i>%{actor}</i> a changé le statut de <i>%{before}</i> à <i>%{after}</i>",
        "deal_tenant_add": "<i>%{actor}</i> a ajouté <i>%{tenant}</i> comme locataire",
        "deal_tenant_broker_add": "<i>%{actor}</i> a ajouté <i>%{tenant_rep}</i> comme répresentant du locataire"
      },
      "to": "à",
      "totalSize": "surface total",
      "undisclosed": "Non revelé",
      "units": {
        "CAD": "CAD",
        "CHF": "CHF",
        "DKK": "DKK",
        "EUR": "EUR",
        "GBP": "GBP",
        "NOK": "NOK",
        "SGD": "SGD",
        "USD": "USD",
        "amount": "espace |||| espaces",
        "amount_desk": "poste de travail |||| postes de travail",
        "amount_person": "personne |||| personnes",
        "amount_room": "chambre |||| chambres",
        "daily": "jour |||| jours",
        "desk": "poste de travail |||| postes de travail",
        "floor": "niveau |||| niveaux",
        "ft²": "ft²",
        "hourly": "heure |||| heures",
        "m2": "m²",
        "monthly": "mois |||| mois",
        "monthly_short": "m",
        "m²": "m²",
        "parking": "parking |||| parkings",
        "person": "personne |||| personnes",
        "room": "chambre |||| chambres",
        "space": "espace |||| espaces",
        "sqft": "ft²",
        "square_foot": "ft²",
        "units": "espaces",
        "weekly": "semaine |||| semaines",
        "yearly": "année |||| années",
        "yearly_short": "an(s)"
      },
      "upload": "Ajouter un fichier",
      "user": {
        "email": "Email",
        "fname": "Prénom",
        "licenseNumber": "Numéro IPI",
        "lname": "Nom de famille",
        "locale": "Langue",
        "mobile": "Numéro de portable",
        "name": "Nom et prénom",
        "password": "Mot de passe",
        "passwordConfirmation": "Confirmation mot de passe",
        "phone": "Numéro de téléphone",
        "role": "Rôle",
        "timezone": "Fuseau horaire",
        "title": "Titre"
      },
      "with": "avec"
    },
    "spaces": {
      "category": "Catégorie"
    }
  },
  "nl-BE": {
    "ActivityFeed": {
      "empty_files": "Geen bestanden.",
      "empty_items": "Geen items.",
      "empty_notes": "Geen private berichten.",
      "empty_updates": "Geen updates.",
      "empty_viewings": "Geen geplande bezoeken.",
      "filters": {
        "Call": "Gesprekken",
        "DealNote": "Berichten",
        "Email": "E-mails",
        "File": "E-mails",
        "Note": "Berichten",
        "Proposal": "Voorstellen",
        "Viewing": "Bezoeken",
        "all": "Alles",
        "call": "Gesprekken",
        "deal_note": "Berichten",
        "email": "E-mails",
        "file": "Bestanden",
        "label": "Toon",
        "note": "Berichten",
        "proposal": "Voorstellen",
        "update": "Berichten",
        "viewing": "Bezoeken"
      },
      "header": {
        "Call": "Gesprek",
        "DealNote": "Bericht",
        "Email": "E-mail",
        "Note": "Bericht",
        "Proposal": "Voorstel",
        "Viewing": "Bezoek",
        "call": "Gesprek",
        "deal_note": "Bericht",
        "email": "E-mail",
        "file": "Bestand",
        "label": "Post",
        "note": "Bericht",
        "proposal": "Voorstel",
        "update": "Bericht",
        "viewing": "Bezoek"
      }
    },
    "AddActions": {
      "addDeal": ""
    },
    "Asset": {
      "deals": {
        "empty": "Geen opportuniteiten",
        "fetching": "Laden..",
        "hide": "Verberg opportuniteiten",
        "show": "Toon %{smart_count} opportuniteit |||| Toon %{smart_count} opportuniteiten"
      },
      "noAvailableSpaces": "Geen ruimtes beschikbaar",
      "spaces": {
        "empty": "Geen ruimtes beschikbaar",
        "fetching": "Laden..",
        "hide": "Verberg ruimtes",
        "show": "Toon %{smart_count} ruimte |||| Toon %{smart_count} ruimtes"
      },
      "spacesFetching": "Laden..",
      "spacesHide": "Verberg ruimtes",
      "spacesView": "Toon %{smart_count} ruimte |||| Toon %{smart_count} ruimtes"
    },
    "AssetActions": {
      "askQuestion": "Informeren",
      "copied": "URL gekopieerd!",
      "copy": "Kopieer flyer URL",
      "download": "Download flyer",
      "open": "Flyer openen",
      "requestFlyer": "Vraag flyer",
      "sendSMS": "Sms'en",
      "subscribed": "Ingeschreven voor het wekelijks overzicht",
      "unsubscribed": "Uitgeschreven voor het wekelijks overzicht"
    },
    "AssetAvailability": {
      "availableSpace": "Beschikbaar",
      "spaces": "ruimtes"
    },
    "AssetCharges": {
      "allIn": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
      "rate": "O.V. (schatting)",
      "sell": "Verkoopprijs",
      "service": "gem. Kosten (schatting)"
    },
    "AssetCreateModal": {
      "autoGenerateFlyer": "Genereer automatisch een flyer voor dit pand",
      "description": "Vul hier basis informatie in over het nieuwe pand. U kan later meer details toevoegen.",
      "title": "Voeg pand toe."
    },
    "AssetDeals": {
      "actions": {
        "dropped": "Afgevallen",
        "edit": "Wijzigen",
        "exclude": "Niet opnemen in rapport",
        "include": "Opnemen in rapport",
        "not_dropped": "Niet afgevallen",
        "not_viewed": "Niet bezichtigd markeren",
        "viewed": "Bezichtigd markeren"
      },
      "groups": {
        "active": "Actief",
        "dead": "Verloren",
        "prospects": "Prospects"
      },
      "nonProspectCommentMissing": "Toelichting / vervolgstappen mist voor export"
    },
    "AssetFilter": {
      "budget": "Budget",
      "region": "Regio",
      "status": "Status",
      "type": "Type"
    },
    "AssetHeader": {
      "deals": "Opportuniteiten",
      "export": {
        "btn": "Exporteren",
        "disabled": "Export niet mogelijk. Informatie mist over toelichting / vervolgstappen",
        "notification": {
          "message": "U ontvangt zometeen een email",
          "title": "Uw verhuurrapportage wordt geëxporteerd"
        }
      },
      "tabs": {
        "access": "Toegang",
        "announcements": "Mededelingen",
        "assetDeals": "Verhuurrapportage",
        "contacts": "Contacten",
        "files": "Foto's & Bestanden",
        "floorplan": "Plattegronden",
        "infosheet": "Fiche",
        "settings": "Instellingen",
        "spaces": "Ruimtes"
      }
    },
    "AssetIncentives": {
      "active": "Actief",
      "emptyMessage": {
        "active": "Plaats uw <strong>actieve</strong> honoraria hier",
        "inactive": "Plaats uw <strong>niet-actieve</strong> honoraria hier"
      },
      "inactive": "Niet-actief",
      "info": "Een nieuw honorarium nodig? U kunt meer honoraria maken in uw <a href=\"/settings/templates/incentives\">algemene instellingen</a>."
    },
    "AssetInfoModal": {
      "btn": "Stel een vraag",
      "header": "Vraag over %{asset}",
      "questionPlaceholder": "Stel uw vraag..",
      "topic": "Betrekking tot",
      "topics": {
        "another": "Andere",
        "commissions": "Fee en commissies",
        "service": "Gemeenschappelijke kosten",
        "viewing": "Aanvragen bezoek"
      }
    },
    "AssetInformation": {
      "incentives": "Honoraria",
      "title": "Fee en commissies",
      "tos": "Servicevoorwaarden"
    },
    "AssetLeadAddress": {
      "title": "Adres details"
    },
    "AssetLeadContacts": {
      "title": "Contacten"
    },
    "AssetLeadCreateForm": {
      "address": "Straat en nummer",
      "assetLead": "Acquisitie"
    },
    "AssetLeadDetails": {
      "description": "Extra informatie",
      "title": "Acquisitie Details"
    },
    "AssetLeadHeader": {
      "collaborators": {
        "title": "Medewerkers"
      },
      "days_active_from_now": "%{days} actief",
      "pointPerson": {
        "dropdownHeader": "Selecteer Contactpersoon",
        "title": "Contactpersoon"
      },
      "reopen": "Kans heropenen?",
      "status": {
        "days_active_from_now": "%{days} actief",
        "number_of_days_active": "%{days} dagen actief",
        "title": "Status"
      },
      "title": "Acquisitie Kans"
    },
    "AssetLeadModal": {
      "title": "Creëer acquisitie kans"
    },
    "AssetLeadStatusMessage": {
      "disregarded": "verloren",
      "executed": "gewonnen",
      "message": "De acquisitie kans is <strong>%{status}</strong> geplaatst door %{actor} op %{date}",
      "message_no_actor": "De acquisitie kans is <strong>%{status}</strong> geplaatst op %{date}"
    },
    "AssetLeadsList": {
      "emptyStage": "Geen acquisitie gevonden in de huidige fase"
    },
    "AssetNavigator": {
      "disclaimer": "De informatie in onderstaand document is strikt confidentieel en u bent niet geautoriseerd om dit document in z'n geheel, of de informatie afzonderlijk, vrij te geven aan eender welke partij behalve voor het informeren van mogelijke huurders waar u rechtstreeks mee in contact bent. In elk ander geval neemt u eerst contact.",
      "filter": "Filter",
      "loading": "Laden...",
      "noAssets": "Uw zoekopdracht leverde geen resultaat op.",
      "searchPlaceholder": "Zoeken.."
    },
    "AssetNavigatorHeader": {
      "collapse": "Verberg alle",
      "display": "Weergave",
      "expand": "Toon alle",
      "placeholder": "Zoeken.."
    },
    "AssetOnMarket": {
      "onMarket": "on-market"
    },
    "AssetSettings": {
      "access": "Toegang",
      "actions": {
        "menuTitle": "Acties",
        "portfolio": {
          "dropdownTitle": "Verplaats naar",
          "information": "Wanneer u dit pand naar een andere portefeuille verplaatst, worden <strong>alle opportuniteiten</strong> voor dit pand ook overgezet naar de nieuwe portefeuille.",
          "menuTitle": "Wijzig portfolio",
          "title": "Wijzig portfolio"
        }
      },
      "assetUsers": {
        "cancel_invite": "Uitnodiging annuleren",
        "invitationPending": "Uitnodiging in behandeling",
        "inviteBtn": "Uitnodigen",
        "menuTitle": "Partners",
        "none": {
          "fully_let": "Uw pand is <strong>volledig verhuurd</strong>. <a href=\"/assets/%{id}/settings/access/status\">Wijzig de status</a> om partners uit te nodigen.",
          "invite": "U heeft nog <strong>geen partners</strong>.",
          "private": "Uw pand is <strong>privaat</strong>. <a href=\"/assets/%{id}/settings/access/status\">Wijzig de status</a> om partners uit te nodigen.",
          "public": "U heeft nog <strong>geen partners</strong>.",
          "sold": "Uw pand is <strong>vendu</strong>. <a href=\"/assets/%{id}/settings/access/status\">Wijzig de status</a> om partners uit te nodigen."
        },
        "resend_invite": "Opnieuw versturen",
        "revoke": "Ontzeg toegang",
        "revoke_company": "Ontzeg toegang team"
      },
      "costs": {
        "allIn": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
        "menuTitle": "Algemeen",
        "rentPrice": "Verhuurprijs",
        "sellPrice": "Verkoopprijs",
        "sellingTitle": "Verkoopprijs",
        "serviceTitle": "Gemeenschappelijke kosten",
        "taxTitle": "Onroerende voorheffing"
      },
      "fees": "Fee en commissies",
      "financial": "Financieel",
      "flyerSettings": {
        "autogenerateFlyer": "Genereer automatisch een flyer voor dit pand",
        "description": "Als u <strong>automatisch genereren</strong> inschakelt voor flyers, wordt een flyer gemaakt en up-to-date gehouden. Dit betekent dat wanneer u een ruimte, foto, plattegronden, ... toevoegt of bijwerkt, we automatisch een nieuwe flyer voor u zullen genereren.",
        "title": "Flyer instellingen"
      },
      "general": "Algemeen",
      "incentives": "Honoraria",
      "options": {
        "delete": {
          "confirm": "Weet je zeker dat je dit pand wilt verwijderen? Dit is onomkeerbaar!",
          "information": "Als u uw makelaars meer informatie wilt geven over waarom het pand verwijderd is, kunt u <a href=%{link}>een mededeling</a> toevoegen of hieronder een reden selecteren.",
          "menuTitle": "Pand verwijderen",
          "reason": "Reden voor verwijderen",
          "title": "Verwijder pand uit portfolio",
          "warning": "Als u dit pand verwijdert, worden alle gegevens verwijderd. <br/> Na het verwijderen worden uw teamleden en makelaars in het wekelijks overzicht op de hoogte gebracht. Nadien hebben ze geen toegang meer en wordt het pand <strong>permanent</strong> verwijderd."
        },
        "menuTitle": "Opties"
      },
      "status": {
        "description": "Het bijwerken van de status bepaalt waarop het pand op Rialto wordt gecommercialiseerd:",
        "descriptionFullyLet": "Wanneer de status <strong>volledig verhuurd</strong> is, is het pand enkel toegankelijk voor u en uw team",
        "descriptionInvite": "Wanneer de status <strong>op uitnodiging</strong> is, kan uw pand enkel gedeeld worden via uitnodiging",
        "descriptionPrivate": "Wanneer de status <strong>privaat</strong> is, is het pand enkel toegankelijk voor u en uw team",
        "descriptionPublic": "Wanneer beschikbaar onder <strong>open mandaat</strong>, is uw pand toegankelijk voor alle makelaars die toegang ontvingen op uw portfolio op Rialto",
        "dropdownTitle": "Status",
        "menuTitle": "Status",
        "public_to_invite": "",
        "public_to_private": "",
        "title": "Status wijzigen"
      },
      "tos": "Servicevoorwaarden",
      "tosExtraInfo": "Selecteer hieronder de servicevoorwaarden om uw partners op de hoogte te stellen van de voorwaarden die van toepassing zijn op dit pand.",
      "tosInfo": "Nieuwe servicevoorwaarden nodig? U kunt meer servicevoorwaarden maken in uw <a href=\"/settings/templates/tos\">algemene instellingen</a>."
    },
    "AssetShareStatus": {
      "Tooltips": {
        "body_fully_let": "Dit pand is volledig verhuurd",
        "body_invite": "List of partners this asset is shared with.",
        "body_private": "Dit pand is enkel zichtbaar voor u en uw team.",
        "body_public": "Dit pand is gedeeld met alle agenten die toegang hebben tot dit portefeuille.",
        "footer_invite": {
          "one": "en %{count} meer",
          "other": "en %{count} meer"
        },
        "header_invite": "Gedeeld met"
      }
    },
    "AssetSort": {
      "name": "Naam",
      "on_market": "Beschikbare ruimte",
      "order_by": "Sorteren op",
      "updated_at": "Laatste update"
    },
    "AssetStatistics": {
      "available": "Nu beschikbaar",
      "deals": "Opportuniteiten",
      "onMarket": "On-market",
      "total": "Totaal",
      "viewings": "Bezoeken"
    },
    "AssetTermsOfService": {
      "info": "Een nieuw honorarium nodig? U kunt meer honoraria maken in uw <a href=\"/settings/incentives\">algemene instellingen</a>."
    },
    "Backbutton": {
      "back": "Terug"
    },
    "BrokerInviteForm": {
      "broker": "Partner",
      "invite": "Uitnodigen",
      "inviting": "Uitnodigen..",
      "portfolioAssets": "Portfolio & panden"
    },
    "BrokerInviteModal": {
      "description": "Als je een partner uitnodigt, zal je het team van de partner toegang geven tot de beschikbaarheidslijsten van de panden die je selecteert, inclusief het marketing materiaal en de documenten. Je deelt nooit opportuniteiten die je zelf aangemaakt hebt, of die aangemaakt zijn door een andere partner, met deze partij. De partner zal in real-time updates ontvangen bij wijzigingen van het marketing materiaal of in de beschikbaarheid van de panden die met hem gedeeld worden, en hij zal per pand opportuniteiten kunnen delen met u.",
      "title": "Uitnodigen Partner"
    },
    "Calendar": {
      "call": "Gesprek",
      "day": "Dag",
      "download": "Inschrijven",
      "due_proposal": "Vervaldatum voorstel",
      "lease_expiration": "Einde huur",
      "lease_start": "Aanvang huur",
      "month": "Maand",
      "space_available": "Ruimte beschikbaar",
      "today": "Vandaag",
      "viewing": "Bezoek",
      "week": "Week"
    },
    "Channels": {
      "category": "Type",
      "company": "Bedrijf",
      "confirm": {
        "delete": "Weet je zeker dat je dit wilt verwijderen?"
      },
      "name": "Naam en voornaam",
      "phone": "Telefoonnummer",
      "title": "Bronnen"
    },
    "Commissions": {
      "durationLabel": "Contractduur",
      "feeLabel": "Commissie",
      "header": "Commissies",
      "info": "Het commissiepercentage is gerelateerd aan de duur van het contract, <strong>ze is als volgt opgesteld</strong>:",
      "year": "jr"
    },
    "CompanyBlock": {
      "newPortfolio": "Nieuw portfolio",
      "visitCompanyPage": "Bedrijfsprofiel"
    },
    "CompanyPage": {
      "Contact": {
        "email": "E-mail ons",
        "phone": "Bel ons"
      },
      "Login": {
        "footer": "Geen account?",
        "header": "Heb je een Rialto-account?",
        "login": "Inloggen bij Rialto",
        "requestAccess": "Toegang vragen"
      },
      "NotFound": {
        "message": "We kunnen geen bedrijf vinden voor deze url",
        "title": "Deze pagina is niet beschikbaar"
      },
      "contacts": "Contacten",
      "features": "Features",
      "incentives": "Honoraria",
      "introduce": "Introduceer klant",
      "portfolios": "Portfolio's",
      "tos": "Servicevoorwaarden"
    },
    "CompanyTooltip": {
      "inCountry": "in %{value}",
      "numberOfAssets": "%{smart_count} pand |||| %{smart_count} panden",
      "viewCompanyProfile": "Bedrijfsprofiel"
    },
    "Dashboard": {
      "empty": "Er is geen dashboard voor dit portfolio"
    },
    "DateTime": {
      "add_date": "Gelieve een datum te kiezen",
      "add_time": "Tijdstip kiezen?",
      "select_date": "Kies datum",
      "set": "Instellen",
      "submit": "Opslaan",
      "time": "Tijdstip",
      "title": "Datum kiezen"
    },
    "DealActions": {
      "delete": {
        "confirm": "Bent u zeker dat u deze opportuniteit permanent wil verwijderen? Ook berichten op deze opportuniteit worden verwijderd.",
        "tooltip": "Verwijderen"
      },
      "duplicate": {
        "tooltip": "Dupliceren"
      },
      "merge": {
        "tooltip": "Samenvoegen"
      }
    },
    "DealCancel": {
      "cancelDate": "Opzegdatum",
      "confirm": "Bevestigen",
      "confirming": "Bevestigen...",
      "feedback": "Feedback",
      "feedbackInfo": "Uw feedback zal worden getoond aan iedereen met toegang tot deze opportuniteit.",
      "feedbackPlaceholder": "Geef uw feedback hier",
      "moveDate": "Verhuisdatum",
      "reason": "Reden",
      "title": "Zeg huurcontract op"
    },
    "DealCard": {
      "nbAssets": "%{smart_count} panden"
    },
    "DealColumns": {
      "title": "Kolommen aanpassen"
    },
    "DealDetail": {
      "confirmDelete": "Bent u zeker dat u deze opportuniteit permanent wil verwijderen? Ook berichten op deze opportuniteit worden verwijderd."
    },
    "DealDetails": {
      "budget": {
        "separator": "tot",
        "title": "Budget"
      },
      "description": "Extra informatie",
      "location": {
        "title": "Locatie"
      },
      "spaces": {
        "archive": "Archief",
        "car_parking": "Buitenparking",
        "category": "Categorie",
        "covered_car_parking": "Overdekte parking",
        "coworking": "Co-working",
        "industrial": "Bedrijfsruimte",
        "land": "Kavel",
        "leisure": "Vrije tijd",
        "logistical": "Logistieke ruimte",
        "meeting": "Meeting / Conferentie",
        "new": "Nieuw",
        "office": "Kantoor",
        "other_cat": "Overig",
        "outdoor_area": "Buitenterrein",
        "residential": "Residentieel",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Opslag",
        "title": "Ruimtes"
      },
      "start_date": {
        "title": "Startdatum"
      },
      "term": {
        "months": "maand",
        "title": "Max huurtermijn",
        "years": "jaar"
      },
      "title": "Details van Opportuniteit",
      "type": "Type",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "plaatsen"
      }
    },
    "DealFilter": {
      "advanced": "Geavanceerde filters",
      "asset": "Pand",
      "selectedAsset": "%{nb} geselecteerd"
    },
    "DealForm": {
      "assets": {
        "info": "Per pand dat u selecteert wordt een afzonderlijke opportuniteit aangemaakt. Kies links onderaan of u de opportuniteit al dan niet wil delen vooraleer ze toe te voegen.",
        "title": "Pand |||| Panden"
      },
      "channel": {
        "expand": "Voeg <strong>oorsprong</strong> toe",
        "title": "Oorsprong"
      },
      "description": {
        "disclose": "<strong>Voeg extra informatie toe</strong>",
        "placeholder": "Voer notitie in",
        "title": "Extra informatie"
      },
      "details": {
        "title": "Opportuniteit"
      },
      "enquiry": {
        "title": ""
      },
      "placeholders": {
        "asset": "Associeer pand(en) (optioneel)",
        "assets": "Associeer pand (optioneel)"
      },
      "portfolio": {
        "title": "Portfolio"
      },
      "save": "Toevoegen",
      "saving": "Toevoegen..",
      "stage": "Fase",
      "tenant": {
        "title": "Huurder",
        "undisclose": "Huurdersgegevens <strong>niet vrijgeven</strong>"
      }
    },
    "DealMerge": {
      "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui sint asperiores maiores eaque voluptatum mollitia eum architecto, neque possimus hic corporis aliquid aut est tempore voluptates iste harum enim iusto rerum blanditiis magni aliquam. Vero maxime qui quis explicabo eum excepturi asperiores rerum eos veritatis, reprehenderit voluptatem possimus aliquam incidunt!",
      "source": "Voeg",
      "target": "Samen met",
      "title": "Opportuniteit samenvoegen"
    },
    "DealModal": {
      "header": "Nieuwe opportuniteit"
    },
    "Deals": {
      "portfolio_subscribed": "Ingeschreven voor het wekelijks overzicht",
      "portfolio_unsubscribed": "Uitgeschreven voor het wekelijks overzicht"
    },
    "DealsFilter": {
      "asset": "Pand",
      "channel": "Oorsprong",
      "searchPlaceholder": "Zoeken..",
      "stage": "Fase"
    },
    "DealsTable": {
      "empty": "Geen opportuniteiten gevonden",
      "empty_stage": "Geen opportuniteiten gevonden in de huidige fase",
      "export": {
        "btnLabel": "Exporteren",
        "csv": "Een CSV versie van de opportuniteitenlijst die bewerken kan worden.",
        "pdf": "Een PDF van de opportuniteitenlijst met alle activiteit per pand.",
        "title": "Opportuniteitenlijst"
      },
      "loading": "Laden..."
    },
    "Dialog": {
      "confirm": "Bevestigen",
      "title": "Bent u zeker?"
    },
    "DisregardModal": {
      "disregard": "Verloren plaatsen",
      "disregarding": "Verloren plaatsen..",
      "feedbackInfo": "Uw feedback zal worden getoond aan iedereen met toegang tot deze opportuniteit.",
      "feedbackPlaceholder": "Geef uw feedback hier",
      "header": "Opportuniteit verloren plaatsen",
      "outcome": "Resultaat",
      "reason": "Reden"
    },
    "DropdownUserItem": {
      "me": "ik"
    },
    "DropdownUserSelect": {
      "pointPerson": "Contactpersoon"
    },
    "Dropzone": {
      "notSupported": "Dit bestandstype wordt niet ondersteund",
      "placeholder": "Klik of sleep hier om een bestand te uploaden",
      "placeholderPicture": "Klik of sleep hier om een foto te uploaden"
    },
    "EnquiryDetails": {
      "budget": {
        "title": ""
      },
      "title": ""
    },
    "EnquiryHeader": {
      "DealStages": {
        "hide": "Verberg",
        "modal": {
          "body": "Hier kun je aanpassen welke panden in de running zijn voor %{stage}. Wanneer u het pand verwijdert, wordt deze opportuniteit verloren geplaatst.",
          "title": "Panden in %{stage} aanpassen"
        },
        "show": "Toon %{smart_count} meer"
      },
      "assignAsset": "Associeer een pand",
      "assignFeePotential": "Voeg waarde toe",
      "collaborators": {
        "title": "Medewerkers"
      },
      "confirm": {
        "assetRemove": "Eén of meer ruimtes van %{asset} kunnen gekoppeld zijn aan deze opportuniteit. Deze koppeling wordt verwijderd wanneer u het pand verwijdert. Weet u zeker dat u verder wilt gaan?",
        "assetUpdate": "Eén of meer ruimtes van %{asset} kunnen gekoppeld zijn aan deze opportuniteit. Deze koppeling wordt verwijderd wanneer u het pand bijwerkt. Weet u zeker dat u verder wilt gaan?",
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "feePotentialRemove": "Ben je zeker dat je de waarde voor deze opportuniteit wenst te verwijderen?"
      },
      "duplicate": "Dupliceer voor hernieuwing",
      "feePotential": "Waarde opportuniteit",
      "modal": {
        "header": "Aangepaste deelinstellingen",
        "info": "Iedere partner die hier getagd is, zal kunnen werken op deze opportuniteit. We laten hen niet weten als je ervoor kiest niet langer met hen te delen.",
        "save": "Opslaan",
        "search_collaborators": "Zoek partners",
        "title": "Partners met toegang tot opportuniteit"
      },
      "point_person": {
        "dropdown_header": "Selecteer Contactpersoon",
        "title": "Contactpersoon"
      },
      "renew": "Dupliceer voor hernieuwing",
      "reopen": "Opportuniteit heropenen?",
      "status": {
        "days_active_from_now": "%{days} actief",
        "number_of_days_active": "%{days} dagen actief",
        "title": "Status"
      },
      "subscribed": "Ingeschreven",
      "title": "Opportuniteit",
      "unsubscribed": "Uitgeschreven"
    },
    "EnquiryModal": {
      "addEnquiry": "Toevoegen",
      "addingEnquiry": "Toevoegen..",
      "assets": {
        "title_pl": "Panden",
        "title_sg": "Pand"
      },
      "channel": {
        "category": "Type",
        "company": "Bedrijfsnaam",
        "email": "Email",
        "name": "Naam",
        "title": "Oorsprong"
      },
      "collapse_channel_details": "Verberg <strong>makelaar</strong>",
      "collapse_comment_details": "<strong>Verberg opmerking</strong> to post upon creation",
      "collapse_tenant_details": "<strong>Verberg huurder</strong> en/of makelaar",
      "comment": {
        "placeholder": "Voer notitie in",
        "title": "Voeg bericht toe"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren."
      },
      "enquiry": {
        "name": "Naam",
        "title": "Opportuniteit"
      },
      "expand_channel_details": "Voeg <strong>oorsprong</strong> toe",
      "expand_comment_details": "<strong>Voeg opmerking toe</strong> bij aanmaak",
      "expand_tenant_details": "<strong>Voeg huurder</strong> en/of makelaar toe",
      "header": "Nieuwe opportuniteit",
      "headerRenewal": "Dupliceer voor vernieuwing",
      "industry": {
        "art_culture": "Kunst & cultuur",
        "automobile": "Automobiel",
        "aviation": "Luchtvaart & toerisme",
        "banks": "Banken",
        "basic_resources": "Grondstoffen",
        "chemicals": "Chemie",
        "construction": "Bouw",
        "consumer_electronics": "Huishoudelectro",
        "education": "Onderwijs",
        "education_art": "Onderwijs & kunst",
        "entertainment_gaming": "Ontspanning & gaming",
        "financial_services": "Financiële diensten",
        "food": "FMCG - Voeding & drank",
        "healthcare": "Zorg & farmacie",
        "household_goods": "Persoonlijke- & huishoudartikelen",
        "industrial_goods": "Industriële goederen & diensten",
        "insurance": "Verzekeringen",
        "legal": "Juridisch",
        "luxury": "Mode, interieur & luxe",
        "media": "Media",
        "oil_gas": "Olie & gas",
        "other_cat": "Andere",
        "professional_services": "Professionele diensten",
        "public": "Publieke sector",
        "real_estate": "Vastgoed",
        "retail": "Retail",
        "sports_leisure": "Sport & vrije tijd",
        "technology": "Technologie",
        "telecommunications": "Telecom",
        "title": "Industrie",
        "travel": "Toerisme & vrije tijd",
        "utilities": "Nutsvoorzieningen",
        "wellbeing": "Welzijn"
      },
      "info": "Per pand dat u selecteert wordt een afzonderlijke opportuniteit aangemaakt. Kies links onderaan of u de opportuniteit al dan niet wil delen vooraleer ze toe te voegen.",
      "portfolio": {
        "title": "Portfolio"
      },
      "size": {
        "separator": "tot",
        "title": "Grootte"
      },
      "start_date": {
        "title": "Startdatum"
      },
      "tenant": {
        "company": "Bedrijf",
        "email": "E-mailadres",
        "industry": "Industrie",
        "name": "Voor- en achternaam",
        "title": "Huurder"
      },
      "tenantRepresentative": {
        "company": "Bedrijf",
        "email": "E-mailadres",
        "name": "Voor- en achternaam",
        "title": "Tenant Rep."
      },
      "undiscloseTenantBroker": "Huurdersgegevens <strong>niet vrijgeven</strong>",
      "undiscloseTenantOwner": "Huurdersgegevens <strong>niet vrijgegeven</strong>",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "plaatsen"
      }
    },
    "EnquiryStatusMessage": {
      "advisedBy": "Geadviseerd door",
      "commencement": "<strong>Aanvang</strong> op",
      "disregarded": "verloren",
      "executed": "gewonnen",
      "expiring": "<strong>Aflopend</strong> op",
      "leaseBreak": "<strong>Eerste break</strong> op",
      "message": "De opportuniteit is <strong>%{status}</strong> geplaatst door %{actor}",
      "message_no_actor": "De opportuniteit is <strong>%{status}</strong> geplaatst",
      "renewal": "Dupliceer voor hernieuwing",
      "renewalPeriod": "<strong>Vernieuwing</strong> elke",
      "reopen": "Opportuniteit heropenen?",
      "size": {
        "of": "van"
      },
      "yearlyRent": {
        "for": "voor",
        "message": "Totale jaarlijkse huur is"
      }
    },
    "ErrorBoundary": {
      "back": "Ga terug",
      "message": "Ons team is op de hoogte gebracht en zal de fout zo snel mogelijk proberen oplossen. <br />\nWe nemen contact met u op nadat het probleem is opgelost.",
      "title": "Sorry, er is iets misgegaan.. "
    },
    "ExecuteModal": {
      "channels": "Komt in aanmerking voor vergoeding",
      "execute": "Gewonnen",
      "executing": "Gewonnen..",
      "header": "Opportuniteit gewonnen plaatsen",
      "info": "De details van het gewonnen huurcontract zullen beschikbaar zijn in de sectie gewonnen opportuniteiten en zullen beschikbaar blijven voor uw eigen team en eventueel uw agenten die uitgenodigd waren tot deze opportuniteit.",
      "involvedSpaces": "Verhuurde Ruimtes",
      "leasingAgent": "Verhuurmakelaar",
      "offered": "verstuurd",
      "reasonForMoving": "Motivatie",
      "received": "ontvangen",
      "tenant": "Naam huurder"
    },
    "ExportActions": {
      "assetLeads": {
        "title": "Acquisitie",
        "xls": "Een XLS export."
      },
      "assets": {
        "csv": "Een CSV export na filter.",
        "pdf": "Een PDF export, na filter.",
        "title": "Panden en Ruimtes",
        "xls": "Een XLS export na filter."
      },
      "btnLabel": "Exporteren",
      "deals": {
        "csv": "Een CSV versie van de opportuniteitenlijst die bewerken kan worden.",
        "pdf": "Een PDF van de opportuniteitenlijst met alle activiteit per pand.",
        "title": "Opportuniteitenlijst",
        "xls": "Een XLS versie van de opportuniteitenlijst die bewerken kan worden."
      },
      "portfolioAssets": {
        "pdf": "Een PDF export dit portfolio (na filter).",
        "title": "Portfolio",
        "xls": "Een XLS export van dit portfolio (na filter)."
      }
    },
    "FileManager": {
      "empty": "Je hebt nog geen foto's of bestanden geüpload.",
      "files": "Documenten",
      "filesSelected": "%{value} bestanden geselecteerd",
      "header": "Gebruik als flyer header",
      "pictures": "Foto's",
      "private": "Niet tonen op flyer",
      "searchPlaceholder": "(name, kind, tag, ..)",
      "thumbnail": "Gebruik als thumbnail",
      "uploaded": "Toegevoegd"
    },
    "Floorplans": {
      "actions": "",
      "addSpace": "Ruimte verbinden",
      "availability": "Beschikbaarheid",
      "clearLines": "Lijnen verwijderen",
      "clickToLink": "Klik om een ruimte te koppelen",
      "createFloorplan": "Nieuwe plattegrond aanmaken",
      "deleteConfirm": "Bent u zeker dat u deze plattegrond wilt verwijderen?",
      "deleteFloorplan": "Verwijder plattegrond",
      "duplicate": "Dupliceer",
      "editSpace": "Ruimte wijzigen",
      "file": "Bestand",
      "floor": "Verdieping",
      "floorPlaceholder": "Naam van verdieping",
      "floorSelector": "Verdieping kiezen",
      "information": "<h3>Inzoomen op de afbeelding</h3>\n<p>Houdt CTRL of CMD ingedrukt en scroll om op de afbeelding in te zoomen</p>\n\n<h3>De afbeelding verplaatsen</h3>\n<p>Houdt CTRL of CMD ingedrukt, klik en beweeg de muis om de afbeelding te verplaatsen</p>\n\n<h3>Tekenen op de afbeelding</h3>\n<p>Klik op de afbeelding om een lijn te teken. Van zodra de tekening afgewerkt is, kan deze met een ruimte van het pand gekoppeld worden</p>\n\n<h3>Een ruimte op de afbeelding koppelen</h3>\n<p>Klik op een getekende ruimte om deze met ruimte uit het pand te kopppelen</p>\n\n<h3>Een getekende ruimte verplaatsen</h3>\n<p>Klik op een getekende ruimte en verplaats de muis om de ruimte te verplaatsen</p>\n\n<h3>Een getekende ruimte dupliceren</h3>\n<p>Klik op een gekende ruimte, vervolgens op de het potlood en tenslotte op dupliceer om de geselecteerde ruimte te dupliceren</p>",
      "informationTitle": "Info over plattegronden",
      "leaseHolder": "Huurder",
      "none": "Geen plattegronden beschikbaar",
      "pricing": "Prijs",
      "scroll": "Houd %{key} ingedrukt om de afbeelding te verschuiven of in te zoomen.",
      "size": "Grootte",
      "startDragging": "Verplaatsen aanvangen",
      "status": "Status",
      "stopDragging": "Verplaatsen stopppen",
      "uploadFloorplan": "Plattegrond uploaden"
    },
    "Flyer": {
      "NotFound": {
        "message": "We vinden het jammer, maar de flyer is niet langer beschikbaar. <br>\nBezoek het <a href=\"https://www.rial.to/app\">Rialto platform</a>, of <a href=\"mailto:dgtqwgb3@incoming.intercom-mail.com\"> neem contact met ons</a>.",
        "title": "Flyer is niet meer beschikbaar"
      },
      "ServiceRate": {
        "allIn": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
        "rate": "onroerende voorheffing (schatting)",
        "service": "gemeenschappelijke kosten (schatting)"
      },
      "contact": "Neem contact",
      "facilities": {
        "categories": {
          "fire_safety": "Brandveiligheid",
          "general": "Algemeen",
          "other_cat": "Andere",
          "security": "Beveiliging"
        },
        "title": "Voorzieningen"
      },
      "location": "Ligging",
      "marketing": "Marketing Package"
    },
    "FlyerContactModal": {
      "info": "Uw vraag wordt naar de contactpersoon van dit pand gestuurd",
      "question": "Stel hier uw vraag",
      "successBody": "De contactpersoon zal u zo snel mogelijk antwoorden",
      "successTitle": "Bericht verzonden",
      "title": "Een vraag stellen"
    },
    "ForgotPasswordModal": {
      "header": "Wachtwoord vergeten",
      "info": "Vul uw e-mailadres in dat u gebruikt op rial.to en druk op versturen. Daarna versturen wij u een e-mail met verdere instructies om uw wachtwoord opnieuw in te stellen."
    },
    "FormButton": {
      "cancel": "Annuleren",
      "delete": "Verwijderen",
      "edit": "Wijzig",
      "save": "Opslaan"
    },
    "GmailAuth": {
      "body": "Identificeer snel leads in uw e-mail inbox op Rialto en converteer ze direct naar een opportuniteit. Zo hoef je niet langer tussen twee apps te wisselen. Klik op de onderstaande knop om te verbinden.",
      "title": "Verbind uw e-mail account met Rialto"
    },
    "Inbox": {
      "convertDeal": "Maak opportuniteit",
      "fetching": "E-mails ophalen..",
      "noSelection": "Geen e-mail geselecteerd"
    },
    "Incentive": {
      "fee": "<strong>%{fee}</strong> commissie zal worden toegekend",
      "minSize": "bij minimaal",
      "months": "maanden",
      "sprinter": "Bij afsluiting contract maximaal <strong>%{duration} maand(en) </strong> na fase <strong>%{stage}</strong>.",
      "termAfter": "na %{date}",
      "termBefore": "voor %{date}"
    },
    "IncentiveCard": {
      "commissionFixed": "%{value} %{currency} na %{type} van huurder.",
      "commissionPercentage": "%{value} na %{type} van huurder.",
      "commissionPeriod": "%{value} %{period} na %{type} van huurder.",
      "conditionsSize": "Contractgrootte > %{value} %{unit}",
      "conditionsTerm": "Contractduur > %{value} %{period}",
      "payoutLinked": "Periodieke betaling in lijn met huurbetalingen voor max. %{value} %{period} huur",
      "payoutRecurring": "Periodieke betaling elke %{recurrenceValue} %{recurrencePeriod} voor max. %{value} %{period} huur",
      "payoutUpfront": "Vooruitbetaling over %{value} %{period} huur",
      "type": {
        "expansion": "uitbreiden",
        "new": "tekenen",
        "reduction": "reduceren",
        "renegotiation": "heronderhandelen",
        "renewal": "hernieuwen"
      }
    },
    "IncentiveForm": {
      "addIncentive": "Nieuw honorarium",
      "autoAssign": "Toon op de bedrijfspagina en wijs automatisch toe op publieke panden",
      "conditionTypes": {
        "conditions": "Voorwaarden",
        "endDate": "Einddatum",
        "minSize": "Minimale grootte",
        "term": "Termijn"
      },
      "deleteAutoassignConfirm": "Bent u zeker dat u dit honorarium wilt verwijderen? Dit honorarium is automatisch toegewezen aan de bedrijfspagina en panden met publieke status. Nadat het honorarium verwijderd is, wordt deze niet langer weergegeven.",
      "deleteConfirm": "Bent u zeker dat u dit honorarium wilt verwijderen?",
      "deleteSuccess": "Honorarium werd verwijderd!",
      "description": "Beschrijving",
      "editIncentive": "Bewerk honorarium",
      "feeTypes": {
        "fees": "Vergoeding",
        "fixedFee": "Vast",
        "monthsFee": "Maanden",
        "percentageFee": "Procent"
      },
      "payout": "Uitbetaling",
      "payoutLinked": "In lijn met huurbetalingen",
      "payoutTypes": {
        "payoutPeriod": "Vooruitbetaling",
        "payoutRecurrence": "Periodiek"
      },
      "rentPeriod": "Huurperiode",
      "title": "Titel",
      "type": "Type"
    },
    "IntegrationStatus": {
      "officernd": "OfficeR&D",
      "syncedAt": "Laatst gesynchroniseerd met <strong>%{integration}</strong> op <strong>%{date}</strong>",
      "syncedFrom": "Gesynchroniseerd met <strong>%{integration}</strong>"
    },
    "Intro": {
      "addButton": "<h3>Opportuniteit, pand of partner toevoegen</h3>\nU kunt een nieuwe opportuniteit, pand of partner toevoegen door hier te klikken.",
      "addButtonBroker": "<h3>Opportuniteit of contractvoorstel</h3>\nU kunt een nieuwe opportuniteit of contractvoorstel toevoegen door hier te klikken.",
      "assetActions": "<h3>Acties</h3>\nMet deze acties kunt in- of uitschrijven op emails over een pand en de flyer bekijken",
      "assetExport": "<h3>Export</h3>\nKlik hier om de lijst van panden en ruimtes, eventueel na toepassen van filter, in het huidige portfolio als CSV of PDF te exporteren.",
      "assetFilter": "<h3>Zoeken</h3>\nHier kunt u in het huidige portfolio zoeken naar ruimtes en panden die aan uw criteria voldoen.",
      "assetInfo": "<h3>Pand informatie</h3>\nDoor te klikken op één van de icoontjes, kunt u meer informatie krijgen over de deelinstellingen, commissies en kosten van het gebouw.",
      "assetList": "<h3>Panden</h3>\nHier krijgt u een overzicht van alle panden in dit portfolio. ",
      "associateAsset": "<h3>Pand koppelen</h3>\nNadat u een pand aan deze opportuniteit heeft gekoppeld, kunt u ernaar filteren op de navigator. U kunt nu ook ruimtes aan deze opportuniteit koppelen en / of voorstellen maken voor ruimtes van dit pand.",
      "channelDetails": "<h3> Specificeer bronnen </ h3>\nBewaar informatie over de oorsprong van deze opportuniteit.",
      "dealDetail": "<h3>Opportuniteit detailpagina</h3>\nOpen een opportuniteit in de lijst om verdere details te raadplegen, huurdergegevens toe te voegen, een update te delen, etc.",
      "dealDetails": "<h3>Specificeer vereisten</h3>\nVerduidelijk waarnaar de huurder zoekt.",
      "dealExport": "<h3>Export</h3>\nKlik hier om uw opportuniteiten in het huidige portfolio als CSV of PDF te exporteren.",
      "dealToggleView": "<h3>Weergave</h3>\nKlik hier om te wisselen tussen een tabelweergave of een kolomweergave met drag-and-drop of selecteer aangepaste tabelkolommen.",
      "deals": "<h3>Deals</h3>Browse hier om de opportuniteiten voor deze portefeuille te raadplegen",
      "dealsList": "<h3>Opportuniteiten</h3>\nHier krijgt u een overzicht van al uw actieve opportuniteiten in dit portfolio. In de filter kunt u schakelen tussen verschillende statussen.",
      "done": "Klaar",
      "expandAsset": "<h3>Ruimtes tonen</h3>\nKlik hier om de ruimtes van dit pand te bekijken.",
      "intercom": "<h3>Help</h3>\nU heeft het einde van de rondleiding bereikt. Als u vragen hebt tijdens het gebruik van ons platform, aarzel dan niet om ons een vraag te stellen door op deze knop te klikken. We nemen zo snel mogelijk contact met u op.",
      "next": "Begrepen",
      "previous": "Vorige",
      "settings": "<h3>Instellingen</h3>\nHier kan u al uw instellingen (taalvoorkeuren, instellingen voor notificaties, teambeheer enz.) terugvinden, alsook uitloggen.",
      "skip": "Overslaan",
      "subscribeAsset": "<h3>Inschrijven voor updates</h3>\nKlik hier om u te in te schrijven voor wekelijkse updates (per mail) van dit pand.",
      "switchPortfolio": "<h3>Veranderen van portfolio</h3>\nHier kan u wisselen tussen alle portfolio's waar u toegang tot heeft alsook zoeken op alle portfolio's in 1 lijst.",
      "tenantDetails": "<h3> Gegevens huurder bewaren </ h3>\nBewaar bedrijfsinformatie van uw huurder.",
      "welcome": "<h3>Welkom bij Rialto!</h3>\nDeze rondleiding begeleidt u door de belangrijkste functies van ons platform. Dit duurt max. drie minuten en geeft je een snelle introductie.\nJe kunt de rondleiding op elk moment stoppen door op de knop 'Overslaan' te klikken."
    },
    "LinkedinOauthCallback": {
      "errorBody": "Meld u in plaats daarvan aan met e-mail en wachtwoord",
      "errorTitle": "LinkedIn gebruiker onbekend"
    },
    "LoginForm": {
      "emailPlaceholder": "Geef e-mailadres",
      "forgotPassword": "Vergeten?",
      "linkedin_signin": "Inloggen met LinkedIn",
      "loggingIn": "Inloggen..",
      "login": "Inloggen",
      "passwordPlaceholder": "Geef wachtwoord in",
      "register": "Heb je geen account?"
    },
    "Modal": {
      "comment": {
        "collapse": "<strong>Verberg opmerking</strong> bij aanmaak",
        "expand": "<strong>Voeg opmerking toe</strong> bij aanmaak",
        "placeholder": "Voer opmerking in",
        "title": "Opmerking"
      }
    },
    "Navbar": {
      "back": "Vorige",
      "dashboard": {
        "deal": "Deal dashboard",
        "marketing": "Marketing dashboard"
      },
      "help": "Hulp vragen",
      "settings": "Instellingen",
      "sign_out": "Log uit"
    },
    "Ner": {
      "area": "Oppervlakte en capaciteit",
      "costs": "Som van de kosten",
      "free_rent_period": "Huurvrije periode (in maanden)",
      "header": "Netto effectieve huur",
      "price": "Prijzen (per maand)",
      "term": "Termijn of hernieuwingstermijn (in maanden)",
      "title": "De <strong>netto effectieve huur</strong> wordt als volgt berekend:"
    },
    "Notes": {
      "alert": {
        "no_content": "Please add %{contentType} before saving!"
      },
      "call": {
        "alert_empty": "No empty calls",
        "btnLabel": "Selecteer datum",
        "placeholder": "Voer uw commentaar hier in",
        "title": "Kies datum voor gesprek"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "delete": "Weet u zeker dat u wilt verwijderen?"
      },
      "email": {
        "alert_empty": "No empty emails",
        "btnLabel": "Selecteer datum",
        "code": "Voeg een email toe door FWD of BCC naar",
        "codeMobile": "FWD of BCC naar",
        "copied": "URL gekopieerd!",
        "copy": "\nKopieer naar klembord",
        "created_by": "Aangemaakt door",
        "date_received": "Datum ontvangen",
        "date_sent": "Datum verzonden",
        "from": "van",
        "paste": "Kopieer en plak de e-mail inhoud hier",
        "placeholder": "Voer uw commentaar hier in",
        "received": "Ontvangen",
        "received_from": "Ontvangen van",
        "sent": "Verzonden",
        "sent_to": "Verzonden naar",
        "title": "Kies datum voor email",
        "to": "naar"
      },
      "file": {
        "comment": "Notitie",
        "comment_placeholder": "Voer notitie in (optioneel)",
        "download": "Downloaden",
        "title": "Titel",
        "title_placeholder": "Voer titel in"
      },
      "no_contacts": "Geen contacten",
      "note": {
        "indicator": "Privé"
      },
      "placeholder": "Voer uw notities hier in",
      "private": "Alleen ik",
      "proposal": {
        "dueDate": "Vervaldatum",
        "offered_by": "Verstuurd door",
        "offering": "Verstuurd",
        "received_by": "Ontvangen door",
        "receiving": "Ontvangen"
      },
      "public": "Publiek",
      "unknownUser": "Onbekend",
      "update": {
        "placeholder": "Voer uw bericht hier in"
      },
      "upload": "Upload bestand",
      "viewing": {
        "add": "Toevoegen aan agenda",
        "btnLabel": "Selecteer datum",
        "placeholder": "Voer uw bezoeksnotities hier in",
        "scheduled_for": "Bezoek gepland voor",
        "title": "Kies bezoeksdatum"
      }
    },
    "Notification": {
      "deal": {
        "create": {
          "body": "%{values}",
          "title": {
            "one": "Nieuwe opportuniteit toegevoegd!",
            "other": "Nieuwe opportuniteiten toegevoegd!"
          }
        },
        "invite": {
          "body": "Ze hebben nu toegang tot opportuniteit %{values}.",
          "title": {
            "one": "Partijen uitgenodigd!",
            "other": ""
          }
        }
      },
      "flyer": {
        "create": {
          "body": "Flyer voor %{values} geüpdatet!",
          "title": {
            "one": "Flyer geüpdatet!",
            "other": ""
          }
        },
        "error": {
          "body": "Probeer opnieuw of contacteer support@rial.to",
          "title": {
            "one": "Flyer kon niet gegenereerd worden!",
            "other": ""
          }
        }
      },
      "user": {
        "invitation_accepted": {
          "body": "%{values} heeft uw uitnodiging geaccepteerd en is nu actief op Rialto!",
          "title": {
            "one": "Uitnodiging geaccepteerd!",
            "other": ""
          }
        }
      }
    },
    "Pagination": {
      "next": "volgende",
      "previous": "vorige"
    },
    "PortfolioActions": {
      "addAsset": "Pand",
      "addAssetLead": "Acquisitie",
      "addBroker": "Partner",
      "addDeal": "Opportuniteit",
      "addProposal": "Voorstel",
      "addSpace": "Ruimte",
      "btnLabel": "Toevoegen"
    },
    "PortfolioBlock": {
      "edit": "Portfolio bijwerken",
      "requestAccess": "Toegang vragen",
      "requestPending": "In aanvraag.."
    },
    "PortfolioDeleteModal": {
      "confirmDelete": "Weet je zeker dat je %{portfolio} wilt verwijderen? Alle bijbehorende panden en opportuniteiten worden verwijderd.",
      "confirmTransfer": "Weet je zeker dat je %{portfolio} wilt verwijderen? Alle bijbehorende panden en opportuniteiten worden overgezet naar %{transferPortfolio}.",
      "header": "Portfolio verwijderen",
      "noPortfolios": "Geen portfolio's om naar over te zetten",
      "transfer": "Overzetten naar",
      "warning": "Wanneer u een portfolio verwijdert, kunt u ervoor kiezen om uw panden, opportuniteiten en notificaties over te zetten naar een ander portfolio. </br> </br> Wanneer u dit niet doet, worden <strong>alle gegevens</strong> die aan dit portfolio gekoppeld zijn, <strong>permanent</strong> verwijderd."
    },
    "PortfolioFilter": {
      "portfolios": "Portfolios",
      "selected": "geselecteerd"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "",
        "deal": ""
      },
      "export": {
        "assets": {
          "csv": "Een CSV export van dit portfolio.",
          "pdf": "Een PDF export dit portfolio.",
          "title": "Portfolio"
        },
        "btnLabel": "Exporteren",
        "deals": {
          "csv": "Een CSV versie van de opportuniteitenlijst die bewerken kan worden.",
          "pdf": "Een PDF van de opportuniteitenlijst met alle activiteit per pand.",
          "title": "Opportuniteitenlijst"
        }
      },
      "tabs": {
        "asset_leads": "Acquisitie",
        "assets": "Panden",
        "dashboard": "Dashboard",
        "deals": "Opportuniteiten"
      }
    },
    "PortfolioInfo": {
      "companiesSelected": "%{value} bedrijven geselecteerd",
      "portfoliosSelected": "%{value} portfolios geselecteerd"
    },
    "PortfolioModal": {
      "delete": "Portfolio verwijderen",
      "nameLabel": "Naam",
      "statsUnitLabel": "Eenheid statistieken ",
      "titleAdd": "Portfolio toevoegen",
      "titleEdit": "Portfolio bewerken",
      "typeLabel": "Type"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisitie",
      "assets": "panden",
      "available": "beschikbaar",
      "availableSpace": "Nu Beschikbaar",
      "deals": "Opportuniteiten",
      "onMarket": "on-market",
      "rentableArea": "Totaal"
    },
    "Proposal": {
      "accepted": "Contractvoorstel",
      "addPrice": "Prijs toevoegen",
      "addSpace": "+ voeg een ruimte toe",
      "asset": "",
      "billingPeriod": "Factureringsperiode",
      "breakDates": "Huuropzegtermijn",
      "breakTerm": "Huuropzegmogelijkheid na",
      "channelFee": "Makelaar",
      "commencementDate": "Startdatum",
      "contractLength": "Details Looptijd Contract",
      "costs": "Kosten",
      "deposit": "Huurgarantie",
      "dueDate": "Geldig tot",
      "expirationDate": "Vervaldag",
      "firstRefusalRight": "Pas \"right of first refusal\" toe",
      "legalFee": "Juridische kosten",
      "movingAllowance": "Vergoeding verhuiskosten",
      "negativeDiscount": "(%{percentage}% boven de prijs)",
      "ner": "Netto huur",
      "offeredBy": "Verstuurd door",
      "offering": "Verstuurd",
      "otherCosts": "Andere kost",
      "placeholder": "Voer uw notities hier in",
      "positiveDiscount": "(%{percentage}% korting)",
      "receivedBy": "Ontvangen door",
      "receiving": "Ontvangen",
      "renewalPeriod": "Verlengingsperiode",
      "rentFreePeriod": "Huurvrije periode",
      "term": "Termijn",
      "terms": "Financiële voorwaarden",
      "tiAllowance": "Budget verbeteringswerken",
      "token": "Kopieer de onderstaande URL om het voorstel met uw klant te delen"
    },
    "ProposalAcceptModal": {
      "accept": "Opvragen",
      "accepting": "Opvragen..",
      "commentPlaceholder": "Voer hier eventuele opmerkingen in",
      "header": "Vraag ontwerpovereenkomst aan"
    },
    "ProposalForm": {
      "deal": "Opportuniteit",
      "dealLabel": "Zoek naar bestaande of maak een nieuwe aan op naam"
    },
    "ProposalModal": {
      "title": "Voorstel toevoegen"
    },
    "ProposalPage": {
      "accept": "Ontwerpovereenkomst",
      "accepted": {
        "message": "Bedankt! %{name} wordt op de hoogte gebracht en neemt spoedig terug contact met u op.",
        "title": "Ontwerpovereenkomst opgevraagd!"
      },
      "proposalFor": "Voorstel voor",
      "proposalOn": "Voorstel op %{date}"
    },
    "RegionFilter": {
      "apply": "Toepassen",
      "region": "Regio",
      "tabs": {
        "region": "Per Regio"
      }
    },
    "ResetPassword": {
      "confirm_label": "Wachtwoord bevestiging",
      "confirm_placeholder": "Geef wachtwoord bevestiging",
      "current_label": "Huidig wachtwoord",
      "current_placeholder": "Geef huidig wachtwoord",
      "description": "Voer alle velden in om uw wachtwoord te veranderen.",
      "new_label": "Nieuw wachtwoord",
      "new_placeholder": "Geef nieuw wachtwoord",
      "title": "Wachtwoord opnieuw instellen"
    },
    "SearchBlock": {
      "landlordsTitle": "Alle portfolios",
      "searchPortfolios": "Zoek portfolios",
      "selectAll": "Selecteer alle",
      "title": "Zoek op alle panden",
      "unselectAll": "Deselecteer alle"
    },
    "SeeMore": {
      "seeMore": "Bekijk meer"
    },
    "SelectAll": {
      "clear": "Wissen",
      "selectAll": "Selecteer alle"
    },
    "Settings": {
      "Subscriptions": {
        "assetDigest": {
          "description": "Selecteer de gebouwen waarvan je per email een activiteitenrapport wenst te ontvangen. Deselecteer alles om je volledig uit te schrijven.",
          "title": "Email over gewijzigde beschikbaarheden"
        },
        "dealDigest": {
          "description": "Selecteer de portfolios waarvan je per email een overzicht van activiteit op opportuniteiten wenst te ontvangen. Deselecteer alles om je volledig uit te schrijven.",
          "title": "Overzicht per mail van activiteit op opportuniteiten"
        },
        "portfolio_deal": {
          "description": "U kan uw voorkeur selecteren voor standaard inschrijving op NIEUWE opportuniteiten. Selecteer de portefeuilles waarvoor u automatisch ingeschreven wil worden op de opportuniteiten:",
          "title": "Nieuwe opportuniteiten"
        },
        "unsubscribeDeals": {
          "body": "Uitschrijven van real-time updates op opportuniteiten?",
          "unsubscribe": "Verwijder alle bestaande email subscriptions voor uit te schrijven portefeuilles"
        }
      },
      "company": {
        "billing": {
          "billingInfo": "We hebben geen factuurgegevens gevonden die aan uw account zijn gekoppeld. Het kan zijn dat u ofwel geen betaald plan hebt, of dat we een fout hebben gemaakt.",
          "contact": "Neem contact met ons op om aan de slag te gaan",
          "manage": "Wijzig instellingen",
          "subscriptions": "U bent momenteel geabonneerd op:",
          "title": "Factureringsinformatie en instellingen",
          "total": "Het volgende factuurbedrag is %{total} (incl. btw indien toepasselijk) en wordt gefactureerd %{date}",
          "trial": "Uw account zit momenteel in de proefperiode (<strong>%{value} dagen resterend</strong>).",
          "vatExclusive": "%{value}, zonder BTW"
        },
        "branding": {
          "HeaderImageInfo": {
            "body": "The image you upload here will be shown in your company's <strong>weekly asset digest</strong> and the <strong>profile page</strong> of your company. For best results, we recommend uploading a high-resolution file. ",
            "header": "Header afbeelding"
          },
          "accentColor": "Accent kleur",
          "comapnyPageBlocks": {
            "contacts": "Show contacts",
            "dealForm": "Introduce client",
            "incentives": "Show auto-assigned incentives",
            "portfolios": "Show portfolios"
          },
          "companyPage": "Bedrijfsprofiel",
          "general": "Algemeen",
          "headerImage": "Header afbeelding",
          "headerImageOverlay": "Voeg een overlay toe over foto",
          "primaryColor": "Primair kleur",
          "slug": "Bedrijfspagina ID"
        },
        "details": {
          "address": "Adres",
          "city": "Stad",
          "country": "Land",
          "description": "Beschrijving",
          "email": "E-mail",
          "industry": "Industrie",
          "mobile": "Mobiel nummer",
          "name": "Naam",
          "phone": "Telefoon nummer",
          "tagline": "Slogan",
          "website": "Website",
          "zip": "Postcode"
        },
        "integrations": {
          "search": "Zoek in integraties..."
        },
        "settings": {
          "CompanyPageInfo": {
            "header": "Bedrijfspagina",
            "infoBody": "Een publiek profiel voor uw bedrijf die als <strong>landingspagina</strong> kan gebruikt worden tussen uzelf en uw partners. Als basis worden de contactgegevens en een overzicht van de portefeuilles getoond, waarna de partner via de pagina ook in kan loggen of toegang kan vragen of het op afgeschermde gedeelte van Rialto. Verder kan u ook de commissies en eventueel een FAQ sectie toevoegen.",
            "infoTitle": "Wat is de bedrijfspagina?",
            "linkBody": "U kan vanuit uw eigen websites altijd linken naar uw bedrijfspagina op ons platform. De pagina kan u vinden op <strong>onderstaande URL</strong>. \n<br /> <br />\nAls u wil kan u ook uw eigen domein gebruiken om de bedrijfspagina te tonen. Dit kan door een <strong>CNAME</strong> in te stellen bij uw domeinnaam provider met de onderstaande URL.",
            "linkTitle": "Aangepast domein",
            "linkToken": "Klik hier om de URL van uw aangepaste bedrijfspagina te kopiëren"
          },
          "accent": "Accent kleur",
          "branding": "Branding",
          "currency": "Valuta",
          "interface": "Interface",
          "language": "Taal",
          "primary": "Primair kleur",
          "regional": "Regionaal",
          "sizeUnit": "Oppervlakte eenheid",
          "slug": "Bedrijfspagina ID",
          "statsUnit": "Eenheid statistieken",
          "type": "Type"
        }
      },
      "delete": "Verwijderen",
      "deleting": "Verwijderen..",
      "incentives": {
        "add": "Voeg honorarium toe",
        "new": "Voeg nieuw toe",
        "none": "U hebt nog geen <strong>honoraria</strong>.",
        "search": "Zoek honorarium"
      },
      "menu": {
        "billing": "Facturatie",
        "branding": "Branding\n",
        "company": "Bedrijf",
        "details": "Bedrijfsgegevens",
        "incentives": "Honoraria",
        "integrations": "Integraties",
        "notifications": "Notificaties",
        "personal_details": "Persoonlijke gegevens",
        "profile": "Mijn profiel",
        "requests": "Verzoeken",
        "settings": "Instellingen",
        "team": "Team",
        "templates": "Sjablonen",
        "tos": "Servicevoorwaarden",
        "users": "Teamleden"
      },
      "profile": {
        "email_label": "Email",
        "fname_label": "Voornaam",
        "license_label": "BIV nummer",
        "lname_label": "Achternaam",
        "mobile_label": "Mobiel nummer",
        "phone_label": "Telefoonnummer",
        "title_label": "Titel"
      },
      "save": "Opslaan",
      "saving": "Opslaan..",
      "settings": {
        "change_password": "Wijzig wachtwoord",
        "confirm_label": "Bevestig nieuw wachtwoord",
        "current_label": "Huidig wachtwoord",
        "delete": {
          "confirmDelete": "Weet je zeker dat je je account wilt verwijderen? Dit is PERMANENT en kan niet ongedaan worden gemaakt. U verliest toegang tot Rialto.",
          "title": "Account verwijderen",
          "warning": "Als u uw account verwijdert, worden al uw gegevens <strong>permanent</strong> verwijderd en is dit onomkeerbaar. U bent verantwoordelijk voor het overdragen van panden en opportuniteiten waar u een contactpersoon bent. <br/> Na het verwijderen van uw account heeft u geen toegang meer tot Rialto en ontvangt u geen update e-mails meer van het platform.",
          "warning_account_holder": "U bent een <strong>beheerder</strong> voor uw huidige bedrijf. Voordat u uw account verwijdert, moet u eerst uw rol in teaminstellingen overdragen."
        },
        "language_label": "Taal",
        "locale": "Taalinstellingen",
        "new_label": "Nieuw wachtwoord",
        "password_empty_hint": "Laat de wachtwoord velden leeg indien u niet wenst uw wachtwoord te wijzigen.",
        "timezone_label": "Tijdzone"
      },
      "team": {
        "add": "Voeg gebruiker toe",
        "confirm": {
          "removeUser": "Weet u zeker dat u deze gebruiker wilt verwijderen? Als de gebruiker contactpersoon was op panden of opportuniteiten, stel dan manueel iemand anders van je team in of contacteer Rialto om alle records aan te passen."
        },
        "edit": "Bewerk gebruiker",
        "remove": "Verwijder gebruiker",
        "requests": {
          "accept": "Accepteren",
          "active": "Actief",
          "empty": "Geen toegangsverzoeken",
          "reject": "Weigeren",
          "rejected": "Geweigerd"
        },
        "resend": "Verstuur uitnodiging opnieuw",
        "roles": {
          "account_holder": "Heeft volledige marketing-, verkoops- en administratierechten",
          "administrator": "Heeft volledige marketing- en verkoopsrechten",
          "internal_user": "Heeft volledige verkoopsrechten"
        },
        "search": "Zoek in gebruikers..."
      },
      "tos": {
        "add": "Voeg servicevoorwaarden toe",
        "edit": "Bewerken",
        "new": "Voeg nieuw toe",
        "none": "U hebt nog geen <strong>servicevoorwaarden</strong>.",
        "remove": "Verwijderen",
        "search": "Zoek servicevoorwaarden"
      }
    },
    "ShareStatusSelector": {
      "header": "Wie moet toegang krijgen?",
      "status": {
        "all": "Alle partners",
        "broker_owner_team": "Ik & mijn client",
        "broker_team_owner_team": "Mijn team & mijn client",
        "custom": "Aangepast",
        "owner_team": "Mijn team"
      }
    },
    "SignUp": {
      "brokerCompany": "Makelaarsbedrijf",
      "cancel": {
        "error": {
          "body": "U heeft uw account al geactiveerd",
          "title": "Uw e-mail kon niet bevestigd worden!"
        },
        "success": {
          "body": "U zal geen herinneringsmails meer ontvangen",
          "title": "Inschrijving geannuleerd!"
        }
      },
      "cancelBtn": "Annuleren",
      "company": {
        "createNew": "Kon je team niet vinden? <a href=\"%{link}\">Klik hier</a> om een eigen team aan te maken.",
        "details": "Vul hieronder de gegevens in om uw bedrijf op Rialto te registreren:",
        "name": "Bedrijfsnaam",
        "requestAccess": "Toegang vragen",
        "requestPending": "In aanvraag",
        "role": "Mijn bedrijf kan het best als volgt worden beschreven:",
        "roles": {
          "broker": "Ik ben een vastgoedmakelaar / online makelaar",
          "ownerFlex": "Ik ben een flex workspace / co-working operator",
          "ownerLeasing": "Ik ben een vastgoedeigenaar en / of heb een eigen leasing team"
        },
        "welcome": "Welkom bij Rialto, %{name}!\n<br />\n<br />\nDe volgende teams komen overeen met uw e-maildomein. Krijg toegang tot de jouwe."
      },
      "existingAccount": "Heb je al een account?",
      "getStarted": "Inschrijven",
      "linkedin_signup": "Registreer met LinkedIn",
      "submitted": "Welkom %{fname}!\n<br />\n<br />\nU ontvangt binnenkort een e-mail om uw e-mailadres te bevestigen. Hierna kan u ervoor kiezen <strong>een bestaand team te vervoegen</strong> of <strong> een nieuw team te maken</strong>.\n<br />\n<br />\n👉🏻 Geen e-mail ontvangen? Controleer zeker uw <strong>spam folder</strong>.\n<br />",
      "submittedCampaign": "Welkom %{fname}!\n<br />\n<br />\nU ontvangt binnenkort een e-mail om uw e-mailadres te bevestigen. Hierna kan u <strong>Rialto beginnen te gebruiken</strong>.",
      "tagline": "Welke processen ondersteunen de groei van de bezettingsgraad? <br />\nJij hebt erover nagedacht. Wij hebben het voor je gebouwd.",
      "title": "Schrijf je gratis in"
    },
    "Size": {
      "amount": "plaats",
      "amounts": "plaatsen",
      "m2": "m²",
      "square_foot": "ft²"
    },
    "SpaceCategory": {
      "residential": ""
    },
    "SpaceModal": {
      "title": "Nieuwe ruimte toevoegen"
    },
    "SpaceStatusDialog": {
      "body": "Bent u zeker dat u deze ruimte off-market wilt plaatsen? Makelaars zullen deze ruimte niet meer zien. Ze zal niet langer zichtbaar zijn op de panden navigator of de flyers.",
      "confirm": "Plaats off-market",
      "notify": "Makelaars informeren dat de ruimte verhuurd is"
    },
    "SpacesTable": {
      "actions": {
        "delete": "Verwijderen",
        "duplicate": "Dupliceren",
        "edit": "Wijzigen",
        "setNotUnderOffer": "Niet langer in Optie",
        "setPrivate": "Plaats off-market",
        "setPublic": "Plaats on-market",
        "setUnderOffer": "Plaats in Optie"
      },
      "addPrice": "toevoegen",
      "assetDetailNoSpaces": "Geen ruimtes voor dit product, klik op <strong>Toevoegen</strong> rechts.",
      "availability": {
        "mobile": {
          "now": "Beschikbaar",
          "tbd": "TBD"
        },
        "now": "Beschikbaar",
        "tbd": "TBD"
      },
      "deals_associated": "%{smart_count} opportuniteit verwijst naar deze ruimte |||| %{smart_count} opportuniteiten verwijzen naar deze ruimte",
      "firstRefusalRight": "Right of first refusal",
      "form": {
        "titleAdd": "Ruimte toevoegen",
        "titleEdit": "Ruimte wijzigen"
      },
      "headers": {
        "availableFrom": "Beschikbaarheid",
        "category": "Type",
        "description": "Beschrijving",
        "edit": " ",
        "floor": "Vloer",
        "image": "",
        "inventory": "Aantal in Inventaris",
        "leaseholder": "Huurder",
        "leaseholders": "Huurder",
        "minContractLength": "Contractduur",
        "name": "Ruimte",
        "period": "Periode",
        "price": "Prijs",
        "size": "Grootte",
        "sizeUnit": "Eenheid",
        "status": "Status",
        "syncInfo": "",
        "unit": "Naam Ruimte"
      },
      "inventory": "Inventaris",
      "lxd": "LXD",
      "noSpaces": "Geen ruimtes beschikbaar voor dit pand.",
      "periods": {
        "daily": {
          "one": "dag",
          "other": "dagen"
        },
        "hourly": {
          "one": "uur",
          "other": "uur"
        },
        "monthly": {
          "one": "maand",
          "other": "maanden"
        },
        "weekly": {
          "one": "week",
          "other": "weken"
        },
        "yearly": {
          "one": "jaar",
          "other": "jaar"
        }
      },
      "price": {
        "all_in": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
        "rate": "Belasting:",
        "rent": "Huur:",
        "service": "Gem. Kost.:",
        "undisclosed": "Op aanvraag"
      },
      "pricing": "Prijs",
      "private": "<strong>off</strong> market",
      "public": "<strong>on</strong> market",
      "removeSpace": "Wilt u deze ruimte permanent verwijderen? De ruimte zal verwijderd worden van opportuniteiten en voorstellen. De makelaars worden niet verwittigd.",
      "renewalPeriod": "Vernieuwing elke",
      "undefined": "Niet gekend",
      "under_offer": "In optie"
    },
    "StageProgress": {
      "selectStage": "Selecteer fase"
    },
    "Statistics": {
      "assetLeads": "Acquisitie |||| Acquisities",
      "totalSize": "totale vraag"
    },
    "StatusButton": {
      "disregard": "Verloren",
      "execute": "Gewonnen"
    },
    "SubmitButton": {
      "submit": "Plaatsen",
      "submitted": "Submitted!",
      "submitting": "Plaatsen.."
    },
    "SubscribeButton": {
      "subscribe": "Inschrijven",
      "subscribed": "Ingeschreven"
    },
    "TabbedFilter": {
      "apply": "Toepassen",
      "channel": "Oorsprong",
      "region": "Regio",
      "regionCategories": {
        "regions": "Per Regio"
      },
      "selected": "%{nb} geselecteerd"
    },
    "Table": {
      "headers": {
        "activity": "Activiteit",
        "asset": "Pand",
        "assetSpaces": "Pand",
        "asset_spaces": "Pand",
        "assets": "Panden",
        "budget": "Budget",
        "category": "Type",
        "channel": "Oorsprong",
        "closeDate": "Close Date",
        "comment": "Toelichting",
        "contact": "Contact",
        "currentSituation": "Huidige situatie",
        "date": "Datum",
        "description": "Extra informatie",
        "disregardComment": "Reden v. afvallen",
        "endDate": "Einddatum",
        "features": "Kenmerken",
        "feePotential": "Waarde opp.",
        "fee_potential": "Waarde opp.",
        "followUpDate": "Vervolgstap",
        "includeInReport": "In rapport",
        "location": "Locatie",
        "name": "Naam",
        "nonProspectComment": "Toelichting / Vervolgstappen",
        "pointPerson": "Contactpersoon",
        "point_person": "Contactpersoon",
        "portfolio": "Portfolio",
        "potential": "Kans",
        "probability": "Kans",
        "prospectComment": "Opmerkingen",
        "shareStatus": "",
        "share_status": "",
        "size": "Grootte",
        "spaceCategories": "Categorie",
        "space_categories": "Categorie",
        "stage": "Fase",
        "startDate": "Startdatum",
        "start_date": "Startdatum",
        "tenant": "Huurder",
        "term": "Termijn",
        "type": "Type",
        "viewed": "Bezichtigd",
        "warning": " "
      },
      "noAsssetLeads": "Geen asset leads gevonden",
      "noDeals": "Geen opportuniteiten gevonden"
    },
    "TenantProfile": {
      "address": {
        "title": "Huidig adres"
      },
      "company": {
        "title": "Bedrijf"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "delete": "Weet u zeker dat u wilt verwijderen?"
      },
      "contacts": {
        "title": "Contacten"
      },
      "email": {
        "title": "E-mail"
      },
      "head_count": {
        "title": "Headcount"
      },
      "industry": {
        "title": "Industrie"
      },
      "leaseExpiration": {
        "title": "Vervaldatum"
      },
      "locale": "Taal",
      "mobile": {
        "title": "GSM"
      },
      "name": {
        "title": "Voor- en achternaam"
      },
      "phone": {
        "title": "Telefoon"
      },
      "position": {
        "title": "Positie"
      },
      "rentable_area": {
        "title": "Oppervlakte"
      },
      "title": "Huurdersprofiel"
    },
    "TenantRepresentative": {
      "actions": {
        "edit": "Wijzig",
        "unlink": "Ontkoppel"
      },
      "company": {
        "title": "Bedrijf"
      },
      "email": {
        "title": "E-mail"
      },
      "job_title": {
        "title": "Titel"
      },
      "name": {
        "title": "Voor- en achternaam"
      },
      "phone": {
        "title": "Telefoon"
      },
      "title": "Tenant Rep."
    },
    "TermsOfServiceForm": {
      "addTos": "Voeg servicevoorwaarden toe",
      "body": "Inhoud",
      "default": "Stel in als default: toon op jullie bedrijfsprofiel en wijs automatisch toe op nieuwe panden",
      "defaultTosWarning": "Je kan slechts één servicevoorwaarde als standaard hebben. Als je verdergaat worden eventuele standaard servicevoorwaarden vervangen. Ben je zeker?",
      "file": "Bestand",
      "title": "Titel"
    },
    "Timestamp": {
      "original": "Feitelijke datum"
    },
    "TitledDate": {
      "title": "%{title} selecteren"
    },
    "TourButton": {
      "book": "Book a tour"
    },
    "UserConfirmModal": {
      "agreement": {
        "agree": "Akkoord",
        "description": "Hallo %{user}, u zal toegang krijgen tot Rialto nadat u uw account details heeft bevestigd.",
        "terms_description": "Door het invullen van dit bevestigingsformulier, bevestigt u dat u onze <a href=\"http://www.getrialto.com/terms\" target=\"_blank\">Terms of Service</a> en <a href=\"https://www.getrialto.com/privacy\" target=\"_blank\">Privacy Policy</a> heeft gelezen en geaccepteerd.",
        "title": "Bevestiging nodig"
      },
      "confirm": "Bevestigen",
      "confirming": "Bevestigen..",
      "details": {
        "description": "Controleer alstublieft uw details en bevestig uw account.",
        "title": "Profiel details"
      }
    },
    "UserDetails": {
      "inactive": "inactief"
    },
    "UserEdit": {
      "first_name": "Voornaam"
    },
    "ViewToggle": {
      "display": "Weergave"
    },
    "deal": {
      "space_categories": "Categorie"
    },
    "forms": {
      "picturePlaceholder": "Een foto uploaden"
    },
    "notifications": {
      "asset": {
        "delete": {
          "success": {
            "title": "Pand verwijderd!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "U ontvangt zometeen een email",
            "title": "Uw portfolio wordt geëxporteerd"
          }
        },
        "requestFlyer": {
          "success": {
            "message": "Je kunt feedback van de asset manager verwachten per email.",
            "title": "Aanvraag met succes verzonden!"
          }
        }
      },
      "deal": {
        "delete": {
          "error": {
            "message": "Gelieve later opnieuw te proberen",
            "title": "Opportuniteit kon niet verwijderd worden!"
          },
          "success": {
            "title": "Opportuniteit verwijderd!"
          }
        },
        "duplicate": {
          "success": {
            "title": "Opportuniteit succesvol gedupliceerd!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "U ontvangt zometeen een email",
            "title": "Opportuniteitenlijst wordt geëxporteerd"
          }
        },
        "renew": {
          "success": {
            "title": "Opportuniteit succesvol gedupliceerd!"
          }
        }
      },
      "defaultErrorTitle": "Er is een fout opgetreden!",
      "defaultInfoTitle": "Info",
      "notAuthenticated": {
        "message": "Gelieve opnieuw in te loggen",
        "title": "U bent niet geauthenticeerd"
      },
      "portfolio": {
        "delete": {
          "success": {
            "bodyDelete": "Alle bijhorende panden en opportuniteiten werden verwijderd.",
            "bodyTransfer": "Alle bijhorende panden en opportuniteiten werden overgezet.",
            "title": "Portfolio verwijderd!"
          }
        }
      },
      "subscriptions": {
        "update": {
          "success": {
            "body": "Uw wijzigingen worden onmiddellijk van kracht",
            "title": "Notificatie-instellingen opgeslagen!"
          }
        }
      },
      "user": {
        "brokerInvite": {
          "success": {
            "messageActive": "%{user} heeft nu toegang tot de geselecteerde panden.",
            "messageNew": "%{user} zal toegang hebben tot de geselecteerde panden na het accepteren van uw uitnodiging.",
            "title": "%{user} werd uitgenodigd!"
          }
        },
        "requestPasswordReset": {
          "success": {
            "message": "U zal snel een e-mail ontvangen met verdere instructies.",
            "title": "Nieuw wachtwoord aangevraagd!"
          }
        },
        "resetPassword": {
          "success": {
            "message": "Gebruik volgende keer dat je inlogt dit wachtwoord.",
            "title": "Wachtwoord gewijzigd!"
          }
        }
      }
    },
    "shared": {
      "add": "Toevoegen",
      "adding": "Toevoegen..",
      "address": "%{address} %{zip} %{city}",
      "amount": "Bedrag",
      "and": "en",
      "askInfo": "Vraag flyer",
      "asset": {
        "address": "Adres",
        "asset": "Pand",
        "city": "Stad",
        "name": "Naam",
        "region": "Regio",
        "state": "Staat",
        "statuses": {
          "fully_let": "Verhuurd",
          "invite": "Op uitnodiging",
          "other": "Andere",
          "private": "Privaat",
          "public": "Open mandaat",
          "sold": "Verkocht"
        },
        "zip": "Postcode"
      },
      "assetCategories": {
        "hotel": "Hotel",
        "industrial": "Semi-Industrieel",
        "land": "Grond",
        "multi_family": "Residentieel multi-family",
        "office": "Kantoorgebouw",
        "other_cat": "Andere",
        "residential": "Residentieel",
        "retail": "Retail",
        "warehouse": "Logistiek"
      },
      "assetLeadStages": {
        "closing": "Closing",
        "negotiating": "Negotiatie",
        "pitch": "Pitch",
        "prospect": "Prospect"
      },
      "assetLeads": "Acquisitie",
      "billingMethods": {
        "post": "betaling achteraf",
        "pre": "vooruitbetaling"
      },
      "budget": "Budget",
      "cancel": "Annuleren",
      "category": "Type",
      "channelCategories": {
        "email": "E-mail",
        "employee_referral": "Verwijzing medewerker",
        "leasing_agent": "Makelaar",
        "listing_site": "Listing site",
        "online_broker": "Online Makelaar",
        "other_cat": "Overige",
        "phone": "Via telefoon",
        "referral": "Doorverwijzing",
        "social_media": "Social Media",
        "tenant_rep": "Tenant Rep",
        "unknown": "Niet gekend",
        "walk_in": "Walk-in",
        "website": "Website"
      },
      "closeDate": "Close Date",
      "company": "Bedrijf",
      "companyTypes": {
        "acquisition": "Acquisitie",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "delete": "Weet je zeker dat je dit wilt verwijderen?"
      },
      "contactCategories": {
        "agent": "Makelaar",
        "asset_manager": "Asset Manager",
        "key_holder": "Sleutelhouder",
        "landlord": "Eigenaar",
        "other_cat": "Overige",
        "property_manager": "Property Manager",
        "tenant": "Huurder"
      },
      "copied": "Gekopieerd!",
      "copy": "Kopiëren",
      "copy_of": "Kopie van",
      "country": "Land",
      "deal": {
        "activity": "Activiteit",
        "asset": "Pand",
        "assets": "Panden",
        "budget": "Budget",
        "channel": "Oorsprong",
        "deal": "Opportuniteit",
        "fee_potential": "Waarde opportuniteit",
        "leaseBreakDates": "Huuropzegtermijnen",
        "leaseCommencementDate": "Startdatum lease",
        "leaseExpirationDate": "Vervaldatum lease",
        "location": "Locatie",
        "point_person": "Contactpersoon",
        "portfolio": "Portfolio",
        "probability": "Kans",
        "share_status": "Deel status",
        "size": "Grootte",
        "space_categories": "Categorie",
        "start_date": "Startdatum",
        "tenant": "Huurder",
        "term": "Termijn",
        "type": "Type"
      },
      "dealStages": {
        "delivery": "Oplevering",
        "execution": "Uitvoering",
        "finder": "Prospect",
        "inquiry": "Inventarisatie",
        "new": "Nieuw",
        "prospects": "Prospect",
        "signed_loi": "Overeenkomst",
        "touring": "Bezichtiging",
        "trading_proposal": "RFP/Voorstel"
      },
      "dealStatuses": {
        "active": "Actief",
        "all": "Alle",
        "dead": "Verloren",
        "executed": "Gewonnen"
      },
      "dealTypes": {
        "expansion": "Uitbreiding",
        "new": "Nieuw",
        "reduction": "Inkrimping",
        "renegotiation": "Heronderhandeling",
        "renewal": "Vernieuwing"
      },
      "deals": "Opportuniteiten",
      "default": "Standaard",
      "delete": "Verwijderen",
      "deletedUser": "Verwijderde Gebruiker",
      "deleting": "Verwijderen..",
      "disregard_outcomes": {
        "move": "Getekend voor concurrerend pand",
        "other_outcome": "Andere",
        "stay": "Huidig huurcontract verlengd",
        "unknown": "Onbekend"
      },
      "disregard_reasons": {
        "broker": "Informatieaanvraag makelaar",
        "duplicate_entry": "Dubbele invoer",
        "location": "Locatie",
        "other_reason": "Andere",
        "price": "Prijs",
        "quality": "Kwaliteit",
        "size": "Voorstelde ruimte(s) beantwoorden vraag niet",
        "tenant_unqualified": "Huurder niet geschikt",
        "timed_out": "Aanvraag verlopen",
        "unknown": "Onbekend"
      },
      "download": "Downloaden",
      "download_ics": "Toevoegen aan agenda",
      "edited": "Bewerkt",
      "email": "E-mail",
      "emptyText": {
        "assetDeal": "Selecteer eerst een pand voor deze opportuniteit",
        "channels": "Voeg eerst bron(nen) toe op de opportuniteiten pagina",
        "proposals": "Voeg eerst voorstel(len) toe op de opportuniteiten pagina",
        "spaces": "Voeg eerst ruimte(s) toe aan het pand",
        "spacesDeal": "Voeg eerst een pand toe aan deze opportuniteit en/of ruimte(s) aan het pand"
      },
      "endDate": "Einddatum",
      "errorTitle": "Er is een fout opgetreden!",
      "every": "Elke",
      "filter": "Filter",
      "flyer": "Flyer",
      "flyerContact": "Flyer contactpersoon",
      "footer": {
        "about": "Over Rialto",
        "blog": "Blog",
        "careers": "Jobs",
        "status": "Status",
        "terms": "Gebruiksvoorwaarden"
      },
      "formChangesPrompt": "U hebt data die nog niet opgeslaan is. Bent u zeker dat u naar een andere pagina wil gaan?",
      "free": "gratis",
      "from": "van",
      "fullName": "Voor- en achternaam",
      "in": "in",
      "industries": {
        "automobile": "Automobiel",
        "aviation": "Luchtvaart & toerisme",
        "banks": "Banken",
        "basic_resources": "Grondstoffen",
        "chemicals": "Chemie",
        "construction": "Bouw",
        "consumer_electronics": "Huishoudelectro",
        "culture": "Cultuur",
        "cw": {
          "automotive": "Automotive",
          "business_space": "Overige bedrijfsruimte",
          "cleanroom": "Cleanroom/Laboratorium",
          "datacenter": "Datacenter",
          "dc": "DC",
          "food": "Food",
          "high_tech": "High Tech/3D",
          "self_storage": "Self Storage",
          "sustainable_energy": "Sustainable/(Nieuwe) energie",
          "urban_logistics": "Urban Logistics/Cross Docks"
        },
        "education": "Onderwijs",
        "education_art": "Onderwijs & kunst",
        "entertainment": "Ontspanning",
        "financial_services": "Financiële diensten",
        "food": "FMCG - Voeding & drank",
        "healthcare": "Zorg & farmacie",
        "household_goods": "Persoonlijke- & huishoudartikelen",
        "industrial_goods": "Industriële goederen & diensten",
        "insurance": "Verzekeringen",
        "legal": "Juridisch",
        "luxury": "Mode, interieur & luxe",
        "media": "Media",
        "oil_gas": "Olie & gas",
        "other_cat": "Andere",
        "professional_services": "Professionele diensten",
        "public": "Publieke sector",
        "real_estate": "Vastgoed",
        "retail": "Retail",
        "sports_leisure": "Sport & vrije tijd",
        "technology": "Technologie",
        "telecommunications": "Telecom",
        "travel": "Toerisme & vrije tijd",
        "utilities": "Nutsvoorzieningen",
        "wellbeing": "Welzijn"
      },
      "industry": "Industrie",
      "integrationCategories": {
        "listing_site": "Vastgoedsite",
        "mail": "E-mail",
        "online_broker": "Online makelaar",
        "other_cat": "Andere",
        "property_management": "Vastgoedbeheer"
      },
      "language": "Taal",
      "languages": {
        "en": "English",
        "en-GB": "British English",
        "en-GB-acquisition": "British English",
        "en-GB-flex": "British English",
        "en-acquisition": "English",
        "en-flex": "English",
        "fr-FR": "Français",
        "fr-FR-acquisition": "Français",
        "fr-FR-flex": "Français",
        "nl-BE": "Nederlands (BE)",
        "nl-BE-acquisition": "Nederlands (BE)",
        "nl-BE-flex": "Nederlands (BE)",
        "nl-NL": "Nederlands (NL)",
        "nl-NL-acquisition": "Nederlands (NL)",
        "nl-NL-flex": "Nederlands (NL)"
      },
      "loading": "Laden..",
      "more": "meer",
      "name": "Naam",
      "ner": "Netto huur",
      "on": "op",
      "password": "Wachtwoord",
      "per": "per",
      "phone": "Telefoonnummer",
      "placeholder": "Voer hier uw tekst in",
      "placeholders": {
        "assets": "Selecteer één of meerdere panden",
        "portfolios": "Selecteer een portfolio"
      },
      "pointPerson": "Contactpersoon",
      "portfolio": "Portfolio",
      "portfolioTypes": {
        "acquisition": "Acquisitie",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "potentials": {
        "above_average": "Bovengemiddeld",
        "average": "Gemiddeld",
        "high": "Hoog",
        "low": "Laag",
        "moderate": "Matig"
      },
      "private": "Privaat",
      "probability": "Kans",
      "proposal": "Contractvoorstel",
      "rofr": "ROFR",
      "rofr_full": "Right of first refusal",
      "roles": {
        "account_holder": "Eigenaar |||| Eigenaars",
        "administrator": "Administrator |||| Administrators",
        "internal_user": "Interne gebruiker |||| Interne gebruikers"
      },
      "save": "Opslaan",
      "saved": "Opgeslaan!",
      "saving": "Opslaan..",
      "search": "Zoeken",
      "search_placeholder": "Zoek...",
      "send": "Verzenden",
      "sending": "Verzenden..",
      "shareStatuses": {
        "all": "Alle partners",
        "broker_owner_team": "Ik & mijn client",
        "broker_team_owner_team": "Mijn team & mijn client",
        "custom": "Aangepast",
        "owner_team": "Mijn team"
      },
      "size": {
        "separator": "tot",
        "title": "Grootte"
      },
      "space": "Ruimte",
      "spaceCategories": {
        "archive": "Archief",
        "carParking": "Buitenparking",
        "car_parking": "Buitenparking",
        "coveredCarParking": "Overdekte parking",
        "covered_car_parking": "Overdekte parking",
        "coworking": "Co-working",
        "industrial": "Bedrijfsruimte",
        "land": "Kavel",
        "leisure": "Vrije tijd",
        "logistical": "Logistieke ruimte",
        "meeting": "Meeting/Conferentie",
        "office": "Kantoor",
        "other": "Overig",
        "other_cat": "Overig",
        "outdoor_area": "Buitenterrein",
        "residential": "Residentieel",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Opslag"
      },
      "spaceStatuses": {
        "all": "Alle",
        "private": "Off market",
        "public": "On-market"
      },
      "spaces": "Ruimtes",
      "startDate": "Startdatum",
      "status": "Status",
      "systemEvents": {
        "asset_lead_add_contact": "Contact <i>%{contact}</i> toegevoegd door <i>%{actor}</i>",
        "asset_lead_create": "<i>%{creator}</i> heeft deze acquisitie toegevoegd",
        "asset_lead_stage_update": "<i>%{actor}</i> heeft de fase veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "asset_lead_status_update": "<i>%{actor}</i> heeft de status veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "deal_accept_proposal": "Ontwerpovereenkomst opgevraagd door <i>%{name}</i>",
        "deal_add_asset": "<i>%{actor}</i> heeft deze opportuniteit toegevoegd aan <i>%{asset}</i>",
        "deal_channel_add": "Bron <i>%{channel}</i> toegevoegd door <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> heeft deze opportuniteit toegevoegd aan <i>%{asset}</i>",
        "deal_create_no_asset": "<i>%{creator}</i> heeft deze opportuniteit toegevoegd",
        "deal_lease_cancel": "<i>%{actor}</i> heeft het huurcontract opgezegd",
        "deal_merge": "De opportuniteit werd samengevoegd met <i>%{after}</i> door <i>%{actor}</i>",
        "deal_point_person_change": "<i>%{creator}</i> veranderde de contactpersoon van <i>%{before}</i> naar <i>%{after}</i><i>",
        "deal_remove_asset": "Opportuniteit ontkoppeld van <i>%{asset}</i> door <i>%{actor}</i>",
        "deal_renewal": "<i>%{creator}</i> heeft opportuniteit <i>%{ancestor}</i> gedupliceerd voor vernieuwing",
        "deal_share_status_update": "De opportuniteit wordt nu gedeeld met <i>%{after}</i> door <i>%{actor}</i>",
        "deal_stage_update": "<i>%{actor}</i> heeft de fase veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "deal_status_update": "<i>%{actor}</i> heeft de status veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "deal_tenant_add": "<i>%{actor}</i> heeft <i>%{tenant}</i> toegevoegd als huurder",
        "deal_tenant_broker_add": "<i>%{actor}</i> heeft <i>%{tenant_rep}</i> toegevoegd als tenant rep"
      },
      "to": "tot",
      "totalSize": "totale grootte",
      "undisclosed": "Niet meegedeeld",
      "units": {
        "CAD": "CAD",
        "CHF": "CHF",
        "DKK": "DKK",
        "EUR": "EUR",
        "GBP": "GBP",
        "NOK": "NOK",
        "SGD": "SGD",
        "USD": "USD",
        "amount": "plaats |||| plaatsen",
        "amount_desk": "werkpost |||| werkposten",
        "amount_person": "persoon |||| personen",
        "amount_room": "kamer |||| kamers",
        "daily": "dag |||| dagen",
        "desk": "werkpost |||| werkposten",
        "floor": "verdieping |||| verdiepingen",
        "ft²": "ft²",
        "hourly": "uur |||| uren",
        "m2": "m²",
        "monthly": "maand |||| maanden",
        "monthly_short": "m",
        "m²": "m²",
        "parking": "parking |||| parkings",
        "person": "persoon |||| personen",
        "room": "kamer |||| kamers",
        "space": "ruimte |||| ruimtes",
        "sqft": "ft²",
        "square_foot": "ft²",
        "units": "plaatsen",
        "weekly": "week |||| weken",
        "yearly": "jaar |||| jaren",
        "yearly_short": "jr"
      },
      "upload": "Upload bestand",
      "user": {
        "email": "E-mail",
        "fname": "Voornaam",
        "licenseNumber": "BIV nummer",
        "lname": "Achternaam",
        "locale": "Taal",
        "mobile": "Mobiel nummer",
        "name": "Voor- en achternaam",
        "password": "Wachtwoord",
        "passwordConfirmation": "Wachtwoord bevestigen",
        "phone": "Telefoonnummer",
        "role": "Rol",
        "timezone": "Tijdzone",
        "title": "Titel"
      },
      "with": "met"
    },
    "spaces": {
      "category": "Categorie"
    }
  },
  "nl-NL": {
    "ActivityFeed": {
      "empty_files": "Geen bestanden.",
      "empty_items": "Geen items.",
      "empty_notes": "Geen private berichten.",
      "empty_updates": "Geen updates.",
      "empty_viewings": "Geen geplande bezichtigingen.",
      "filters": {
        "Call": "Gesprekken",
        "DealNote": "Berichten",
        "Email": "E-mails",
        "File": "E-mails",
        "Note": "Berichten",
        "Proposal": "Voorstellen",
        "Viewing": "Bezichtigingen",
        "all": "Alles",
        "call": "Gesprekken",
        "deal_note": "Berichten",
        "email": "E-mails",
        "file": "Bestanden",
        "label": "Toon",
        "note": "Berichten",
        "proposal": "Voorstellen",
        "update": "Berichten",
        "viewing": "Bezichtigingen"
      },
      "header": {
        "Call": "Gesprek",
        "DealNote": "Bericht",
        "Email": "E-mail",
        "Note": "Bericht",
        "Proposal": "Voorstel",
        "Viewing": "Bezichtiging",
        "call": "Gesprek",
        "deal_note": "Bericht",
        "email": "E-mail",
        "file": "Bestand",
        "label": "Post",
        "note": "Bericht",
        "proposal": "Voorstel",
        "update": "Bericht",
        "viewing": "Bezichtiging"
      }
    },
    "AddActions": {
      "addDeal": ""
    },
    "Asset": {
      "deals": {
        "empty": "Geen kansen",
        "fetching": "Laden..",
        "hide": "Verberg kansen",
        "show": "Toon %{smart_count} kans |||| Toon %{smart_count} kansen"
      },
      "noAvailableSpaces": "Geen ruimtes beschikbaar",
      "spaces": {
        "empty": "Geen ruimtes beschikbaar",
        "fetching": "Laden..",
        "hide": "Verberg ruimtes",
        "show": "Toon %{smart_count} ruimte |||| Toon %{smart_count} ruimtes"
      },
      "spacesFetching": "Laden..",
      "spacesHide": "Verberg ruimtes",
      "spacesView": "Toon %{smart_count} ruimte |||| Toon %{smart_count} ruimtes"
    },
    "AssetActions": {
      "askQuestion": "Informeren",
      "copied": "URL gekopieerd!",
      "copy": "Kopieer flyer URL",
      "download": "Download flyer",
      "open": "Flyer openen",
      "requestFlyer": "Vraag flyer",
      "sendSMS": "Sms'en",
      "subscribed": "Ingeschreven voor het wekelijks overzicht",
      "unsubscribed": "Uitgeschreven voor het wekelijks overzicht"
    },
    "AssetAvailability": {
      "availableSpace": "Beschikbaar",
      "spaces": "ruimtes"
    },
    "AssetCharges": {
      "allIn": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
      "rate": "O.V. (schatting)",
      "sell": "Verkoopprijs",
      "service": "gem. Kosten (schatting)"
    },
    "AssetCreateModal": {
      "autoGenerateFlyer": "Genereer automatisch een flyer voor dit object",
      "description": "Vul hier basis informatie in over het nieuwe object. U kan later meer details toevoegen.",
      "title": "Voeg object toe."
    },
    "AssetDeals": {
      "actions": {
        "dropped": "Afgevallen",
        "edit": "Wijzigen",
        "exclude": "Niet opnemen in rapport",
        "include": "Opnemen in rapport",
        "not_dropped": "Niet afgevallen",
        "not_viewed": "Niet bezichtigd markeren",
        "viewed": "Bezichtigd markeren"
      },
      "groups": {
        "active": "Actief",
        "dead": "Verloren",
        "prospects": "Prospects"
      },
      "nonProspectCommentMissing": "Toelichting / vervolgstappen mist voor export"
    },
    "AssetFilter": {
      "budget": "Budget",
      "region": "Regio",
      "status": "Status",
      "type": "Type"
    },
    "AssetHeader": {
      "deals": "Kansen",
      "export": {
        "btn": "Exporteren",
        "disabled": "Export niet mogelijk. Informatie mist over toelichting / vervolgstappen",
        "notification": {
          "message": "U ontvangt zometeen een email",
          "title": "Uw verhuurrapportage wordt geëxporteerd"
        }
      },
      "tabs": {
        "access": "Toegang",
        "announcements": "Mededelingen",
        "assetDeals": "Verhuurrapportage",
        "contacts": "Contacten",
        "files": "Foto's & Bestanden",
        "floorplan": "Plattegronden",
        "infosheet": "Fiche",
        "settings": "Instellingen",
        "spaces": "Ruimtes"
      }
    },
    "AssetIncentives": {
      "active": "Actief",
      "emptyMessage": {
        "active": "Plaats uw <strong>actieve</strong> honoraria hier",
        "inactive": "Plaats uw <strong>niet-actieve</strong> honoraria hier"
      },
      "inactive": "Niet-actief",
      "info": "Een nieuw honorarium nodig? U kunt meer honoraria maken in uw <a href=\"/settings/templates/incentives\">algemene instellingen</a>."
    },
    "AssetInfoModal": {
      "btn": "Stel een vraag",
      "header": "Vraag over %{asset}",
      "questionPlaceholder": "Stel uw vraag..",
      "topic": "Betrekking tot",
      "topics": {
        "another": "Andere",
        "commissions": "Fee en commissies",
        "service": "Gemeenschappelijke kosten",
        "viewing": "Aanvragen bezoek"
      }
    },
    "AssetInformation": {
      "incentives": "Honoraria",
      "title": "Fee en commissies",
      "tos": "Servicevoorwaarden"
    },
    "AssetLeadAddress": {
      "title": "Adres details"
    },
    "AssetLeadContacts": {
      "title": "Contacten"
    },
    "AssetLeadCreateForm": {
      "address": "Straat en nummer",
      "assetLead": "Acquisitie"
    },
    "AssetLeadDetails": {
      "description": "Extra informatie",
      "title": "Acquisitie Details"
    },
    "AssetLeadHeader": {
      "collaborators": {
        "title": "Medewerkers"
      },
      "days_active_from_now": "%{days} actief",
      "pointPerson": {
        "dropdownHeader": "Selecteer Contactpersoon",
        "title": "Contactpersoon"
      },
      "reopen": "Kans heropenen?",
      "status": {
        "days_active_from_now": "%{days} actief",
        "number_of_days_active": "%{days} dagen actief",
        "title": "Status"
      },
      "title": "Acquisitie Kans"
    },
    "AssetLeadModal": {
      "title": "Creëer acquisitie kans"
    },
    "AssetLeadStatusMessage": {
      "disregarded": "verloren",
      "executed": "gewonnen",
      "message": "De acquisitie kans is <strong>%{status}</strong> geplaatst door %{actor} op %{date}",
      "message_no_actor": "De acquisitie kans is <strong>%{status}</strong> geplaatst op %{date}"
    },
    "AssetLeadsList": {
      "emptyStage": "Geen acquisitie gevonden in de huidige fase"
    },
    "AssetNavigator": {
      "disclaimer": "De informatie in onderstaand document is strikt confidentieel en u bent niet geautoriseerd om dit document in z'n geheel, of de informatie afzonderlijk, vrij te geven aan eender welke partij behalve voor het informeren van mogelijke huurders waar u rechtstreeks mee in contact bent. In elk ander geval neemt u eerst contact.",
      "filter": "Filter",
      "loading": "Laden...",
      "noAssets": "Uw zoekopdracht leverde geen resultaat op.",
      "searchPlaceholder": "Zoeken.."
    },
    "AssetNavigatorHeader": {
      "collapse": "Verberg alle",
      "display": "Weergave",
      "expand": "Toon alle",
      "placeholder": "Zoeken.."
    },
    "AssetOnMarket": {
      "onMarket": "on-market"
    },
    "AssetSettings": {
      "access": "Toegang",
      "actions": {
        "menuTitle": "Acties",
        "portfolio": {
          "dropdownTitle": "Verplaats naar",
          "information": "Wanneer u dit object naar een andere portefeuille verplaatst, worden <strong>alle kansen</strong> voor dit pand ook overgezet naar de nieuwe portefeuille.",
          "menuTitle": "Wijzig portfolio",
          "title": "Wijzig portfolio"
        }
      },
      "assetUsers": {
        "cancel_invite": "Uitnodiging annuleren",
        "invitationPending": "Uitnodiging in behandeling",
        "inviteBtn": "Uitnodigen",
        "menuTitle": "Partners",
        "none": {
          "fully_let": "Uw pand is <strong>volledig verhuurd</strong>. <a href=\"/assets/%{id}/settings/access/status\">Wijzig de status</a> om partners uit te nodigen.",
          "invite": "U heeft nog <strong>geen partners</strong>.",
          "private": "Uw pand is <strong>privaat</strong>. <a href=\"/assets/%{id}/settings/access/status\">Wijzig de status</a> om partners uit te nodigen.",
          "public": "U heeft nog <strong>geen partners</strong>.",
          "sold": "Uw pand is <strong>verkocht</strong>. <a href=\"/assets/%{id}/settings/access/status\">Wijzig de status</a> om partners uit te nodigen."
        },
        "resend_invite": "Opnieuw versturen",
        "revoke": "Ontzeg toegang",
        "revoke_company": "Ontzeg toegang team"
      },
      "costs": {
        "allIn": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
        "menuTitle": "Algemeen",
        "rentPrice": "Verhuurprijs",
        "sellPrice": "Verkoopprijs",
        "sellingTitle": "Verkoopprijs",
        "serviceTitle": "Gemeenschappelijke kosten",
        "taxTitle": "Onroerende voorheffing"
      },
      "fees": "Fee en commissies",
      "financial": "Financieel",
      "flyerSettings": {
        "autogenerateFlyer": "Genereer automatisch een flyer voor dit object",
        "description": "Als u <strong>automatisch genereren</strong> inschakelt voor flyers, wordt een flyer gemaakt en up-to-date gehouden. Dit betekent dat wanneer u een ruimte, foto, plattegronden, ... toevoegt of bijwerkt, we automatisch een nieuwe flyer voor u zullen genereren.",
        "title": "Flyer instellingen"
      },
      "general": "Algemeen",
      "incentives": "Honoraria",
      "options": {
        "delete": {
          "confirm": "Weet je zeker dat je dit object wilt verwijderen? Dit is onomkeerbaar!",
          "information": "Als u uw makelaars meer informatie wilt geven over waarom het object verwijderd is, kunt u <a href=%{link}>een mededeling</a> toevoegen of hieronder een reden selecteren.",
          "menuTitle": "Object verwijderen",
          "reason": "Reden voor verwijderen",
          "title": "Verwijder object uit portfolio",
          "warning": "Als u dit object verwijdert, worden alle gegevens verwijderd. <br/> Na het verwijderen worden uw teamleden en makelaars in het wekelijks overzicht op de hoogte gebracht. Nadien hebben ze geen toegang meer en wordt het object <strong>permanent</strong> verwijderd."
        },
        "menuTitle": "Opties"
      },
      "status": {
        "description": "Het bijwerken van de status bepaalt waarop het object op Rialto wordt gecommercialiseerd:",
        "descriptionFullyLet": "Wanneer de status <strong>volledig verhuurd</strong> is, is het object enkel toegankelijk voor u en uw team",
        "descriptionInvite": "Wanneer de status <strong>op uitnodiging</strong> is, kan uw object enkel gedeeld worden via uitnodiging",
        "descriptionPrivate": "Wanneer de status <strong>privaat</strong> is, is het object enkel toegankelijk voor u en uw team",
        "descriptionPublic": "Wanneer beschikbaar onder <strong>open mandaat</strong>, is uw object toegankelijk voor alle makelaars die toegang ontvingen op uw portfolio op Rialto",
        "dropdownTitle": "Status",
        "menuTitle": "Status",
        "public_to_invite": "",
        "public_to_private": "",
        "title": "Status wijzigen"
      },
      "tos": "Servicevoorwaarden",
      "tosExtraInfo": "Selecteer hieronder de servicevoorwaarden om uw partners op de hoogte te stellen van de voorwaarden die van toepassing zijn op dit object.",
      "tosInfo": "Nieuwe servicevoorwaarden nodig? U kunt meer servicevoorwaarden maken in uw <a href=\"/settings/templates/tos\">algemene instellingen</a>."
    },
    "AssetShareStatus": {
      "Tooltips": {
        "body_fully_let": "Dit object is volledig verhuurd",
        "body_invite": "List of partners this asset is shared with.",
        "body_private": "Dit object is enkel zichtbaar voor u en uw team.",
        "body_public": "Dit object is gedeeld met alle makelaars die toegang hebben tot dit portfolio.",
        "footer_invite": {
          "one": "en %{count} meer",
          "other": "en %{count} meer"
        },
        "header_invite": "Gedeeld met"
      }
    },
    "AssetSort": {
      "name": "Naam",
      "on_market": "Beschikbare ruimte",
      "order_by": "Sorteren op",
      "updated_at": "Laatste update"
    },
    "AssetStatistics": {
      "available": "Nu beschikbaar",
      "deals": "Kansen",
      "onMarket": "On-market",
      "total": "Totaal",
      "viewings": "Bezichtigingen"
    },
    "AssetTermsOfService": {
      "info": "Een nieuw honorarium nodig? U kunt meer honoraria maken in uw <a href=\"/settings/incentives\">algemene instellingen</a>."
    },
    "Backbutton": {
      "back": "Terug"
    },
    "BrokerInviteForm": {
      "broker": "Partner",
      "invite": "Uitnodigen",
      "inviting": "Uitnodigen..",
      "portfolioAssets": "Portfolio & objecten"
    },
    "BrokerInviteModal": {
      "description": "Als je een partner uitnodigt, zal je het team van de partner toegang geven tot de beschikbaarheidslijsten van de objecten die je selecteert, inclusief het marketing materiaal en de documenten. Je deelt nooit verhuurkansen die je zelf aangemaakt hebt, of die aangemaakt zijn door een andere partner, met deze partij. De partner zal in real-time updates ontvangen bij wijzigingen van het marketing materiaal of in de beschikbaarheid van de objecten die met hem gedeeld worden, en hij zal per object kansen kunnen delen met u.",
      "title": "Uitnodigen Partner"
    },
    "Calendar": {
      "call": "Gesprek",
      "day": "Dag",
      "download": "Inschrijven",
      "due_proposal": "Vervaldatum voorstel",
      "lease_expiration": "Einde huur",
      "lease_start": "Start contract",
      "month": "Maand",
      "space_available": "Ruimte beschikbaar",
      "today": "Vandaag",
      "viewing": "Bezichtiging",
      "week": "Week"
    },
    "Channels": {
      "category": "Type",
      "company": "Bedrijf",
      "confirm": {
        "delete": "Weet je zeker dat je dit wilt verwijderen?"
      },
      "name": "Naam en voornaam",
      "phone": "Telefoonnummer",
      "title": "Bronnen"
    },
    "Commissions": {
      "durationLabel": "Contractduur",
      "feeLabel": "Commissie",
      "header": "Commissies",
      "info": "Het commissiepercentage is gerelateerd aan de duur van het contract, <strong>ze is als volgt opgesteld</strong>:",
      "year": "jr"
    },
    "CompanyBlock": {
      "newPortfolio": "Nieuw portfolio",
      "visitCompanyPage": "Bedrijfsprofiel"
    },
    "CompanyPage": {
      "Contact": {
        "email": "E-mail ons",
        "phone": "Bel ons"
      },
      "Login": {
        "footer": "Geen account?",
        "header": "Heb je een Rialto-account?",
        "login": "Inloggen bij Rialto",
        "requestAccess": "Toegang vragen"
      },
      "NotFound": {
        "message": "We kunnen geen bedrijf vinden voor deze url",
        "title": "Deze pagina is niet beschikbaar"
      },
      "contacts": "Contacten",
      "features": "Features",
      "incentives": "Honoraria",
      "introduce": "Introduceer klant",
      "portfolios": "Portfolio's",
      "tos": "Servicevoorwaarden"
    },
    "CompanyTooltip": {
      "inCountry": "in %{value}",
      "numberOfAssets": "%{smart_count} object |||| %{smart_count} objecten",
      "viewCompanyProfile": "Bedrijfsprofiel"
    },
    "Dashboard": {
      "empty": "Er is geen dashboard voor dit portfolio"
    },
    "DateTime": {
      "add_date": "Gelieve een datum te kiezen",
      "add_time": "Tijdstip kiezen?",
      "select_date": "Kies datum",
      "set": "Instellen",
      "submit": "Opslaan",
      "time": "Tijdstip",
      "title": "Datum kiezen"
    },
    "DealActions": {
      "delete": {
        "confirm": "Bent u zeker dat u deze kans permanent wil verwijderen? Ook berichten op deze kans worden verwijderd.",
        "tooltip": "Verwijderen"
      },
      "duplicate": {
        "tooltip": "Dupliceren"
      },
      "merge": {
        "tooltip": "Samenvoegen"
      }
    },
    "DealCancel": {
      "cancelDate": "Opzegdatum",
      "confirm": "Bevestigen",
      "confirming": "Bevestigen...",
      "feedback": "Feedback",
      "feedbackInfo": "Uw feedback zal worden getoond aan iedereen met toegang tot deze verhuurkans.",
      "feedbackPlaceholder": "Geef uw feedback hier",
      "moveDate": "Verhuisdatum",
      "reason": "Reden",
      "title": "Zeg huurcontract op"
    },
    "DealCard": {
      "nbAssets": "%{smart_count} objecten"
    },
    "DealColumns": {
      "title": "Kolommen aanpassen"
    },
    "DealDetail": {
      "confirmDelete": "Bent u zeker dat u deze kans permanent wil verwijderen? Ook berichten op deze kans worden verwijderd."
    },
    "DealDetails": {
      "budget": {
        "separator": "tot",
        "title": "Budget"
      },
      "description": "Extra informatie",
      "location": {
        "title": "Locatie"
      },
      "spaces": {
        "archive": "Archief",
        "car_parking": "Buitenparking",
        "category": "Categorie",
        "covered_car_parking": "Overdekte parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Kavel",
        "leisure": "Vrijetijd",
        "logistical": "Logistieke ruimte",
        "meeting": "Meeting / Conferentie",
        "new": "Nieuw",
        "office": "Kantoor",
        "other_cat": "Overig",
        "outdoor_area": "Buitenterrein",
        "residential": "Residentieel",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Opslag",
        "title": "Ruimtes"
      },
      "start_date": {
        "title": "Startdatum"
      },
      "term": {
        "months": "maand",
        "title": "Max huurtermijn",
        "years": "jaar"
      },
      "title": "Details van Kans",
      "type": "Type",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "plaatsen"
      }
    },
    "DealFilter": {
      "advanced": "Geavanceerde filters",
      "asset": "Object",
      "selectedAsset": "%{nb} geselecteerd"
    },
    "DealForm": {
      "assets": {
        "info": "Per object dat u selecteert wordt een afzonderlijke verhuurkans aangemaakt. Kies links onderaan of u de verhuurkans al dan niet wil delen vooraleer ze toe te voegen.",
        "title": "Object |||| Objecten"
      },
      "channel": {
        "expand": "Voeg <strong>consultant</strong> toe",
        "title": "Oorsprong"
      },
      "description": {
        "disclose": "<strong>Voeg extra informatie toe</strong>",
        "placeholder": "Voer notitie in",
        "title": "Extra informatie"
      },
      "details": {
        "title": "Kans"
      },
      "enquiry": {
        "title": ""
      },
      "placeholders": {
        "asset": "Associeer object(en) (optioneel)",
        "assets": "Associeer object (optioneel)"
      },
      "portfolio": {
        "title": "Portfolio"
      },
      "save": "Toevoegen",
      "saving": "Toevoegen..",
      "stage": "Fase",
      "tenant": {
        "title": "Huurder",
        "undisclose": "Huurdersgegevens <strong>niet vrijgeven</strong>"
      }
    },
    "DealMerge": {
      "description": "Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui sint asperiores maiores eaque voluptatum mollitia eum architecto, neque possimus hic corporis aliquid aut est tempore voluptates iste harum enim iusto rerum blanditiis magni aliquam. Vero maxime qui quis explicabo eum excepturi asperiores rerum eos veritatis, reprehenderit voluptatem possimus aliquam incidunt!",
      "source": "Voeg",
      "target": "Samen met",
      "title": "Kans samenvoegen"
    },
    "DealModal": {
      "header": "Nieuwe verhuurkans"
    },
    "Deals": {
      "portfolio_subscribed": "Ingeschreven voor het wekelijks overzicht",
      "portfolio_unsubscribed": "Uitgeschreven voor het wekelijks overzicht"
    },
    "DealsFilter": {
      "asset": "Object",
      "channel": "Oorsprong",
      "searchPlaceholder": "Zoeken..",
      "stage": "Fase"
    },
    "DealsTable": {
      "empty": "Geen kansen gevonden",
      "empty_stage": "Geen kansen gevonden in de huidige fase",
      "export": {
        "btnLabel": "Exporteren",
        "csv": "Een CSV versie van de verhuurkansen die bewerkt kan worden",
        "pdf": "Een PDF van de verhuurkansen met alle activiteit per object.",
        "title": "Kansen"
      },
      "loading": "Laden..."
    },
    "Dialog": {
      "confirm": "Bevestigen",
      "title": "Bent u zeker?"
    },
    "DisregardModal": {
      "disregard": "Verloren plaatsen",
      "disregarding": "Verloren plaatsen..",
      "feedbackInfo": "Uw feedback zal worden getoond aan iedereen met toegang tot deze verhuurkans.",
      "feedbackPlaceholder": "Geef uw feedback hier",
      "header": "Kans verloren plaatsen",
      "outcome": "Resultaat",
      "reason": "Reden"
    },
    "DropdownUserItem": {
      "me": "ik"
    },
    "DropdownUserSelect": {
      "pointPerson": "Contactpersoon"
    },
    "Dropzone": {
      "notSupported": "Dit bestandstype wordt niet ondersteund",
      "placeholder": "Klik of sleep hier om een bestand te uploaden",
      "placeholderPicture": "Klik of sleep hier om een foto te uploaden"
    },
    "EnquiryDetails": {
      "budget": {
        "title": ""
      },
      "title": ""
    },
    "EnquiryHeader": {
      "DealStages": {
        "hide": "Verberg",
        "modal": {
          "body": "Hier kun je aanpassen welke objecten in de running zijn voor %{stage}. Wanneer u het pand verwijdert, wordt deze verhuurkans verloren geplaatst.",
          "title": "Objecten in %{stage} aanpassen"
        },
        "show": "Toon %{smart_count} meer"
      },
      "assignAsset": "Link een object",
      "assignFeePotential": "Toevoegen waarde kans",
      "collaborators": {
        "title": "Medewerkers"
      },
      "confirm": {
        "assetRemove": "Eén of meer ruimtes van %{asset} kunnen gekoppeld zijn aan deze kans. Deze koppeling wordt verwijderd wanneer u het object verwijdert. Weet u zeker dat u verder wilt gaan?",
        "assetUpdate": "Eén of meer ruimtes van %{asset} kunnen gekoppeld zijn aan deze kans. Deze koppeling wordt verwijderd wanneer u het object bijwerkt. Weet u zeker dat u verder wilt gaan?",
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "feePotentialRemove": "Ben je zeker dat je de waarde voor deze kans wenst te verwijderen?"
      },
      "duplicate": "Dupliceer voor hernieuwing",
      "feePotential": "Waarde kans",
      "modal": {
        "header": "Aangepaste deelinstellingen",
        "info": "Iedere partner die hier getagd is, zal kunnen werken op deze kans. We laten hen niet weten als je ervoor kiest niet langer met hen te delen.",
        "save": "Opslaan",
        "search_collaborators": "Zoek partners",
        "title": "Partners met toegang tot verhuurkans"
      },
      "point_person": {
        "dropdown_header": "Selecteer Contactpersoon",
        "title": "Contactpersoon"
      },
      "renew": "Dupliceer voor hernieuwing",
      "reopen": "Verhuurkans heropenen?",
      "status": {
        "days_active_from_now": "%{days} actief",
        "number_of_days_active": "%{days} dagen actief",
        "title": "Status"
      },
      "subscribed": "Ingeschreven",
      "title": "Verhuurkans",
      "unsubscribed": "Uitgeschreven"
    },
    "EnquiryModal": {
      "addEnquiry": "Toevoegen",
      "addingEnquiry": "Toevoegen..",
      "assets": {
        "title_pl": "Objecten",
        "title_sg": "Object"
      },
      "channel": {
        "category": "Type",
        "company": "Bedrijfsnaam",
        "email": "Email",
        "name": "Naam",
        "title": "Oorsprong"
      },
      "collapse_channel_details": "Verberg <strong>makelaar</strong>",
      "collapse_comment_details": "<strong>Verberg opmerking</strong> to post upon creation",
      "collapse_tenant_details": "<strong>Verberg huurder</strong> en/of aanhuurmakelaar",
      "comment": {
        "placeholder": "Voer notitie in",
        "title": "Voeg bericht toe"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren."
      },
      "enquiry": {
        "name": "Naam",
        "title": "Verhuurkans"
      },
      "expand_channel_details": "Voeg <strong>consultant</strong> toe",
      "expand_comment_details": "<strong>Voeg opmerking toe</strong> bij aanmaak",
      "expand_tenant_details": "<strong>Voeg huurder</strong> en/of makelaar toe",
      "header": "Nieuwe verhuurkans",
      "headerRenewal": "Dupliceer voor vernieuwing",
      "industry": {
        "art_culture": "Kunst & cultuur",
        "automobile": "Automobiel",
        "aviation": "Luchtvaart & toerisme",
        "banks": "Banken",
        "basic_resources": "Grondstoffen",
        "chemicals": "Chemie",
        "construction": "Bouw",
        "consumer_electronics": "Huishoudelectro",
        "education": "Onderwijs",
        "education_art": "Onderwijs & kunst",
        "entertainment_gaming": "Ontspanning & gaming",
        "financial_services": "Financiële diensten",
        "food": "FMCG - Voeding & drank",
        "healthcare": "Zorg & farmacie",
        "household_goods": "Persoonlijke- & huishoudartikelen",
        "industrial_goods": "Industriële goederen & diensten",
        "insurance": "Verzekeringen",
        "legal": "Juridisch",
        "luxury": "Mode, interieur & luxe",
        "media": "Media",
        "oil_gas": "Olie & gas",
        "other_cat": "Andere",
        "professional_services": "Professionele diensten",
        "public": "Publieke sector",
        "real_estate": "Vastgoed",
        "retail": "Retail",
        "sports_leisure": "Sport & vrije tijd",
        "technology": "Technologie",
        "telecommunications": "Telecom",
        "title": "Industrie",
        "travel": "Toerisme & vrije tijd",
        "utilities": "Nutsvoorzieningen",
        "wellbeing": "Welzijn"
      },
      "info": "Per object dat u selecteert wordt een afzonderlijke verhuurkans aangemaakt. Kies links onderaan of u de verhuurkans al dan niet wil delen vooraleer ze toe te voegen.",
      "portfolio": {
        "title": "Portfolio"
      },
      "size": {
        "separator": "tot",
        "title": "Grootte"
      },
      "start_date": {
        "title": "Startdatum"
      },
      "tenant": {
        "company": "Bedrijf",
        "email": "E-mailadres",
        "industry": "Industrie",
        "name": "Voor- en achternaam",
        "title": "Huurder"
      },
      "tenantRepresentative": {
        "company": "Bedrijf",
        "email": "E-mailadres",
        "name": "Voor- en achternaam",
        "title": "Aanhuurmakelaar"
      },
      "undiscloseTenantBroker": "Huurdersgegevens <strong>niet vrijgeven</strong>",
      "undiscloseTenantOwner": "Huurdersgegevens <strong>niet vrijgegeven</strong>",
      "units": {
        "ft2": "ft²",
        "m2": "m²",
        "units": "plaatsen"
      }
    },
    "EnquiryStatusMessage": {
      "advisedBy": "Geadviseerd door",
      "commencement": "<strong>Aanvang</strong> op",
      "disregarded": "verloren",
      "executed": "gewonnen",
      "expiring": "<strong>Aflopend</strong> op",
      "leaseBreak": "<strong>Eerste break</strong> op",
      "message": "De verhuurkans is <strong>%{status}</strong> geplaatst door %{actor}",
      "message_no_actor": "De verhuurkans is <strong>%{status}</strong> geplaatst",
      "renewal": "Dupliceer voor hernieuwing",
      "renewalPeriod": "<strong>Vernieuwing</strong> elke",
      "reopen": "Verhuurkans heropenen?",
      "size": {
        "of": "van"
      },
      "yearlyRent": {
        "for": "voor",
        "message": "Totale jaarlijkse huur is"
      }
    },
    "ErrorBoundary": {
      "back": "Ga terug",
      "message": "Ons team is op de hoogte gebracht en zal de fout zo snel mogelijk proberen oplossen. <br />\nWe nemen contact met u op nadat het probleem is opgelost.",
      "title": "Sorry, er is iets misgegaan.. "
    },
    "ExecuteModal": {
      "channels": "Komt in aanmerking voor vergoeding",
      "execute": "Gewonnen",
      "executing": "Gewonnen..",
      "header": "Kans gewonnen plaatsen",
      "info": "De details van het gewonnen huurcontract zullen beschikbaar zijn in de sectie gewonnen kansen en zullen beschikbaar blijven voor uw eigen team en eventueel uw makelaars die uitgenodigd waren tot deze kans.",
      "involvedSpaces": "Verhuurde Ruimtes",
      "leasingAgent": "Verhuurmakelaar",
      "offered": "verstuurd",
      "reasonForMoving": "Motivatie",
      "received": "ontvangen",
      "tenant": "Naam huurder"
    },
    "ExportActions": {
      "assetLeads": {
        "title": "Acquisitie",
        "xls": "Een XLS export."
      },
      "assets": {
        "csv": "Een CSV export na filter.",
        "pdf": "Een PDF export, na filter.",
        "title": "Objecten en Ruimtes",
        "xls": "Een XLS export na filter."
      },
      "btnLabel": "Exporteren",
      "deals": {
        "csv": "Een CSV versie van de kansen die bewerkt kan worden",
        "pdf": "Een PDF van de kansen met alle activiteit per object.",
        "title": "Kansen",
        "xls": "Een XLS versie van de kansen die bewerkt kan worden"
      },
      "portfolioAssets": {
        "pdf": "Een PDF export van dit portfolio (na filter).",
        "title": "Portfolio",
        "xls": "Een XLS export van dit portfolio (na filter)."
      }
    },
    "FileManager": {
      "empty": "Je hebt nog geen foto's of bestanden geüpload.",
      "files": "Documenten",
      "filesSelected": "%{value} bestanden geselecteerd",
      "header": "Gebruik als flyer header",
      "pictures": "Foto's",
      "private": "Niet tonen op flyer",
      "searchPlaceholder": "(name, kind, tag, ..)",
      "thumbnail": "Gebruik als thumbnail",
      "uploaded": "Toegevoegd"
    },
    "Floorplans": {
      "actions": "",
      "addSpace": "Ruimte verbinden",
      "availability": "Beschikbaarheid",
      "clearLines": "Lijnen verwijderen",
      "clickToLink": "Klik om een ruimte te koppelen",
      "createFloorplan": "Nieuwe plattegrond aanmaken",
      "deleteConfirm": "Bent u zeker dat u deze plattegrond wilt verwijderen?",
      "deleteFloorplan": "Verwijder plattegrond",
      "duplicate": "Dupliceer",
      "editSpace": "Ruimte wijzigen",
      "file": "Bestand",
      "floor": "Verdieping",
      "floorPlaceholder": "Naam van verdieping",
      "floorSelector": "Verdieping kiezen",
      "information": "<h3>Inzoomen op de afbeelding</h3>\n<p>Houdt CTRL of CMD ingedrukt en scroll om op de afbeelding in te zoomen</p>\n\n<h3>De afbeelding verplaatsen</h3>\n<p>Houdt CTRL of CMD ingedrukt, klik en beweeg de muis om de afbeelding te verplaatsen</p>\n\n<h3>Tekenen op de afbeelding</h3>\n<p>Klik op de afbeelding om een lijn te teken. Van zodra de tekening afgewerkt is, kan deze met een ruimte van het pand gekoppeld worden</p>\n\n<h3>Een ruimte op de afbeelding koppelen</h3>\n<p>Klik op een getekende ruimte om deze met ruimte uit het pand te kopppelen</p>\n\n<h3>Een getekende ruimte verplaatsen</h3>\n<p>Klik op een getekende ruimte en verplaats de muis om de ruimte te verplaatsen</p>\n\n<h3>Een getekende ruimte dupliceren</h3>\n<p>Klik op een gekende ruimte, vervolgens op de het potlood en tenslotte op dupliceer om de geselecteerde ruimte te dupliceren</p>",
      "informationTitle": "Info over plattegronden",
      "leaseHolder": "Huurder",
      "none": "Geen plattegronden beschikbaar",
      "pricing": "Prijs",
      "scroll": "Houd %{key} ingedrukt om de afbeelding te verschuiven of in te zoomen.",
      "size": "Grootte",
      "startDragging": "Verplaatsen aanvangen",
      "status": "Status",
      "stopDragging": "Verplaatsen stoppen",
      "uploadFloorplan": "Plattegrond uploaden"
    },
    "Flyer": {
      "NotFound": {
        "message": "We vinden het jammer, maar de flyer is niet langer beschikbaar. <br>\nBezoek het <a href=\"https://www.rial.to/app\">Rialto platform</a>, of <a href=\"mailto:dgtqwgb3@incoming.intercom-mail.com\"> neem contact met ons</a>.",
        "title": "Flyer is niet meer beschikbaar"
      },
      "ServiceRate": {
        "allIn": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
        "rate": "onroerende voorheffing (schatting)",
        "service": "gemeenschappelijke kosten (schatting)"
      },
      "contact": "Neem contact",
      "facilities": {
        "categories": {
          "fire_safety": "Brandveiligheid",
          "general": "Algemeen",
          "other_cat": "Andere",
          "security": "Beveiliging"
        },
        "title": "Voorzieningen\n"
      },
      "location": "Ligging",
      "marketing": "Marketing Package"
    },
    "FlyerContactModal": {
      "info": "Uw vraag wordt naar de contactpersoon van dit object gestuurd",
      "question": "Stel hier uw vraag",
      "successBody": "De contactpersoon zal u zo snel mogelijk antwoorden",
      "successTitle": "Bericht verzonden",
      "title": "Een vraag stellen"
    },
    "ForgotPasswordModal": {
      "header": "Wachtwoord vergeten",
      "info": "Vul uw e-mailadres in dat u gebruikt op rial.to en druk op versturen. Daarna versturen wij u een e-mail met verdere instructies om uw wachtwoord opnieuw in te stellen."
    },
    "FormButton": {
      "cancel": "Annuleren",
      "delete": "Verwijderen",
      "edit": "Wijzig",
      "save": "Opslaan"
    },
    "GmailAuth": {
      "body": "Identificeer snel leads in uw e-mail inbox op Rialto en converteer ze direct naar een opportuniteit. Zo hoef je niet langer tussen twee apps te wisselen. Klik op de onderstaande knop om te verbinden.",
      "title": "Verbind uw e-mail account met Rialto"
    },
    "Inbox": {
      "convertDeal": "Maak verhuurkans",
      "fetching": "E-mails ophalen..",
      "noSelection": "Geen e-mail geselecteerd"
    },
    "Incentive": {
      "fee": "<strong>%{fee}</strong> commissie zal worden toegekend",
      "minSize": "bij minimaal",
      "months": "maanden",
      "sprinter": "Bij afsluiting contract maximaal <strong>%{duration} maand(en) </strong> na fase <strong>%{stage}</strong>.",
      "termAfter": "na %{date}",
      "termBefore": "voor %{date}"
    },
    "IncentiveCard": {
      "commissionFixed": "%{value} %{currency} na %{type} van huurder",
      "commissionPercentage": "%{value} na %{type} van huurder",
      "commissionPeriod": "%{value} %{period} na %{type} van huurder",
      "conditionsSize": "Contractgrootte > %{value} %{unit}",
      "conditionsTerm": "Contractduur > %{value} %{period}",
      "payoutLinked": "Periodieke betaling in lijn met huurbetalingen voor max. %{value} %{period} huur",
      "payoutRecurring": "Periodieke betaling elke %{recurrenceValue} %{recurrencePeriod} voor max. %{value} %{period} huur",
      "payoutUpfront": "Vooruitbetaling over %{value} %{period} huur",
      "type": {
        "expansion": "uitbreiden",
        "new": "tekenen",
        "reduction": "reduceren",
        "renegotiation": "heronderhandelen",
        "renewal": "hernieuwen"
      }
    },
    "IncentiveForm": {
      "addIncentive": "Nieuw honorarium",
      "autoAssign": "Toon op de bedrijfspagina en wijs automatisch toe op publieke panden",
      "conditionTypes": {
        "conditions": "Voorwaarden",
        "endDate": "Einddatum",
        "minSize": "Minimale grootte",
        "term": "Termijn"
      },
      "deleteAutoassignConfirm": "Bent u zeker dat u dit honorarium wilt verwijderen? Dit honorarium is automatisch toegewezen aan de bedrijfspagina en objecten met publieke status. Nadat het honorarium verwijderd is, wordt deze niet langer weergegeven.",
      "deleteConfirm": "Bent u zeker dat u dit honorarium wilt verwijderen?",
      "deleteSuccess": "Honorarium werd verwijderd!",
      "description": "Beschrijving",
      "editIncentive": "Bewerk honorarium",
      "feeTypes": {
        "fees": "Vergoeding",
        "fixedFee": "Vast",
        "monthsFee": "Maanden",
        "percentageFee": "Procent"
      },
      "payout": "Uitbetaling",
      "payoutLinked": "In lijn met huurbetalingen",
      "payoutTypes": {
        "payoutPeriod": "Vooruitbetaling",
        "payoutRecurrence": "Periodiek"
      },
      "rentPeriod": "Huurperiode",
      "title": "Titel",
      "type": "Type"
    },
    "IntegrationStatus": {
      "officernd": "OfficeR&D",
      "syncedAt": "Laatst gesynchroniseerd met <strong>%{integration}</strong> op <strong>%{date}</strong>",
      "syncedFrom": "Gesynchroniseerd met <strong>%{integration}</strong>"
    },
    "Intro": {
      "addButton": "<h3>Verhuurkans, object of partner toevoegen</h3>\nU kunt een nieuwe verhuurkans, object of partner toevoegen door hier te klikken.",
      "addButtonBroker": "",
      "assetActions": "<h3>Acties</h3>\nMet deze acties kunt in- of uitschrijven op emails over een object en de flyer bekijken",
      "assetExport": "<h3>Export</h3>\nKlik hier om de lijst van objecten en ruimtes, eventueel na toepassen van filter, in het huidige portfolio als CSV of PDF te exporteren.",
      "assetFilter": "<h3>Zoeken</h3>\nHier kunt u in het huidige portfolio zoeken naar ruimtes en objecten die aan uw criteria voldoen.",
      "assetInfo": "<h3>Pand informatie</h3>\nDoor te klikken op één van de icoontjes, kunt u meer informatie krijgen over de deelinstellingen, commissies en kosten van het object.",
      "assetList": "<h3>Objecten</h3>\nHier krijgt u een overzicht van alle objecten in dit portfolio.",
      "associateAsset": "<h3>Pand verbinden</h3>\nNadat u een object aan deze kans heeft gekoppeld, kunt u ernaar filteren op de navigator. U kunt nu ook ruimtes aan deze kans koppelen en / of voorstellen maken voor ruimtes van dit object.",
      "channelDetails": "<h3> Specificeer bronnen </ h3>\nBewaar informatie over de oorsprong van deze kans.",
      "dealDetail": "<h3>Verhuurkans detailpagina</h3>\nOpen een verhuurkans in de lijst om verdere details te raadplegen, huurdergegevens toe te voegen, een update te delen, etc.",
      "dealDetails": "<h3>Specificeer vereisten</h3>\nVerduidelijk waarnaar de huurder zoekt.",
      "dealExport": "<h3>Export</h3>\nKlik hier om uw kansen in het huidige portfolio als CSV of PDF te exporteren.",
      "dealToggleView": "<h3>Weergave</h3>\nKlik hier om te wisselen tussen een tabelweergave of een kolomweergave met drag-and-drop of selecteer aangepaste tabelkolommen.",
      "deals": "<h3>Deals</h3>Browse hier om de kansen voor deze portefeuille te raadplegen",
      "dealsList": "<h3>Verhuurkansen</h3>\nHier krijgt u een overzicht van al uw actieve kansen in dit portfolio. In de filter kunt u schakelen tussen verschillende statussen.",
      "done": "Klaar",
      "expandAsset": "<h3>Ruimtes tonen</h3>\nKlik hier om ruimtes van dit pand te bekijken.",
      "intercom": "<h3>Help</h3>\nU heeft het einde van de rondleiding bereikt. Als u vragen hebt tijdens het gebruik van ons platform, aarzel dan niet om ons een vraag te stellen door op deze knop te klikken. We nemen zo snel mogelijk contact met u op.",
      "next": "Begrepen",
      "previous": "Vorige",
      "settings": "<h3>Instellingen</h3>\nHier kan u al uw instellingen (taalvoorkeuren, instellingen voor notificaties, teambeheer enz.) terugvinden, alsook uitloggen.",
      "skip": "Overslaan",
      "subscribeAsset": "<h3>Inschrijven voor updates</h3>\nKlik hier om u te in te schrijven voor wekelijkse updates (per mail) van dit object.",
      "switchPortfolio": "<h3>Veranderen van portfolio</h3>\nHier kan u wisselen tussen alle portfolio's waar u toegang tot heeft alsook zoeken op alle portfolio's in 1 lijst.",
      "tenantDetails": "<h3> Gegevens huurder bewaren </ h3>\nBewaar bedrijfsinformatie van uw huurder.",
      "welcome": "<h3>Welkom bij Rialto!</h3>\nDeze rondleiding begeleidt u door de belangrijkste functies van ons platform. Dit duurt max. drie minuten en geeft je een snelle introductie.\nJe kunt de rondleiding op elk moment stoppen door op de knop 'Overslaan' te klikken."
    },
    "LinkedinOauthCallback": {
      "errorBody": "Meld u in plaats daarvan aan met e-mail en wachtwoord",
      "errorTitle": "LinkedIn gebruiker onbekend"
    },
    "LoginForm": {
      "emailPlaceholder": "Geef e-mailadres",
      "forgotPassword": "Vergeten?",
      "linkedin_signin": "Inloggen met LinkedIn",
      "loggingIn": "Inloggen..",
      "login": "Inloggen",
      "passwordPlaceholder": "Geef wachtwoord in",
      "register": "Heb je geen account?"
    },
    "Modal": {
      "comment": {
        "collapse": "<strong>Verberg opmerking</strong> bij aanmaak",
        "expand": "<strong>Voeg opmerking toe</strong> bij aanmaak",
        "placeholder": "Voer opmerking in",
        "title": "Opmerking"
      }
    },
    "Navbar": {
      "back": "Vorige",
      "dashboard": {
        "deal": "Deal dashboard",
        "marketing": "Marketing dashboard"
      },
      "help": "Hulp vragen",
      "settings": "Instellingen",
      "sign_out": "Log uit"
    },
    "Ner": {
      "area": "Oppervlakte en capaciteit",
      "costs": "Som van de kosten",
      "free_rent_period": "Huurvrije period (in maanden)",
      "header": "Netto effectieve huur",
      "price": "Prijzen (per maand)",
      "term": "Termijn of hernieuwingsperiod (in maanden)",
      "title": "De <strong>netto effectieve huur</strong> wordt als volgt berekend:"
    },
    "Notes": {
      "alert": {
        "no_content": "Please add %{contentType} before saving!"
      },
      "call": {
        "alert_empty": "No empty calls",
        "btnLabel": "Selecteer datum",
        "placeholder": "Voer uw commentaar hier in",
        "title": "Kies datum voor gesprek"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "delete": "Weet u zeker dat u wilt verwijderen?"
      },
      "email": {
        "alert_empty": "No empty emails",
        "btnLabel": "Selecteer datum",
        "code": "Voeg een email toe door FWD of BCC naar",
        "codeMobile": "FWD of BCC naar",
        "copied": "URL gekopieerd!",
        "copy": "\nKopieer naar klembord",
        "created_by": "Aangemaakt door",
        "date_received": "Datum ontvangen",
        "date_sent": "Datum verzonden",
        "from": "van",
        "paste": "Kopieer en plak de e-mail inhoud hier",
        "placeholder": "Voer uw commentaar hier in",
        "received": "Ontvangen",
        "received_from": "Ontvangen van",
        "sent": "Verzonden",
        "sent_to": "Verzonden naar",
        "title": "Kies datum voor email",
        "to": "naar"
      },
      "file": {
        "comment": "Notitie",
        "comment_placeholder": "Voer notitie in (optioneel)",
        "download": "Downloaden",
        "title": "Titel",
        "title_placeholder": "Voer titel in"
      },
      "no_contacts": "Geen contacten",
      "note": {
        "indicator": "Privé"
      },
      "placeholder": "Voer uw notities hier in",
      "private": "Alleen ik",
      "proposal": {
        "dueDate": "Vervaldatum",
        "offered_by": "Verstuurd door",
        "offering": "Verstuurd",
        "received_by": "Ontvangen door",
        "receiving": "Ontvangen"
      },
      "public": "Publiek",
      "unknownUser": "Onbekend",
      "update": {
        "placeholder": "Voer uw bericht hier in"
      },
      "upload": "Upload bestand",
      "viewing": {
        "add": "Toevoegen aan agenda",
        "btnLabel": "Selecteer datum",
        "placeholder": "Voer uw bezichtigingsnotities hier in",
        "scheduled_for": "Bezichtiging gepland voor",
        "title": "Kies bezichtigingsdatum"
      }
    },
    "Notification": {
      "deal": {
        "create": {
          "body": "%{values}",
          "title": {
            "one": "Nieuwe kans toegevoegd!",
            "other": "Nieuwe kansen toegevoegd!"
          }
        },
        "invite": {
          "body": "Ze hebben nu toegang tot verhuurkans: %{values}.",
          "title": {
            "one": "Partijen uitgenodigd!",
            "other": ""
          }
        }
      },
      "flyer": {
        "create": {
          "body": "",
          "title": {
            "one": "Flyer geüpdatet!",
            "other": ""
          }
        },
        "error": {
          "body": "",
          "title": {
            "one": "Flyer kon niet gegenereerd worden!",
            "other": ""
          }
        }
      },
      "user": {
        "invitation_accepted": {
          "body": "%{values} heeft uw uitnodiging geaccepteerd en is nu actief op Rialto!",
          "title": {
            "one": "Uitnodiging geaccepteerd!",
            "other": ""
          }
        }
      }
    },
    "Pagination": {
      "next": "volgende",
      "previous": "vorige"
    },
    "PortfolioActions": {
      "addAsset": "Object",
      "addAssetLead": "Acquisitie",
      "addBroker": "Partner",
      "addDeal": "Kans",
      "addProposal": "Voorstel",
      "addSpace": "Ruimte",
      "btnLabel": "Toevoegen"
    },
    "PortfolioBlock": {
      "edit": "Portfolio bijwerken",
      "requestAccess": "Toegang vragen",
      "requestPending": "In aanvraag.."
    },
    "PortfolioDeleteModal": {
      "confirmDelete": "Weet je zeker dat je %{portfolio} wilt verwijderen? Alle bijbehorende objecten en kansen worden verwijderd.",
      "confirmTransfer": "Weet je zeker dat je %{portfolio} wilt verwijderen? Alle bijbehorende objecten en kansen worden overgezet naar %{transferPortfolio}.",
      "header": "Portfolio verwijderen",
      "noPortfolios": "Geen portfolio's om naar over te zetten",
      "transfer": "Overzetten naar",
      "warning": "Wanneer u een portfolio verwijdert, kunt u ervoor kiezen om uw objecten, kansen en notificaties over te zetten naar een ander portfolio. </br> </br> Wanneer u dit niet doet, worden <strong>alle gegevens</strong> die aan dit portfolio gekoppeld zijn, <strong>permanent</strong> verwijderd."
    },
    "PortfolioFilter": {
      "portfolios": "Portfolios",
      "selected": "geselecteerd"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "",
        "deal": ""
      },
      "export": {
        "assets": {
          "csv": "Een CSV export van dit portfolio.",
          "pdf": "Een PDF export van dit portfolio.",
          "title": "Portfolio"
        },
        "btnLabel": "Exporteren",
        "deals": {
          "csv": "Een CSV versie van de kansen die bewerkt kan worden",
          "pdf": "Een PDF van de verhuurkansen met alle activiteit per object.",
          "title": "Verhuurkansen"
        }
      },
      "tabs": {
        "asset_leads": "Acquisitie",
        "assets": "Objecten",
        "dashboard": "Dashboard",
        "deals": "Verhuurkansen"
      }
    },
    "PortfolioInfo": {
      "companiesSelected": "%{value} bedrijven geselecteerd",
      "portfoliosSelected": "%{value} portfolios geselecteerd"
    },
    "PortfolioModal": {
      "delete": "Portfolio verwijderen",
      "nameLabel": "Naam",
      "statsUnitLabel": "Eenheid statistieken ",
      "titleAdd": "Portfolio toevoegen",
      "titleEdit": "Portfolio bewerken",
      "typeLabel": "Type"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisitie",
      "assets": "objecten",
      "available": "beschikbaar",
      "availableSpace": "Nu Beschikbaar",
      "deals": "Kansen",
      "onMarket": "on-market",
      "rentableArea": "Totaal"
    },
    "Proposal": {
      "accepted": "Contractvoorstel",
      "addPrice": "Prijs toevoegen",
      "addSpace": "+ voeg een ruimte toe",
      "asset": "",
      "billingPeriod": "Factureringsperiode",
      "breakDates": "Huuropzegtermijn",
      "breakTerm": "Huuropzegmogelijkheid na",
      "channelFee": "Makelaar",
      "commencementDate": "Startdatum",
      "contractLength": "Details Looptijd Contract",
      "costs": "Kosten",
      "deposit": "Huurgarantie",
      "dueDate": "Geldig tot",
      "expirationDate": "Vervaldag",
      "firstRefusalRight": "Pas \"right of first refusal\" toe",
      "legalFee": "Juridische kosten",
      "movingAllowance": "Vergoeding verhuiskosten",
      "negativeDiscount": "(%{percentage}% boven de prijs)",
      "ner": "Netto huur",
      "offeredBy": "Verstuurd door",
      "offering": "Verstuurd",
      "otherCosts": "Andere kost",
      "placeholder": "Voer uw notities hier in",
      "positiveDiscount": "(%{percentage}% korting)",
      "receivedBy": "Ontvangen door",
      "receiving": "Ontvangen",
      "renewalPeriod": "Verlengingsperiode",
      "rentFreePeriod": "Huurvrije periode",
      "term": "Termijn",
      "terms": "Financiële voorwaarden",
      "tiAllowance": "Budget verbeteringswerken",
      "token": "Kopieer de onderstaande URL om het voorstel met uw klant te delen"
    },
    "ProposalAcceptModal": {
      "accept": "Opvragen",
      "accepting": "Opvragen..",
      "commentPlaceholder": "Voer hier eventuele opmerkingen in",
      "header": "Vraag ontwerpovereenkomst aan"
    },
    "ProposalForm": {
      "deal": "Kans",
      "dealLabel": "Zoek naar bestaande of maak een nieuwe aan op naam"
    },
    "ProposalModal": {
      "title": "Voorstel toevoegen"
    },
    "ProposalPage": {
      "accept": "Ontwerpovereenkomst",
      "accepted": {
        "message": "Bedankt! %{name} wordt op de hoogte gebracht en neemt spoedig terug contact met u op.",
        "title": "Ontwerpovereenkomst opgevraagd!"
      },
      "proposalFor": "Voorstel voor",
      "proposalOn": "Voorstel op %{date}"
    },
    "RegionFilter": {
      "apply": "Toepassen",
      "region": "Regio",
      "tabs": {
        "region": "Per Regio"
      }
    },
    "ResetPassword": {
      "confirm_label": "Wachtwoord bevestiging",
      "confirm_placeholder": "Geef wachtwoord bevestiging",
      "current_label": "Huidig wachtwoord",
      "current_placeholder": "Geef huidig wachtwoord",
      "description": "Voer alle velden in om uw wachtwoord te veranderen.",
      "new_label": "Nieuw wachtwoord",
      "new_placeholder": "geef nieuw wachtwoord",
      "title": "Wachtwoord opnieuw instellen"
    },
    "SearchBlock": {
      "landlordsTitle": "Alle portfolios",
      "searchPortfolios": "Zoek portfolios",
      "selectAll": "Selecteer alle",
      "title": "Zoek op alle objecten",
      "unselectAll": "Deselecteer alle"
    },
    "SeeMore": {
      "seeMore": "Bekijk meer"
    },
    "SelectAll": {
      "clear": "Wissen",
      "selectAll": "Selecteer alle"
    },
    "Settings": {
      "Subscriptions": {
        "assetDigest": {
          "description": "Selecteer de gebouwen waarvan je per email een activiteitenrapport wenst te ontvangen. Deselecteer alles om je volledig uit te schrijven.",
          "title": "Email over gewijzigde beschikbaarheden"
        },
        "dealDigest": {
          "description": "Selecteer de portfolios waarvan je per email een overzicht van activiteit op kansen wenst te ontvangen. Deselecteer alles om je volledig uit te schrijven.",
          "title": "Overzicht per mail van activiteit op kansen"
        },
        "portfolio_deal": {
          "description": "U kan uw voorkeur selecteren voor standaard inschrijving op NIEUWE verhuurkansen. Selecteer de portefeuilles waarvoor u automatisch ingeschreven wil worden op de verhuurkansen:",
          "title": "Nieuwe kansen"
        },
        "unsubscribeDeals": {
          "body": "Uitschrijven van real-time updates op verhuurkansen?",
          "unsubscribe": ""
        }
      },
      "company": {
        "billing": {
          "billingInfo": "We hebben geen factuurgegevens gevonden die aan uw account zijn gekoppeld. Het kan zijn dat u ofwel geen betaald plan hebt, of dat we een fout hebben gemaakt.",
          "contact": "Neem contact met ons op om aan de slag te gaan",
          "manage": "Wijzig instellingen",
          "subscriptions": "U bent momenteel geabonneerd op:",
          "title": "Factureringsinformatie en instellingen",
          "total": "",
          "trial": "Uw account zit momenteel in de proefperiode (<strong>%{value} dagen resterend</strong>).",
          "vatExclusive": "%{value}, zonder BTW"
        },
        "branding": {
          "HeaderImageInfo": {
            "body": "The image you upload here will be shown in your company's <strong>weekly asset digest</strong> and the <strong>profile page</strong> of your company. For best results, we recommend uploading a high-resolution file. ",
            "header": "Header afbeelding"
          },
          "accentColor": "Accent kleur",
          "comapnyPageBlocks": {
            "contacts": "Show contacts",
            "dealForm": "Introduce client",
            "incentives": "Show auto-assigned incentives",
            "portfolios": "Show portfolios"
          },
          "companyPage": "Bedrijfsprofiel",
          "general": "Algemeen",
          "headerImage": "Header afbeelding",
          "headerImageOverlay": "Voeg een overlay toe over foto",
          "primaryColor": "Primair kleur",
          "slug": "Bedrijfspagina ID"
        },
        "details": {
          "address": "Adres",
          "city": "Stad",
          "country": "Land",
          "description": "Beschrijving",
          "email": "E-mail",
          "industry": "Industrie",
          "mobile": "Mobiel nummer",
          "name": "Naam",
          "phone": "Telefoon nummber",
          "tagline": "Slogan",
          "website": "Website",
          "zip": "Postcode"
        },
        "integrations": {
          "search": "Zoek in integraties..."
        },
        "settings": {
          "CompanyPageInfo": {
            "header": "Bedrijfspagina",
            "infoBody": "Een publiek profiel voor uw bedrijf die als <strong>landingspagina</strong> kan gebruikt worden tussen uzelf en uw partners. Als basis worden de contactgegevens en een overzicht van de portefeuilles getoond, waarna de partner via de pagina ook in kan loggen of toegang kan vragen of het op afgeschermde gedeelte van Rialto. Verder kan u ook de commissies en eventueel een FAQ sectie toevoegen.",
            "infoTitle": "Wat is de bedrijfspagina?",
            "linkBody": "U kan vanuit uw eigen websites altijd linken naar uw bedrijfspagina op ons platform. De pagina kan u vinden op <strong>onderstaande URL</strong>. \n<br /> <br />\nAls u wil kan u ook uw eigen domein gebruiken om de bedrijfspagina te tonen. Dit kan door een <strong>CNAME</strong> in te stellen bij uw domeinnaam provider met de onderstaande URL.",
            "linkTitle": "Aangepast domein",
            "linkToken": "Klik hier om de URL van uw aangepaste bedrijfspagina te kopiëren"
          },
          "accent": "Accent kleur",
          "branding": "Branding",
          "currency": "Valuta",
          "interface": "Interface",
          "language": "Taal",
          "primary": "Primair kleur",
          "regional": "Regionaal",
          "sizeUnit": "Oppervlakte eenheid",
          "slug": "Bedrijfspagina ID",
          "statsUnit": "Eenheid statistieken",
          "type": "Type"
        }
      },
      "delete": "Verwijderen",
      "deleting": "Verwijderen..",
      "incentives": {
        "add": "Voeg honorarium toe",
        "new": "Voeg nieuw toe",
        "none": "U hebt nog geen <strong>honoraria</strong>.",
        "search": "Zoek honorarium"
      },
      "menu": {
        "billing": "Facturatie",
        "branding": "Branding\n",
        "company": "Bedrijf",
        "details": "Bedrijfsgegevens",
        "incentives": "Honoraria",
        "integrations": "Integraties",
        "notifications": "Notificaties",
        "personal_details": "Persoonlijke gegevens",
        "profile": "Mijn profiel",
        "requests": "Verzoeken",
        "settings": "Instellingen",
        "team": "Team",
        "templates": "Sjablonen",
        "tos": "Servicevoorwaarden",
        "users": "Teamleden"
      },
      "profile": {
        "email_label": "Email",
        "fname_label": "Voornaam",
        "license_label": "Branchevereniging",
        "lname_label": "Achternaam",
        "mobile_label": "Mobiel nummer",
        "phone_label": "Telefoonnummer",
        "title_label": "Titel"
      },
      "save": "Opslaan",
      "saving": "Opslaan..",
      "settings": {
        "change_password": "Wijzig wachtwoord",
        "confirm_label": "Bevestig nieuw wachtwoord",
        "current_label": "Huidig wachtwoord",
        "delete": {
          "confirmDelete": "Weet je zeker dat je je account wilt verwijderen? Dit is PERMANENT en kan niet ongedaan worden gemaakt. U verliest toegang tot Rialto.",
          "title": "Account verwijderen",
          "warning": "Als u uw account verwijdert, worden al uw gegevens <strong>permanent</strong> verwijderd en is dit onomkeerbaar. U bent verantwoordelijk voor het overdragen van objecten en verhuurkansen waar u een contactpersoon bent. <br/> Na het verwijderen van uw account heeft u geen toegang meer tot Rialto en ontvangt u geen update e-mails meer van het platform.",
          "warning_account_holder": "U bent een <strong>beheerder</strong> voor uw huidige bedrijf. Voordat u uw account verwijdert, moet u eerst uw rol in teaminstellingen overdragen."
        },
        "language_label": "Taal",
        "locale": "Taalinstellingen",
        "new_label": "Nieuw wachtwoord",
        "password_empty_hint": "Laat de wachtwoord velden leeg indien u niet wenst uw wachtwoord te wijzigen.",
        "timezone_label": "Tijdzone"
      },
      "team": {
        "add": "Voeg gebruiker toe",
        "confirm": {
          "removeUser": "Weet u zeker dat u deze gebruiker wilt verwijderen? Als de gebruiker contactpersoon was op objecten of kansen, stel dan manueel iemand anders van je team in of contacteer Rialto om alle records aan te passen."
        },
        "edit": "Bewerk gebruiker",
        "remove": "Verwijder gebruiker",
        "requests": {
          "accept": "Accepteren",
          "active": "Actief",
          "empty": "Geen toegangsverzoeken",
          "reject": "Weigeren",
          "rejected": "Geweigerd"
        },
        "resend": "Verstuur uitnodiging opnieuw",
        "roles": {
          "account_holder": "Heeft volledige marketing-, verkoops- en administratierechten",
          "administrator": "Heeft volledige marketing- en verkoopsrechten",
          "internal_user": "Heeft volledige verkoopsrechten"
        },
        "search": "Zoek in gebruikers..."
      },
      "tos": {
        "add": "Voeg servicevoorwaarden toe",
        "edit": "Bewerken",
        "new": "Voeg nieuw toe",
        "none": "U hebt nog geen <strong>servicevoorwaarden</strong>.",
        "remove": "Verwijderen",
        "search": "Zoek servicevoorwaarden"
      }
    },
    "ShareStatusSelector": {
      "header": "Wie moet toegang krijgen?",
      "status": {
        "all": "Alle partners",
        "broker_owner_team": "Ik & mijn client",
        "broker_team_owner_team": "Mijn team & mijn client",
        "custom": "Aangepast",
        "owner_team": "Mijn team"
      }
    },
    "SignUp": {
      "brokerCompany": "Makelaarsbedrijf",
      "cancel": {
        "error": {
          "body": "U heeft uw account al geactiveerd",
          "title": "Uw e-mail kon niet bevestigd worden!"
        },
        "success": {
          "body": "U zal geen herinneringsmails meer ontvangen",
          "title": "Inschrijving geannuleerd!"
        }
      },
      "cancelBtn": "Annuleren",
      "company": {
        "createNew": "Kon je team niet vinden? <a href=\"%{link}\">Klik hier</a> om een eigen team aan te maken.",
        "details": "Vul hieronder de gegevens in om uw bedrijf op Rialto te registreren:",
        "name": "Bedrijfsnaam",
        "requestAccess": "Toegang vragen",
        "requestPending": "In aanvraag",
        "role": "Mijn bedrijf kan het best als volgt worden beschreven:",
        "roles": {
          "broker": "Ik ben een vastgoedmakelaar / online makelaar",
          "ownerFlex": "Ik ben een flex workspace / co-working operator",
          "ownerLeasing": "Ik ben een vastgoedeigenaar en / of heb een eigen leasing team"
        },
        "welcome": "Welkom bij Rialto, %{name}!\n<br />\n<br />\nDe volgende teams komen overeen met uw e-maildomein. Krijg toegang tot de jouwe."
      },
      "existingAccount": "Heb je al een account?",
      "getStarted": "Inschrijven",
      "linkedin_signup": "Registreer met LinkedIn",
      "submitted": "Welkom %{fname}!\n<br />\n<br />\nU ontvangt binnenkort een e-mail om uw e-mailadres te bevestigen. Hierna kan u ervoor kiezen <strong>een bestaand team te vervoegen</strong> of <strong> een nieuw team te maken</strong>.\n<br />\n<br />\n👉🏻 Geen e-mail ontvangen? Controleer zeker uw <strong>spam folder</strong>.\n<br />",
      "submittedCampaign": "Welkom %{fname}!\n<br />\n<br />\nU ontvangt binnenkort een e-mail om uw e-mailadres te bevestigen. Hierna kan u <strong>Rialto beginnen te gebruiken</strong>.",
      "tagline": "Welke processen ondersteunen de groei van de bezettingsgraad? <br />\nJij hebt erover nagedacht. Wij hebben het voor je gebouwd.",
      "title": "Schrijf je gratis in"
    },
    "Size": {
      "amount": "plaats",
      "amounts": "plaatsen",
      "m2": "m²",
      "square_foot": "ft²"
    },
    "SpaceCategory": {
      "residential": ""
    },
    "SpaceModal": {
      "title": "Nieuwe ruimte toevoegen"
    },
    "SpaceStatusDialog": {
      "body": "Bent u zeker dat u deze ruimte off-market wilt plaatsen? Makelaars zullen deze ruimte niet meer zien. Ze zal niet langer zichtbaar zijn op de objecten navigator of de flyers.",
      "confirm": "Plaats off-market",
      "notify": "Makelaars informeren dat de ruimte verhuurd is"
    },
    "SpacesTable": {
      "actions": {
        "delete": "Verwijderen",
        "duplicate": "Dupliceren",
        "edit": "Wijzigen",
        "setNotUnderOffer": "Niet langer in Optie",
        "setPrivate": "Plaats off-market",
        "setPublic": "Plaats on-market",
        "setUnderOffer": "Plaats in Optie"
      },
      "addPrice": "toevoegen",
      "assetDetailNoSpaces": "Geen ruimtes voor dit product, klik op <strong>Toevoegen</strong> rechts.",
      "availability": {
        "mobile": {
          "now": "Beschikbaar",
          "tbd": "TBD"
        },
        "now": "Beschikbaar",
        "tbd": "TBD"
      },
      "deals_associated": "%{smart_count} verhuurkans verwijst naar deze ruimte. |||| %{smart_count} verhuurkansen verwijzen naar deze ruimte.",
      "firstRefusalRight": "Right of first refusal",
      "form": {
        "titleAdd": "Ruimte toevoegen",
        "titleEdit": "Ruimte wijzigen"
      },
      "headers": {
        "availableFrom": "Beschikbaarheid",
        "category": "Type",
        "description": "Beschrijving",
        "edit": " ",
        "floor": "Vloer",
        "image": "",
        "inventory": "Aantal in Inventaris",
        "leaseholder": "Huurder",
        "leaseholders": "Huurder",
        "minContractLength": "Contractduur",
        "name": "Ruimte",
        "period": "Periode",
        "price": "Prijs",
        "size": "Grootte",
        "sizeUnit": "Eenheid",
        "status": "Status",
        "syncInfo": "",
        "unit": "Naam Ruimte"
      },
      "inventory": "Inventaris",
      "lxd": "LXD",
      "noSpaces": "Geen ruimtes beschikbaar voor dit object.",
      "periods": {
        "daily": {
          "one": "dag",
          "other": "dagen"
        },
        "hourly": {
          "one": "uur",
          "other": "uur"
        },
        "monthly": {
          "one": "maand",
          "other": "maanden"
        },
        "weekly": {
          "one": "week",
          "other": "weken"
        },
        "yearly": {
          "one": "jaar",
          "other": "jaar"
        }
      },
      "price": {
        "all_in": "Gemeenschappelijke kosten en onroerende voorheffing (excl. BTW) inbegrepen",
        "rate": "Belasting:",
        "rent": "Huur:",
        "service": "Gem. Kost.:",
        "undisclosed": "Op aanvraag"
      },
      "pricing": "Prijs",
      "private": "<strong>off</strong> market",
      "public": "<strong>on</strong> market",
      "removeSpace": "Wilt u deze ruimte permanent verwijderen? De ruimte zal verwijderd worden van verhuurkansen en voorstellen. De makelaars worden niet verwittigd.",
      "renewalPeriod": "Vernieuwing elke",
      "undefined": "Niet gekend",
      "under_offer": "In optie"
    },
    "StageProgress": {
      "selectStage": "Selecteer fase"
    },
    "Statistics": {
      "assetLeads": "Acquisitie |||| Acquisities",
      "totalSize": "totale vraag"
    },
    "StatusButton": {
      "disregard": "Verloren",
      "execute": "Gewonnen"
    },
    "SubmitButton": {
      "submit": "Plaatsen",
      "submitted": "Submitted!",
      "submitting": "Plaatsen.."
    },
    "SubscribeButton": {
      "subscribe": "Inschrijven",
      "subscribed": "Ingeschreven"
    },
    "TabbedFilter": {
      "apply": "Toepassen",
      "channel": "Oorsprong",
      "region": "Regio",
      "regionCategories": {
        "regions": "Per Regio"
      },
      "selected": "%{nb} geselecteerd"
    },
    "Table": {
      "headers": {
        "activity": "Activiteit",
        "asset": "Object",
        "assetSpaces": "Object",
        "asset_spaces": "Object",
        "assets": "Objecten",
        "budget": "Budget",
        "category": "Type",
        "channel": "Oorsprong",
        "closeDate": "Close Date",
        "comment": "Toelichting",
        "contact": "Contact",
        "currentSituation": "Huidige situatie",
        "date": "Datum",
        "description": "Extra informatie",
        "disregardComment": "Reden v. afvallen",
        "endDate": "Einddatum",
        "features": "Kenmerken",
        "feePotential": "Waarde kans",
        "fee_potential": "Waarde kans",
        "followUpDate": "Vervolgstap",
        "includeInReport": "In rapport",
        "location": "Zoekgebied",
        "name": "Naam",
        "nonProspectComment": "Toelichting / Vervolgstappen",
        "pointPerson": "Contactpersoon",
        "point_person": "Contactpersoon",
        "portfolio": "Portfolio",
        "potential": "Kans",
        "probability": "Kans",
        "prospectComment": "Opmerkingen",
        "shareStatus": "",
        "share_status": "",
        "size": "Grootte",
        "spaceCategories": "Categorie",
        "space_categories": "Categorie",
        "stage": "Fase",
        "startDate": "Startdatum",
        "start_date": "Startdatum",
        "tenant": "Huurder",
        "term": "Termijn",
        "type": "Type",
        "viewed": "Bezichtigd",
        "warning": " "
      },
      "noAsssetLeads": "Geen asset leads gevonden",
      "noDeals": "Geen verhuurkansen gevonden"
    },
    "TenantProfile": {
      "address": {
        "title": "Huidig adres"
      },
      "company": {
        "title": "Bedrijf"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "delete": "Weet u zeker dat u wilt verwijderen?"
      },
      "contacts": {
        "title": "Contacten"
      },
      "email": {
        "title": "E-mail"
      },
      "head_count": {
        "title": "Headcount"
      },
      "industry": {
        "title": "Industrie"
      },
      "leaseExpiration": {
        "title": "Vervaldatum"
      },
      "locale": "Taal",
      "mobile": {
        "title": "GSM"
      },
      "name": {
        "title": "Voor- en achternaam"
      },
      "phone": {
        "title": "Telefoon"
      },
      "position": {
        "title": "Positie"
      },
      "rentable_area": {
        "title": "Oppervlakte"
      },
      "title": "Huurdersprofiel"
    },
    "TenantRepresentative": {
      "actions": {
        "edit": "Wijzig",
        "unlink": "Ontkoppel"
      },
      "company": {
        "title": "Bedrijf"
      },
      "email": {
        "title": "E-mail"
      },
      "job_title": {
        "title": "Titel"
      },
      "name": {
        "title": "Voor- en achternaam"
      },
      "phone": {
        "title": "Telefoon"
      },
      "title": "Aanhuurmakelaar"
    },
    "TermsOfServiceForm": {
      "addTos": "Voeg servicevoorwaarden toe",
      "body": "Inhoud",
      "default": "Stel in als default: toon op jullie bedrijfsprofiel en wijs automatisch toe op nieuwe objecten",
      "defaultTosWarning": "Je kan slechts één servicevoorwaarde als standaard hebben. Als je verdergaat worden eventuele standaard servicevoorwaarden vervangen. Ben je zeker?",
      "file": "Bestand",
      "title": "Titel"
    },
    "Timestamp": {
      "original": "Feitelijke datum"
    },
    "TitledDate": {
      "title": "%{title} selecteren"
    },
    "TourButton": {
      "book": "Book a tour"
    },
    "UserConfirmModal": {
      "agreement": {
        "agree": "Akkoord",
        "description": "Hallo %{user}, u zal toegang krijgen tot Rialto nadat u uw account details heeft bevestigd.",
        "terms_description": "Door het invullen van dit bevestigingsformulier, bevestigt u dat u onze <a href=\"http://www.getrialto.com/terms\" target=\"_blank\">Terms of Service</a> en <a href=\"https://www.getrialto.com/privacy\" target=\"_blank\">Privacy Policy</a> heeft gelezen en geaccepteerd.",
        "title": "Bevestiging nodig"
      },
      "confirm": "Bevestigen",
      "confirming": "Bevestigen..",
      "details": {
        "description": "Controleer alstublieft uw details en bevestig uw account.",
        "title": "Profiel details"
      }
    },
    "UserDetails": {
      "inactive": "inactief"
    },
    "UserEdit": {
      "first_name": "Voornaam"
    },
    "ViewToggle": {
      "display": "Weergave"
    },
    "deal": {
      "space_categories": "Categorie"
    },
    "forms": {
      "picturePlaceholder": "Een foto uploaden"
    },
    "notifications": {
      "asset": {
        "delete": {
          "success": {
            "title": "Object verwijderd!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "U ontvangt zometeen een email",
            "title": "Uw portfolio wordt geëxporteerd"
          }
        },
        "requestFlyer": {
          "success": {
            "message": "Je kunt feedback van de asset manager verwachten per email.",
            "title": "Aanvraag met succes verzonden!"
          }
        }
      },
      "deal": {
        "delete": {
          "error": {
            "message": "Gelieve later opnieuw te proberen",
            "title": "Kans kon niet verwijderd worden!"
          },
          "success": {
            "title": "Kans verwijderd!"
          }
        },
        "duplicate": {
          "success": {
            "title": "Verhuurkans succesvol gedupliceerd!"
          }
        },
        "exportPdf": {
          "success": {
            "message": "U ontvangt zometeen een email",
            "title": "Kansen worden geëxporteerd"
          }
        },
        "renew": {
          "success": {
            "title": "Verhuurkans succesvol gedupliceerd!"
          }
        }
      },
      "defaultErrorTitle": "Er is een fout opgetreden!",
      "defaultInfoTitle": "Info",
      "notAuthenticated": {
        "message": "Gelieve opnieuw in te loggen",
        "title": "U bent niet geauthenticeerd"
      },
      "portfolio": {
        "delete": {
          "success": {
            "bodyDelete": "Alle bijhorende objecten en kansen werden verwijderd.",
            "bodyTransfer": "Alle bijhorende objecten en kansen werden overgezet.",
            "title": "Portfolio verwijderd!"
          }
        }
      },
      "subscriptions": {
        "update": {
          "success": {
            "body": "Uw wijzigingen worden onmiddellijk van kracht",
            "title": "Notificatie-instellingen opgeslagen!"
          }
        }
      },
      "user": {
        "brokerInvite": {
          "success": {
            "messageActive": "%{user} heeft nu toegang tot de geselecteerde objecten.",
            "messageNew": "%{user} zal toegang hebben tot de geselecteerde objecten na het accepteren van uw uitnodiging.",
            "title": "%{user} werd uitgenodigd!"
          }
        },
        "requestPasswordReset": {
          "success": {
            "message": "U zal snel een e-mail ontvangen met verdere instructies.",
            "title": "Nieuw wachtwoord aangevraagd!"
          }
        },
        "resetPassword": {
          "success": {
            "message": "Gebruik volgende keer dat je inlogt dit wachtwoord.",
            "title": "Wachtwoord gewijzigd!"
          }
        }
      }
    },
    "shared": {
      "add": "Toevoegen",
      "adding": "Toevoegen..",
      "address": "%{address} %{zip} %{city}",
      "amount": "Bedrag",
      "and": "en",
      "askInfo": "Vraag flyer",
      "asset": {
        "address": "Adres",
        "asset": "Object",
        "city": "Stad",
        "name": "Naam",
        "region": "Regio",
        "state": "Staat",
        "statuses": {
          "fully_let": "Verhuurd",
          "invite": "Op uitnodiging",
          "other": "Andere",
          "private": "Privaat",
          "public": "Open mandaat",
          "sold": "Verkocht"
        },
        "zip": "Postcode"
      },
      "assetCategories": {
        "hotel": "Hotel",
        "industrial": "Bedrijfsruimte",
        "land": "Grond",
        "multi_family": "Residentieel multi-family",
        "office": "Kantoorgebouw",
        "other_cat": "Andere",
        "residential": "Residentieel",
        "retail": "Retail",
        "warehouse": "Logistiek"
      },
      "assetLeadStages": {
        "closing": "Closing",
        "negotiating": "Negotiatie",
        "pitch": "Pitch",
        "prospect": "Prospect"
      },
      "assetLeads": "Acquisitie",
      "billingMethods": {
        "post": "betaling achteraf",
        "pre": "vooruitbetaling"
      },
      "budget": "Budget",
      "cancel": "Annuleren",
      "category": "Type",
      "channelCategories": {
        "email": "E-mail",
        "employee_referral": "Synergy",
        "leasing_agent": "Verhuurmakelaar",
        "listing_site": "Marktplaats",
        "online_broker": "Online Makelaar",
        "other_cat": "Overige",
        "phone": "Via telefoon",
        "referral": "Doorverwijzing",
        "social_media": "Social Media",
        "tenant_rep": "Aanhuurmakelaar",
        "unknown": "Niet gekend",
        "walk_in": "Walk-in",
        "website": "Website"
      },
      "closeDate": "Close Date",
      "company": "Bedrijf",
      "companyTypes": {
        "acquisition": "Acquisitie",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "confirm": {
        "cancel": "Weet u zeker dat u wilt annuleren? Alle wijzigingen gaan verloren.",
        "delete": "Weet je zeker dat je dit wilt verwijderen?"
      },
      "contactCategories": {
        "agent": "Makelaar",
        "asset_manager": "Asset Manager",
        "key_holder": "Sleutelhouder",
        "landlord": "Eigenaar",
        "other_cat": "Overige",
        "property_manager": "Property Manager",
        "tenant": "Huurder"
      },
      "copied": "Gekopieerd!",
      "copy": "Kopiëren",
      "copy_of": "Kopie van",
      "country": "Land",
      "deal": {
        "activity": "Activiteit",
        "asset": "Object",
        "assets": "Objecten",
        "budget": "Budget",
        "channel": "Oorsprong",
        "deal": "Kans",
        "fee_potential": "Waarde kans",
        "leaseBreakDates": "Huuropzegtermijnen",
        "leaseCommencementDate": "Startdatum lease",
        "leaseExpirationDate": "Vervaldatum lease",
        "location": "Locatie",
        "point_person": "Contactpersoon",
        "portfolio": "Portfolio",
        "probability": "Kans",
        "share_status": "Deel status",
        "size": "Grootte",
        "space_categories": "Categorie",
        "start_date": "Startdatum",
        "tenant": "Huurder",
        "term": "Termijn",
        "type": "Type"
      },
      "dealStages": {
        "delivery": "Oplevering",
        "execution": "Uitvoering",
        "finder": "Prospect",
        "inquiry": "Zoekvraag",
        "new": "Nieuw",
        "prospects": "Prospect",
        "signed_loi": "Overeenkomst",
        "touring": "Bezichtiging",
        "trading_proposal": "RFP/Voorstel"
      },
      "dealStatuses": {
        "active": "Actief",
        "all": "Alle",
        "dead": "Verloren",
        "executed": "Gewonnen"
      },
      "dealTypes": {
        "expansion": "Uitbreiding",
        "new": "Nieuw",
        "reduction": "Inkrimping",
        "renegotiation": "Heronderhandeling",
        "renewal": "Vernieuwing"
      },
      "deals": "Verhuurkansen",
      "default": "Standaard",
      "delete": "Verwijderen",
      "deletedUser": "Verwijderde Gebruiker",
      "deleting": "Verwijderen..",
      "disregard_outcomes": {
        "move": "Getekend voor concurrerend pand",
        "other_outcome": "Andere",
        "stay": "Huidig huurcontract verlengd",
        "unknown": "Onbekend"
      },
      "disregard_reasons": {
        "broker": "Informatieaanvraag makelaar",
        "duplicate_entry": "Dubbele invoer",
        "location": "Locatie",
        "other_reason": "Andere",
        "price": "Prijs",
        "quality": "Kwaliteit",
        "size": "Voorstelde ruimte(s) beantwoorden vraag niet",
        "tenant_unqualified": "Huurder niet geschikt",
        "timed_out": "Aanvraag verlopen",
        "unknown": "Onbekend"
      },
      "download": "Downloaden",
      "download_ics": "Toevoegen aan agenda",
      "edited": "Bewerkt",
      "email": "E-mail",
      "emptyText": {
        "assetDeal": "Selecteer eerst een object voor deze kans",
        "channels": "Voeg eerst bron(nen) toe op de kans pagina",
        "proposals": "Voeg eerst voorstel(len) toe op de kans pagina",
        "spaces": "Voeg eerst ruimte(s) toe aan het object",
        "spacesDeal": "Voeg eerst een object toe aan deze kans en/of ruimte(s) aan het object"
      },
      "endDate": "Einddatum",
      "errorTitle": "Er is een fout opgetreden!",
      "every": "Elke",
      "filter": "Filter",
      "flyer": "Flyer",
      "flyerContact": "Flyer contactpersoon",
      "footer": {
        "about": "Over Rialto",
        "blog": "Blog",
        "careers": "Jobs",
        "status": "Status",
        "terms": "Gebruiksvoorwaarden"
      },
      "formChangesPrompt": "U hebt data die nog niet opgeslaan is. Bent u zeker dat u naar een andere pagina wil gaan?",
      "free": "gratis",
      "from": "van",
      "fullName": "Voor- en achternaam",
      "in": "in",
      "industries": {
        "automobile": "Automobiel",
        "aviation": "Luchtvaart & toerisme",
        "banks": "Banken",
        "basic_resources": "Grondstoffen",
        "chemicals": "Chemie",
        "construction": "Bouw",
        "consumer_electronics": "Huishoudelectro",
        "culture": "Cultuur",
        "cw": {
          "automotive": "Automotive",
          "business_space": "Overige bedrijfsruimte",
          "cleanroom": "Cleanroom/Laboratorium",
          "datacenter": "Datacenter",
          "dc": "DC",
          "food": "Food",
          "high_tech": "High Tech/3D",
          "self_storage": "Self Storage",
          "sustainable_energy": "Sustainable/(Nieuwe) energie",
          "urban_logistics": "Urban Logistics/Cross Docks"
        },
        "education": "Onderwijs",
        "education_art": "Onderwijs & kunst",
        "entertainment": "Ontspanning",
        "financial_services": "Financiële diensten",
        "food": "FMCG - Voeding & drank",
        "healthcare": "Zorg & farmacie",
        "household_goods": "Persoonlijke- & huishoudartikelen",
        "industrial_goods": "Industriële goederen & diensten",
        "insurance": "Verzekeringen",
        "legal": "Juridisch",
        "luxury": "Mode, interieur & luxe",
        "media": "Media",
        "oil_gas": "Olie & gas",
        "other_cat": "Andere",
        "professional_services": "Professionele diensten",
        "public": "Publieke sector",
        "real_estate": "Vastgoed",
        "retail": "Retail",
        "sports_leisure": "Sport & vrije tijd",
        "technology": "Technologie",
        "telecommunications": "Telecom",
        "travel": "Toerisme & vrije tijd",
        "utilities": "Nutsvoorzieningen",
        "wellbeing": "Welzijn"
      },
      "industry": "Industrie",
      "integrationCategories": {
        "listing_site": "Marktplaats",
        "mail": "E-mail",
        "online_broker": "Online makelaar",
        "other_cat": "Andere",
        "property_management": "Vastgoedbeheer"
      },
      "language": "Taal",
      "languages": {
        "en": "English",
        "en-GB": "British English",
        "en-GB-acquisition": "British English",
        "en-GB-flex": "British English",
        "en-acquisition": "English",
        "en-flex": "English",
        "fr-FR": "Français",
        "fr-FR-acquisition": "Français",
        "fr-FR-flex": "Français",
        "nl-BE": "Nederlands (BE)",
        "nl-BE-acquisition": "Nederlands (BE)",
        "nl-BE-flex": "Nederlands (BE)",
        "nl-NL": "Nederlands (NL)",
        "nl-NL-acquisition": "Nederlands (NL)",
        "nl-NL-flex": "Nederlands (NL)"
      },
      "loading": "Laden..",
      "more": "meer",
      "name": "Naam",
      "ner": "Netto huur",
      "on": "op",
      "password": "Wachtwoord",
      "per": "per",
      "phone": "Telefoonnummer",
      "placeholder": "Voer hier uw tekst in",
      "placeholders": {
        "assets": "Selecteer één of meerdere objecten",
        "portfolios": "Selecteer een portfolio"
      },
      "pointPerson": "Contactpersoon",
      "portfolio": "Portfolio",
      "portfolioTypes": {
        "acquisition": "Acquisitie",
        "flex": "Flex",
        "leasing": "Leasing"
      },
      "potentials": {
        "above_average": "Bovengemiddeld",
        "average": "Gemiddeld",
        "high": "Hoog",
        "low": "Laag",
        "moderate": "Matig"
      },
      "private": "Privaat",
      "probability": "Kans",
      "proposal": "Contractvoorstel",
      "rofr": "ROFR",
      "rofr_full": "Right of first refusal",
      "roles": {
        "account_holder": "Eigenaar |||| Eigenaars",
        "administrator": "Administrator |||| Administrators",
        "internal_user": "Interne gebruiker |||| Interne gebruikers"
      },
      "save": "Opslaan",
      "saved": "Opgeslaan!",
      "saving": "Opslaan..",
      "search": "Zoeken",
      "search_placeholder": "Zoek...",
      "send": "Verzenden",
      "sending": "Verzenden..",
      "shareStatuses": {
        "all": "Alle partners",
        "broker_owner_team": "Ik & mijn client",
        "broker_team_owner_team": "Mijn team & mijn client",
        "custom": "Aangepast",
        "owner_team": "Mijn team"
      },
      "size": {
        "separator": "tot",
        "title": "Grootte"
      },
      "space": "Ruimte",
      "spaceCategories": {
        "archive": "Archief",
        "carParking": "Buitenparking",
        "car_parking": "Buitenparking",
        "coveredCarParking": "Overdekte parking",
        "covered_car_parking": "Overdekte parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Kavel",
        "leisure": "Vrije tijd",
        "logistical": "Logistieke ruimte",
        "meeting": "Meeting/Conferentie",
        "office": "Kantoor",
        "other": "Overig",
        "other_cat": "Overig",
        "outdoor_area": "Buitenterrein",
        "residential": "Residentieel",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Opslag"
      },
      "spaceStatuses": {
        "all": "Alle",
        "private": "Off market",
        "public": "On-market"
      },
      "spaces": "Ruimtes",
      "startDate": "Startdatum",
      "status": "Status",
      "systemEvents": {
        "asset_lead_add_contact": "Contact <i>%{contact}</i> toegevoegd door <i>%{actor}</i>",
        "asset_lead_create": "<i>%{creator}</i> heeft deze acquisitie toegevoegd",
        "asset_lead_stage_update": "<i>%{actor}</i> heeft de fase veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "asset_lead_status_update": "<i>%{actor}</i> heeft de status veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "deal_accept_proposal": "Ontwerpovereenkomst opgevraagd door <i>%{name}</i>",
        "deal_add_asset": "<i>%{actor}</i> heeft deze opportuniteit toegevoegd aan <i>%{asset}</i>",
        "deal_channel_add": "Bron <i>%{channel}</i> toegevoegd door <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> heeft deze kans toegevoegd aan <i>%{asset}</i>",
        "deal_create_no_asset": "<i>%{creator}</i> heeft deze kans toegevoegd",
        "deal_lease_cancel": "<i>%{actor}</i> heeft het huurcontract opgezegd",
        "deal_merge": "De kans werd samengevoegd met <i>%{after}</i> door <i>%{actor}</i>",
        "deal_point_person_change": "<i>%{creator}</i> veranderde de contactpersoon van <i>%{before}</i> naar <i>%{after}</i><i>",
        "deal_remove_asset": "Verhuurkans ontkoppeld van <i>%{asset}</i> door <i>%{actor}</i>",
        "deal_renewal": "<i>%{creator}</i> heeft kans <i>%{ancestor}</i> gedupliceerd voor vernieuwing",
        "deal_share_status_update": "De kans wordt nu gedeeld met <i>%{after}</i> door <i>%{actor}</i>",
        "deal_stage_update": "<i>%{actor}</i> heeft de fase veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "deal_status_update": "<i>%{actor}</i> heeft de status veranderd van <i>%{before}</i> naar <i>%{after}</i>",
        "deal_tenant_add": "<i>%{actor}</i> heeft <i>%{tenant}</i> toegevoegd als huurder",
        "deal_tenant_broker_add": "<i>%{actor}</i> heeft <i>%{tenant_rep}</i> toegevoegd als aanhuurmakelaar"
      },
      "to": "tot",
      "totalSize": "totale grootte",
      "undisclosed": "Niet meegedeeld",
      "units": {
        "CAD": "CAD",
        "CHF": "CHF",
        "DKK": "DKK",
        "EUR": "EUR",
        "GBP": "GBP",
        "NOK": "NOK",
        "SGD": "SGD",
        "USD": "USD",
        "amount": "plaats |||| plaatsen",
        "amount_desk": "werkpost |||| werkposten",
        "amount_person": "persoon |||| personen",
        "amount_room": "kamer |||| kamers",
        "daily": "dag |||| dagen",
        "desk": "werkpost |||| werkposten",
        "floor": "verdieping |||| verdiepingen",
        "ft²": "ft²",
        "hourly": "uur |||| uren",
        "m2": "m²",
        "monthly": "maand |||| maanden",
        "monthly_short": "m",
        "m²": "m²",
        "parking": "parking |||| parkings",
        "person": "persoon |||| personen",
        "room": "kamer |||| kamers",
        "space": "ruimte |||| ruimtes",
        "sqft": "ft²",
        "square_foot": "ft²",
        "units": "plaatsen",
        "weekly": "week |||| weken",
        "yearly": "jaar |||| jaren",
        "yearly_short": "jr"
      },
      "upload": "Upload bestand",
      "user": {
        "email": "E-mail",
        "fname": "Voornaam",
        "licenseNumber": "Branchevereniging",
        "lname": "Achternaam",
        "locale": "Taal",
        "mobile": "Mobiel nummer",
        "name": "Voor- en achternaam",
        "password": "Wachtwoord",
        "passwordConfirmation": "Wachtwoord bevestigen",
        "phone": "Telefoonnummer",
        "role": "Rol",
        "timezone": "Tijdzone",
        "title": "Titel"
      },
      "with": "met"
    },
    "spaces": {
      "category": "Categorie"
    }
  },
  "en-GB-flex": {
    "AssetCreateModal": {
      "description": "Fill in basic information on new product here. You can fill in more details later.",
      "title": "Add product"
    },
    "AssetSettings": {
      "actions": {
        "portfolio": {
          "information": "When you move this product to another portfolio, <strong>all enquiries</strong> with an association to that product in the current portfolio will be moved to the new portfolio too."
        }
      },
      "options": {
        "delete": {
          "confirm": "Are you sure you want to remove this product? This is irreversible!",
          "information": "If you wish to provide your agents more information on why the product was deleted, you can add <a href=%{link}>an announcement</a> or select a reason below.",
          "menuTitle": "Delete product",
          "title": "Delete product from location",
          "warning": "Removing this product will remove all its data and is <strong>irreversible</strong>. <br/> After deleting, your team members and brokers will be notified in next weeks digest. Afterwards, they will no longer have access and the product will be <strong>permanently</strong> removed."
        }
      },
      "status": {
        "descriptionFullyLet": "When set <strong>fully let</strong>, your product can only be accessed by you and your team",
        "descriptionPrivate": "When set <strong>private</strong>, your product can only be accessed by you and your team"
      }
    },
    "AssetStatistics": {
      "deals": "Enquiries"
    },
    "BrokerInviteForm": {
      "portfolioAssets": "Location & products"
    },
    "CompanyBlock": {
      "newPortfolio": "New location"
    },
    "CompanyTooltip": {
      "numberOfAssets": "%{smart_count} product |||| %{smart_count} products"
    },
    "DealCancel": {
      "cancelDate": "Date of cancellation",
      "title": "Cancel agreement"
    },
    "DealFilter": {
      "asset": "Product"
    },
    "DealForm": {
      "assets": {
        "info": "An equiry will be created per product selected. Mind the privacy settings on the bottom left before adding.",
        "title": "Product |||| Products"
      },
      "details": {
        "title": "Enquiry"
      },
      "save": "Add enquiry",
      "tenant": {
        "title": "Customer",
        "undisclose": "<strong>Do not</strong> disclose customer details"
      }
    },
    "DealModal": {
      "header": "Add new customer"
    },
    "DealsFilter": {
      "asset": "Product"
    },
    "DealsTable": {
      "export": {
        "title": "Interest Schedule"
      }
    },
    "EnquiryDetails": {
      "title": "Enquiry Details"
    },
    "EnquiryHeader": {
      "assignAsset": "Associate product",
      "modal": {
        "title": "Collaborators with access to the enquiry"
      },
      "title": "Enquiry"
    },
    "EnquiryModal": {
      "assets": {
        "title_pl": "Products"
      },
      "tenant": {
        "company": "Company"
      }
    },
    "ExportActions": {
      "assets": {
        "title": "Products and Spaces"
      }
    },
    "FlyerContactModal": {
      "info": "Your question will be sent to the contact person of this location"
    },
    "Intro": {
      "addButton": "<h3>Add enquiry, product or collaborator </h3>\nYou can add a new enquiry, product or collaborator by clicking here.",
      "assetActions": "<h3>Product actions</h3>\nWith these actions you can email (un)subscribe to an product and view the flyer when present.",
      "assetExport": "<h3>Export</h3>\nClick here to export the filtered list of products and spaces in the current portfolio as XLSX or PDF.",
      "assetFilter": "<h3>Search</h3>\nHere you can search the current location for products and assets that meet your criteria.",
      "assetInfo": "<h3>Product info</h3>\nBy hovering and / or clicking these icons, you can get more information about sharing settings, commissions as well as service charges and taxes of the product.",
      "assetList": "<h3>Products</h3>\nHere you can see an overview of all products on this location.",
      "associateAsset": "<h3>Associate product<h3>\nAfter associating a product to this enquiry, you will find this enquiry by filtering on the navigator. Also, you'll be able to associate spaces to this enquiry and/or make proposals for spaces on this product.",
      "dealDetail": "<h3>Enquiry detail</h3>\nOpen an enquiry in the list to find more details, share an update, add customer details, etc.",
      "dealDetails": "<h3>Specify requirements</h3>\nDefine detailed requirements the customer has.",
      "deals": "<h3>Deals</h3>Browse here to access the enquiries on this location.",
      "expandAsset": "<h3>View spaces</h3>\nClick here to see the list of spaces for this product.",
      "switchPortfolio": "<h3>Switch portfolios</h3>\nHere you can switch between all locations available to you as well as search all locations in one view.",
      "tenantDetails": "<h3> Specify customer details </h3>\nSave key company details of the customer."
    },
    "PortfolioActions": {
      "addAsset": "Product"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "Product",
        "deal": "Enquiry"
      },
      "export": {
        "assets": {
          "csv": "A CSV export of products on this location.",
          "pdf": "A PDF of products on this location.",
          "title": "Portfolio"
        },
        "deals": {
          "csv": "A XLSX version of the interest schedule that allows for editing.",
          "pdf": "A PDF version of the interest schedule with all activity per product.",
          "title": "Interest Schedule"
        }
      },
      "tabs": {
        "assets": "Products",
        "deals": "Enquiries"
      }
    },
    "PortfolioModal": {
      "titleAdd": "Add new Location"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "assets": "products",
      "deals": "Enquiries",
      "rentableArea": "Total"
    },
    "SearchBlock": {
      "title": "Search all products"
    },
    "Settings": {
      "Subscriptions": {
        "portfolio_deal": {
          "description": "You can select your preference for default subscription on NEW enquiries. Select the locations on which you want automatic enquiry subscriptions:"
        }
      },
      "profile": {
        "license_label": "RICS membership number"
      }
    },
    "SpacesTable": {
      "assetDetailNoSpaces": "No spaces for this product yet, click <strong>Add</strong> on the right.",
      "headers": {
        "leaseholders": "Customer",
        "price": "Price"
      },
      "noSpaces": "No available spaces for this product.",
      "price": {
        "rent": "Rent:"
      }
    },
    "Table": {
      "headers": {
        "asset": "Spaces & Products",
        "assetSpaces": "Spaces & Products",
        "asset_spaces": "Spaces & Products",
        "assets": "Spaces & Products",
        "endDate": "End Date",
        "startDate": "Start Date",
        "start_date": "Start Date",
        "tenant": "Customer"
      }
    },
    "TenantProfile": {
      "title": "Customer Profile"
    },
    "TermsOfServiceForm": {
      "default": "Set as default: show on company profile and auto-assigns to new products created"
    },
    "shared": {
      "deal": {
        "asset": "Spaces & Products",
        "assets": "Spaces & Products",
        "start_date": "Start Date",
        "tenant": "Customer"
      },
      "deals": "Enquiries",
      "emptyText": {
        "assetDeal": "First associate a product to this opportunity",
        "spaces": "First add space(s) to the product of this enquiry",
        "spacesDeal": "First associate a product to this enquiry and/or space(s) to its product"
      },
      "placeholders": {
        "assets": "Select one or more products"
      },
      "rofr": "Waiting List",
      "rofr_full": "Right of first refusal",
      "spaces": "units",
      "systemEvents": {
        "deal_lease_cancel": "<i>%{actor}</i> has cancelled the agreement"
      },
      "user": {
        "licenseNumber": "RICS membership number"
      }
    }
  },
  "en-flex": {
    "AssetCreateModal": {
      "description": "Fill in basic information on new product here. You can fill in more details later.",
      "title": "Add product"
    },
    "AssetSettings": {
      "actions": {
        "portfolio": {
          "information": "When you move this product to another portfolio, <strong>all opportunities</strong> with an association to that product in the current portfolio will be moved to the new portfolio too."
        }
      },
      "options": {
        "delete": {
          "confirm": "Are you sure you want to remove this product? This is irreversible!",
          "information": "If you wish to provide your brokers more information on why the product was deleted, you can add <a href=%{link}>an announcement</a> or select a reason below.",
          "menuTitle": "Delete product",
          "title": "Delete product from location",
          "warning": "Removing this product will remove all its data and is <strong>irreversible</strong>. <br/> After deleting, your team members and agents will be notified in next weeks digest. Afterwards, they will no longer have access and the product will be <strong>permanently</strong> removed."
        }
      },
      "status": {
        "descriptionFullyLet": "When set <strong>fully let</strong>, your product can only be accessed by you and your team",
        "descriptionPrivate": "When set <strong>private</strong>, your product can only be accessed by you and your team"
      }
    },
    "AssetStatistics": {
      "deals": "Opportunities"
    },
    "BrokerInviteForm": {
      "portfolioAssets": "Location & products"
    },
    "CompanyBlock": {
      "newPortfolio": "New location"
    },
    "CompanyTooltip": {
      "numberOfAssets": "%{smart_count} product |||| %{smart_count} products"
    },
    "DealCancel": {
      "cancelDate": "Date of cancellation",
      "title": "Cancel agreement"
    },
    "DealForm": {
      "assets": {
        "info": "An opportunity will be created per product selected. Mind the privacy settings on the bottom left before adding.",
        "title": "Product |||| Products"
      },
      "details": {
        "title": "Opportunity"
      },
      "save": "Add opportunity",
      "tenant": {
        "title": "Customer",
        "undisclose": "<strong>Do not</strong> disclose customer details"
      }
    },
    "DealModal": {
      "header": "Add new customer"
    },
    "DealsFilter": {
      "asset": "Product"
    },
    "DealsTable": {
      "export": {
        "title": "Interest Schedule"
      }
    },
    "EnquiryDetails": {
      "title": "Opportunity Details"
    },
    "EnquiryHeader": {
      "assignAsset": "Associate product",
      "modal": {
        "title": "Collaborators with access to the opportunity"
      },
      "title": "Opportunity"
    },
    "EnquiryModal": {
      "assets": {
        "title_pl": "Products"
      },
      "tenant": {
        "company": "Company"
      }
    },
    "ExportActions": {
      "assets": {
        "title": "Products and Spaces"
      }
    },
    "FlyerContactModal": {
      "info": "Your question will be sent to the contact person of this location"
    },
    "Intro": {
      "addButton": "<h3>Add opportunity, product or collaborator</h3>\nYou can add a new opportunity, product or collaborator by clicking here.",
      "assetActions": "<h3>Product actions</h3>\nWith these actions you can email (un)subscribe to a product and view the product flyer when present.",
      "assetExport": "<h3>Export</h3>\nClick here to export the filtered list of products and spaces in the current location as XLSX or PDF.",
      "assetFilter": "<h3>Search</h3>\nHere you can search the current location for products and spaces that meet your criteria.",
      "assetInfo": "<h3>Product info</h3>\nBy hovering and / or clicking these icons, you can get more information about sharing settings, commissions as well as service charges and taxes of the product.",
      "assetList": "<h3>Products</h3>\nHere you can see an overview of all products on this loation.",
      "associateAsset": "<h3>Associate asset</h3>\nAfter associating a product to this opportunity, you will find this opportunity by filtering on the navigator. Also, you'll be able to associate spaces to this opportunity and/or make proposals for spaces on this product.",
      "dealDetail": "<h3>Opportunity detail</h3>\nOpen an opportunity in the list to find more details, share an update, add customer details, etc.",
      "dealDetails": "<h3>Specify requirements</h3>\nDefine detailed requirements the customer has.",
      "deals": "<h3>Opportunities</h3>Browse here to access the opportunities on this location.",
      "expandAsset": "<h3>View spaces</h3>\nClick here to see the list of spaces for this product.",
      "switchPortfolio": "<h3>Switch locations</h3>\nHere you can switch between all locations available to you as well as search all locations in one view.",
      "tenantDetails": "<h3>Specify customer details </h3>\nSave key company details of the customer."
    },
    "PortfolioActions": {
      "addAsset": "Product"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "Product",
        "deal": "Opportunity"
      },
      "export": {
        "assets": {
          "csv": "A CSV export of products on this location.",
          "pdf": "A PDF of products on this location.",
          "title": "Portfolio"
        },
        "deals": {
          "csv": "A XLSX version of the interest schedule that allows for editing.",
          "pdf": "A PDF version of the opportunities schedule with all activity per product.",
          "title": "Opportunities"
        }
      },
      "tabs": {
        "assets": "Products",
        "deals": "Opportunities"
      }
    },
    "PortfolioModal": {
      "titleAdd": "Add new Location"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "assets": "products",
      "deals": "Opportunities",
      "rentableArea": "Total"
    },
    "SearchBlock": {
      "title": "Search all products"
    },
    "Settings": {
      "profile": {
        "license_label": "RICS membership number"
      }
    },
    "SpacesTable": {
      "assetDetailNoSpaces": "No spaces for this product yet, click <strong>Add</strong> on the right.",
      "headers": {
        "leaseholders": "Customer",
        "price": "Price"
      },
      "noSpaces": "No available spaces for this product.",
      "price": {
        "rent": "Rent:"
      }
    },
    "Table": {
      "headers": {
        "asset": "Products & Spaces",
        "assetSpaces": "Products & Spaces",
        "asset_spaces": "Products & Spaces",
        "assets": "Products & Spaces",
        "endDate": "End Date",
        "startDate": "Start Date",
        "start_date": "Start Date",
        "tenant": "Customer"
      }
    },
    "TenantProfile": {
      "title": "Customer Profile"
    },
    "TermsOfServiceForm": {
      "default": "Set as default: show on company profile and auto-assigns to new products created"
    },
    "shared": {
      "deal": {
        "asset": "Products & Spaces",
        "assets": "Products & Spaces",
        "start_date": "Start Date",
        "tenant": "Customer"
      },
      "deals": "Opportunities",
      "emptyText": {
        "assetDeal": "First associate a product to this opportunity",
        "spaces": "First add space(s) to the product of this opportunity",
        "spacesDeal": "First associate a product to this opportunity and/or space(s) to its product"
      },
      "placeholders": {
        "assets": "Select one or more products"
      },
      "rofr": "Waiting List",
      "rofr_full": "Waiting List",
      "spaces": "units",
      "systemEvents": {
        "deal_lease_cancel": "<i>%{actor}</i> has cancelled the agreement"
      },
      "user": {
        "licenseNumber": "RICS membership number"
      }
    }
  },
  "fr-FR-flex": {
    "AssetSettings": {
      "actions": {
        "portfolio": {
          "information": "Lorsque vous transférez ce produit dans un autre portefeuille, toutes les <strong>demandes</strong> associées à ce produit du portefeuille actuel seront également transférées dans le nouveau portefeuille."
        }
      },
      "options": {
        "delete": {
          "confirm": "Êtes-vous sûr de vouloir supprimer ce produit? C'est irréversible!",
          "information": "Si vous souhaitez fournir à vos courtiers plus d'informations sur les raisons pour lesquelles le produit a été supprimé, vous pouvez ajouter <a href=%{link}>une annonce</a> ou sélectionner une raison ci-dessous.",
          "menuTitle": "Supprimer le produit",
          "title": "Supprimer le produit du portefeuille",
          "warning": "La suppression du produit supprime toutes ses données et est <strong>irréversible</strong>. <br/> Après la suppression, les membres de votre équipe et les courtiers seront avertis dans le résumé de la semaine prochaine. Ensuite, ils n'auront plus accès et le produit sera <strong>définitivement</strong> supprimé."
        }
      }
    },
    "BrokerInviteForm": {
      "portfolioAssets": "Portefeuille & produits"
    },
    "CompanyTooltip": {
      "numberOfAssets": "%{smart_count} produit |||| %{smart_count} produits"
    },
    "DealCancel": {
      "cancelDate": "Date d'annulation",
      "title": "Annuler l'accord"
    },
    "DealFilter": {
      "asset": "Produit"
    },
    "DealForm": {
      "assets": {
        "title": "Produit |||| Produits"
      }
    },
    "EnquiryModal": {
      "assets": {
        "title_pl": "Produits"
      }
    },
    "ExportActions": {
      "assets": {
        "title": "Produits et Espaces"
      }
    },
    "FlyerContactModal": {
      "info": "Votre question sera envoyée à la personne de contact de ce produit"
    },
    "Intro": {
      "associateAsset": "<h3>Connecter produit</h3>\nIci, vous pouvez connecter un produit et utilisez les informations d'espace."
    },
    "PortfolioActions": {
      "addAsset": "Produit"
    },
    "PortfolioHeader": {
      "tabs": {
        "assets": "Produits"
      }
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "assets": "produits"
    },
    "SearchBlock": {
      "title": "Rechercher tous les produits"
    },
    "TermsOfServiceForm": {
      "default": "Défaut: afficher sur le profil de la société et attribuer automatiquement aux nouveaux produits crées"
    },
    "shared": {
      "deal": {
        "tenant": "Client"
      },
      "emptyText": {
        "spacesDeal": "Premièrement ajouter un produit à cette demande et/ou espace(s) à ce produit"
      },
      "placeholders": {
        "assets": "Selectionner un ou plusieur produits"
      },
      "systemEvents": {
        "deal_lease_cancel": "<i>%{actor}</i> a terminé l'accord"
      }
    }
  },
  "nl-BE-flex": {
    "AssetCreateModal": {
      "description": "Vul hier basis informatie in over het nieuwe product. U kan later meer details toevoegen.",
      "title": "Voeg product toe."
    },
    "AssetSettings": {
      "actions": {
        "portfolio": {
          "information": "Wanneer u dit product naar een andere portefeuille verplaatst, worden <strong>alle opportuniteiten</strong> voor dit product ook overgezet naar de nieuwe portefeuille."
        }
      },
      "options": {
        "delete": {
          "confirm": "Weet je zeker dat je dit product wilt verwijderen? Dit is onomkeerbaar!",
          "information": "Als u uw makelaars meer informatie wilt geven over waarom het product verwijderd is, kunt u <a href=%{link}>een mededeling</a> toevoegen of hieronder een reden selecteren.",
          "menuTitle": "Product verwijderen",
          "title": "Verwijder product uit locatie",
          "warning": "Als u dit product verwijdert, worden alle gegevens verwijderd. <br/> Na het verwijderen worden uw teamleden en makelaars in het wekelijks overzicht op de hoogte gebracht. Nadien hebben ze geen toegang meer en wordt het product <strong>permanent</strong> verwijderd."
        }
      },
      "status": {
        "descriptionFullyLet": "Wanneer de status <strong>volledig verhuurd</strong> is, is het product enkel toegankelijk voor u en uw team",
        "descriptionPrivate": "Wanneer de status <strong>privaat</strong> is, is het product enkel toegankelijk voor u en uw team"
      }
    },
    "AssetStatistics": {
      "deals": "Opportuniteiten"
    },
    "BrokerInviteForm": {
      "portfolioAssets": "Locatie & producten"
    },
    "CompanyBlock": {
      "newPortfolio": "Nieuwe locatie"
    },
    "DealCancel": {
      "cancelDate": "Opzegdatum",
      "title": "Zeg akkoord op"
    },
    "DealFilter": {
      "asset": "Product"
    },
    "DealForm": {
      "assets": {
        "info": "Een opportuniteit wordt aangemaakt per product geselecteerd. Kies links onderaan of u de gegevens al dan niet wenst te delen met overige teamleden.",
        "title": "Product |||| Producten"
      },
      "details": {
        "title": "Opportuniteit"
      },
      "save": "Toevoegen",
      "tenant": {
        "title": "Klant",
        "undisclose": "Naam klant <strong>niet vrijgeven</strong>"
      }
    },
    "DealModal": {
      "header": "Nieuwe klant"
    },
    "DealsFilter": {
      "asset": "Product"
    },
    "DealsTable": {
      "export": {
        "title": "Opportuniteitenlijst"
      }
    },
    "EnquiryDetails": {
      "title": "Details van de opportuniteit"
    },
    "EnquiryHeader": {
      "assignAsset": "Associeer een product",
      "modal": {
        "title": "Partners met toegang tot opportuniteit"
      },
      "title": "Opportuniteit"
    },
    "EnquiryModal": {
      "assets": {
        "title_pl": "Producten"
      },
      "tenant": {
        "company": "Bedrijf"
      }
    },
    "ExportActions": {
      "assets": {
        "title": "Producten en Ruimtes"
      }
    },
    "FlyerContactModal": {
      "info": "Uw vraag wordt naar de contactpersoon van dit product gestuurd"
    },
    "Intro": {
      "addButton": "<h3>Opportuniteit, product of partner toevoegen</h3>\nU kunt een nieuwe opportuniteit, product of partner toevoegen door hier te klikken.",
      "assetActions": "<h3>Acties</h3>\nMet deze acties kunt in- of uitschrijven op emails over een product en de flyer bekijken",
      "assetExport": "<h3>Export</h3>\nKlik hier om de lijst van producten en ruimtes, eventueel na toepassen van filter, in het huidige portfolio als XLSX of PDF te exporteren.",
      "assetFilter": "<h3>Zoeken</h3>\nHier kunt u in het huidige locatie zoeken naar producten en ruimtes die aan uw criteria voldoen.",
      "assetInfo": "<h3>Product informatie</h3>\nDoor te klikken op één van de icoontjes, kunt u meer informatie krijgen over de deelinstellingen, commissies en kosten van het product.",
      "assetList": "<h3>Producten</h3>\nHier krijgt u een overzicht van alle producten op deze locatie.",
      "associateAsset": "<h3>Pand koppelen</h3>\nNadat u een product aan deze opportuniteit heeft gekoppeld, kunt u ernaar filteren op de navigator. U kunt nu ook ruimtes aan deze opportuniteit koppelen en / of voorstellen maken voor ruimtes van dit pand.",
      "dealDetail": "<h3>Opportuniteit detailpagina</h3>\nOpen een opportuniteit in de lijst om verdere details te raadplegen, klantgegevens toe te voegen, een update te delen, etc.",
      "dealDetails": "<h3>Specificeer vereisten</h3>\nVerduidelijk waarnaar de klant zoekt.",
      "deals": "<h3>Deals</h3>Browse hier om de opportuniteiten voor deze locatie te raadplegen",
      "expandAsset": "<h3>Ruimtes tonen</h3>\nKlik hier om de ruimtes van dit product te bekijken.",
      "switchPortfolio": "<h3>Veranderen van portfolio</h3>\nHier kan u wisselen tussen alle locaties waar u toegang tot heeft alsook zoeken op alle locaties in 1 lijst.",
      "tenantDetails": "<h3> Gegevens huurder bewaren </ h3>\nBewaar bedrijfsinformatie van uw klant."
    },
    "PortfolioActions": {
      "addAsset": "Product"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "Product",
        "deal": "Opportuniteit"
      },
      "export": {
        "assets": {
          "csv": "Een CSV export van producten op deze locatie.",
          "pdf": "Een PDF export van producten op deze locatie.",
          "title": "Porfolio"
        },
        "deals": {
          "csv": "Een XLSX versie van de opportuniteitenlijst die bewerken kan worden.",
          "pdf": "Een PDF van de opportuniteitenlijst met alle activiteit per product.",
          "title": "Opportuniteitenlijst"
        }
      },
      "tabs": {
        "assets": "Producten",
        "deals": "Opportuniteiten"
      }
    },
    "PortfolioModal": {
      "titleAdd": "Locatie toevoegen"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisitie",
      "assets": "producten",
      "deals": "Opportuniteiten",
      "rentableArea": "Totaal"
    },
    "SearchBlock": {
      "title": "Zoek op alle producten"
    },
    "Settings": {
      "Subscriptions": {
        "unsubscribeDeals": {
          "unsubscribe": "Verwijder alle bestaande email subscriptions voor uit te schrijven locaties"
        }
      },
      "company": {
        "billing": {
          "total": "Het volgende factuurbedrag is %{total} (incl. btw indien toepasselijk) en wordt gefactureerd %{date}"
        }
      }
    },
    "SpacesTable": {
      "assetDetailNoSpaces": "Geen ruimtes voor dit product, klik op <strong>Toevoegen</strong> rechts.",
      "headers": {
        "leaseholders": "Klant",
        "price": "Prijs"
      },
      "noSpaces": "Geen ruimtes beschikbaar voor dit product.",
      "price": {
        "rent": "Huur:"
      }
    },
    "Table": {
      "headers": {
        "asset": "Producten & ruimtes",
        "assetSpaces": "Producten & ruimtes",
        "asset_spaces": "Producten & ruimtes",
        "assets": "Producten & ruimtes",
        "startDate": "Startdatum",
        "start_date": "Startdatum",
        "tenant": "Klant"
      }
    },
    "TenantProfile": {
      "title": "Klantprofiel"
    },
    "TermsOfServiceForm": {
      "default": "Stel in als default: toon op jullie bedrijfsprofiel en wijs automatisch toe op nieuwe producten"
    },
    "shared": {
      "deal": {
        "asset": "Producten & ruimtes",
        "assets": "Producten & ruimtes",
        "start_date": "Startdatum",
        "tenant": "Klant"
      },
      "dealStages": {
        "finder": "Prospect"
      },
      "deals": "Opportuniteiten",
      "emptyText": {
        "assetDeal": "Selecteer eerst een product voor deze opportuniteit",
        "spaces": "Voeg eerst ruimte(s) toe aan het product",
        "spacesDeal": "Voeg eerst een product toe aan deze opportuniteit en/of ruimte(s) aan het product"
      },
      "placeholders": {
        "assets": "Selecteer één of meerdere producten"
      },
      "rofr": "Wachtlijst",
      "rofr_full": "Wachtlijst",
      "spaces": "ruimtes",
      "systemEvents": {
        "deal_lease_cancel": "<i>%{actor}</i> heeft de overeenkomst opgezegd"
      }
    }
  },
  "nl-NL-flex": {
    "AssetCreateModal": {
      "description": "Vul hier basis informatie in over het nieuwe product. U kan later meer details toevoegen.",
      "title": "Voeg product toe."
    },
    "AssetSettings": {
      "actions": {
        "portfolio": {
          "information": "Wanneer u dit product naar een andere portefeuille verplaatst, worden <strong>alle kansen</strong> voor dit product ook overgezet naar de nieuwe portefeuille."
        }
      },
      "options": {
        "delete": {
          "confirm": "Weet je zeker dat je dit product wilt verwijderen? Dit is onomkeerbaar!",
          "information": "Als u uw makelaars meer informatie wilt geven over waarom het product verwijderd is, kunt u <a href=%{link}>een mededeling</a> toevoegen of hieronder een reden selecteren.",
          "menuTitle": "Product verwijderen",
          "title": "Verwijder product uit locatie",
          "warning": "Als u dit product verwijdert, worden alle gegevens verwijderd. <br/> Na het verwijderen worden uw teamleden en makelaars in het wekelijks overzicht op de hoogte gebracht. Nadien hebben ze geen toegang meer en wordt het product <strong>permanent</strong> verwijderd."
        }
      },
      "status": {
        "descriptionFullyLet": "Wanneer de status <strong>volledig verhuurd</strong> is, is het product enkel toegankelijk voor u en uw team",
        "descriptionPrivate": "Wanneer de status <strong>privaat</strong> is, is het product enkel toegankelijk voor u en uw team"
      }
    },
    "AssetStatistics": {
      "deals": "Kansen"
    },
    "BrokerInviteForm": {
      "portfolioAssets": "Locatie & producten"
    },
    "CompanyBlock": {
      "newPortfolio": "Nieuwe locatie"
    },
    "CompanyTooltip": {
      "numberOfAssets": "%{smart_count} product |||| %{smart_count} producten"
    },
    "DealCancel": {
      "cancelDate": "Opzegdatum",
      "title": "Zeg akkoord op"
    },
    "DealFilter": {
      "asset": "Product"
    },
    "DealForm": {
      "assets": {
        "info": "Een kans wordt aangemaakt per product geselecteerd. Kies links onderaan of u de gegevens al dan niet wenst te delen met overige teamleden vooraleer ze toe te voegen.",
        "title": "Product |||| Producten"
      },
      "details": {
        "title": "Kans"
      },
      "save": "Toevoegen",
      "tenant": {
        "title": "Klant",
        "undisclose": "Klant <strong>niet vrijgeven</strong>"
      }
    },
    "DealModal": {
      "header": "Nieuwe klant"
    },
    "DealsFilter": {
      "asset": "Product"
    },
    "DealsTable": {
      "export": {
        "title": "Kansenlijst"
      }
    },
    "EnquiryDetails": {
      "title": "Details van de kans"
    },
    "EnquiryHeader": {
      "assignAsset": "Link een product",
      "modal": {
        "title": "Partners met toegang tot kans"
      },
      "title": "Kans"
    },
    "EnquiryModal": {
      "assets": {
        "title_pl": "Producten"
      },
      "tenant": {
        "company": "Bedrijf"
      }
    },
    "ExportActions": {
      "assets": {
        "title": "Producten en Ruimtes"
      }
    },
    "FlyerContactModal": {
      "info": "Uw vraag wordt naar de contactpersoon van dit product gestuurd"
    },
    "Intro": {
      "addButton": "<h3>Kans, product of partner toevoegen</h3>\nU kunt een nieuwe kans, product of partner toevoegen door hier te klikken.",
      "addButtonBroker": "<h3>Kans of contractvoorstel toevoegen</h3>\nU kunt een nieuwe kans of contractvoorstel toevoegen door hier te klikken.",
      "assetActions": "<h3>Acties</h3>\nMet deze acties kunt in- of uitschrijven op emails over een product en de flyer bekijken",
      "assetExport": "<h3>Export</h3>\nKlik hier om de lijst van producten en ruimtes, eventueel na toepassen van filter, in het huidige portfolio als XLSX of PDF te exporteren.",
      "assetFilter": "<h3>Zoeken</h3>\nHier kunt u in het huidige portfolio zoeken naar producten en ruimtes die aan uw criteria voldoen.",
      "assetInfo": "<h3>Product informatie</h3>\nDoor te klikken op één van de icoontjes, kunt u meer informatie krijgen over de deelinstellingen, commissies en kosten van het product.",
      "assetList": "<h3>Producten</h3>\nHier krijgt u een overzicht van alle producten op deze locatie.",
      "associateAsset": "<h3>Product verbinden</h3>\nNadat u een product aan deze kans heeft gekoppeld, kunt u ernaar filteren op de navigator. U kunt nu ook ruimtes aan deze kans koppelen en / of voorstellen maken voor ruimtes van dit product.",
      "dealDetail": "<h3>Verhuurkans detailpagina</h3>\nOpen een verhuurkans in de lijst om verdere details te raadplegen, klantgegevens toe te voegen, een update te delen, etc.",
      "dealDetails": "<h3>Specificeer vereisten</h3>\nVerduidelijk waarnaar de klant zoekt.",
      "deals": "<h3>Deals</h3>Browse hier om de kansen voor deze locatie te raadplegen",
      "expandAsset": "<h3>Ruimtes tonen</h3>\nKlik hier om ruimtes van dit product te bekijken.",
      "switchPortfolio": "<h3>Veranderen van portfolio</h3>\nHier kan u wisselen tussen alle locaties waar u toegang tot heeft alsook zoeken op alle locaties in 1 lijst.",
      "tenantDetails": "<h3> Bewaar bedrijfsprofiel</ h3>\nBewaar bedrijfsinformatie van uw klant."
    },
    "PortfolioActions": {
      "addAsset": "Product"
    },
    "PortfolioHeader": {
      "add": {
        "asset": "Product",
        "deal": "Kans"
      },
      "export": {
        "assets": {
          "csv": "Een CSV export van producten op deze locatie.",
          "pdf": "Een PDF export van producten op deze locatie.",
          "title": "Portfolio"
        },
        "deals": {
          "csv": "Een XLSX versie van de kansen die bewerkt kan worden",
          "pdf": "Een PDF van de verhuurkansen met alle activiteit per product.",
          "title": "Kansen"
        }
      },
      "tabs": {
        "assets": "Producten",
        "deals": "Kansen"
      }
    },
    "PortfolioModal": {
      "titleAdd": "Locatie toevoegen"
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisitie",
      "assets": "producten",
      "deals": "Kansen",
      "rentableArea": "Totaal"
    },
    "SearchBlock": {
      "title": "Zoek op alle producten"
    },
    "Settings": {
      "Subscriptions": {
        "portfolio_deal": {
          "description": "U kan uw voorkeur selecteren voor standaard inschrijving op NIEUWE verhuurkansen. Selecteer de locaties waarvoor u automatisch ingeschreven wil worden op de verhuurkansen:"
        },
        "unsubscribeDeals": {
          "unsubscribe": "Verwijder alle bestaande email subscriptions voor uit te schrijven locaties"
        }
      }
    },
    "SpacesTable": {
      "assetDetailNoSpaces": "Geen ruimtes voor dit product, klik op <strong>Toevoegen</strong> rechts.",
      "headers": {
        "leaseholders": "Klant",
        "price": "Prijs"
      },
      "noSpaces": "Geen ruimtes beschikbaar voor dit product.",
      "price": {
        "rent": "Huur:"
      }
    },
    "Table": {
      "headers": {
        "asset": "Producten & kamers",
        "assetSpaces": "Producten & kamers",
        "asset_spaces": "Producten & kamers",
        "assets": "Producten & kamers",
        "startDate": "Startdatum",
        "start_date": "Startdatum",
        "tenant": "Klant"
      }
    },
    "TenantProfile": {
      "title": "Klantprofiel"
    },
    "TermsOfServiceForm": {
      "default": "Stel in als default: toon op jullie bedrijfsprofiel en wijs automatisch toe op nieuwe producten"
    },
    "shared": {
      "deal": {
        "asset": "Producten & kamers",
        "assets": "Producten & kamers",
        "start_date": "Startdatum",
        "tenant": "Klant"
      },
      "dealStages": {
        "finder": "Prospect"
      },
      "deals": "Kansen",
      "emptyText": {
        "assetDeal": "Selecteer eerst een product voor deze kans",
        "spaces": "Voeg eerst ruimte(s) toe aan het product",
        "spacesDeal": "Voeg eerst een product toe aan deze kans en/of ruimte(s) aan het product"
      },
      "placeholders": {
        "assets": "Selecteer één of meerdere producten"
      },
      "rofr": "Wachtlijst",
      "rofr_full": "Wachtlijst",
      "spaces": "ruimtes",
      "systemEvents": {
        "deal_lease_cancel": "<i>%{actor}</i> heeft de overeenkomst opgezegd"
      }
    }
  },
  "en-acquisition": {
    "ActivityFeed": {
      "empty_viewings": "No meetings.",
      "filters": {
        "viewing": "Meetings"
      },
      "header": {
        "viewing": "Meeting"
      }
    },
    "AddActions": {
      "addDeal": "Deal"
    },
    "AssetStatistics": {
      "deals": "Deals",
      "viewings": "Meetings"
    },
    "Channels": {
      "title": "Advisors"
    },
    "DealActions": {
      "delete": {
        "confirm": "Are you sure you want to permanently delete this deal? Comments will also be removed."
      },
      "duplicate": {
        "tooltip": "Duplicate"
      }
    },
    "DealCancel": {
      "cancelDate": "Date of cancellation",
      "title": "Cancel agreement"
    },
    "DealDetail": {
      "confirmDelete": "Are you sure you want to permanently delete this deal? Comments will also be removed."
    },
    "DealForm": {
      "assets": {
        "info": "Mind the privacy settings on the bottom left before adding.",
        "title": "Asset |||| Assets"
      },
      "channel": {
        "expand": "Add <strong>originator</strong> details",
        "title": "Advisor"
      },
      "enquiry": {
        "title": "Deal"
      },
      "save": "Add ",
      "tenant": {
        "title": "Company details",
        "undisclose": "<strong>Do not</strong> disclose the company details"
      }
    },
    "DealModal": {
      "header": "Add new deal"
    },
    "DealsFilter": {
      "channel": "Advisors"
    },
    "DealsTable": {
      "empty": "No deals found",
      "empty_stage": "No deals found in the current phase",
      "export": {
        "title": "Deal Export"
      }
    },
    "EnquiryDetails": {
      "budget": {
        "title": "Budget"
      },
      "title": "Deal Details"
    },
    "EnquiryHeader": {
      "confirm": {
        "feePotentialRemove": "Are you sure you wish to remove the fee potential for this enquiry?"
      },
      "feePotential": "Fee potential",
      "modal": {
        "title": "Collaborators with access to the deal"
      },
      "subscribed": "Subscribed",
      "title": "Deal Title"
    },
    "Notes": {
      "viewing": {
        "scheduled_for": "Meeting scheduled for"
      }
    },
    "PortfolioHeader": {
      "add": {
        "deal": "Deal"
      },
      "export": {
        "deals": {
          "csv": "A CSV version of the interest schedule that allows for editing.",
          "pdf": "A PDF version of the deals with all activity per asset.",
          "title": "Deal Schedule"
        }
      },
      "tabs": {
        "deals": "Deals"
      }
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "deals": "Deals",
      "rentableArea": "Total area"
    },
    "SpacesTable": {
      "availability": {
        "mobile": {
          "tbd": "-"
        },
        "tbd": "-"
      },
      "headers": {
        "leaseholders": "Leaseholder",
        "price": "Price"
      }
    },
    "TabbedFilter": {
      "channel": "Advisor"
    },
    "Table": {
      "headers": {
        "budget": "Budget",
        "channel": "Advisor",
        "feePotential": "Fee potential",
        "fee_potential": "Fee potential",
        "portfolio": "Portfolio",
        "tenant": "Company"
      }
    },
    "TenantProfile": {
      "title": "Company Profile"
    },
    "notifications": {
      "deal": {
        "delete": {
          "success": {
            "title": "Deal deleted successfully!"
          }
        }
      }
    },
    "shared": {
      "budget": "Budget",
      "channelCategories": {
        "employee_referral": "Employee referral"
      },
      "deal": {
        "budget": "Budget",
        "channel": "Advisor",
        "fee_potential": "Fee potential",
        "portfolio": "Portfolio",
        "tenant": "Tenant"
      },
      "dealStages": {
        "prospects": "Prospect",
        "signed_loi": "Agreement",
        "touring": "Viewing",
        "trading_proposal": "RFP/Proposal"
      },
      "deals": "Deals",
      "systemEvents": {
        "deal_channel_add": "Advisor <i>%{channel}</i> added by <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> created deal for <i>%{asset}</i>",
        "deal_lease_cancel": "<i>%{actor}</i> has cancelled the agreement",
        "deal_share_status_update": "Sharing settings updated to <i>%{after}</i> by <i>%{actor}</i>",
        "deal_tenant_add": "<i>%{actor}</i> added <i>%{tenant}</i>",
        "deal_tenant_broker_add": "<i>%{actor}</i> added <i>%{tenant_rep}</i> as advisor"
      }
    }
  },
  "en-GB-acquisition": {
    "ActivityFeed": {
      "empty_viewings": "No meetings.",
      "filters": {
        "viewing": "Meetings"
      },
      "header": {
        "viewing": "Meeting"
      }
    },
    "AddActions": {
      "addDeal": "Deal"
    },
    "AssetLeadsList": {
      "emptyStage": "No acquisition found in the current phase"
    },
    "AssetStatistics": {
      "deals": "Deals",
      "viewings": "Meetings"
    },
    "Channels": {
      "title": "Advisors"
    },
    "DealActions": {
      "delete": {
        "confirm": "Are you sure you want to permanently delete this deal? Comments will also be removed."
      }
    },
    "DealCancel": {
      "cancelDate": "Date of cancellation",
      "title": "Cancel agreement"
    },
    "DealDetail": {
      "confirmDelete": "Are you sure you want to permanently delete this deal? Comments will also be removed."
    },
    "DealForm": {
      "assets": {
        "info": "Mind the privacy settings on the bottom left before adding.",
        "title": "Asset |||| Assets"
      },
      "channel": {
        "expand": "Add <strong>originator</strong> details",
        "title": "Advisor"
      },
      "enquiry": {
        "title": "Deal"
      },
      "save": "Add ",
      "stage": "Phase",
      "tenant": {
        "title": "Company details",
        "undisclose": "<strong>Do not</strong> disclose the company details"
      }
    },
    "DealModal": {
      "header": "Add new deal"
    },
    "DealsFilter": {
      "channel": "Advisors",
      "stage": "Phase"
    },
    "DealsTable": {
      "empty": "No deals found",
      "empty_stage": "No deals found in the current phase",
      "export": {
        "title": "Deal Export"
      }
    },
    "EnquiryDetails": {
      "budget": {
        "title": "Budget"
      },
      "title": "Deal Details"
    },
    "EnquiryHeader": {
      "assignFeePotential": "Add fee potential",
      "feePotential": "Fee potential",
      "modal": {
        "title": "Collaborators with access to the deal"
      },
      "subscribed": "Subscribed",
      "title": "Deal Title"
    },
    "Intro": {
      "channelDetails": "<h3>Associate advisor</h3>\nSpecify more information about the advisors you're collaborating with for this enquiry."
    },
    "Notes": {
      "viewing": {
        "scheduled_for": "Meeting scheduled for"
      }
    },
    "PortfolioHeader": {
      "add": {
        "deal": "Deal"
      },
      "export": {
        "deals": {
          "csv": "A CSV version of the interest schedule that allows for editing.",
          "pdf": "A PDF version of the deals with all activity per asset.",
          "title": "Deal Schedule"
        }
      },
      "tabs": {
        "deals": "Deals"
      }
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "deals": "Deals",
      "rentableArea": "Total area"
    },
    "SpacesTable": {
      "availability": {
        "mobile": {
          "tbd": "-"
        },
        "tbd": "-"
      },
      "headers": {
        "leaseholders": "Leaseholder",
        "price": "Price"
      }
    },
    "StageProgress": {
      "selectStage": "Select phase"
    },
    "TabbedFilter": {
      "channel": "Advisor"
    },
    "Table": {
      "headers": {
        "budget": "Budget",
        "channel": "Advisor",
        "feePotential": "Fee potential",
        "fee_potential": "Fee potential",
        "nonProspectComment": "Comments / Follow up",
        "portfolio": "Portfolio",
        "stage": "Phase",
        "tenant": "Company"
      }
    },
    "TenantProfile": {
      "title": "Company Profile"
    },
    "notifications": {
      "deal": {
        "delete": {
          "success": {
            "title": "Deal deleted successfully!"
          }
        }
      }
    },
    "shared": {
      "assetLeadStages": {
        "prospect": "Prospect"
      },
      "budget": "Budget",
      "channelCategories": {
        "employee_referral": "Employee referral"
      },
      "deal": {
        "budget": "Budget",
        "channel": "Advisor",
        "fee_potential": "Fee potential",
        "portfolio": "Portfolio",
        "tenant": "Tenant"
      },
      "dealStages": {
        "prospects": "Prospect",
        "signed_loi": "Agreement",
        "touring": "Viewing",
        "trading_proposal": "RFP/Proposal"
      },
      "deals": "Deals",
      "systemEvents": {
        "asset_lead_stage_update": "<i>%{actor}</i> changed phase from <i>%{before}</i> to <i>%{after}</i>",
        "deal_channel_add": "Advisor <i>%{channel}</i> added by <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> created deal for <i>%{asset}</i>",
        "deal_lease_cancel": "<i>%{actor}</i> has cancelled the agreement",
        "deal_share_status_update": "Sharing settings updated to <i>%{after}</i> by <i>%{actor}</i>",
        "deal_stage_update": "<i>%{actor}</i> changed phase from <i>%{before}</i> to <i>%{after}</i>",
        "deal_tenant_add": "<i>%{actor}</i> added <i>%{tenant}</i>",
        "deal_tenant_broker_add": "<i>%{actor}</i> added <i>%{tenant_rep}</i> as advisor"
      }
    }
  },
  "fr-FR-acquisition": {
    "ActivityFeed": {
      "empty_viewings": "Aucune réunion.",
      "filters": {
        "viewing": "Réunions"
      },
      "header": {
        "viewing": "Réunion"
      }
    },
    "AddActions": {
      "addDeal": "Opportunité"
    },
    "AssetStatistics": {
      "deals": "Opportunités",
      "viewings": "Réunions"
    },
    "Channels": {
      "title": "Représentants"
    },
    "DealActions": {
      "delete": {
        "confirm": "Êtes-vous sûr de vouloir supprimer définitivement cette opportunité ? Les commentaires sur cette opération seront aussi supprimés."
      },
      "duplicate": {
        "tooltip": "Dupliquer"
      }
    },
    "DealCancel": {
      "cancelDate": "Date d'annulation",
      "title": "Annuler l'accord"
    },
    "DealDetail": {
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer définitivement cette opportunité ? Les commentaires sur cette opération seront aussi supprimés."
    },
    "DealFilter": {
      "advanced": "Filtres avancés"
    },
    "DealForm": {
      "assets": {
        "info": "N'oubliez pas les paramètres de confidentialité en bas à gauche avant l'ajout.",
        "title": "Actif |||| Actifs"
      },
      "channel": {
        "expand": "Ajouter les détails du <strong>bailleur</strong>",
        "title": "Consultant"
      },
      "enquiry": {
        "title": "Opportunité"
      },
      "save": "Ajouter",
      "tenant": {
        "title": "Profile de l'entreprise",
        "undisclose": "<strong>Ne partagez pas</strong> les détails de l'entreprise"
      }
    },
    "DealModal": {
      "header": "Nouvelle opportunité"
    },
    "DealsFilter": {
      "channel": "Représentants"
    },
    "DealsTable": {
      "empty": "Aucune opportunité",
      "empty_stage": "Aucune opportunité au stage présent",
      "export": {
        "title": "Export des opportunités"
      }
    },
    "EnquiryDetails": {
      "budget": {
        "title": "Budget"
      },
      "title": "Détails"
    },
    "EnquiryHeader": {
      "modal": {
        "title": "Collaborateurs ayant accès"
      },
      "title": "Titre"
    },
    "IntegrationStatus": {
      "syncedFrom": "Synchronisé avec <strong>%{integration}</strong>"
    },
    "Notes": {
      "viewing": {
        "scheduled_for": "Rendez-vous prévue pour"
      }
    },
    "PortfolioHeader": {
      "add": {
        "deal": "Opportunité"
      },
      "export": {
        "deals": {
          "csv": "Une version CSV du calendrier des opportunités qui permet la modification.",
          "pdf": "Une version PDF du calendrier des opportunités contenant le suivi par actif.",
          "title": "Opportunités"
        }
      },
      "tabs": {
        "deals": "Opportunités"
      }
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisition",
      "deals": "Opportunités",
      "rentableArea": "Surface totale"
    },
    "SpacesTable": {
      "availability": {
        "mobile": {
          "tbd": "-"
        },
        "tbd": "-"
      },
      "headers": {
        "leaseholders": "Locataire",
        "price": "Prix"
      }
    },
    "TabbedFilter": {
      "channel": "Représentant"
    },
    "Table": {
      "headers": {
        "budget": "Budget",
        "channel": "Représentant",
        "tenant": "Entrerprise"
      }
    },
    "TenantProfile": {
      "title": "Détails de l'entreprise"
    },
    "notifications": {
      "deal": {
        "delete": {
          "success": {
            "title": "Supprimée avec succès !"
          }
        }
      }
    },
    "shared": {
      "budget": "Budget",
      "channelCategories": {
        "employee_referral": "Référence d'employée"
      },
      "deal": {
        "budget": "Budget",
        "channel": "Représentant",
        "tenant": "Locataire"
      },
      "dealStages": {
        "prospects": "Prospect",
        "signed_loi": "Acte",
        "touring": "Visite",
        "trading_proposal": "Compromis"
      },
      "deals": "Opportunités",
      "systemEvents": {
        "deal_channel_add": "Représentant <i>%{channel}</i> ajouté par <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> a créée cet opportunité sur <i>%{asset}</i>",
        "deal_lease_cancel": "<i>%{actor}</i> a terminé l'accord",
        "deal_share_status_update": "Partagée avec <i>%{after}</i> par <i>%{actor}</i>",
        "deal_tenant_add": "<i>%{actor}</i> a ajouté <i>%{tenant}</i>",
        "deal_tenant_broker_add": "<i>%{actor}</i> a ajouté <i>%{tenant_rep}</i> comme répresentant"
      }
    }
  },
  "nl-BE-acquisition": {
    "ActivityFeed": {
      "empty_viewings": "Geen afspraken.",
      "filters": {
        "viewing": "Aspraken"
      },
      "header": {
        "viewing": "Afspraak"
      }
    },
    "AddActions": {
      "addDeal": "Opportuniteit"
    },
    "AssetStatistics": {
      "deals": "Opportuniteit",
      "viewings": "Afspraken"
    },
    "Channels": {
      "title": "Consultants"
    },
    "DealActions": {
      "delete": {
        "confirm": "Bent u zeker dat u deze opportuniteit permanent wil verwijderen? Ook updates worden verwijderd."
      }
    },
    "DealCancel": {
      "cancelDate": "Opzegdatum",
      "title": "Zeg akkoord op"
    },
    "DealDetail": {
      "confirmDelete": "Bent u zeker dat u deze opportuniteit permanent wil verwijderen? Ook updates worden verwijderd."
    },
    "DealForm": {
      "assets": {
        "info": "Kies links onderaan of u de gegevens al dan niet wenst te delen met overige teamleden vooraleer ze toe te voegen.",
        "title": "Pand |||| Panden"
      },
      "channel": {
        "expand": "Voeg <strong>oorsprong</strong> toe",
        "title": "Consultant"
      },
      "enquiry": {
        "title": "Opportuniteit"
      },
      "save": "Toevoegen",
      "tenant": {
        "title": "Bedrijfsprofiel",
        "undisclose": "Bedrijfsprofiel <strong>niet vrijgeven</strong>"
      }
    },
    "DealModal": {
      "header": "Nieuwe kans"
    },
    "DealsFilter": {
      "channel": "Consultants"
    },
    "DealsTable": {
      "empty": "Geen opportuniteiten gevonden",
      "empty_stage": "Geen opportuniteiten gevonden in de huidige fase",
      "export": {
        "title": "Export van opportuniteiten"
      }
    },
    "EnquiryDetails": {
      "budget": {
        "title": "Budget"
      },
      "title": "Details van opportuniteit"
    },
    "EnquiryHeader": {
      "modal": {
        "title": "Partners met toegang tot opportuniteit"
      },
      "title": "Titel van opportuniteit"
    },
    "Notes": {
      "viewing": {
        "scheduled_for": "Afspraak gepland voor"
      }
    },
    "PortfolioHeader": {
      "add": {
        "deal": "Opportuniteit"
      },
      "export": {
        "deals": {
          "csv": "Een CSV versie van de opportuniteitenlijst die bewerken kan worden.",
          "pdf": "Een PDF van de opportuniteiten met alle activiteit per pand.",
          "title": "Opportuniteiten"
        }
      },
      "tabs": {
        "deals": "Opportuniteiten"
      }
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisitie",
      "deals": "Opportuniteiten",
      "rentableArea": "Totale oppervlakte"
    },
    "SpacesTable": {
      "availability": {
        "mobile": {
          "tbd": "-"
        },
        "tbd": "-"
      },
      "headers": {
        "leaseholders": "Huuder",
        "price": "Prijs"
      }
    },
    "TabbedFilter": {
      "channel": "Consultant"
    },
    "Table": {
      "headers": {
        "budget": "Budget",
        "channel": "Consultant",
        "tenant": "Bedrijfsprofiel"
      }
    },
    "TenantProfile": {
      "title": "Bedrijfsprofiel"
    },
    "notifications": {
      "deal": {
        "delete": {
          "success": {
            "title": "Opportuniteit verwijderd!"
          }
        }
      }
    },
    "shared": {
      "assetLeadStages": {
        "prospect": "Prospect"
      },
      "budget": "Budget",
      "channelCategories": {
        "employee_referral": "Verwijzing medewerker"
      },
      "deal": {
        "budget": "Budget",
        "channel": "Consultant",
        "tenant": "Huurder"
      },
      "dealStages": {
        "finder": "Prospect",
        "prospects": "Prospect",
        "signed_loi": "Overeenkomst",
        "touring": "Bezichtiging",
        "trading_proposal": "RFP/Voorstel"
      },
      "deals": "Opportuniteiten",
      "systemEvents": {
        "deal_channel_add": "Consultant <i>%{channel}</i> toegevoegd door <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> heeft deze opportuniteit toegevoegd aan <i>%{asset}</i>",
        "deal_lease_cancel": "<i>%{actor}</i> heeft de overeenkomst opgezegd",
        "deal_share_status_update": "Gedeeld met <i>%{after}</i> door <i>%{actor}</i>",
        "deal_tenant_add": "<i>%{actor}</i> heeft <i>%{tenant}</i> toegevoegd",
        "deal_tenant_broker_add": "<i>%{actor}</i> heeft <i>%{tenant_rep}</i> toegevoegd als consultant"
      }
    }
  },
  "nl-NL-acquisition": {
    "ActivityFeed": {
      "empty_viewings": "Geen afspraken.",
      "filters": {
        "viewing": "Afspraken"
      },
      "header": {
        "viewing": "Afspraak"
      }
    },
    "AddActions": {
      "addDeal": "Kans"
    },
    "AssetIncentives": {
      "emptyMessage": {
        "active": "Plaats uw <strong>actieve</strong> courtages hier",
        "inactive": "Plaats uw <strong>niet-actieve</strong> courtages hier"
      },
      "info": "Een nieuwe courtage nodig? U kunt meer courtages maken in uw <a href=\"/settings/templates/incentives\">algemene instellingen</a>."
    },
    "AssetInformation": {
      "incentives": "Courtages"
    },
    "AssetLeadCreateForm": {
      "assetLead": "Acquisitie"
    },
    "AssetLeadHeader": {
      "pointPerson": {
        "dropdownHeader": "Selecteer Consultant",
        "title": "Consultant"
      },
      "reopen": "Kans heropenen?"
    },
    "AssetLeadStatusMessage": {
      "message": "De acquisitie kans is <strong>%{status}</strong> geplaatst door %{actor} op %{date}",
      "message_no_actor": "De acquisitie kans is <strong>%{status}</strong> op %{date}"
    },
    "AssetSettings": {
      "incentives": "Courtages"
    },
    "AssetStatistics": {
      "deals": "Kansen",
      "viewings": "Afspraken"
    },
    "Channels": {
      "title": "Contactpersonen"
    },
    "CompanyPage": {
      "incentives": "Courtages"
    },
    "DealActions": {
      "delete": {
        "confirm": "Bent u zeker dat u deze kans permanent wil verwijderen? Ook updates worden verwijderd."
      }
    },
    "DealCancel": {
      "cancelDate": "Opzegdatum",
      "title": "Zeg akkoord op"
    },
    "DealDetail": {
      "confirmDelete": "Bent u zeker dat u deze kans permanent wil verwijderen? Ook updates worden verwijderd."
    },
    "DealDetails": {
      "location": {
        "title": "Zoekgebied"
      },
      "spaces": {
        "archive": "Archief",
        "car_parking": "Buitenparking",
        "covered_car_parking": "Overdekte parking",
        "coworking": "Co-working",
        "industrial": "Industrial",
        "land": "Kavel",
        "leisure": "Vrijetijd",
        "logistical": "Logistieke ruimte",
        "meeting": "Meeting / Conferentie",
        "new": "Nieuw",
        "office": "Kantoor",
        "other_cat": "Overig",
        "outdoor_area": "Buitenterrein",
        "residential": "Residentieel",
        "retail": "Retail",
        "showroom": "Showroom",
        "storage": "Opslag",
        "title": "Ruimtes"
      }
    },
    "DealForm": {
      "assets": {
        "info": "Kies links onderaan of u de gegevens al dan niet wenst te delen met overige teamleden vooraleer ze toe te voegen.",
        "title": "Object |||| Objecten"
      },
      "channel": {
        "expand": "Voeg <strong>contactpersoon</strong> toe",
        "title": "Contactpersoon"
      },
      "enquiry": {
        "title": "Kans"
      },
      "save": "Toevoegen",
      "tenant": {
        "title": "Bedrijfsprofiel",
        "undisclose": "Bedrijfsprofiel <strong>niet vrijgeven</strong>"
      }
    },
    "DealModal": {
      "header": "Nieuwe kans"
    },
    "DealsFilter": {
      "channel": "Contactpersoon"
    },
    "DealsTable": {
      "empty": "Geen kansen gevonden",
      "empty_stage": "Geen kansen gevonden in de huidige fase",
      "export": {
        "csv": "Een CSV versie van de kansen die bewerkt kan worden",
        "pdf": "Een PDF van de kansen met alle activiteit per object.",
        "title": "Export van kansen"
      }
    },
    "DropdownUserSelect": {
      "pointPerson": "Consultant"
    },
    "EnquiryDetails": {
      "budget": {
        "title": "Budget"
      },
      "title": "Details van kans"
    },
    "EnquiryHeader": {
      "assignFeePotential": "Toevoegen fee potential",
      "confirm": {
        "feePotentialRemove": "Ben je zeker dat je het fee potential voor deze kans wenst te verwijderen?"
      },
      "feePotential": "Fee Potential",
      "modal": {
        "title": "Partners met toegang tot kans"
      },
      "point_person": {
        "dropdown_header": "Selecteer Consultant",
        "title": "Consultant"
      },
      "reopen": "Kans heropenen?",
      "title": "Titel van kans"
    },
    "EnquiryModal": {
      "expand_channel_details": "Voeg <strong>contactpersoon</strong> toe"
    },
    "EnquiryStatusMessage": {
      "message": "De kans is <strong>%{status}</strong> geplaatst door %{actor}",
      "message_no_actor": "De kans is <strong>%{status}</strong> geplaatst",
      "reopen": "Kans heropenen?"
    },
    "Incentive": {
      "fee": "<strong>%{fee}</strong> courtage zal worden toegekend"
    },
    "IncentiveForm": {
      "addIncentive": "Nieuwe courtage",
      "deleteAutoassignConfirm": "Bent u zeker dat u deze courtage wilt verwijderen? Deze courtage is automatisch toegewezen aan de bedrijfspagina en objecten met publieke status. Nadat de courtage verwijderd is, wordt deze niet langer weergegeven.",
      "deleteConfirm": "Bent u zeker dat u deze courtage wilt verwijderen?",
      "deleteSuccess": "Courtage werd verwijderd!",
      "editIncentive": "Bewerk courtage"
    },
    "Intro": {
      "channelDetails": "<h3> Specificeer contactpersonen </ h3>\nBewaar informatie over de contactpersoon van de collega makelaars waarmee samengewerkt wordt op deze kans.",
      "dealDetails": "<h3>Specificeer de kans</h3>\nGeef specificaties mee van deze kans.",
      "tenantDetails": "<h3> Bewaar bedrijfsprofiel</ h3>\nBewaar bedrijfsinformatie en contactgegevens."
    },
    "Notes": {
      "viewing": {
        "scheduled_for": "Afspraak gepland voor"
      }
    },
    "PortfolioHeader": {
      "add": {
        "deal": "Kans"
      },
      "export": {
        "deals": {
          "csv": "Een CSV versie van de lijst van kansenlijst die bewerkt kan worden",
          "pdf": "Een PDF van de lijst van kansen met alle activiteit per object.",
          "title": "Lijst van kansen"
        }
      },
      "tabs": {
        "deals": "Kansen"
      }
    },
    "PortfolioStatistics": {
      "assetLeads": "Acquisitie",
      "deals": "Kansen",
      "rentableArea": "Totale oppervlakte"
    },
    "Settings": {
      "Subscriptions": {
        "unsubscribeDeals": {
          "body": "Uitschrijven van real-time updates op kansen?",
          "unsubscribe": "Verwijder alle bestaande email subscriptions voor uit te schrijven portefeuilles"
        }
      },
      "settings": {
        "delete": {
          "warning": "Als u uw account verwijdert, worden al uw gegevens <strong>permanent</strong> verwijderd en is dit onomkeerbaar. U bent verantwoordelijk voor het overdragen van objecten en kansen waar u als consultant point person bent. <br/> Na het verwijderen van uw account heeft u geen toegang meer tot Rialto en ontvangt u geen update e-mails meer van het platform."
        }
      },
      "team": {
        "confirm": {
          "removeUser": "Weet u zeker dat u deze gebruiker wilt verwijderen? Als de gebruiker als consultant point person was op objecten of kansen, stel dan manueel iemand anders van je team in of contacteer Rialto om alle records aan te passen."
        }
      }
    },
    "SpacesTable": {
      "availability": {
        "mobile": {
          "tbd": "-"
        },
        "tbd": "-"
      },
      "headers": {
        "leaseholders": "Huurder",
        "price": "Prijs"
      }
    },
    "TabbedFilter": {
      "channel": "Contactpersoon"
    },
    "Table": {
      "headers": {
        "budget": "Budget",
        "channel": "Contactpersoon",
        "feePotential": "Fee Potential",
        "fee_potential": "Fee Potential",
        "pointPerson": "Consultant",
        "point_person": "Consultant",
        "startDate": "Ingangsdatum",
        "start_date": "Ingangsdatum",
        "tenant": "Bedrijfprofiel"
      }
    },
    "TenantProfile": {
      "title": "Bedrijfsprofiel"
    },
    "notifications": {
      "deal": {
        "delete": {
          "success": {
            "title": "Kans verwijderd!"
          }
        }
      }
    },
    "shared": {
      "assetCategories": {
        "hotel": "Hotel",
        "industrial": "Bedrijfsruimte",
        "land": "Grond",
        "multi_family": "Residentieel multi-family",
        "office": "Kantoorgebouw",
        "other_cat": "Andere",
        "residential": "Residentieel",
        "retail": "Retail",
        "warehouse": "Logistiek"
      },
      "assetLeadStages": {
        "closing": "Opdracht",
        "negotiating": "Voorstel",
        "prospect": "Prospect"
      },
      "budget": "Budget",
      "channelCategories": {
        "employee_referral": "Synergy"
      },
      "deal": {
        "budget": "Budget",
        "channel": "Contactpersoon",
        "fee_potential": "Fee Potential",
        "point_person": "Consultant",
        "tenant": "Huurder"
      },
      "dealStages": {
        "finder": "Prospect",
        "prospects": "Prospect",
        "signed_loi": "Overeenkomst",
        "touring": "Bezichtiging",
        "trading_proposal": "RFP/Voorstel"
      },
      "deals": "Kansen",
      "disregard_reasons": {
        "location": "Zoekgebied"
      },
      "pointPerson": "Consultant",
      "startDate": "Ingangsdatum",
      "systemEvents": {
        "deal_channel_add": "Contactpersoon <i>%{channel}</i> toegevoegd door <i>%{actor}</i>",
        "deal_create": "<i>%{creator}</i> heeft deze kans toegevoegd aan <i>%{asset}</i>",
        "deal_lease_cancel": "<i>%{actor}</i> heeft de overeenkomst opgezegd",
        "deal_point_person_change": "<i>%{creator}</i> veranderde de consultant van <i>%{before}</i> naar <i>%{after}</i><i>",
        "deal_share_status_update": "Gedeeld met <i>%{after}</i> door <i>%{actor}</i>",
        "deal_tenant_add": "<i>%{actor}</i> heeft <i>%{tenant}</i> toegevoegd",
        "deal_tenant_broker_add": "<i>%{actor}</i> heeft <i>%{tenant_rep}</i> toegevoegd als contactpersoon"
      }
    },
    "spaces": {
      "category": "Categorie"
    }
  }
};